import { __decorate, __metadata } from 'tslib';
import { Input, Component, EventEmitter, Renderer2, Output, HostListener, ViewChild, ElementRef, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

function IccDrawDimensionsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
} if (rf & 2) {
    const element_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", element_r1.class)("ngStyle", element_r1.style)("innerHTML", element_r1.innerHtml ? element_r1.innerHtml : "", ɵngcc0.ɵɵsanitizeHtml);
} }
function IccDrawInterfaceComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r0.stickyPreviewStyle);
} }
function IccDrawInterfaceComponent_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵlistener("click", function IccDrawInterfaceComponent_div_2_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const button_r5 = ctx.$implicit; const group_r3 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onButtonClick(button_r5, group_r3); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", button_r5.innerHtml ? button_r5.innerHtml : "", ɵngcc0.ɵɵsanitizeHtml)("ngClass", button_r5.class)("ngStyle", button_r5.style);
    ɵngcc0.ɵɵattribute("title", button_r5.title);
} }
const _c0 = function (a0) { return { "active": a0 }; };
function IccDrawInterfaceComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵlistener("click", function IccDrawInterfaceComponent_div_2_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); return $event.stopPropagation(); });
    ɵngcc0.ɵɵtemplate(1, IccDrawInterfaceComponent_div_2_span_1_Template, 1, 4, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(group_r3.side);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c0, group_r3.uuid === ctx_r1.uuid))("ngStyle", group_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r3.buttons);
} }
function IccDrawInterfaceComponent_div_3_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵlistener("click", function IccDrawInterfaceComponent_div_3_span_4_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onClickCancel(); });
    ɵngcc0.ɵɵelementEnd();
} }
function IccDrawInterfaceComponent_div_3_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵlistener("click", function IccDrawInterfaceComponent_div_3_span_5_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onClickSubmit(); });
    ɵngcc0.ɵɵelementEnd();
} }
function IccDrawInterfaceComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵlistener("click", function IccDrawInterfaceComponent_div_3_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); return $event.stopPropagation(); });
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function IccDrawInterfaceComponent_div_3_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.move.inputs.prev = $event; })("change", function IccDrawInterfaceComponent_div_3_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onChangePrev(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function IccDrawInterfaceComponent_div_3_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.move.inputs.next = $event; })("change", function IccDrawInterfaceComponent_div_3_Template_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.onChangeNext(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, IccDrawInterfaceComponent_div_3_span_4_Template, 1, 0, "span", 11);
    ɵngcc0.ɵɵtemplate(5, IccDrawInterfaceComponent_div_3_span_5_Template, 1, 0, "span", 12);
    ɵngcc0.ɵɵelementStart(6, "span", 13);
    ɵngcc0.ɵɵlistener("mousedown", function IccDrawInterfaceComponent_div_3_Template_span_mousedown_6_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onStartMoving(); })("touchstart", function IccDrawInterfaceComponent_div_3_Template_span_touchstart_6_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onStartMoving(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.move.direction)("ngStyle", ctx_r2.move.style);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("text--position-invalid", ctx_r2.stickyPositions && (!ctx_r2.isPositionValid && (!ctx_r2.currentStickyBounds || !ctx_r2.isPositionMinMaxValid)));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.move.inputs.prev);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("text--position-invalid", ctx_r2.stickyPositions && (!ctx_r2.isPositionValid && (!ctx_r2.currentStickyBounds || !ctx_r2.isPositionMinMaxValid)));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.move.inputs.next);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.move.actions.onClick);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.move.actions.onClick);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("move--position-invalid", ctx_r2.stickyPositions && (!ctx_r2.isPositionValid && (!ctx_r2.currentStickyBounds || !ctx_r2.isPositionMinMaxValid)));
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.move.direction === "horizontal" ? "ico-move-horizontal" : "ico-move-vertical");
} }
const _c1 = function (a0) { return { "pointer-events": a0 }; };
const _c2 = ["svg"];
const _c3 = ["icc-draw-svg", ""];
function IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_linearGradient_1__svg_stop_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "stop");
} if (rf & 2) {
    const svgGradientStep_r8 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("offset", svgGradientStep_r8.offset)("stop-color", svgGradientStep_r8.color);
} }
function IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_linearGradient_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "linearGradient");
    ɵngcc0.ɵɵtemplate(1, IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_linearGradient_1__svg_stop_1_Template, 1, 2, "stop", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const svgGradient_r6 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("id", svgGradient_r6.id)("gradientTransform", svgGradient_r6.gradientTransform)("x1", svgGradient_r6.x1)("x2", svgGradient_r6.x2)("y1", svgGradient_r6.y1)("y2", svgGradient_r6.y2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", svgGradient_r6.steps);
} }
function IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2__svg_rect_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "rect");
} if (rf & 2) {
    const svgPattern_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵattribute("fill", svgPattern_r9.color)("width", svgPattern_r9.width)("height", svgPattern_r9.height)("x", 0)("y", 0);
} }
function IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2__svg_image_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "image", 5);
} if (rf & 2) {
    const svgPattern_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵattribute("href", svgPattern_r9.image, null, "xlink")("width", svgPattern_r9.width)("height", svgPattern_r9.height)("x", 0)("y", 0);
} }
function IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2__svg_path_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "path", 6);
} if (rf & 2) {
    const svgPath_r15 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("d", svgPath_r15.d)("fill", svgPath_r15.fill)("stroke", svgPath_r15.stroke)("stroke-dasharray", svgPath_r15.strokeDasharray)("stroke-width", svgPath_r15.strokeWidth)("vector-effect", svgPath_r15.vectorEffect);
} }
function IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "pattern");
    ɵngcc0.ɵɵtemplate(1, IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2__svg_rect_1_Template, 1, 5, "rect", 1);
    ɵngcc0.ɵɵtemplate(2, IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2__svg_image_2_Template, 1, 5, "image", 3);
    ɵngcc0.ɵɵtemplate(3, IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2__svg_path_3_Template, 1, 6, "path", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const svgPattern_r9 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("id", svgPattern_r9.id)("patternTransform", svgPattern_r9.patternTransform)("patternUnits", svgPattern_r9.patternUnits)("width", svgPattern_r9.width)("height", svgPattern_r9.height)("x", svgPattern_r9.x)("y", svgPattern_r9.y);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", svgPattern_r9.color);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", svgPattern_r9.image);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", svgPattern_r9.paths);
} }
function IccDrawSvgComponent__svg_g_0__svg_defs_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "defs");
    ɵngcc0.ɵɵtemplate(1, IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_linearGradient_1_Template, 2, 7, "linearGradient", 0);
    ɵngcc0.ɵɵtemplate(2, IccDrawSvgComponent__svg_g_0__svg_defs_1__svg_pattern_2_Template, 4, 10, "pattern", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", node_r1.svg.gradients);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", node_r1.svg.patterns);
} }
function IccDrawSvgComponent__svg_g_0__svg_g_2__svg_path_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "path", 10);
    ɵngcc0.ɵɵlistener("click", function IccDrawSvgComponent__svg_g_0__svg_g_2__svg_path_1_Template__svg_path_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const i_r21 = ctx.index; const node_r1 = ɵngcc0.ɵɵnextContext(2).$implicit; return node_r1.options.actions && node_r1.options.actions.onHover === "single-hover" ? node_r1.options.actions.onClick(node_r1.onClick({ index: i_r21 })) : null; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const svgPath_r20 = ctx.$implicit;
    const node_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵattribute("d", svgPath_r20.d)("fill", svgPath_r20.fill)("stroke", svgPath_r20.stroke)("stroke-dasharray", svgPath_r20.strokeDasharray)("stroke-width", svgPath_r20.strokeWidth)("vector-effect", svgPath_r20.vectorEffect)("pointer-events", node_r1.options.actions && node_r1.options.actions.onHover ? "all" : "none");
} }
function IccDrawSvgComponent__svg_g_0__svg_g_2__svg_text_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "text", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const svgText_r26 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("dominant-baseline", svgText_r26.dominantBaseline)("fill", svgText_r26.fill)("font-size", svgText_r26.fontSize)("stroke", svgText_r26.stroke)("stroke-width", svgText_r26.strokeWidth)("text-anchor", svgText_r26.textAnchor)("transform", svgText_r26.transform)("x", svgText_r26.x)("y", svgText_r26.y);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(svgText_r26.value);
} }
function IccDrawSvgComponent__svg_g_0__svg_g_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "g", 7);
    ɵngcc0.ɵɵlistener("click", function IccDrawSvgComponent__svg_g_0__svg_g_2_Template__svg_g_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r29); const node_r1 = ɵngcc0.ɵɵnextContext().$implicit; return node_r1.options.actions && node_r1.options.actions.onHover === "group-hover" ? node_r1.options.actions.onClick(node_r1.onClick({ index: "all" })) : null; });
    ɵngcc0.ɵɵtemplate(1, IccDrawSvgComponent__svg_g_0__svg_g_2__svg_path_1_Template, 1, 7, "path", 8);
    ɵngcc0.ɵɵtemplate(2, IccDrawSvgComponent__svg_g_0__svg_g_2__svg_text_2_Template, 2, 10, "text", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", node_r1.options.actions ? node_r1.options.actions.onHover : null);
    ɵngcc0.ɵɵattribute("pointer-events", node_r1.options.actions && node_r1.options.actions.onHover ? "all" : "none");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", node_r1.svg.paths);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", node_r1.svg.texts);
} }
function IccDrawSvgComponent__svg_g_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "g");
    ɵngcc0.ɵɵtemplate(1, IccDrawSvgComponent__svg_g_0__svg_defs_1_Template, 3, 2, "defs", 1);
    ɵngcc0.ɵɵtemplate(2, IccDrawSvgComponent__svg_g_0__svg_g_2_Template, 3, 4, "g", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r1 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("class", node_r1.constructor.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r1.svg.gradients.length || node_r1.svg.patterns.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r1.svg.paths.length || node_r1.svg.texts.length);
} }
class IccDrawMathService {
    static getAreaFromPoly(poly) {
        let angle, area = 0, circle;
        if (poly.length < 3) {
            return 0;
        }
        for (let i = 0, j = 1; i < poly.length; ++i, ++j, j %= poly.length) {
            area -=
                (Number(poly[i].x) * Number(poly[j].y) - Number(poly[j].x) * Number(poly[i].y)) / 2;
            if (poly[j].cr) {
                circle = this.getCircleCenter(poly[i], poly[j], poly[j].cr);
                // angle = poly[j].cw
                //     ? Math.atan2(poly[j].y - circle.cy, poly[j].x - circle.cx) - Math.atan2(poly[i].y - circle.cy, poly[i].x - circle.cx)
                //     : Math.atan2(poly[i].y - circle.cy, poly[i].x - circle.cx) - Math.atan2(poly[j].y - circle.cy, poly[j].x - circle.cx);
                // angle = poly[j].cw ? -angle : angle;
                angle =
                    Math.atan2(poly[i].y - circle.cy, poly[i].x - circle.cx)
                        - Math.atan2(poly[j].y - circle.cy, poly[j].x - circle.cx);
                angle = (angle + Math.PI * 2) % (Math.PI * 2);
                area -=
                    ((poly[j].cw ? 1 : -1) * Math.pow(poly[j].cr, 2) * (angle - Math.sin(angle)))
                        / 2;
            }
        }
        return Number(area) || 0;
    }
    static getAreaFromRect(rect) {
        return Number(rect.width) * Number(rect.height) || 0;
    }
    static getCircleCenter(point1, point2, radius) {
        const q = Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
        const baseX = (Math.sqrt(Math.pow(radius, 2) - Math.pow(q / 2, 2)) * (point1.y - point2.y)) / q;
        const baseY = (Math.sqrt(Math.pow(radius, 2) - Math.pow(q / 2, 2)) * (point2.x - point1.x)) / q;
        return {
            cx: (point1.x + point2.x) / 2 - baseX,
            cy: (point1.y + point2.y) / 2 - baseY,
        };
    }
    // Na postawie http://paulbourke.net/geometry/circlesphere/
    static getCircleRadius(point1, point2, point3) {
        const x1 = point1.x;
        const y1 = point1.y;
        const x2 = point2.x;
        const y2 = point2.y;
        const x3 = point3.x;
        const y3 = point3.y;
        const linchk = x2 * y3 + x1 * y2 + x3 * y1 - x1 * y3 - x2 * y1 - x3 * y2;
        return {
            rx: (0.5
                * ((x1 * x1 + y1 * y1) * (x3 - x2)
                    + (x2 * x2 + y2 * y2) * (x1 - x3)
                    + (x3 * x3 + y3 * y3) * (x2 - x1)))
                / linchk,
            ry: (0.5
                * ((x1 * x1 + y1 * y1) * (y3 - y2)
                    + (x2 * x2 + y2 * y2) * (y1 - y3)
                    + (x3 * x3 + y3 * y3) * (y2 - y1)))
                / linchk,
        };
    }
    static getGravityFromPoly(poly) {
        const gravity = {};
        let sum = 0;
        const vsum = { x: 0, y: 0 };
        for (let x = 0, y = poly.length - 1; x < poly.length; y = x++) {
            const p1 = poly[x];
            const p2 = poly[y];
            const cross = p1.x * p2.y - p1.y * p2.x;
            sum += cross;
            vsum.x += (p1.x + p2.x) * cross;
            vsum.y += (p1.y + p2.y) * cross;
        }
        const z = 1 / (3 * sum);
        gravity.x = Math.ceil(vsum.x * z);
        gravity.y = Math.ceil(vsum.y * z);
        const rect = this.getRectFromPoly(poly);
        gravity.width = Math.ceil(Math.min(gravity.x - rect.x, rect.x + rect.width - gravity.x));
        gravity.height = Math.ceil(Math.min(gravity.y - rect.y, rect.y + rect.height - gravity.y));
        gravity.horizontal = IccDrawMathService.intersectLineWithPoly([{ x: rect.x, y: gravity.y }, { x: rect.x + rect.width, y: gravity.y }], poly);
        gravity.vertical = IccDrawMathService.intersectLineWithPoly([{ x: gravity.x, y: rect.y }, { x: gravity.x, y: rect.y + rect.height }], poly);
        return gravity;
    }
    static getGravityFromRect(rect) {
        return {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2,
        };
    }
    static getLineEquationOld(line) {
        const div = line[1].x - line[0].x || 0.000001;
        const m = (line[1].y - line[0].y) / div;
        const b = -m * line[0].x + line[0].y;
        return { m, b };
    }
    static getLineEquation(line) {
        let A, B, C;
        if (line[0].x === line[1].x) {
            A = 1;
            B = 0;
            C = -line[0].x;
        }
        else if (line[0].y === line[1].y) {
            A = 0;
            B = 1;
            C = -line[0].y;
        }
        else {
            /** Ax + By + C = 0 */
            A = Number(line[0].y - line[1].y);
            B = Number(line[1].x - line[0].x);
            C = Number(line[0].x * line[1].y - line[1].x * line[0].y);
        }
        return { A, B, C };
    }
    static getNearestPointInPoly(poly, point) {
        const polyDistances = [];
        poly.forEach(element => {
            const distance = Math.sqrt(Math.pow(element.x - point.x, 2) + Math.pow(element.y - point.y, 2));
            polyDistances.push(distance);
        });
        return poly[polyDistances.indexOf(Math.min(...polyDistances))];
    }
    static getLineInfo(line, poly = null) {
        let angle, circle, length, side;
        if (line[0] && line[1]) {
            angle = Math.atan2(line[1].y - line[0].y, line[1].x - line[0].x);
            angle = (angle / Math.PI + 2) % 2;
            side =
                angle === 1
                    ? 'top'
                    : angle === 0
                        ? 'bottom'
                        : angle > 1
                            ? 'right'
                            : angle < 1
                                ? 'left'
                                : null;
            if (line[1].cr) {
                if (poly) {
                    let hasTop = false;
                    let hasBottom = false;
                    for (let curr = 0, next = 1; curr < poly.length; ++curr, ++next, next %= poly.length) {
                        const { side: side2 } = IccDrawMathService.getLineInfo([
                            poly[curr],
                            poly[next],
                        ]);
                        if (side2 === 'top') {
                            hasTop = true;
                        }
                        if (side2 === 'bottom') {
                            hasBottom = true;
                        }
                    }
                    if (!hasTop && !hasBottom) {
                        side = 'top';
                    }
                    else if (!hasTop && angle > 0.5 && angle < 1.5) {
                        side = 'top';
                    }
                    else if (!hasBottom && (angle < 0.5 || angle > 1.5)) {
                        side = 'bottom';
                    }
                }
                circle = this.getCircleCenter(line[0], line[1], line[1].cr);
                let circleAngle = line[1].cw
                    ? Math.atan2(line[1].y - circle.cy, line[1].x - circle.cx)
                        - Math.atan2(line[0].y - circle.cy, line[0].x - circle.cx)
                    : Math.atan2(line[0].y - circle.cy, line[0].x - circle.cx)
                        - Math.atan2(line[1].y - circle.cy, line[1].x - circle.cx);
                circleAngle = (circleAngle / Math.PI + 2) % 2;
                length = Math.abs(line[1].cr * circleAngle * Math.PI);
            }
            else {
                length = Math.sqrt(Math.pow(Number(line[1].x) - Number(line[0].x), 2)
                    + Math.pow(Number(line[1].y) - Number(line[0].y), 2));
            }
            return { angle, circle, length, side };
        }
        else {
            return { angle: 0, circle: 0, length: 0, side: null };
        }
    }
    static getLineShift(oldLine, shift, direction = null, x = null) {
        if (oldLine && oldLine[1] && oldLine[1].cr) {
            return this.getLineArcShift(oldLine, shift, direction);
        }
        else {
            return this.getLinePolyShift(oldLine, shift, direction, x);
        }
    }
    static getLineArcShift(oldLine, shift, direction = null) {
        const circle = this.getCircleCenter(oldLine[0], oldLine[1], oldLine[1].cr);
        const lineAngle0 = Math.atan2(circle.cy - oldLine[0].y, circle.cx - oldLine[0].x) / Math.PI;
        const lineAngle1 = Math.atan2(circle.cy - oldLine[1].y, circle.cx - oldLine[1].x) / Math.PI;
        const lineShift = Number.isFinite(shift) ? shift : shift.top;
        return [
            {
                x: this.round(oldLine[0].x + Math.cos(lineAngle0 * Math.PI) * lineShift),
                y: this.round(oldLine[0].y + Math.sin(lineAngle0 * Math.PI) * lineShift),
            },
            {
                cr: oldLine[1].cr - lineShift,
                x: this.round(oldLine[1].x + Math.cos(lineAngle1 * Math.PI) * lineShift),
                y: this.round(oldLine[1].y + Math.sin(lineAngle1 * Math.PI) * lineShift),
            },
        ];
    }
    static getLinePolyShift(line, shift, direction = null, x = null) {
        const { angle, side } = this.getLineInfo(line);
        const lineShift = Number.isFinite(shift) ? shift : shift[side];
        if ((line[0].y === line[1].y && line[0].x !== line[1].x)
            || direction === 'top'
            || direction === 'bottom') {
            return [
                {
                    y: this.round(line[0].y
                        + (line[0].x < line[1].x || direction === 'bottom' ? -1 : 1) * lineShift),
                    x: line[0].x,
                },
                {
                    y: this.round(line[1].y
                        + (line[0].x < line[1].x || direction === 'bottom' ? -1 : 1) * lineShift),
                    x: line[1].x,
                },
            ];
        }
        else if (line[0].x === line[1].x || direction === 'left' || direction === 'right') {
            return [
                {
                    x: this.round(line[0].x
                        + (line[0].y > line[1].y || direction === 'right' ? -1 : 1) * lineShift),
                    y: line[0].y,
                },
                {
                    x: this.round(line[1].x
                        + (line[0].y > line[1].y || direction === 'right' ? -1 : 1) * lineShift),
                    y: line[1].y,
                },
            ];
        }
        else {
            const lineAngle = angle - 0.500001;
            return [
                {
                    x: this.round(line[0].x + Math.cos(lineAngle * Math.PI) * lineShift),
                    y: this.round(line[0].y + Math.sin(lineAngle * Math.PI) * lineShift),
                },
                {
                    x: this.round(line[1].x + Math.cos(lineAngle * Math.PI) * lineShift),
                    y: this.round(line[1].y + Math.sin(lineAngle * Math.PI) * lineShift),
                },
            ];
        }
    }
    static getLinesIntersection(line1, line2) {
        if (line1[1].cr && line2[1].cr) {
            return this.getLinesArcArcIntersection(line1, line2);
        }
        else if (line1[1].cr) {
            return this.getLinesPolyArcIntersection(line2, line1, true);
        }
        else if (line2[1].cr) {
            return this.getLinesPolyArcIntersection(line1, line2, false);
        }
        else {
            return this.getLinesPolyPolyIntersection(line1, line2);
        }
    }
    static getLinesArcArcIntersection(line1, line2) {
        return line1[1];
    }
    static getLinesPolyArcIntersection(line1, line2, arc) {
        const intersection = {
            cr: arc ? line2[1].cr : null,
            x: 0,
            y: 0,
        };
        const circle = this.getCircleCenter(line2[0], line2[1], line2[1].cr);
        const lineEq = this.getLineEquationOld(line1);
        const { x, y } = this.getLinesPolyPolyIntersection(line1, line2);
        const delta = Math.pow(line2[1].cr, 2) * (1 + Math.pow(lineEq.m, 2))
            - Math.pow(circle.cy - lineEq.m * circle.cx - lineEq.b, 2);
        if (delta >= 0) {
            const x1 = (circle.cx + circle.cy * lineEq.m - lineEq.b * lineEq.m + Math.sqrt(delta))
                / (1 + Math.pow(lineEq.m, 2));
            const x2 = (circle.cx + circle.cy * lineEq.m - lineEq.b * lineEq.m - Math.sqrt(delta))
                / (1 + Math.pow(lineEq.m, 2));
            const y1 = lineEq.m * x1 + lineEq.b;
            const y2 = lineEq.m * x2 + lineEq.b;
            const d1 = Math.sqrt(Math.pow(x1 - x, 2) + Math.pow(y1 - y, 2));
            const d2 = Math.sqrt(Math.pow(x2 - x, 2) + Math.pow(y2 - y, 2));
            intersection.x = d1 < d2 ? x1 : x2;
            intersection.y = d1 < d2 ? y1 : y2;
        }
        else {
            intersection.x = x;
            intersection.y = y;
        }
        return intersection;
    }
    static getLinesPolyPolyIntersection(line1, line2) {
        let x, y;
        const line1eq = this.getLineEquation(line1);
        const line2eq = this.getLineEquation(line2);
        if (line1eq.A * line2eq.B - line2eq.A * line1eq.B) {
            x =
                (line1eq.B * line2eq.C - line2eq.B * line1eq.C)
                    / (line1eq.A * line2eq.B - line2eq.A * line1eq.B);
            y =
                (line2eq.A * line1eq.C - line1eq.A * line2eq.C)
                    / (line1eq.A * line2eq.B - line2eq.A * line1eq.B);
        }
        return { x, y };
    }
    static getParallelPoly(innerPoly, outerPoly) {
        const poly = innerPoly.map(() => null);
        let line1, line1eq, line2, line2eq;
        for (let currInner = 0, nextInner = 1; currInner < innerPoly.length; ++currInner, ++nextInner, nextInner %= innerPoly.length) {
            line1 = [innerPoly[currInner], innerPoly[nextInner]];
            line1eq = this.getLineEquation(line1);
            poly[currInner] = this.getLineInfo(line1, innerPoly).side;
            for (let currOuter = 0, nextOuter = 1; currOuter < outerPoly.length; ++currOuter, ++nextOuter, nextOuter %= outerPoly.length) {
                line2 = [outerPoly[currOuter], outerPoly[nextOuter]];
                line2eq = this.getLineEquation(line2);
                /** odcinek linii */
                if (this.round(line2eq.A * line1[0].x + line2eq.B * line1[0].y + line2eq.C, 5)
                    === 0
                    && this.round(line2eq.A * line1[1].x + line2eq.B * line1[1].y + line2eq.C, 5)
                        === 0) {
                    poly[currInner] = currOuter;
                    break;
                }
                /** fragment łuku */
                if (innerPoly[nextInner].cr && outerPoly[nextOuter].cr) {
                    const innerCircle = IccDrawMathService.getCircleCenter(innerPoly[currInner], innerPoly[nextInner], innerPoly[nextInner].cr);
                    // const outerCircle = IccDrawMathService.getCircleCenter(outerPoly[currOuter], outerPoly[nextOuter], outerPoly[nextOuter].cr);
                    const circleCenter = {
                        x: this.round(innerCircle.cx, 2),
                        y: this.round(innerCircle.cy, 2),
                    };
                    const currInnerAngle = IccDrawMathService.getLineInfo([
                        circleCenter,
                        innerPoly[currInner],
                    ]).angle;
                    const nextInnerAngle = IccDrawMathService.getLineInfo([
                        circleCenter,
                        innerPoly[nextInner],
                    ]).angle;
                    const currOuterAngle = IccDrawMathService.getLineInfo([
                        circleCenter,
                        outerPoly[currOuter],
                    ]).angle;
                    const nextOuterAngle = IccDrawMathService.getLineInfo([
                        circleCenter,
                        outerPoly[nextOuter],
                    ]).angle;
                    if (currInnerAngle <= currOuterAngle && nextInnerAngle >= nextOuterAngle) {
                        poly[currInner] = currOuter;
                        break;
                    }
                }
            }
        }
        return poly;
    }
    static getPerimeterFromPoly(poly) {
        let perimeter = 0;
        if (poly.length < 2) {
            return 0;
        }
        for (let i = 0, j = 1; i < poly.length; ++i, ++j, j %= poly.length) {
            perimeter += this.getLineInfo([poly[i], poly[j]]).length;
        }
        return Number(perimeter) || 0;
    }
    static getPerimeterFromRect(rect) {
        return (Number(rect.width) + Number(rect.height)) * 2 || 0;
    }
    static getPolyFromRect(rect) {
        return [
            { x: rect.x, y: rect.y },
            { x: rect.x, y: rect.y + rect.height },
            { x: rect.x + rect.width, y: rect.y + rect.height },
            { x: rect.x + rect.width, y: rect.y },
        ];
    }
    static getPolyFromShape(shape, parentRect) {
        let polygon = [];
        switch (shape.shape) {
            case 'arc':
                polygon = this.getPolyFromArcShape(shape);
                break;
            case 'circle':
                polygon.push({ cr: shape.d / 2, x: 0, y: shape.d / 2 });
                polygon.push({ cr: shape.d / 2, x: shape.d / 2, y: shape.d });
                polygon.push({ cr: shape.d / 2, x: shape.d, y: shape.d / 2 });
                polygon.push({ cr: shape.d / 2, x: shape.d / 2, y: 0 });
                break;
            default:
                polygon.push({ x: 0, y: shape.h1 });
                polygon.push({ x: shape.s1 + shape.s2 + shape.s3, y: shape.h1 });
                polygon.push({ x: shape.s1 + shape.s2 + shape.s3, y: shape.h1 - shape.h2 });
                polygon.push({ x: shape.s1 + shape.s2, y: 0 });
                polygon.push({ x: shape.s1, y: 0 });
                polygon.push({ x: 0, y: shape.h1 - shape.h3 });
                break;
        }
        polygon = polygon.filter((o, i, s) => s.findIndex(t => t.x === o.x && t.y === o.y) === i);
        polygon.forEach(p => {
            p.x += parentRect.x;
            p.y += parentRect.y;
        });
        return polygon;
    }
    static getPolyFromArcShape(shape) {
        let circle = {};
        const polygon = [];
        shape.s1 = shape.s1 || shape.width;
        polygon.push({ x: 0, y: shape.h1 + shape.h2 });
        polygon.push({ x: shape.s1, y: shape.h1 + shape.h2 });
        switch (shape.type) {
            case 'F':
                circle = this.getCircleRadius({ x: shape.s1, y: shape.h2 }, { x: shape.s1 / 2, y: 0 }, { x: 0, y: shape.h2 });
                polygon.push({ x: shape.s1, y: shape.h2 });
                polygon.push({ cr: circle.rx, x: shape.s1 / 2, y: 0 });
                polygon.push({ cr: circle.rx, x: 0, y: shape.h2 });
                break;
            case 'R':
                if (shape.s1 >= shape.h2) {
                    circle = this.getCircleRadius({ x: shape.s1, y: shape.h2 }, { x: 0, y: 0 }, { x: -shape.s1, y: shape.h2 });
                }
                else {
                    circle = this.getCircleRadius({ x: shape.s1, y: shape.h2 }, { x: 0, y: 0 }, { x: shape.s1, y: -shape.h2 });
                }
                polygon.push({ x: shape.s1, y: shape.h2 });
                polygon.push({ cr: circle.rx || circle.ry, x: 0, y: 0 });
                break;
            case 'L':
                if (shape.s1 >= shape.h2) {
                    circle = this.getCircleRadius({ x: shape.s1 * 2, y: shape.h2 }, { x: shape.s1, y: 0 }, { x: 0, y: shape.h2 });
                }
                else {
                    circle = this.getCircleRadius({ x: shape.s1 * 2, y: shape.h2 }, { x: shape.s1, y: 0 }, { x: shape.s1 * 2, y: -shape.h2 });
                }
                polygon.push({ x: shape.s1, y: 0 });
                polygon.push({ cr: circle.rx || circle.ry, x: 0, y: shape.h2 });
                break;
        }
        if (!shape.h1) {
            polygon.unshift(polygon.pop());
        }
        return polygon;
    }
    static getPolyShift(oldPolygon, shift) {
        const newLines = [];
        const newPolygon = [];
        for (let curr = 0, next = 1; curr < oldPolygon.length; ++curr, ++next, next %= oldPolygon.length) {
            const oldLine = [oldPolygon[curr], oldPolygon[next]];
            const newLine = this.getLineShift(oldLine, Array.isArray(shift) ? shift[curr] : shift);
            newLines.push(newLine);
        }
        for (let curr = 0, prev = oldPolygon.length - 1; curr < oldPolygon.length; ++curr, ++prev, prev %= oldPolygon.length) {
            const intersection = this.getLinesIntersection(newLines[prev], newLines[curr]);
            newPolygon.push(intersection);
        }
        const newRect = this.getRectFromPoly(newPolygon);
        let top, left, right, bottom;
        for (let curr = 0, next = 1; curr < newPolygon.length; ++curr, ++next, next %= newPolygon.length) {
            const info = this.getLineInfo([newPolygon[curr], newPolygon[next]]);
            switch (info.angle) {
                case 0:
                    bottom = newPolygon[curr].y;
                    break;
                case 1:
                    top = newPolygon[curr].y;
                    break;
                case 0.5:
                    left = newPolygon[curr].x;
                    break;
                case 1.5:
                    right = newPolygon[curr].x;
                    break;
            }
        }
        for (let curr = 0, next = 1; curr < newPolygon.length; ++curr, ++next, next %= newPolygon.length) {
            newPolygon[curr].x = Math.max(newPolygon[curr].x, left || newRect.x);
            newPolygon[curr].x = Math.min(newPolygon[curr].x, right || newRect.x + newRect.width);
            newPolygon[curr].y = Math.max(newPolygon[curr].y, top || newRect.y);
            newPolygon[curr].y = Math.min(newPolygon[curr].y, bottom || newRect.y + newRect.height);
        }
        return newPolygon.filter((o, i, s) => s.findIndex(t => this.round(t.x) === this.round(o.x) && this.round(t.y) === this.round(o.y)) === i);
    }
    static getPolygons(outerPoly, innerPoly, jointAngle = []) {
        var _a, _b;
        const joints = [];
        const polygons = [];
        const length = innerPoly.length;
        const polygonLineMap = {};
        for (let a = length - 1, b = 0, c = 1; b < length; ++a, ++b, ++c, a %= length, c %= length) {
            joints[b] = null;
            if (jointAngle[b] === 'L') {
                joints[b] = IccDrawMathService.getLinesIntersection([innerPoly[a], innerPoly[b]], [outerPoly[b], outerPoly[c]]);
            }
            if (jointAngle[b] === 'R') {
                joints[b] = IccDrawMathService.getLinesIntersection([innerPoly[b], innerPoly[c]], [outerPoly[a], outerPoly[b]]);
            }
        }
        if (outerPoly.length !== length) {
            return { polygons, polygonLineMap };
        }
        let d = 0;
        for (let a = length - 1, b = 0, c = 1; b < length; ++a, ++b, ++c, a %= length, c %= length) {
            if (b > 0 && outerPoly[b].cr && outerPoly[c].cr) {
                polygons[polygons.length - 1].splice(polygons[polygons.length - 1].length - d - 2, 1, {
                    x: joints[c] && jointAngle[c] === 'R' ? joints[c].x : outerPoly[c].x,
                    y: joints[c] && jointAngle[c] === 'R' ? joints[c].y : outerPoly[c].y,
                    cr: outerPoly[c].cr,
                    cw: false,
                }, {
                    x: joints[c] && jointAngle[c] === 'L' ? joints[c].x : innerPoly[c].x,
                    y: joints[c] && jointAngle[c] === 'L' ? joints[c].y : innerPoly[c].y,
                    onlyMove: b === length - 1 && outerPoly[0].cr && outerPoly[1].cr,
                }, {
                    x: joints[b] && jointAngle[b] === 'R' ? joints[b].x : innerPoly[b].x,
                    y: joints[b] && jointAngle[b] === 'R' ? joints[b].y : innerPoly[b].y,
                    cr: innerPoly[c].cr,
                    cw: true,
                });
                d++;
            }
            else {
                d = 0;
                polygons.push([
                    {
                        x: joints[b] && jointAngle[b] === 'L' ? joints[b].x : outerPoly[b].x,
                        y: joints[b] && jointAngle[b] === 'L' ? joints[b].y : outerPoly[b].y,
                    },
                    {
                        x: joints[c] && jointAngle[c] === 'R' ? joints[c].x : outerPoly[c].x,
                        y: joints[c] && jointAngle[c] === 'R' ? joints[c].y : outerPoly[c].y,
                        cr: outerPoly[c].cr,
                        cw: false,
                    },
                    {
                        x: joints[c] && jointAngle[c] === 'L' ? joints[c].x : innerPoly[c].x,
                        y: joints[c] && jointAngle[c] === 'L' ? joints[c].y : innerPoly[c].y,
                    },
                    {
                        x: joints[b] && jointAngle[b] === 'R' ? joints[b].x : innerPoly[b].x,
                        y: joints[b] && jointAngle[b] === 'R' ? joints[b].y : innerPoly[b].y,
                        cr: innerPoly[c].cr,
                        cw: true,
                    },
                ]);
            }
            polygonLineMap[b] = polygons.length - 1;
        }
        if (((_a = outerPoly[0]) === null || _a === void 0 ? void 0 : _a.cr) && ((_b = outerPoly[1]) === null || _b === void 0 ? void 0 : _b.cr) && polygons.length > 1) {
            const lastPolygons = polygons.splice(polygons.length - 1, 1);
            const lastPolygon = lastPolygons[0];
            let replaceIndex = lastPolygon.length - 2;
            for (let i = lastPolygon.length - 1; i >= 0; i--) {
                if (!lastPolygon[i].cr) {
                    replaceIndex = i;
                    break;
                }
            }
            polygons[0].shift();
            lastPolygon.splice(replaceIndex, 1, ...polygons[0]);
            polygons.splice(0, 1, lastPolygon);
            Object.keys(polygonLineMap)
                .filter(key => polygonLineMap[key] > polygons.length - 1)
                .forEach(key => (polygonLineMap[key] = 0));
        }
        return { polygons, polygonLineMap };
    }
    static getRectFromPoly(poly) {
        const minX = Math.min.apply(Math, poly.map(o => o.x));
        const minY = Math.min.apply(Math, poly.map(o => o.y));
        const maxX = Math.max.apply(Math, poly.map(o => o.x));
        const maxY = Math.max.apply(Math, poly.map(o => o.y));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    }
    static increaseRectPolyLength(poly, increaseBy) {
        const maxY = Math.max.apply(Math, poly.map(o => o.y));
        poly.filter(point => point.y == maxY).map(p => Object.assign(p, { y: maxY + increaseBy }));
        return poly;
    }
    static getRectShift(rect, shift) {
        return {
            x: rect.x + (Number(shift.left) || 0),
            y: rect.y + (Number(shift.top) || 0),
            width: rect.width - (Number(shift.left) || 0) - (Number(shift.right) || 0),
            height: rect.height - (Number(shift.top) || 0) - (Number(shift.bottom) || 0),
        };
    }
    static getRelativePosition(outerRect, innerRect, side) {
        let position = {};
        let relative = {};
        position.top = ((innerRect.y - outerRect.y) * 100) / (outerRect.height - outerRect.y);
        position.left = ((innerRect.x - outerRect.x) * 100) / (outerRect.width - outerRect.x);
        position.right =
            100
                - position.left
                - ((innerRect.width - outerRect.x) * 100) / (outerRect.width - outerRect.x);
        position.bottom =
            100
                - position.top
                - ((innerRect.height - outerRect.y) * 100) / (outerRect.height - outerRect.y);
        Object.keys(position).map(key => {
            relative[key] = `${this.round(position[key])}%`;
        });
        if (side === 'outer') {
            relative = {
                top: relative.top,
                left: relative.right,
                right: relative.left,
                bottom: relative.bottom,
            };
        }
        return relative;
    }
    static intersectLineWithPoly(line, poly) {
        const rect = this.getRectFromPoly(poly);
        for (let curr = 0, next = 1; curr < poly.length; curr++, next++, next %= poly.length) {
            const intersection = this.getLinesIntersection(line, [poly[curr], poly[next]]);
            if (Number.isFinite(intersection.x)
                && Number.isFinite(intersection.y) &&
                // && rect.x <= intersection.x && intersection.x <= rect.x + rect.width
                rect.y <= intersection.y
                && intersection.y <= rect.y + rect.height) {
                const info = this.getLineInfo([poly[curr], poly[next]]);
                const info0 = this.getLineInfo([poly[curr], line[0]]);
                const info1 = this.getLineInfo([poly[curr], line[1]]);
                if ((2 + info0.angle - info.angle) % 2 < 1) {
                    line[0] = intersection;
                }
                if ((2 + info1.angle - info.angle) % 2 < 1) {
                    line[1] = intersection;
                }
            }
        }
        return line;
    }
    static getPolyRangeInPerpendicularLine(poly, size, axis) {
        poly = poly.map(i => {
            return {
                x: i === null || i === void 0 ? void 0 : i.width,
                y: i === null || i === void 0 ? void 0 : i.height
            };
        });
        const sortedPoly = Array.from(new Set(poly)).sort((a, b) => {
            return Number(a[axis]) > Number(b[axis]) ? 1 : -1;
        });
        const perpendicularAxis = axis === "x" ? "y" : "x";
        const polyMinValue = sortedPoly[0][axis];
        const polyMaxValue = sortedPoly[(poly === null || poly === void 0 ? void 0 : poly.length) - 1][axis];
        const line = axis === 'x' ? [
            { x: 0, y: size },
            { x: Number.MAX_SAFE_INTEGER, y: size }
        ] : [
            { x: size, y: 0 },
            { x: size, y: Number.MAX_SAFE_INTEGER }
        ];
        let intersections = [];
        for (let i = 0; i < poly.length; i++) {
            let intersection;
            if (poly[i + 1]) {
                intersection = this.getLinesIntersection([poly[i], poly[i + 1]], line);
                if (this.isValueInRange([poly[i][perpendicularAxis], poly[i + 1][perpendicularAxis]], intersection[perpendicularAxis])) {
                    intersections.push(intersection);
                }
            }
            else {
                intersection = this.getLinesIntersection([poly[i], poly[0]], line);
                if (this.isValueInRange([poly[i][perpendicularAxis], poly[0][perpendicularAxis]], intersection[perpendicularAxis])) {
                    intersections.push(intersection);
                }
            }
        }
        intersections = intersections.filter(item => (item === null || item === void 0 ? void 0 : item.x) && (item === null || item === void 0 ? void 0 : item.y) && item[axis] >= polyMinValue && item[axis] <= polyMaxValue).sort((a, b) => {
            return a[axis] < b[axis] ? -1 : 1;
        });
        const concatIntersections = [];
        intersections = intersections.map(i => Math.round(i[axis]));
        for (let i = 0; i < (intersections === null || intersections === void 0 ? void 0 : intersections.length); i += 2) {
            concatIntersections.push([intersections[i], intersections[i + 1]]);
        }
        return (concatIntersections === null || concatIntersections === void 0 ? void 0 : concatIntersections.length) ? concatIntersections : null;
    }
    static isValueInRange(rangeArr, value) {
        rangeArr = rangeArr.map(item => Number(item)).sort((a, b) => a < b ? -1 : 1);
        return value >= rangeArr[0] && value <= rangeArr[1];
    }
    static intersectPolyWithLine(poly, line, side) {
        let polygon = [];
        for (let curr = 0, next = 1; curr < poly.length; curr++, next++, next %= poly.length) {
            const isInside = [];
            switch (side) {
                case 'top':
                    isInside[0] = poly[curr].y <= line[0].y;
                    isInside[1] = poly[next].y <= line[0].y;
                    break;
                case 'left':
                    isInside[0] = poly[curr].x <= line[0].x;
                    isInside[1] = poly[next].x <= line[0].x;
                    break;
                case 'right':
                    isInside[0] = poly[curr].x >= line[0].x;
                    isInside[1] = poly[next].x >= line[0].x;
                    break;
                case 'bottom':
                    isInside[0] = poly[curr].y >= line[0].y;
                    isInside[1] = poly[next].y >= line[0].y;
                    break;
            }
            if (isInside[0] && isInside[1]) {
                polygon.push(poly[curr]);
                polygon.push(poly[next]);
            }
            if (isInside[0] && !isInside[1]) {
                polygon.push(poly[curr]);
                polygon.push(this.getLinesIntersection([poly[curr], poly[next]], line));
            }
            if (!isInside[0] && isInside[1]) {
                polygon.push(this.getLinesIntersection(line, [poly[curr], poly[next]]));
                polygon.push(poly[next]);
            }
        }
        polygon = polygon.filter((o, i, s) => s.findIndex(t => this.round(t.x) === this.round(o.x) && this.round(t.y) === this.round(o.y)) === i);
        return polygon;
    }
    static intersectPolyWithRect(poly, rect) {
        rect = this.getPolyFromRect(rect);
        poly = this.intersectPolyWithLine(poly, [rect[0], rect[1]], 'right');
        poly = this.intersectPolyWithLine(poly, [rect[1], rect[2]], 'top');
        poly = this.intersectPolyWithLine(poly, [rect[2], rect[3]], 'left');
        poly = this.intersectPolyWithLine(poly, [rect[3], rect[0]], 'bottom');
        poly = this.sortPoly(poly);
        return poly;
    }
    static intersectPolyWithRectPoly(poly, rectPoly) {
        poly = this.intersectPolyWithLine(poly, [rectPoly[0], rectPoly[1]], 'right');
        poly = this.intersectPolyWithLine(poly, [rectPoly[1], rectPoly[2]], 'top');
        poly = this.intersectPolyWithLine(poly, [rectPoly[2], rectPoly[3]], 'left');
        poly = this.intersectPolyWithLine(poly, [rectPoly[3], rectPoly[0]], 'bottom');
        poly = this.sortPoly(poly);
        return poly;
    }
    static rotatePoly(poly, center, angle) {
        const cos = Math.cos(angle * Math.PI);
        const sin = Math.sin(angle * Math.PI);
        poly = poly.map(point => {
            return {
                cr: point.cr,
                x: cos * (point.x - center.x) - sin * (point.y - center.y) + center.x,
                y: sin * (point.x - center.x) + cos * (point.y - center.y) + center.y,
            };
        });
        return poly;
    }
    static rotateRect(rect, rotation) {
        let rectPoly = IccDrawMathService.getPolyFromRect(rect);
        rectPoly = IccDrawMathService.rotatePoly(rectPoly, rectPoly[0], rotation);
        return rectPoly;
    }
    static sortPoly(poly) {
        const min = Math.min(...poly.map(o => o.x));
        for (let curr = 0, next = 1; curr < poly.length; curr++, next++, next %= poly.length) {
            if (curr > 0 && poly[curr].x === min && poly[next].x > min) {
                poly.push(...poly.splice(0, curr));
                break;
            }
        }
        return poly;
    }
    static round(value, decimal = 2) {
        value = Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
        return value;
    }
    static movePoly(poly, shift) {
        const newPoly = poly.map(p => {
            const movedP = Object.assign({}, p);
            movedP.x += shift.x;
            movedP.y += shift.y;
            return movedP;
        });
        return newPoly;
    }
    static getJointAngles(polygon, jointAnglesOption, shape = 'rect', profilesJointAngles = []) {
        let angles = [];
        for (let a = polygon.length - 1, b = 0, c = 1; b < polygon.length; ++a, ++b, ++c, a %= polygon.length, c %= polygon.length) {
            const line = [polygon[b], polygon[c]];
            const prevLine = [polygon[a], polygon[b]];
            const info = IccDrawMathService.getLineInfo(line, polygon);
            const prevInfo = IccDrawMathService.getLineInfo(prevLine, polygon);
            let joint = 'E';
            const profileJointAngle = profilesJointAngles && profilesJointAngles[b] || jointAnglesOption;
            if (profileJointAngle === 'E_E_E_E'
                || (shape === 'arc' && info.side !== 'bottom' && prevInfo.side !== 'bottom')) {
                joint = 'E';
            }
            else if (profileJointAngle === 'L_L_L_L') {
                joint = 'L';
            }
            else if (profileJointAngle === 'R_R_R_R') {
                joint = 'R';
            }
            else if (profileJointAngle === 'R_L_R_L') {
                joint =
                    IccDrawMathService.getRLRLJointAngle(b, info.side, info.angle, prevInfo.side, prevInfo.angle, polygon.length) || 'E';
            }
            else if (profileJointAngle === 'L_R_L_R') {
                joint =
                    IccDrawMathService.getLRLRJointAngle(b, info.side, info.angle, prevInfo.side, prevInfo.angle, polygon.length) || 'R';
            }
            angles.push(joint);
        }
        return angles;
    }
    static getRLRLJointAngle(index, side, angle, prevSide, prevAngle, polygonLength) {
        if (side === 'bottom') {
            return 'R';
        }
        else {
            if (prevSide == 'left') {
                return 'E';
            }
            else if (prevSide == 'bottom') {
                return 'L';
            }
            else if (prevSide === 'right') {
                if (side === 'right') {
                    return 'E';
                }
                else if (side === 'left') {
                    if (prevAngle === 1.5 && angle > 0.5 && angle < 1) {
                        return 'R';
                    }
                    return 'L';
                }
                else if (side === 'top') {
                    if (index == 3 && polygonLength - index + 1 == 1) {
                        return 'L';
                    }
                    return 'R';
                }
            }
            else {
                if (index == 4 && polygonLength - index + 1 == 0) {
                    return 'R';
                }
                return 'L';
            }
        }
    }
    static getLRLRJointAngle(index, side, angle, prevSide, prevAngle, polygonLength) {
        if (side === 'bottom') {
            return 'L';
        }
        else if (prevSide === 'bottom' || index == 4 || index == 5) {
            return 'R';
        }
        else if (prevSide === 'right' && side !== 'left') {
            return 'L';
        }
        else if (index == 3) {
            return 'R';
        }
        else if ((index == 2 && polygonLength - index + 1 == 1)
            || (prevAngle === 1.5 && angle > 0.5 && angle < 1)) {
            return 'L';
        }
        else {
            return 'R';
        }
    }
}

class SvgGradient {
    constructor(params = {}) {
        this.x1 = 0.5;
        this.x2 = 0;
        this.y1 = 1;
        this.y2 = 0;
        this.gradientTransform = null;
        this.id = null;
        this.steps = [];
        Object.assign(this, params);
    }
}
class SvgPattern {
    constructor(params = {}) {
        this.color = null;
        this.image = null;
        this.id = null;
        this.patternTransform = null;
        this.patternUnits = 'userSpaceOnUse';
        this.width = 1;
        this.height = 1;
        this.x = 0;
        this.y = 0;
        this.paths = [];
        Object.assign(this, params);
    }
}
class SvgPath {
    constructor(params = {}) {
        this.d = '';
        this.fill = 'transparent';
        this.stroke = null;
        this.strokeDasharray = null;
        this.strokeWidth = null;
        this.vectorEffect = 'non-scaling-stroke';
        Object.assign(this, params);
    }
}
class SvgText {
    constructor(params = {}) {
        this.dominantBaseline = 'central';
        this.fill = 'transparent';
        this.fontSize = null;
        this.stroke = null;
        this.strokeWidth = null;
        this.textAnchor = 'middle';
        this.transform = null;
        this.value = '';
        this.x = 0;
        this.y = 0;
        this.source = null;
        Object.assign(this, params);
    }
}
class IccDrawSvgService {
    static getGradient(params) {
        const svgGradient = new SvgGradient(params);
        return svgGradient;
    }
    static getPattern(params) {
        const svgPattern = new SvgPattern(params);
        return svgPattern;
    }
    static getPath(polygon, closedPath, side, params) {
        const svgPath = new SvgPath(params);
        // svgPath.fill = '#' + ((1<<24)*Math.random()|0).toString(16);
        if (polygon && polygon.length > 0) {
            if (closedPath) {
                polygon = [...polygon, polygon[0]];
            }
            svgPath.d = polygon.map((o, i) => {
                let { x, y, cr, cw, onlyMove } = o;
                if (side === 'outer') {
                    x = -x;
                    cw = !cw;
                }
                if (i === 0 || onlyMove) {
                    return `M ${x} ${y}`;
                }
                else if (cr) {
                    return `A ${cr} ${cr} 0 0 ${cw ? 1 : 0} ${x} ${y}`;
                }
                else {
                    return `L ${x} ${y}`;
                }
            }).join(' ');
        }
        return svgPath;
    }
    static getText(text, params) {
        const svgText = new SvgText(params);
        Object.assign(svgText, text);
        return svgText;
    }
}
var Layers;
(function (Layers) {
    Layers[Layers["Colors"] = 0] = "Colors";
    Layers[Layers["Base"] = 1] = "Base";
    Layers[Layers["Shape"] = 2] = "Shape";
    Layers[Layers["Shutter"] = 3] = "Shutter";
    Layers[Layers["ShutterBox"] = 4] = "ShutterBox";
    Layers[Layers["ShutterDrive"] = 5] = "ShutterDrive";
    Layers[Layers["Reno"] = 6] = "Reno";
    Layers[Layers["Extensions"] = 7] = "Extensions";
    Layers[Layers["RollerShutter"] = 8] = "RollerShutter";
    Layers[Layers["Glazing"] = 9] = "Glazing";
    Layers[Layers["Muntin"] = 10] = "Muntin";
    Layers[Layers["SashFrameOutside"] = 11] = "SashFrameOutside";
    Layers[Layers["Frame"] = 12] = "Frame";
    Layers[Layers["DowelHoles"] = 13] = "DowelHoles";
    Layers[Layers["Sash"] = 14] = "Sash";
    Layers[Layers["Alignment"] = 15] = "Alignment";
    Layers[Layers["Mullion"] = 16] = "Mullion";
    Layers[Layers["SashFrameInside"] = 17] = "SashFrameInside";
    Layers[Layers["OverlayInside"] = 18] = "OverlayInside";
    Layers[Layers["GlazingBead"] = 19] = "GlazingBead";
    Layers[Layers["Renson"] = 20] = "Renson";
    Layers[Layers["Ventilator"] = 21] = "Ventilator";
    Layers[Layers["Symbol"] = 22] = "Symbol";
    Layers[Layers["Handle"] = 23] = "Handle";
    Layers[Layers["Dimension"] = 24] = "Dimension";
    Layers[Layers["Indexes"] = 25] = "Indexes";
})(Layers || (Layers = {}));
var GarageDoorLayers;
(function (GarageDoorLayers) {
    GarageDoorLayers[GarageDoorLayers["Colors"] = 0] = "Colors";
    GarageDoorLayers[GarageDoorLayers["Base"] = 1] = "Base";
    GarageDoorLayers[GarageDoorLayers["Wall"] = 2] = "Wall";
    GarageDoorLayers[GarageDoorLayers["Panels"] = 3] = "Panels";
    GarageDoorLayers[GarageDoorLayers["Panel"] = 4] = "Panel";
    GarageDoorLayers[GarageDoorLayers["PanelPattern"] = 5] = "PanelPattern";
    GarageDoorLayers[GarageDoorLayers["Embossing"] = 6] = "Embossing";
    GarageDoorLayers[GarageDoorLayers["Inserts"] = 7] = "Inserts";
    GarageDoorLayers[GarageDoorLayers["PanelInsertContainer"] = 8] = "PanelInsertContainer";
    GarageDoorLayers[GarageDoorLayers["PanelInsertFrame"] = 9] = "PanelInsertFrame";
    GarageDoorLayers[GarageDoorLayers["PanelInsertFramePattern"] = 10] = "PanelInsertFramePattern";
    GarageDoorLayers[GarageDoorLayers["PanelInsert"] = 11] = "PanelInsert";
    GarageDoorLayers[GarageDoorLayers["WicketDoorFrame"] = 12] = "WicketDoorFrame";
    GarageDoorLayers[GarageDoorLayers["WicketDoorHandle"] = 13] = "WicketDoorHandle";
    GarageDoorLayers[GarageDoorLayers["WicketDoor"] = 14] = "WicketDoor";
    GarageDoorLayers[GarageDoorLayers["Dimension"] = 15] = "Dimension";
    GarageDoorLayers[GarageDoorLayers["Indexes"] = 16] = "Indexes";
})(GarageDoorLayers || (GarageDoorLayers = {}));

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// used strictly for logging the processing of the algorithm... only useful if you intend on
// looking under the covers (for pretty UI's or debugging)
//
function BuildLog() {
    let nextSegmentId = 0;
    let curVert = false;
    const my = {
        list: [],
        segmentId: function () {
            return nextSegmentId++;
        },
        checkIntersection: function (seg1, seg2) {
            return push('check', { seg1: seg1, seg2: seg2 });
        },
        segmentChop: function (seg, end) {
            push('div_seg', { seg: seg, pt: end });
            return push('chop', { seg: seg, pt: end });
        },
        statusRemove: function (seg) {
            return push('pop_seg', { seg: seg });
        },
        segmentUpdate: function (seg) {
            return push('seg_update', { seg: seg });
        },
        segmentNew: function (seg, primary) {
            return push('new_seg', { seg: seg, primary: primary });
        },
        segmentRemove: function (seg) {
            return push('rem_seg', { seg: seg });
        },
        tempStatus: function (seg, above, below) {
            return push('temp_status', { seg: seg, above: above, below: below });
        },
        rewind: function (seg) {
            return push('rewind', { seg: seg });
        },
        status: function (seg, above, below) {
            return push('status', { seg: seg, above: above, below: below });
        },
        vert: function (x) {
            if (x === curVert) {
                return my;
            }
            curVert = x;
            return push('vert', { x: x });
        },
        log: function (data) {
            if (typeof data !== 'string') {
                data = JSON.stringify(data, null, '  ');
            }
            return push('log', { txt: data });
        },
        reset: function () {
            return push('reset');
        },
        selected: function (segs) {
            return push('selected', { segs: segs });
        },
        chainStart: function (seg) {
            return push('chain_start', { seg: seg });
        },
        chainRemoveHead: function (index, pt) {
            return push('chain_rem_head', { index: index, pt: pt });
        },
        chainRemoveTail: function (index, pt) {
            return push('chain_rem_tail', { index: index, pt: pt });
        },
        chainNew: function (pt1, pt2) {
            return push('chain_new', { pt1: pt1, pt2: pt2 });
        },
        chainMatch: function (index) {
            return push('chain_match', { index: index });
        },
        chainClose: function (index) {
            return push('chain_close', { index: index });
        },
        chainAddHead: function (index, pt) {
            return push('chain_add_head', { index: index, pt: pt });
        },
        chainAddTail: function (index, pt) {
            return push('chain_add_tail', { index: index, pt: pt });
        },
        chainConnect: function (index1, index2) {
            return push('chain_con', { index1: index1, index2: index2 });
        },
        chainReverse: function (index) {
            return push('chain_rev', { index: index });
        },
        chainJoin: function (index1, index2) {
            return push('chain_join', { index1: index1, index2: index2 });
        },
        done: function () {
            return push('done');
        },
    };
    return my;
    function push(type, data) {
        my.list.push({
            type: type,
            data: data ? JSON.parse(JSON.stringify(data)) : void 0,
        });
        return my;
    }
}

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// provides the raw computation functions that takes epsilon into account
//
// zero is defined to be between (-epsilon, epsilon) exclusive
//
class Epsilon {
    static pointAboveOrOnLine(pt, left, right) {
        const Ax = left[0];
        const Ay = left[1];
        const Bx = right[0];
        const By = right[1];
        const Cx = pt[0];
        const Cy = pt[1];
        return (Bx - Ax) * (Cy - Ay) - (By - Ay) * (Cx - Ax) >= -Epsilon.epsilon;
    }
    static pointBetween(p, left, right) {
        // p must be collinear with left->right
        // returns false if p == left, p == right, or left == right
        const d_py_ly = p[1] - left[1];
        const d_rx_lx = right[0] - left[0];
        const d_px_lx = p[0] - left[0];
        const d_ry_ly = right[1] - left[1];
        const dot = d_px_lx * d_rx_lx + d_py_ly * d_ry_ly;
        // if `dot` is 0, then `p` == `left` or `left` == `right` (reject)
        // if `dot` is less than 0, then `p` is to the left of `left` (reject)
        if (dot < Epsilon.epsilon) {
            return false;
        }
        const sqlen = d_rx_lx * d_rx_lx + d_ry_ly * d_ry_ly;
        // if `dot` > `sqlen`, then `p` is to the right of `right` (reject)
        // therefore, if `dot - sqlen` is greater than 0, then `p` is to the right of `right` (reject)
        if (dot - sqlen > -Epsilon.epsilon) {
            return false;
        }
        return true;
    }
    static pointsSameX(p1, p2) {
        return Math.abs(p1[0] - p2[0]) < Epsilon.epsilon;
    }
    static pointsSameY(p1, p2) {
        return Math.abs(p1[1] - p2[1]) < Epsilon.epsilon;
    }
    static pointsSame(p1, p2) {
        return Epsilon.pointsSameX(p1, p2) && Epsilon.pointsSameY(p1, p2);
    }
    static pointsCompare(p1, p2) {
        // returns -1 if p1 is smaller, 1 if p2 is smaller, 0 if equal
        if (Epsilon.pointsSameX(p1, p2)) {
            return Epsilon.pointsSameY(p1, p2) ? 0 : p1[1] < p2[1] ? -1 : 1;
        }
        return p1[0] < p2[0] ? -1 : 1;
    }
    static pointsCollinear(pt1, pt2, pt3) {
        // does pt1->pt2->pt3 make a straight line?
        // essentially this is just checking to see if the slope(pt1->pt2) === slope(pt2->pt3)
        // if slopes are equal, then they must be collinear, because they share pt2
        const dx1 = pt1[0] - pt2[0];
        const dy1 = pt1[1] - pt2[1];
        const dx2 = pt2[0] - pt3[0];
        const dy2 = pt2[1] - pt3[1];
        return Math.abs(dx1 * dy2 - dx2 * dy1) < Epsilon.epsilon;
    }
    static linesIntersect(a0, a1, b0, b1) {
        // returns false if the lines are coincident (e.g., parallel or on top of each other)
        //
        // returns an object if the lines intersect:
        //   {
        //     pt: [x, y],    where the intersection point is at
        //     alongA: where intersection point is along A,
        //     alongB: where intersection point is along B
        //   }
        //
        //  alongA and alongB will each be one of: -2, -1, 0, 1, 2
        //
        //  with the following meaning:
        //
        //    -2   intersection point is before segment's first point
        //    -1   intersection point is directly on segment's first point
        //     0   intersection point is between segment's first and second points (exclusive)
        //     1   intersection point is directly on segment's second point
        //     2   intersection point is after segment's second point
        const adx = a1[0] - a0[0];
        const ady = a1[1] - a0[1];
        const bdx = b1[0] - b0[0];
        const bdy = b1[1] - b0[1];
        const axb = adx * bdy - ady * bdx;
        if (Math.abs(axb) < Epsilon.epsilon) {
            return false;
        } // lines are coincident
        const dx = a0[0] - b0[0];
        const dy = a0[1] - b0[1];
        const A = (bdx * dy - bdy * dx) / axb;
        const B = (adx * dy - ady * dx) / axb;
        const ret = {
            alongA: 0,
            alongB: 0,
            pt: [a0[0] + A * adx, a0[1] + A * ady],
        };
        // categorize where intersection point is along A and B
        if (A <= -Epsilon.epsilon) {
            ret.alongA = -2;
        }
        else if (A < Epsilon.epsilon) {
            ret.alongA = -1;
        }
        else if (A - 1 <= -Epsilon.epsilon) {
            ret.alongA = 0;
        }
        else if (A - 1 < Epsilon.epsilon) {
            ret.alongA = 1;
        }
        else {
            ret.alongA = 2;
        }
        if (B <= -Epsilon.epsilon) {
            ret.alongB = -2;
        }
        else if (B < Epsilon.epsilon) {
            ret.alongB = -1;
        }
        else if (B - 1 <= -Epsilon.epsilon) {
            ret.alongB = 0;
        }
        else if (B - 1 < Epsilon.epsilon) {
            ret.alongB = 1;
        }
        else {
            ret.alongB = 2;
        }
        return ret;
    }
    static pointInsideRegion(pt, region) {
        const x = pt[0];
        const y = pt[1];
        let last_x = region[region.length - 1][0];
        let last_y = region[region.length - 1][1];
        let inside = false;
        for (let i = 0; i < region.length; i++) {
            const curr_x = region[i][0];
            const curr_y = region[i][1];
            // if y is between curr_y and last_y, and
            // x is to the right of the boundary created by the line
            if (curr_y - y > Epsilon.epsilon !== last_y - y > Epsilon.epsilon
                && ((last_x - curr_x) * (y - curr_y)) / (last_y - curr_y) + curr_x - x > Epsilon.epsilon) {
                inside = !inside;
            }
            last_x = curr_x;
            last_y = curr_y;
        }
        return inside;
    }
}
Epsilon.epsilon = 0.0000000001;

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// simple linked list implementation that allows you to traverse down nodes and save positions
//
class LinkedList {
    constructor() {
        this.root = {
            root: true,
            next: null,
        };
    }
    static create() {
        return new LinkedList();
    }
    static node(data) {
        data.prev = null;
        data.next = null;
        data.remove = function () {
            data.prev.next = data.next;
            if (data.next) {
                data.next.prev = data.prev;
            }
            data.prev = null;
            data.next = null;
        };
        return data;
    }
    exists(node) {
        if (node === null || node === this.root) {
            return false;
        }
        return true;
    }
    isEmpty() {
        return this.root.next === null;
    }
    getHead() {
        return this.root.next;
    }
    insertBefore(node, check) {
        let last = this.root;
        let here = this.root.next;
        while (here !== null) {
            if (check(here)) {
                node.prev = here.prev;
                node.next = here;
                here.prev.next = node;
                here.prev = node;
                return;
            }
            last = here;
            here = here.next;
        }
        last.next = node;
        node.prev = last;
        node.next = null;
    }
    findTransition(check) {
        let prev = this.root;
        let here = this.root.next;
        while (here !== null) {
            if (check(here)) {
                break;
            }
            prev = here;
            here = here.next;
        }
        return {
            before: prev === this.root ? null : prev,
            after: here,
            insert: function (node) {
                node.prev = prev;
                node.next = here;
                prev.next = node;
                if (here !== null) {
                    here.prev = node;
                }
                return node;
            },
        };
    }
}

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
function Intersecter(selfIntersection, buildLog) {
    // selfIntersection is true/false depending on the phase of the overall algorithm
    //
    // segment creation
    //
    function segmentNew(start, end) {
        return {
            id: buildLog ? buildLog.segmentId() : -1,
            start: start,
            end: end,
            myFill: {
                above: null,
                below: null,
            },
            otherFill: null,
        };
    }
    function segmentCopy(start, end, seg) {
        return {
            id: buildLog ? buildLog.segmentId() : -1,
            start: start,
            end: end,
            myFill: {
                above: seg.myFill.above,
                below: seg.myFill.below,
            },
            otherFill: null,
        };
    }
    //
    // event logic
    //
    const event_root = LinkedList.create();
    function eventCompare(p1_isStart, p1_1, p1_2, p2_isStart, p2_1, p2_2) {
        // compare the selected points first
        const comp = Epsilon.pointsCompare(p1_1, p2_1);
        if (comp !== 0) {
            return comp;
        }
        // the selected points are the same
        if (Epsilon.pointsSame(p1_2, p2_2)) {
            // if the non-selected points are the same too...
            return 0;
        } // then the segments are equal
        if (p1_isStart !== p2_isStart) {
            // if one is a start and the other isn't...
            return p1_isStart ? 1 : -1;
        } // favor the one that isn't the start
        // otherwise, we'll have to calculate which one is below the other manually
        return Epsilon.pointAboveOrOnLine(p1_2, p2_isStart ? p2_1 : p2_2, // order matters
        p2_isStart ? p2_2 : p2_1)
            ? 1
            : -1;
    }
    function eventAdd(ev, other_pt) {
        event_root.insertBefore(ev, function (here) {
            // should ev be inserted before here?
            const comp = eventCompare(ev.isStart, ev.pt, other_pt, here.isStart, here.pt, here.other.pt);
            return comp < 0;
        });
    }
    function eventAddSegmentStart(seg, primary) {
        const ev_start = LinkedList.node({
            isStart: true,
            pt: seg.start,
            seg: seg,
            primary: primary,
            other: null,
            status: null,
        });
        eventAdd(ev_start, seg.end);
        return ev_start;
    }
    function eventAddSegmentEnd(ev_start, seg, primary) {
        const ev_end = LinkedList.node({
            isStart: false,
            pt: seg.end,
            seg: seg,
            primary: primary,
            other: ev_start,
            status: null,
        });
        ev_start.other = ev_end;
        eventAdd(ev_end, ev_start.pt);
    }
    function eventAddSegment(seg, primary) {
        const ev_start = eventAddSegmentStart(seg, primary);
        eventAddSegmentEnd(ev_start, seg, primary);
        return ev_start;
    }
    function eventUpdateEnd(ev, end) {
        // slides an end backwards
        //   (start)------------(end)    to:
        //   (start)---(end)
        if (buildLog) {
            buildLog.segmentChop(ev.seg, end);
        }
        ev.other.remove();
        ev.seg.end = end;
        ev.other.pt = end;
        eventAdd(ev.other, ev.pt);
    }
    function eventDivide(ev, pt) {
        const ns = segmentCopy(pt, ev.seg.end, ev.seg);
        eventUpdateEnd(ev, pt);
        return eventAddSegment(ns, ev.primary);
    }
    function calculate(primaryPolyInverted, secondaryPolyInverted) {
        // if selfIntersection is true then there is no secondary polygon, so that isn't used
        //
        // status logic
        //
        const status_root = LinkedList.create();
        function statusCompare(ev1, ev2) {
            const a1 = ev1.seg.start;
            const a2 = ev1.seg.end;
            const b1 = ev2.seg.start;
            const b2 = ev2.seg.end;
            if (Epsilon.pointsCollinear(a1, b1, b2)) {
                if (Epsilon.pointsCollinear(a2, b1, b2)) {
                    return 1;
                } // eventCompare(true, a1, a2, true, b1, b2);
                return Epsilon.pointAboveOrOnLine(a2, b1, b2) ? 1 : -1;
            }
            return Epsilon.pointAboveOrOnLine(a1, b1, b2) ? 1 : -1;
        }
        function statusFindSurrounding(ev) {
            return status_root.findTransition(function (here) {
                const comp = statusCompare(ev, here.ev);
                return comp > 0;
            });
        }
        function checkIntersection(ev1, ev2) {
            // returns the segment equal to ev1, or false if nothing equal
            const seg1 = ev1.seg;
            const seg2 = ev2.seg;
            const a1 = seg1.start;
            const a2 = seg1.end;
            const b1 = seg2.start;
            const b2 = seg2.end;
            if (buildLog) {
                buildLog.checkIntersection(seg1, seg2);
            }
            const i = Epsilon.linesIntersect(a1, a2, b1, b2);
            if (i === false) {
                // segments are parallel or coincident
                // if points aren't collinear, then the segments are parallel, so no intersections
                if (!Epsilon.pointsCollinear(a1, a2, b1)) {
                    return false;
                }
                // otherwise, segments are on top of each other somehow (aka coincident)
                if (Epsilon.pointsSame(a1, b2) || Epsilon.pointsSame(a2, b1)) {
                    return false;
                } // segments touch at endpoints... no intersection
                const a1_equ_b1 = Epsilon.pointsSame(a1, b1);
                const a2_equ_b2 = Epsilon.pointsSame(a2, b2);
                if (a1_equ_b1 && a2_equ_b2) {
                    return ev2;
                } // segments are exactly equal
                const a1_between = !a1_equ_b1 && Epsilon.pointBetween(a1, b1, b2);
                const a2_between = !a2_equ_b2 && Epsilon.pointBetween(a2, b1, b2);
                // handy for debugging:
                // buildLog.log({
                // 	a1_equ_b1: a1_equ_b1,
                // 	a2_equ_b2: a2_equ_b2,
                // 	a1_between: a1_between,
                // 	a2_between: a2_between
                // });
                if (a1_equ_b1) {
                    if (a2_between) {
                        //  (a1)---(a2)
                        //  (b1)----------(b2)
                        eventDivide(ev2, a2);
                    }
                    else {
                        //  (a1)----------(a2)
                        //  (b1)---(b2)
                        eventDivide(ev1, b2);
                    }
                    return ev2;
                }
                else if (a1_between) {
                    if (!a2_equ_b2) {
                        // make a2 equal to b2
                        if (a2_between) {
                            //         (a1)---(a2)
                            //  (b1)-----------------(b2)
                            eventDivide(ev2, a2);
                        }
                        else {
                            //         (a1)----------(a2)
                            //  (b1)----------(b2)
                            eventDivide(ev1, b2);
                        }
                    }
                    //         (a1)---(a2)
                    //  (b1)----------(b2)
                    eventDivide(ev2, a1);
                }
            }
            else {
                // otherwise, lines intersect at i.pt, which may or may not be between the endpoints
                // is A divided between its endpoints? (exclusive)
                if (i.alongA === 0) {
                    if (i.alongB === -1) {
                        // yes, at exactly b1
                        eventDivide(ev1, b1);
                    }
                    else if (i.alongB === 0) {
                        // yes, somewhere between B's endpoints
                        eventDivide(ev1, i.pt);
                    }
                    else if (i.alongB === 1) {
                        // yes, at exactly b2
                        eventDivide(ev1, b2);
                    }
                }
                // is B divided between its endpoints? (exclusive)
                if (i.alongB === 0) {
                    if (i.alongA === -1) {
                        // yes, at exactly a1
                        eventDivide(ev2, a1);
                    }
                    else if (i.alongA === 0) {
                        // yes, somewhere between A's endpoints (exclusive)
                        eventDivide(ev2, i.pt);
                    }
                    else if (i.alongA === 1) {
                        // yes, at exactly a2
                        eventDivide(ev2, a2);
                    }
                }
            }
            return false;
        }
        //
        // main event loop
        //
        const segments = [];
        while (!event_root.isEmpty()) {
            const ev = event_root.getHead();
            if (buildLog) {
                buildLog.vert(ev.pt[0]);
            }
            if (ev.isStart) {
                if (buildLog) {
                    buildLog.segmentNew(ev.seg, ev.primary);
                }
                const surrounding = statusFindSurrounding(ev);
                const above = surrounding.before ? surrounding.before.ev : null;
                const below = surrounding.after ? surrounding.after.ev : null;
                if (buildLog) {
                    buildLog.tempStatus(ev.seg, above ? above.seg : false, below ? below.seg : false);
                }
                let eve = false;
                if (above) {
                    const even = checkIntersection(ev, above);
                    if (even) {
                        eve = even;
                    }
                }
                if (below) {
                    eve = checkIntersection(ev, below);
                }
                if (eve) {
                    // ev and eve are equal
                    // we'll keep eve and throw away ev
                    // merge ev.seg's fill information into eve.seg
                    if (selfIntersection) {
                        let toggle; // are we a toggling edge?
                        if (ev.seg.myFill.below === null) {
                            toggle = true;
                        }
                        else {
                            toggle = ev.seg.myFill.above !== ev.seg.myFill.below;
                        }
                        // merge two segments that belong to the same polygon
                        // think of this as sandwiching two segments together, where `eve.seg` is
                        // the bottom -- this will cause the above fill flag to toggle
                        if (toggle) {
                            eve.seg.myFill.above = !eve.seg.myFill.above;
                        }
                    }
                    else {
                        // merge two segments that belong to different polygons
                        // each segment has distinct knowledge, so no special logic is needed
                        // note that this can only happen once per segment in this phase, because we
                        // are guaranteed that all self-intersections are gone
                        eve.seg.otherFill = ev.seg.myFill;
                    }
                    if (buildLog) {
                        buildLog.segmentUpdate(eve.seg);
                    }
                    ev.other.remove();
                    ev.remove();
                }
                if (event_root.getHead() !== ev) {
                    // something was inserted before us in the event queue, so loop back around and
                    // process it before continuing
                    if (buildLog) {
                        buildLog.rewind(ev.seg);
                    }
                    continue;
                }
                //
                // calculate fill flags
                //
                if (selfIntersection) {
                    let toggle; // are we a toggling edge?
                    if (ev.seg.myFill.below === null) {
                        // if we are a new segment...
                        toggle = true;
                    }
                    else {
                        toggle = ev.seg.myFill.above !== ev.seg.myFill.below;
                    } // calculate toggle
                    // next, calculate whether we are filled below us
                    if (!below) {
                        // if nothing is below us...
                        // we are filled below us if the polygon is inverted
                        ev.seg.myFill.below = primaryPolyInverted;
                    }
                    else {
                        // otherwise, we know the answer -- it's the same if whatever is below
                        // us is filled above it
                        ev.seg.myFill.below = below.seg.myFill.above;
                    }
                    // since now we know if we're filled below us, we can calculate whether
                    // we're filled above us by applying toggle to whatever is below us
                    if (toggle) {
                        ev.seg.myFill.above = !ev.seg.myFill.below;
                    }
                    else {
                        ev.seg.myFill.above = ev.seg.myFill.below;
                    }
                }
                else {
                    // now we fill in any missing transition information, since we are all-knowing
                    // at this point
                    if (ev.seg.otherFill === null) {
                        // if we don't have other information, then we need to figure out if we're
                        // inside the other polygon
                        let inside;
                        if (!below) {
                            // if nothing is below us, then we're inside if the other polygon is
                            // inverted
                            inside = ev.primary ? secondaryPolyInverted : primaryPolyInverted;
                        }
                        else {
                            // otherwise, something is below us
                            // so copy the below segment's other polygon's above
                            if (ev.primary === below.primary) {
                                inside = below.seg.otherFill.above;
                            }
                            else {
                                inside = below.seg.myFill.above;
                            }
                        }
                        ev.seg.otherFill = {
                            above: inside,
                            below: inside,
                        };
                    }
                }
                if (buildLog) {
                    buildLog.status(ev.seg, above ? above.seg : false, below ? below.seg : false);
                }
                // insert the status and remember it for later removal
                ev.other.status = surrounding.insert(LinkedList.node({ ev: ev }));
            }
            else {
                const st = ev.status;
                if (st === null) {
                    throw new Error('PolyBool: Zero-length segment detected; your Epsilon is '
                        + 'probably too small or too large');
                }
                // removing the status will create two new adjacent edges, so we'll need to check
                // for those
                if (status_root.exists(st.prev) && status_root.exists(st.next)) {
                    checkIntersection(st.prev.ev, st.next.ev);
                }
                if (buildLog) {
                    buildLog.statusRemove(st.ev.seg);
                }
                // remove the status
                st.remove();
                // if we've reached this point, we've calculated everything there is to know, so
                // save the segment for reporting
                if (!ev.primary) {
                    // make sure `seg.myFill` actually points to the primary polygon though
                    const s = ev.seg.myFill;
                    ev.seg.myFill = ev.seg.otherFill;
                    ev.seg.otherFill = s;
                }
                segments.push(ev.seg);
            }
            // remove the event and continue
            event_root.getHead().remove();
        }
        if (buildLog) {
            buildLog.done();
        }
        return segments;
    }
    // return the appropriate API depending on what we're doing
    if (!selfIntersection) {
        // performing combination of polygons, so only deal with already-processed segments
        return {
            calculate: function (segments1, inverted1, segments2, inverted2) {
                // segmentsX come from the self-intersection API, or this API
                // invertedX is whether we treat that list of segments as an inverted polygon or not
                // returns segments that can be used for further operations
                segments1.forEach(function (seg) {
                    eventAddSegment(segmentCopy(seg.start, seg.end, seg), true);
                });
                segments2.forEach(function (seg) {
                    eventAddSegment(segmentCopy(seg.start, seg.end, seg), false);
                });
                return calculate(inverted1, inverted2);
            },
        };
    }
    // otherwise, performing self-intersection, so deal with regions
    return {
        addRegion: function (region) {
            // regions are a list of points:
            //  [ [0, 0], [100, 0], [50, 100] ]
            // you can add multiple regions before running calculate
            let pt1;
            let pt2 = region[region.length - 1];
            for (let i = 0; i < region.length; i++) {
                pt1 = pt2;
                pt2 = region[i];
                const forward = Epsilon.pointsCompare(pt1, pt2);
                if (forward === 0) {
                    // points are equal, so we have a zero-length segment
                    continue;
                } // just skip it
                eventAddSegment(segmentNew(forward < 0 ? pt1 : pt2, forward < 0 ? pt2 : pt1), true);
            }
        },
        calculate: function (inverted) {
            // is the polygon inverted?
            // returns segments
            return calculate(inverted, false);
        },
    };
}

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// converts a list of segments into a list of regions, while also removing unnecessary verticies
//
function SegmentChainer(segments, buildLog) {
    const chains = [];
    const regions = [];
    segments.forEach(function (seg) {
        const pt1 = seg.start;
        const pt2 = seg.end;
        if (Epsilon.pointsSame(pt1, pt2)) {
            console.warn('PolyBool: Warning: Zero-length segment detected; your epsilon is '
                + 'probably too small or too large');
            return;
        }
        if (buildLog) {
            buildLog.chainStart(seg);
        }
        // search for two chains that this segment matches
        const first_match = {
            index: 0,
            matches_head: false,
            matches_pt1: false,
        };
        const second_match = {
            index: 0,
            matches_head: false,
            matches_pt1: false,
        };
        let next_match = first_match;
        function setMatch(index, matches_head, matches_pt1) {
            // return true if we've matched twice
            next_match.index = index;
            next_match.matches_head = matches_head;
            next_match.matches_pt1 = matches_pt1;
            if (next_match === first_match) {
                next_match = second_match;
                return false;
            }
            next_match = null;
            return true; // we've matched twice, we're done here
        }
        for (let i = 0; i < chains.length; i++) {
            const chain = chains[i];
            const head = chain[0];
            const head2 = chain[1];
            const tail = chain[chain.length - 1];
            const tail2 = chain[chain.length - 2];
            if (Epsilon.pointsSame(head, pt1)) {
                if (setMatch(i, true, true)) {
                    break;
                }
            }
            else if (Epsilon.pointsSame(head, pt2)) {
                if (setMatch(i, true, false)) {
                    break;
                }
            }
            else if (Epsilon.pointsSame(tail, pt1)) {
                if (setMatch(i, false, true)) {
                    break;
                }
            }
            else if (Epsilon.pointsSame(tail, pt2)) {
                if (setMatch(i, false, false)) {
                    break;
                }
            }
        }
        if (next_match === first_match) {
            // we didn't match anything, so create a new chain
            chains.push([pt1, pt2]);
            if (buildLog) {
                buildLog.chainNew(pt1, pt2);
            }
            return;
        }
        if (next_match === second_match) {
            // we matched a single chain
            if (buildLog) {
                buildLog.chainMatch(first_match.index);
            }
            // add the other point to the apporpriate end, and check to see if we've closed the
            // chain into a loop
            const index = first_match.index;
            const pt = first_match.matches_pt1 ? pt2 : pt1; // if we matched pt1, then we add pt2, etc
            const addToHead = first_match.matches_head; // if we matched at head, then add to the head
            const chain = chains[index];
            let grow = addToHead ? chain[0] : chain[chain.length - 1];
            const grow2 = addToHead ? chain[1] : chain[chain.length - 2];
            const oppo = addToHead ? chain[chain.length - 1] : chain[0];
            const oppo2 = addToHead ? chain[chain.length - 2] : chain[1];
            if (Epsilon.pointsCollinear(grow2, grow, pt)) {
                // grow isn't needed because it's directly between grow2 and pt:
                // grow2 ---grow---> pt
                if (addToHead) {
                    if (buildLog) {
                        buildLog.chainRemoveHead(first_match.index, pt);
                    }
                    chain.shift();
                }
                else {
                    if (buildLog) {
                        buildLog.chainRemoveTail(first_match.index, pt);
                    }
                    chain.pop();
                }
                grow = grow2; // old grow is gone... new grow is what grow2 was
            }
            if (Epsilon.pointsSame(oppo, pt)) {
                // we're closing the loop, so remove chain from chains
                chains.splice(index, 1);
                if (Epsilon.pointsCollinear(oppo2, oppo, grow)) {
                    // oppo isn't needed because it's directly between oppo2 and grow:
                    // oppo2 ---oppo--->grow
                    if (addToHead) {
                        if (buildLog) {
                            buildLog.chainRemoveTail(first_match.index, grow);
                        }
                        chain.pop();
                    }
                    else {
                        if (buildLog) {
                            buildLog.chainRemoveHead(first_match.index, grow);
                        }
                        chain.shift();
                    }
                }
                if (buildLog) {
                    buildLog.chainClose(first_match.index);
                }
                // we have a closed chain!
                regions.push(chain);
                return;
            }
            // not closing a loop, so just add it to the apporpriate side
            if (addToHead) {
                if (buildLog) {
                    buildLog.chainAddHead(first_match.index, pt);
                }
                chain.unshift(pt);
            }
            else {
                if (buildLog) {
                    buildLog.chainAddTail(first_match.index, pt);
                }
                chain.push(pt);
            }
            return;
        }
        // otherwise, we matched two chains, so we need to combine those chains together
        function reverseChain(index) {
            if (buildLog) {
                buildLog.chainReverse(index);
            }
            chains[index].reverse(); // gee, that's easy
        }
        function appendChain(index1, index2) {
            // index1 gets index2 appended to it, and index2 is removed
            const chain1 = chains[index1];
            const chain2 = chains[index2];
            let tail = chain1[chain1.length - 1];
            const tail2 = chain1[chain1.length - 2];
            const head = chain2[0];
            const head2 = chain2[1];
            if (Epsilon.pointsCollinear(tail2, tail, head)) {
                // tail isn't needed because it's directly between tail2 and head
                // tail2 ---tail---> head
                if (buildLog) {
                    buildLog.chainRemoveTail(index1, tail);
                }
                chain1.pop();
                tail = tail2; // old tail is gone... new tail is what tail2 was
            }
            if (Epsilon.pointsCollinear(tail, head, head2)) {
                // head isn't needed because it's directly between tail and head2
                // tail ---head---> head2
                if (buildLog) {
                    buildLog.chainRemoveHead(index2, head);
                }
                chain2.shift();
            }
            if (buildLog) {
                buildLog.chainJoin(index1, index2);
            }
            chains[index1] = chain1.concat(chain2);
            chains.splice(index2, 1);
        }
        const F = first_match.index;
        const S = second_match.index;
        if (buildLog) {
            buildLog.chainConnect(F, S);
        }
        const reverseF = chains[F].length < chains[S].length; // reverse the shorter chain, if needed
        if (first_match.matches_head) {
            if (second_match.matches_head) {
                if (reverseF) {
                    // <<<< F <<<< --- >>>> S >>>>
                    reverseChain(F);
                    // >>>> F >>>> --- >>>> S >>>>
                    appendChain(F, S);
                }
                else {
                    // <<<< F <<<< --- >>>> S >>>>
                    reverseChain(S);
                    // <<<< F <<<< --- <<<< S <<<<   logically same as:
                    // >>>> S >>>> --- >>>> F >>>>
                    appendChain(S, F);
                }
            }
            else {
                // <<<< F <<<< --- <<<< S <<<<   logically same as:
                // >>>> S >>>> --- >>>> F >>>>
                appendChain(S, F);
            }
        }
        else {
            if (second_match.matches_head) {
                // >>>> F >>>> --- >>>> S >>>>
                appendChain(F, S);
            }
            else {
                if (reverseF) {
                    // >>>> F >>>> --- <<<< S <<<<
                    reverseChain(F);
                    // <<<< F <<<< --- <<<< S <<<<   logically same as:
                    // >>>> S >>>> --- >>>> F >>>>
                    appendChain(S, F);
                }
                else {
                    // >>>> F >>>> --- <<<< S <<<<
                    reverseChain(S);
                    // >>>> F >>>> --- >>>> S >>>>
                    appendChain(F, S);
                }
            }
        }
    });
    return regions;
}

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs
//
// filter a list of segments based on boolean operations
//
function select(segments, selection, buildLog) {
    const result = [];
    segments.forEach(function (seg) {
        const index = (seg.myFill.above ? 8 : 0)
            + (seg.myFill.below ? 4 : 0)
            + (seg.otherFill && seg.otherFill.above ? 2 : 0)
            + (seg.otherFill && seg.otherFill.below ? 1 : 0);
        if (selection[index] !== 0) {
            // copy the segment to the results, while also calculating the fill status
            result.push({
                id: buildLog ? buildLog.segmentId() : -1,
                start: seg.start,
                end: seg.end,
                myFill: {
                    above: selection[index] === 1,
                    below: selection[index] === 2,
                },
                otherFill: null,
            });
        }
    });
    if (buildLog) {
        buildLog.selected(result);
    }
    return result;
}
const ɵ0 = function (segments, buildLog) {
    // primary | secondary
    // above1 below1 above2 below2    Keep?               Value
    //    0      0      0      0   =>   no                  0
    //    0      0      0      1   =>   yes filled below    2
    //    0      0      1      0   =>   yes filled above    1
    //    0      0      1      1   =>   no                  0
    //    0      1      0      0   =>   yes filled below    2
    //    0      1      0      1   =>   yes filled below    2
    //    0      1      1      0   =>   no                  0
    //    0      1      1      1   =>   no                  0
    //    1      0      0      0   =>   yes filled above    1
    //    1      0      0      1   =>   no                  0
    //    1      0      1      0   =>   yes filled above    1
    //    1      0      1      1   =>   no                  0
    //    1      1      0      0   =>   no                  0
    //    1      1      0      1   =>   no                  0
    //    1      1      1      0   =>   no                  0
    //    1      1      1      1   =>   no                  0
    return select(segments, [0, 2, 1, 0, 2, 2, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0], buildLog);
}, ɵ1 = function (segments, buildLog) {
    // primary & secondary
    // above1 below1 above2 below2    Keep?               Value
    //    0      0      0      0   =>   no                  0
    //    0      0      0      1   =>   no                  0
    //    0      0      1      0   =>   no                  0
    //    0      0      1      1   =>   no                  0
    //    0      1      0      0   =>   no                  0
    //    0      1      0      1   =>   yes filled below    2
    //    0      1      1      0   =>   no                  0
    //    0      1      1      1   =>   yes filled below    2
    //    1      0      0      0   =>   no                  0
    //    1      0      0      1   =>   no                  0
    //    1      0      1      0   =>   yes filled above    1
    //    1      0      1      1   =>   yes filled above    1
    //    1      1      0      0   =>   no                  0
    //    1      1      0      1   =>   yes filled below    2
    //    1      1      1      0   =>   yes filled above    1
    //    1      1      1      1   =>   no                  0
    return select(segments, [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 2, 1, 0], buildLog);
}, ɵ2 = function (segments, buildLog) {
    // primary - secondary
    // above1 below1 above2 below2    Keep?               Value
    //    0      0      0      0   =>   no                  0
    //    0      0      0      1   =>   no                  0
    //    0      0      1      0   =>   no                  0
    //    0      0      1      1   =>   no                  0
    //    0      1      0      0   =>   yes filled below    2
    //    0      1      0      1   =>   no                  0
    //    0      1      1      0   =>   yes filled below    2
    //    0      1      1      1   =>   no                  0
    //    1      0      0      0   =>   yes filled above    1
    //    1      0      0      1   =>   yes filled above    1
    //    1      0      1      0   =>   no                  0
    //    1      0      1      1   =>   no                  0
    //    1      1      0      0   =>   no                  0
    //    1      1      0      1   =>   yes filled above    1
    //    1      1      1      0   =>   yes filled below    2
    //    1      1      1      1   =>   no                  0
    return select(segments, [0, 0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1, 2, 0], buildLog);
}, ɵ3 = function (segments, buildLog) {
    // secondary - primary
    // above1 below1 above2 below2    Keep?               Value
    //    0      0      0      0   =>   no                  0
    //    0      0      0      1   =>   yes filled below    2
    //    0      0      1      0   =>   yes filled above    1
    //    0      0      1      1   =>   no                  0
    //    0      1      0      0   =>   no                  0
    //    0      1      0      1   =>   no                  0
    //    0      1      1      0   =>   yes filled above    1
    //    0      1      1      1   =>   yes filled above    1
    //    1      0      0      0   =>   no                  0
    //    1      0      0      1   =>   yes filled below    2
    //    1      0      1      0   =>   no                  0
    //    1      0      1      1   =>   yes filled below    2
    //    1      1      0      0   =>   no                  0
    //    1      1      0      1   =>   no                  0
    //    1      1      1      0   =>   no                  0
    //    1      1      1      1   =>   no                  0
    return select(segments, [0, 2, 1, 0, 0, 0, 1, 1, 0, 2, 0, 2, 0, 0, 0, 0], buildLog);
}, ɵ4 = function (segments, buildLog) {
    // primary ^ secondary
    // above1 below1 above2 below2    Keep?               Value
    //    0      0      0      0   =>   no                  0
    //    0      0      0      1   =>   yes filled below    2
    //    0      0      1      0   =>   yes filled above    1
    //    0      0      1      1   =>   no                  0
    //    0      1      0      0   =>   yes filled below    2
    //    0      1      0      1   =>   no                  0
    //    0      1      1      0   =>   no                  0
    //    0      1      1      1   =>   yes filled above    1
    //    1      0      0      0   =>   yes filled above    1
    //    1      0      0      1   =>   no                  0
    //    1      0      1      0   =>   no                  0
    //    1      0      1      1   =>   yes filled below    2
    //    1      1      0      0   =>   no                  0
    //    1      1      0      1   =>   yes filled above    1
    //    1      1      1      0   =>   yes filled below    2
    //    1      1      1      1   =>   no                  0
    return select(segments, [0, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0, 2, 0, 1, 2, 0], buildLog);
};
const SegmentSelector = {
    union: ɵ0,
    intersect: ɵ1,
    difference: ɵ2,
    differenceRev: ɵ3,
    xor: ɵ4,
};

class IccDrawBooleanService {
    // helper functions for common operations
    static union(poly1, poly2) {
        return IccDrawBooleanService.operate(poly1, poly2, IccDrawBooleanService.selectUnion);
    }
    static intersect(poly1, poly2) {
        return IccDrawBooleanService.operate(poly1, poly2, IccDrawBooleanService.selectIntersect);
    }
    static difference(poly1, poly2) {
        return IccDrawBooleanService.operate(poly1, poly2, IccDrawBooleanService.selectDifference);
    }
    static differenceRev(poly1, poly2) {
        return IccDrawBooleanService.operate(poly1, poly2, IccDrawBooleanService.selectDifferenceRev);
    }
    static xor(poly1, poly2) {
        return IccDrawBooleanService.operate(poly1, poly2, IccDrawBooleanService.selectXor);
    }
    static operate(poly1, poly2, selector) {
        const seg1 = IccDrawBooleanService.segments(poly1);
        const seg2 = IccDrawBooleanService.segments(poly2);
        const comb = IccDrawBooleanService.combine(seg1, seg2);
        const seg3 = selector(comb);
        return IccDrawBooleanService.polygon(seg3);
    }
    // getter/setter for epsilon
    static epsilon() {
        return Epsilon.epsilon;
    }
    // core API
    static segments(poly) {
        const i = Intersecter(true, IccDrawBooleanService.buildLog);
        poly.regions.forEach(i.addRegion);
        return {
            segments: i.calculate(poly.inverted),
            inverted: poly.inverted,
        };
    }
    static combine(segments1, segments2) {
        const i3 = Intersecter(false, IccDrawBooleanService.buildLog);
        return {
            combined: i3.calculate(segments1.segments, segments1.inverted, segments2.segments, segments2.inverted),
            inverted1: segments1.inverted,
            inverted2: segments2.inverted,
        };
    }
    static selectUnion(combined) {
        return {
            segments: SegmentSelector.union(combined.combined, IccDrawBooleanService.buildLog),
            inverted: combined.inverted1 || combined.inverted2,
        };
    }
    static selectIntersect(combined) {
        return {
            segments: SegmentSelector.intersect(combined.combined, IccDrawBooleanService.buildLog),
            inverted: combined.inverted1 && combined.inverted2,
        };
    }
    static selectDifference(combined) {
        return {
            segments: SegmentSelector.difference(combined.combined, IccDrawBooleanService.buildLog),
            inverted: combined.inverted1 && !combined.inverted2,
        };
    }
    static selectDifferenceRev(combined) {
        return {
            segments: SegmentSelector.differenceRev(combined.combined, IccDrawBooleanService.buildLog),
            inverted: !combined.inverted1 && combined.inverted2,
        };
    }
    static selectXor(combined) {
        return {
            segments: SegmentSelector.xor(combined.combined, IccDrawBooleanService.buildLog),
            inverted: combined.inverted1 !== combined.inverted2,
        };
    }
    static polygon(segments) {
        return {
            regions: SegmentChainer(segments.segments, IccDrawBooleanService.buildLog),
            inverted: segments.inverted,
        };
    }
}
IccDrawBooleanService.buildLog = BuildLog();

class DrawData {
    constructor(poly, params = {}, getInfo) {
        Object.assign(this, params);
        this.poly = poly;
        this.polyArea = IccDrawMathService.getAreaFromPoly(this.poly) / 1e6;
        this.polyEdge = IccDrawMathService.getPerimeterFromPoly(this.poly) / 1e3;
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.rectArea = IccDrawMathService.getAreaFromRect(this.rect) / 1e6;
        this.rectEdge = IccDrawMathService.getPerimeterFromRect(this.rect) / 1e3;
        if (getInfo) {
            this.innerEdge = IccDrawMathService.getLineInfo([poly[2], poly[3]], poly);
            this.outerEdge = IccDrawMathService.getLineInfo([poly[0], poly[1]], poly);
        }
        if (params.direction) {
            this.length = params.direction === 'horizontal' ? this.rect.width : this.rect.height;
        }
        else if (getInfo) {
            this.length = this.outerEdge.length;
        }
    }
}

class BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        this.root = null;
        this.parent = null;
        this.children = [];
        this.uri = window.location.href;
        this.panelTypes = {
            Inset: 'panel_type_inset',
            Outer: 'panel_type_outer',
            Double: 'panel_type_double',
            Inner: 'panel_type_inner',
        };
        this.poly = [];
        this.rect = { x: 0, y: 0, width: 0, height: 0 };
        this.regions = [];
        this.layer = Layers.Base;
        this.zIndex = 0;
        this.svg = {
            gradients: [],
            patterns: [],
            paths: [],
            texts: [],
        };
        this.options = {};
        this.positionId = null;
        this.rotation = 0;
        this.outerSash = false;
        this.outerSide = false;
        this.includeInExtendedDimensions = true;
        Object.assign(this.options, options);
        this.root = this;
        this.uuid = this.getUUID();
        if (this.uri.indexOf('file:///') > -1) {
            this.uri = '';
        }
        this.outerSide = this.options.side === 'outer';
        this.setParent(parentNode);
        this.setChildren(childrenNodes);
        Object.assign(this, params);
    }
    getUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    onClick(params) {
        return {};
    }
    init() { }
    setChildren(childrenNodes) {
        if (childrenNodes) {
            childrenNodes.map(node => {
                node.root = this.root;
                node.parent = this;
                node.positionId = this.positionId;
                node.zIndex = this.zIndex;
                this.children.push(node);
            });
        }
    }
    setParent(parentNode) {
        if (parentNode) {
            this.root = parentNode.root;
            this.parent = parentNode;
            this.positionId = parentNode.positionId;
            this.zIndex = parentNode.zIndex;
            this.rotation = parentNode.rotation;
            this.outerSide = parentNode.outerSide;
            this.outerSash = parentNode.outerSash;
            this.parent.children.push(this);
        }
    }
    setParentPoly() {
        if (this.parent) {
            const { regions } = IccDrawBooleanService.union({
                regions: this.parent.regions && this.parent.regions.length
                    ? this.parent.regions
                    : [this.parent.poly.map(p => [p.x, p.y])],
                inverted: false,
            }, {
                regions: [this.poly.map(p => [p.x, p.y])],
                inverted: false,
            });
            this.parent.regions =
                regions.sort((a, b) => {
                    const rectA = IccDrawMathService.getRectFromPoly(a.map(p => ({
                        x: p[0],
                        y: p[1],
                    })));
                    const rectB = IccDrawMathService.getRectFromPoly(b.map(p => ({
                        x: p[0],
                        y: p[1],
                    })));
                    return rectB.width * rectB.height - rectA.width * rectA.height;
                });
            this.parent.poly = this.parent.regions.length
                ? this.parent.regions[0].map(p => ({
                    x: p[0],
                    y: p[1],
                }))
                : [];
            this.parent.rect = IccDrawMathService.getRectFromPoly(this.parent.poly);
            this.parent.setParentPoly();
        }
        else {
            this.onRootChange();
        }
    }
    onRootChange() {
        this.children.forEach(child => {
            child.onRootChange();
        });
    }
    moveChildren(shift) {
        this.poly = IccDrawMathService.movePoly(this.poly, shift);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.init();
        this.children.forEach(child => {
            child.moveChildren(shift);
        });
    }
    setDrawData(data) {
        data.base.push(new DrawData(this.poly, {
            positionId: this.positionId,
        }));
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal
            .filter(o => o.positionsId.some(e => e === this.positionId))
            .map(dimension => {
            dimension.major.push(this.rect.x, this.rect.x + this.rect.width);
            dimension.minor.push(this.rect.x, this.rect.x + this.rect.width);
        });
        dimensions.vertical
            .filter(o => o.positionsId.some(e => e === this.positionId))
            .map(dimension => {
            dimension.major.push(this.rect.y, this.rect.y + this.rect.height);
            dimension.minor.push(this.rect.y, this.rect.y + this.rect.height);
        });
    }
    setColorVisualization(visualization, color, outerSide, patternId, polygon, reverse = false) {
        visualization = Object.assign({}, visualization);
        const decorPanelImageSize = {
            width: Number(visualization.visualizationWidthMM),
            height: Number(visualization.visualizationHeightMM),
            x: 0,
            y: 0,
            shift: {
                x: polygon[0].x,
                y: polygon[0].y,
            },
        };
        if (outerSide) {
            if (visualization.visualizationPositionX === 'left') {
                visualization.visualizationPositionX = 'right';
            }
            else if (visualization.visualizationPositionX === 'right') {
                visualization.visualizationPositionX = 'left';
            }
        }
        const verticalLineInfo = IccDrawMathService.getLineInfo([polygon[0], polygon[1]], polygon);
        const horizontalLineInfo = IccDrawMathService.getLineInfo([polygon[1], polygon[2]], polygon);
        const angleDeg = ((reverse ? horizontalLineInfo : verticalLineInfo).angle * 180 - 90);
        switch (visualization.visualizationPositionX) {
            case 'center':
                decorPanelImageSize.shift.x -= (decorPanelImageSize.width - horizontalLineInfo.length) / 2;
                break;
            case 'right':
                decorPanelImageSize.shift.x += horizontalLineInfo.length - decorPanelImageSize.width;
                break;
        }
        if (outerSide) {
            decorPanelImageSize.shift.x = -decorPanelImageSize.shift.x;
        }
        switch (visualization.visualizationPositionY) {
            case 'center':
                decorPanelImageSize.shift.y -= (decorPanelImageSize.height - verticalLineInfo.length) / 2;
                break;
            case 'bottom':
                decorPanelImageSize.shift.y -= decorPanelImageSize.height - verticalLineInfo.length;
                break;
        }
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-color-${patternId}-${this.uuid}`,
            color: color ? `#${color}` : null,
            image: `/files/color/${visualization.visualizationImage}`,
            height: decorPanelImageSize.height,
            width: decorPanelImageSize.width,
            x: decorPanelImageSize.shift.x,
            y: decorPanelImageSize.shift.y,
            patternTransform: `rotate(${angleDeg + (visualization.visualizationOrientation === 'horizontal' ? 90 : 0)}, ${polygon[0].x}, ${polygon[0].y})`,
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, this.root.side, {
            stroke: '#bbb',
            fill: `url('${this.root.uri}#iccDraw-color-${patternId}-${this.uuid}')`,
        }));
    }
}

class IccColorContrastService {
    static hexToRgb(hex) {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    static getInvertedColor(color) {
        if (!color) {
            color = "ffffff";
        }
        color = this.colorToGrayscale("#" + color);
        let increasedColor = Math.ceil(color.r + this.contrastRatio / 100 * 255) <= 255 ? Math.ceil(color.r + this.contrastRatio / 100 * 255) : Math.ceil(color.r - this.contrastRatio / 100 * 255);
        return this.rgbToHex({
            r: increasedColor,
            g: increasedColor,
            b: increasedColor
        });
    }
    static colorToGrayscale(color) {
        if (color[0] === '#') {
            color = this.hexToRgb(color);
        }
        const x = Math.round(((color === null || color === void 0 ? void 0 : color.r) + (color === null || color === void 0 ? void 0 : color.g) + (color === null || color === void 0 ? void 0 : color.b)) / 3);
        return {
            r: x,
            g: x,
            b: x,
        };
    }
    static valueToHex(c) {
        const hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    static getAvgColor([...colors]) {
        colors = colors.map(color => this.hexToRgb(color));
        return {
            r: this.getAvgProperty(colors.map(color => color.r)),
            g: this.getAvgProperty(colors.map(color => color.g)),
            b: this.getAvgProperty(colors.map(color => color.b)),
        };
    }
    static getAvgProperty([...data]) {
        const dataPow = data.map(i => Math.sqrt(Math.pow(i, 2)));
        const dataSum = dataPow.reduce((prev, curr) => prev + curr);
        return Math.abs(dataSum / data.length);
    }
    static rgbToHex({ r, g, b }) {
        r = Math.ceil(r);
        g = Math.ceil(g);
        b = Math.ceil(b);
        return "#" + this.valueToHex(r) + this.valueToHex(g) + this.valueToHex(b);
    }
}
IccColorContrastService.contrastRatio = 30;

class FrameNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.frame = {};
        this.sashes = {};
        this.profiles = [];
        this.usedProfiles = [];
        this.profilesPolygonsMap = {};
        this.windowIndex = null;
        this.filledDoor = false;
        this.thresholdColor = null;
        this.jointAngles = 'E_E_E_E';
        this.thresholdJointAngles = 'L_R';
        this.shape = 'rect';
        this.color = {};
        this.polygons = [];
        this.width = [];
        this.profileJointAngles = [];
        this.layer = Layers.Frame;
        this.frameExtensionHeight = 0;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            profiles: this.profiles,
            frame: this.frame,
            positionId: this.positionId,
        }, params);
    }
    setDrawData(data) {
        const parallelPoly = IccDrawMathService.getParallelPoly(this.parent.poly, this.parent.parent.poly);
        const parallel = new Array(Math.max(...Object.values(this.profilesPolygonsMap).map(Number)) + 1);
        Object.keys(this.profilesPolygonsMap).forEach(k => {
            if (parallel[this.profilesPolygonsMap[k]] == null
                || parallelPoly[k] < parallel[this.profilesPolygonsMap[k]]) {
                parallel[this.profilesPolygonsMap[k]] = parallelPoly[k];
            }
        });
        data.frame.push({
            inner: new DrawData(this.poly),
            outer: new DrawData(this.parent.poly),
            sides: this.polygons.map(poly => new DrawData(poly, {}, true)),
            frameId: this.frame ? this.frame.id : null,
            positionId: this.positionId,
            parallel: {
                poly: parallel || [],
            },
        });
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal
            .filter(o => o.positionsId.some(e => e === this.positionId))
            .map(dimension => {
            dimension.minor.push(...this.poly.map(o => o.x));
        });
        dimensions.vertical
            .filter(o => o.positionsId.some(e => e === this.positionId))
            .map(dimension => {
            dimension.minor.push(...this.poly.map(o => o.y));
        });
    }
    init() {
        var _a, _b;
        this.svg.paths = [];
        /** class: przygotowanie zestawu profili  */
        this.setProfiles();
        const profileTypes = [];
        /** math: obliczenie przesunięcia */
        Object.keys(this.parent.poly).forEach(index => {
            const frame = this.profiles[index] || this.profiles[0] || {};
            const frameProfile = this.usedProfiles.find(o => o.id === frame.profileId)
                || this.usedProfiles.find(o => o.type === 'frame')
                || {};
            if (this.root.outerSide !== this.outerSash
                || (this.frame.lowThreshold
                    && !this.root.options.kickerLowThreshold
                    && Number(index) === 0)) {
                this.width[index] = Number(frameProfile.widthOut || 70);
            }
            else {
                this.width[index] = Number(frameProfile.width || 45);
            }
            profileTypes[index] = (frameProfile && frameProfile.type) || 'frame';
            this.profileJointAngles[index] = (frameProfile && frameProfile.jointAngles) || null;
        });
        /** math: obliczenie współrzędnych figury */
        this.poly = IccDrawMathService.getPolyShift(this.parent.poly, this.width);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        /** math: przygotowanie zestawów profili */
        const mainSash = this.sashes[0] || {};
        const mainSashFilling = mainSash.filling || {};
        const jointAngle = IccDrawMathService.getJointAngles(this.parent.poly, this.jointAngles, this.shape, this.profileJointAngles);
        if (profileTypes[0] === 'threshold' && this.thresholdJointAngles) {
            jointAngle.splice(0, 2, ...this.thresholdJointAngles.split('_'));
        }
        const { polygons, polygonLineMap } = IccDrawMathService.getPolygons(this.parent.poly, this.poly, jointAngle);
        this.polygons = polygons;
        this.profilesPolygonsMap = polygonLineMap;
        /** svg: rysowanie ścieżek */
        if (this.root.outerSide) {
            if (mainSashFilling.length > 0
                && (mainSashFilling.type === 'deco_panels'
                    && [this.root.panelTypes.Outer, this.root.panelTypes.Double].indexOf(mainSashFilling.overlay_type) !== -1)) {
                return this;
            }
        }
        let i = 0;
        for (const polygon of this.polygons) {
            const info = IccDrawMathService.getLineInfo([polygon[0], polygon[1]], polygon);
            const angleDeg = (info.angle * 180 - 90);
            const type = profileTypes[i] || 'frame';
            if (['left', 'right'].includes(info.side) && type === 'frame' && this.frameExtensionHeight > 0) {
                IccDrawMathService.increaseRectPolyLength(polygon, this.frameExtensionHeight);
            }
            if (type === 'threshold' && this.thresholdColor && this.thresholdColor.id) {
                this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: `iccDraw-frame-${i}-${this.uuid}`,
                    color: this.thresholdColor.color ? `#${this.thresholdColor.color}` : '#fff',
                    image: this.thresholdColor.color_img
                        ? `/files/color/${this.thresholdColor.color_img}`
                        : null,
                    x: this.root.rect.x,
                    y: this.root.rect.y,
                    height: this.root.rect.height,
                    width: this.root.rect.width,
                    patternTransform: `rotate(${angleDeg})`,
                }));
                this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, this.root.side, {
                    stroke: IccColorContrastService.getInvertedColor((_a = this === null || this === void 0 ? void 0 : this.color) === null || _a === void 0 ? void 0 : _a.color) || "#bbb",
                    fill: `url('${this.root.uri}#iccDraw-frame-${i}-${this.uuid}')`,
                }));
            }
            else {
                /** svg: kolor ramy */
                if (this.color && this.color.visualization && this.color.visualization.visualizationImage) {
                    const frameColor = this.color && this.color.color ? this.color.color : 'fff';
                    this.setColorVisualization(this.color.visualization, frameColor, this.root.outerSide, 'frame' + i, polygon);
                }
                else {
                    this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, this.root.side, {
                        stroke: IccColorContrastService.getInvertedColor((_b = this === null || this === void 0 ? void 0 : this.color) === null || _b === void 0 ? void 0 : _b.color) || "#bbb",
                        fill: `url('${this.root.uri}#iccDraw-frame-${this.root.uuid}-${this.positionId}')`,
                    }));
                }
            }
            i++;
        }
    }
    setProfiles() {
        if (!Array.isArray(this.profiles) || !this.profiles.length) {
            this.profiles = this.parent.poly.map(() => {
                return {};
            });
        }
        if (this.profiles.length && this.profiles.length < this.parent.poly.length) {
            const profiles = [];
            this.parent.poly.forEach((v, i) => profiles.push(this.profiles[i] || this.profiles[i - 1] || this.profiles[0]));
            this.profiles = profiles;
        }
    }
}

class IccDrawDimensionsService {
    static getBreakpoints(details) {
        const breakpoints = {
            horizontal: [details.y || 0, details.height || 0],
            vertical: [details.x || 0, details.width || 0],
        };
        if (details.type !== 'coupled_window') {
            for (const coupling of details.couplings || []) {
                const frame = details.frames.find(f => coupling.framesId.find(fId => f.id === fId.id));
                breakpoints[coupling.direction].push((coupling.direction === 'vertical'
                    ? frame.x + frame.width
                    : frame.y + frame.height) + Math.ceil(coupling.width / 2));
            }
            for (const mullion of details.mullions || []) {
                const frame = details.frames.find(f => f.id === mullion.frameId);
                breakpoints[mullion.direction].push((mullion.direction === 'vertical' ? frame.x : frame.y) + mullion.position);
            }
            for (const sash of details.sashes || []) {
                const frame = details.frames.find(f => f.id === sash.frameId);
                for (const mullion of sash.intMullions || []) {
                    breakpoints[mullion.direction].push((mullion.direction === 'vertical' ? frame.x + sash.x : frame.y + sash.y)
                        + mullion.position);
                }
            }
        }
        else {
            for (const coupling of details.couplings || []) {
                const window = details.windows.find(w => coupling.framesId.some(fId => w.positionId === fId.positionId)
                    || coupling.otherFramesId.some(fId => w.positionId === fId.positionId));
                if (window) {
                    breakpoints[coupling.direction].push(coupling.direction === 'vertical'
                        ? window.x + window.details.width
                        : window.y + window.details.height);
                    breakpoints[coupling.direction].push((coupling.direction === 'vertical'
                        ? window.x + window.details.width
                        : window.y + window.details.height) + coupling.width);
                }
            }
        }
        for (const direction of ['horizontal', 'vertical']) {
            breakpoints[direction] = breakpoints[direction]
                .filter((v, i, a) => a.indexOf(v) === i)
                .sort((a, b) => a - b);
        }
        return breakpoints;
    }
    static getDimensions(details, node, options) {
        const dimensions = {
            horizontal: [],
            vertical: [],
        };
        const breakpoints = this.getBreakpoints(details);
        if (options.type === 'extended') {
            for (const direction of ['horizontal', 'vertical']) {
                for (let i = 0; i < breakpoints[direction].length - 1; i++) {
                    dimensions[direction].push({
                        id: i,
                        letter: null,
                        major: [],
                        minor: [],
                        sashes: [],
                        positionsId: [],
                        start: breakpoints[direction][i],
                        stop: breakpoints[direction][i + 1],
                    });
                }
            }
            this.getDetailsData(dimensions, details, options, node);
            this.getNodeData(dimensions, node);
        }
        else if (options.type === 'outer') {
            dimensions.horizontal.push({
                major: [node.rect.x, node.rect.x + node.rect.width],
                minor: [node.rect.x, node.rect.x + node.rect.width].concat(breakpoints.vertical),
            });
            dimensions.vertical.push({
                major: [node.rect.y, node.rect.y + node.rect.height],
                minor: [node.rect.y, node.rect.y + node.rect.height].concat(breakpoints.horizontal),
            });
        }
        else {
            dimensions.horizontal.push({
                major: [details.x || 0, details.width || 0],
                minor: breakpoints.vertical,
            });
            dimensions.vertical.push({
                major: [details.y || 0, details.height || 0],
                minor: breakpoints.horizontal,
            });
        }
        for (const direction of ['horizontal', 'vertical']) {
            for (const dimension of dimensions[direction]) {
                dimension.major = dimension.major
                    .map(Math.round)
                    .filter((v, i, a) => a.indexOf(v) === i)
                    .sort((a, b) => a - b);
                dimension.minor = dimension.minor
                    .map(Math.round)
                    .filter((v, i, a) => a.indexOf(v) === i)
                    .sort((a, b) => a - b);
            }
        }
        this.getLetters(dimensions);
        return dimensions;
    }
    static getDetailsData(dimensions, details, options, node, x = 0, y = 0, positionId = null) {
        if (details.type === 'coupled_window') {
            for (const window of details.windows || []) {
                dimensions.horizontal
                    .filter(o => (window.y <= o.start && o.start < window.y + window.details.height)
                    || (window.y < o.stop && o.stop <= window.y + window.details.height))
                    .map(dimension => {
                    dimension.positionsId.push(window.positionId);
                });
                dimensions.vertical
                    .filter(o => (window.x <= o.start && o.start < window.x + window.details.width)
                    || (window.x < o.stop && o.stop <= window.x + window.details.width))
                    .map(dimension => {
                    dimension.positionsId.push(window.positionId);
                });
                this.getDetailsData(dimensions, window.details, options, node, window.x, window.y, window.positionId);
            }
        }
        else {
            dimensions.horizontal.map(dimension => dimension.positionsId.push(null));
            dimensions.vertical.map(dimension => dimension.positionsId.push(null));
            for (const sash of details.sashes || []) {
                const frame = details.frames.find(f => f.id === sash.frameId);
                dimensions.horizontal
                    .filter(o => (y + frame.y + sash.y <= o.start
                    && o.start < y + frame.y + sash.y + sash.height)
                    || (y + frame.y + sash.y < o.stop
                        && o.stop <= y + frame.y + sash.y + sash.height))
                    .map(dimension => {
                    dimension.sashes.push(positionId + sash.id);
                    dimension.major.push(x + frame.x + sash.x, x + frame.x + sash.x + sash.width);
                });
                dimensions.vertical
                    .filter(o => (x + frame.x + sash.x <= o.start
                    && o.start < x + frame.x + sash.x + sash.width)
                    || (x + frame.x + sash.x < o.stop
                        && o.stop <= x + frame.x + sash.x + sash.width))
                    .map(dimension => {
                    dimension.sashes.push(positionId + sash.id);
                    dimension.major.push(y + frame.y + sash.y, y + frame.y + sash.y + sash.height);
                });
                for (const intSash of sash.intSashes || []) {
                    dimensions.horizontal
                        .filter(o => (y + frame.y + sash.y + intSash.y <= o.start
                        && o.start < y + frame.y + sash.y + intSash.y + intSash.height)
                        || (y + frame.y + sash.y + intSash.y < o.stop
                            && o.stop <= y + frame.y + sash.y + intSash.y + intSash.height))
                        .map(dimension => {
                        dimension.sashes.push(positionId + intSash.id);
                    });
                    dimensions.vertical
                        .filter(o => (x + frame.x + sash.x + intSash.x <= o.start
                        && o.start < x + frame.x + sash.x + intSash.x + intSash.width)
                        || (x + frame.x + sash.x + intSash.x < o.stop
                            && o.stop <= x + frame.x + sash.x + intSash.x + intSash.width))
                        .map(dimension => {
                        dimension.sashes.push(positionId + intSash.id);
                    });
                }
            }
        }
    }
    static getElements(dimensions, node, options) {
        const elements = [];
        const letters = {
            horizontal: [],
            vertical: [],
        };
        if (!node || !node.rect) {
            return elements;
        }
        for (const direction of ['horizontal', 'vertical']) {
            for (const dimension of dimensions[direction]) {
                if (options.type === 'extended') {
                    elements.push({
                        class: [direction, 'letter', 'center'],
                        innerHtml: dimension.letter,
                        style: direction === 'horizontal'
                            ? {
                                top: this.getRelative(dimension.start, node.rect.y, node.rect.height, false),
                                bottom: this.getRelative(dimension.stop, node.rect.y, node.rect.height, true),
                                left: `-30px`,
                                width: `20px`,
                            }
                            : {
                                left: this.getRelative(dimension.start, node.rect.x, node.rect.width, false),
                                right: this.getRelative(dimension.stop, node.rect.x, node.rect.width, true),
                                top: `-30px`,
                                height: `20px`,
                            },
                    });
                }
                if (letters[direction].indexOf(dimension.letter) === -1) {
                    letters[direction].push(dimension.letter);
                    if (options.type === 'extended') {
                        elements.push({
                            class: [direction, 'letter', 'center'],
                            innerHtml: dimension.letter,
                            style: direction === 'horizontal'
                                ? {
                                    bottom: `-${50 * letters[direction].length}px`,
                                    left: `-30px`,
                                    width: `20px`,
                                    height: `40px`,
                                }
                                : {
                                    right: `-${70 * letters[direction].length}px`,
                                    top: `-30px`,
                                    width: `60px`,
                                    height: `20px`,
                                },
                        });
                    }
                    for (const type of ['major', 'minor']) {
                        for (let i = 0, j = 1; i < dimension[type].length; i++, j++) {
                            if (j < dimension[type].length) {
                                elements.push({
                                    class: [direction, type, 'center'],
                                    innerHtml: IccDrawMathService.round((dimension[type][j] - dimension[type][i])
                                        / (options.ratio || 1), 2),
                                    style: direction === 'horizontal'
                                        ? {
                                            bottom: `-${50 * letters[direction].length
                                                - (type === 'major' ? 0 : 20)}px`,
                                            left: this.getRelative(dimension[type][i], node.rect.x, node.rect.width, false),
                                            right: this.getRelative(dimension[type][j], node.rect.x, node.rect.width, true),
                                            height: `20px`,
                                        }
                                        : {
                                            right: `-${70 * letters[direction].length
                                                - (type === 'major' ? 0 : 30)}px`,
                                            top: this.getRelative(dimension[type][i], node.rect.y, node.rect.height, false),
                                            bottom: this.getRelative(dimension[type][j], node.rect.y, node.rect.height, true),
                                            width: `30px`,
                                        },
                                });
                            }
                            elements.push({
                                class: [direction, type, 'line'],
                                style: direction === 'horizontal'
                                    ? {
                                        bottom: `-${50 * letters[direction].length
                                            - (type === 'major' ? 15 : 20)}px`,
                                        left: this.getRelative(dimension[type][i], node.rect.x, node.rect.width, false),
                                        right: this.getRelative(dimension[type][j], node.rect.x, node.rect.width, true),
                                        height: `5px`,
                                    }
                                    : {
                                        right: `-${70 * letters[direction].length
                                            - (type === 'major' ? 25 : 30)}px`,
                                        top: this.getRelative(dimension[type][i], node.rect.y, node.rect.height, false),
                                        bottom: this.getRelative(dimension[type][j], node.rect.y, node.rect.height, true),
                                        width: `5px`,
                                    },
                            });
                        }
                    }
                }
            }
        }
        return elements;
    }
    static getLetters(dimensions) {
        let letter = 'A';
        for (const direction of ['vertical', 'horizontal']) {
            for (const d1 of dimensions[direction]) {
                for (const d2 of dimensions[direction]) {
                    if (d1.id > d2.id
                        && d1.major.length === d2.major.length
                        && d1.major.every((v, i) => v === d2.major[i])
                        && d1.minor.length === d2.minor.length
                        && d1.minor.every((v, i) => v === d2.minor[i])) {
                        d1.letter = d2.letter;
                        break;
                    }
                }
                if (!d1.letter) {
                    d1.letter = letter;
                    letter = String.fromCharCode(letter.charCodeAt(0) + 1);
                }
            }
        }
    }
    static getNodeData(dimensions, node) {
        if (node.setDimensionsData && typeof node.setDimensionsData === 'function' && node.includeInExtendedDimensions) {
            node.setDimensionsData(dimensions);
        }
        if (node.children && node.children.length) {
            node.children.map(child => this.getNodeData(dimensions, child));
        }
    }
    static getRelative(position, rectPosition, rectLength, reverse) {
        position = (position - rectPosition) / rectLength;
        return `${Math.round((reverse ? 1 - position : position) * 1e4) / 1e2}%`;
    }
    static getExtensionWidth(side, sideProfiles, frames, usedProfiles, options, node) {
        const frameNodes = this.getFrameNodes(node);
        const sides = this.getFrameSidesOnEdge(frames, frameNodes);
        let width = 0;
        if (sideProfiles && sideProfiles.length) {
            const extensions = this.profilesBySide(sides[side], sideProfiles);
            extensions.map(extension => {
                const extensionProfile = usedProfiles.find(o => o.id === extension.profileId) || {};
                if (options.type !== 'outer') {
                    width += Number(extension.width) || Number(extensionProfile.width) || 45;
                }
                else {
                    width += Number(extension.widthOut) || Number(extensionProfile.widthOut) || 45;
                }
            });
        }
        return width;
    }
    static getFrameSidesOnEdge(frames, frameNodes) {
        const sides = {
            top: [],
            bottom: [],
            left: [],
            right: [],
        };
        const windowSides = [
            { side: 'bottom', sideSimple: 'bottom' },
            { side: 'right', sideSimple: 'side' },
            { side: 'top', sideSimple: 'top' },
            { side: 'left', sideSimple: 'side' },
        ];
        windowSides.forEach((side, sideIndex) => {
            if (frames && frames.length && frameNodes.length) {
                for (const frame of frames) {
                    const frameNode = frameNodes.find(f => f.frame.id === frame.id);
                    const parallelPoly = IccDrawMathService.getParallelPoly(frameNode.parent.poly, frameNode.parent.parent.poly);
                    sides[side.side].push({
                        frameId: frame.id,
                        frameEdgeIndex: parallelPoly.indexOf(sideIndex),
                    });
                }
            }
            else {
                sides[side.side].push({
                    frameId: 0,
                    frameEdgeIndex: sideIndex,
                });
            }
        });
        return sides;
    }
    static profilesBySide(frameEdges, sideProfiles) {
        const profiles = [];
        const firstProfiles = sideProfiles.filter(s => s.framesId.some(f => frameEdges.some(fE => f.id === fE.frameId && f.edges.includes(fE.frameEdgeIndex))));
        profiles.push(...firstProfiles);
        profiles.push(...firstProfiles
            .map(s => s.adjacentOtherSideProfileId.length > 0
            ? this.getNextProfiles(s, sideProfiles)
            : null)
            .reduce((acc, val) => val && acc.concat(val) || acc, []));
        return profiles;
    }
    static getNextProfiles(baseProfile, sideProfiles) {
        const allNextProfiles = [];
        const nextProfiles = sideProfiles.filter(s => baseProfile.adjacentOtherSideProfileId.includes(s.id));
        allNextProfiles.push(...nextProfiles);
        allNextProfiles.push(...nextProfiles
            .map(s => s.adjacentOtherSideProfileId.length > 0 ? this.getNextProfiles(s, sideProfiles) : null)
            .reduce((acc, val) => val && acc.concat(val) || acc, []));
        return allNextProfiles;
    }
    static getFrameNodes(node, data = []) {
        if (node instanceof FrameNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getFrameNodes(child, data)));
        return data;
    }
}

let IccDrawDimensionsComponent = class IccDrawDimensionsComponent {
    constructor() {
        this.dimensions = {};
        this.elements = [];
        this.margins = {};
        this.timestamp = 0;
    }
    ngDoCheck() {
        if (this.details && this.details.timestamp !== this.timestamp) {
            this.timestamp = this.details.timestamp;
            this.dimensions = {};
            this.elements = [];
            if (this.options && this.options.type === 'extended') {
                this.dimensions = IccDrawDimensionsService.getDimensions(this.details, this.node, this.options);
                this.elements = IccDrawDimensionsService.getElements(this.dimensions, this.node, this.options);
            }
            this.margins = this.getMargins();
        }
    }
    getMargins() {
        if (this.elements && this.elements.length) {
            const marginTop = this.options && this.options.type === 'extended' ? `30px` : `0`;
            const marginLeft = this.options && this.options.type === 'extended' ? `30px` : `0`;
            const marginRight = `${this.dimensions.vertical.reduce((r, o) => r.indexOf(o.letter) !== -1 ? r : r.concat(o.letter), []).length * 70}px`;
            const marginBottom = `${this.dimensions.horizontal.reduce((r, o) => r.indexOf(o.letter) !== -1 ? r : r.concat(o.letter), []).length * 50}px`;
            return {
                margin: `${marginTop} ${marginRight} ${marginBottom} ${marginLeft}`,
            };
        }
        else {
            return {};
        }
    }
};
IccDrawDimensionsComponent.ɵfac = function IccDrawDimensionsComponent_Factory(t) { return new (t || IccDrawDimensionsComponent)(); };
IccDrawDimensionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IccDrawDimensionsComponent, selectors: [["icc-draw-dimensions"]], inputs: { details: "details", node: "node", options: "options" }, decls: 2, vars: 1, consts: [[1, "icc-draw-dimensions"], [3, "ngClass", "ngStyle", "innerHTML", 4, "ngFor", "ngForOf"], [3, "ngClass", "ngStyle", "innerHTML"]], template: function IccDrawDimensionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, IccDrawDimensionsComponent_div_1_Template, 1, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.elements);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box;margin:0;padding:0}.icc-draw-dimensions[_ngcontent-%COMP%]{color:#000;font:400 14px/1em Arial}.icc-draw-dimensions[_ngcontent-%COMP%]   .center[_ngcontent-%COMP%]{display:flex;-webkit-box-orient:vertical;-webkit-box-pack:center;align-items:center;justify-content:center}.icc-draw-dimensions[_ngcontent-%COMP%]   .horizontal[_ngcontent-%COMP%], .icc-draw-dimensions[_ngcontent-%COMP%]   .vertical[_ngcontent-%COMP%]{position:absolute}.icc-draw-dimensions[_ngcontent-%COMP%]   .letter[_ngcontent-%COMP%]{font-weight:700}.icc-draw-dimensions[_ngcontent-%COMP%]   .major.line.horizontal[_ngcontent-%COMP%]{border-left:1px solid #000}.icc-draw-dimensions[_ngcontent-%COMP%]   .minor.line.horizontal[_ngcontent-%COMP%]{border-left:1px solid #000;border-bottom:1px solid #000}.icc-draw-dimensions[_ngcontent-%COMP%]   .major.line.vertical[_ngcontent-%COMP%]{border-top:1px solid #000}.icc-draw-dimensions[_ngcontent-%COMP%]   .minor.line.vertical[_ngcontent-%COMP%]{border-top:1px solid #000;border-right:1px solid #000}.icc-draw-dimensions[_ngcontent-%COMP%]   .major.center[_ngcontent-%COMP%]{font-size:.8em;font-weight:700}.icc-draw-dimensions[_ngcontent-%COMP%]   .minor.center[_ngcontent-%COMP%]{font-size:.6em}.icc-draw-dimensions[_ngcontent-%COMP%]   .major.center.horizontal[_ngcontent-%COMP%]{align-items:flex-end}.icc-draw-dimensions[_ngcontent-%COMP%]   .minor.center.horizontal[_ngcontent-%COMP%]{align-items:flex-start}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawDimensionsComponent.prototype, "details", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawDimensionsComponent.prototype, "node", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawDimensionsComponent.prototype, "options", void 0);
IccDrawDimensionsComponent = __decorate([ __metadata("design:paramtypes", [])
], IccDrawDimensionsComponent);

class SashNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.alignments = [];
        this.mullions = [];
        this.sash = {};
        this.usedProfiles = [];
        this.rectShift = {};
        this.layer = Layers.Sash;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            sash: this.sash,
        }, params);
    }
    setDrawData(data) {
        const shapeData = data.shape.find(s => s.positionId === this.positionId) || data.shape[0];
        const poly = IccDrawMathService.intersectPolyWithRect(shapeData.poly, this.rect);
        const parallelPoly = IccDrawMathService.getParallelPoly(this.poly, this.parent.poly);
        const parallelProfiles = parallelPoly.map(i => typeof i === 'number' && Number.isInteger(i)
            ? (this.parent.profiles[i] || this.parent.profiles[0]).profileId
            : null);
        data.sash.push({
            inner: new DrawData(this.poly),
            outer: new DrawData(poly),
            sashId: this.sash ? this.sash.id : null,
            parallel: {
                poly: parallelPoly || [],
                profiles: parallelProfiles || [],
            },
        });
    }
    init() {
        /** math: obliczenie współrzędnych figury */
        this.rect.x = this.parent.parent.rect.x + this.sash.x;
        this.rect.y = this.parent.parent.rect.y + this.sash.y;
        this.rect.width = this.sash.width;
        this.rect.height = this.sash.height;
        /** math: odcięcie sąsiadujących słupków i wyrównań */
        const rect = IccDrawMathService.getRectShift(this.rect, this.getMullionsShift());
        this.rectShift = rect;
        this.poly = IccDrawMathService.intersectPolyWithRect(this.parent.poly, rect);
        this.poly = IccDrawMathService.getPolyShift(this.poly, this.getAlignmentsShift());
        // this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, { fill: '#' + ((1<<24)*Math.random()|0).toString(16) }));
    }
    getAlignmentsShift() {
        const shift = { top: 0, left: 0, right: 0, bottom: 0 };
        if (this.sash.nearAlignments) {
            Object.keys(this.sash.nearAlignments).map(side => {
                if (this.sash.nearAlignments[side] !== -1) {
                    shift[side] += this.getAlignmentShift(this.sash.nearAlignments[side], side);
                }
            });
        }
        return shift;
    }
    getAlignmentShift(alignmentId, side) {
        const alignment = this.alignments.find(o => o.id === alignmentId) || {};
        const alignmentProfile = this.usedProfiles.find(o => o.id === alignment.profileId) || {};
        let shift;
        if (this.root.side !== 'outer') {
            shift = Number(alignmentProfile.width) || 45;
        }
        else {
            shift = Number(alignmentProfile.widthOut) || 45;
        }
        if (alignment && alignment.id) {
            if (alignment.parallelAlignments[side] && alignment.parallelAlignments[side].length) {
                shift += this.getAlignmentShift(alignment.parallelAlignments[side][0], side);
            }
            if (alignment.parallelMullions[side] && alignment.parallelMullions[side].length) {
                shift += this.getMullionShift(alignment.parallelMullions[side][0], side);
            }
        }
        return shift;
    }
    getMullionsShift() {
        const shift = { top: 0, left: 0, right: 0, bottom: 0 };
        if (this.sash.nearMullions) {
            Object.keys(this.sash.nearMullions).map(side => {
                if (this.sash.nearMullions[side] !== -1) {
                    shift[side] += this.getMullionShift(this.sash.nearMullions[side], side);
                }
            });
        }
        return shift;
    }
    getMullionShift(mullionId, side) {
        const mullion = this.mullions.find(o => o.id === mullionId) || {};
        const mullionProfile = this.usedProfiles.find(o => o.id === mullion.profileId) || this.usedProfiles.find(o => o.type === 'divider') || {};
        if (!mullionProfile || !mullionProfile.id) {
            return 0;
        }
        if (this.root.outerSide !== this.outerSash) {
            return (Number(mullionProfile.widthOut) || 90) / 2;
        }
        else {
            return (Number(mullionProfile.width) || 45) / 2;
        }
    }
}

class GlazingBeadNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.profiles = {};
        this.sash = {};
        this.usedProfiles = [];
        this.profilesPolygonsMap = {};
        this.filledDoor = false;
        this.jointAngles = 'E_E_E_E';
        this.shape = 'rect';
        this.parentPoly = [];
        this.parentRect = {};
        this.polygons = [];
        this.frameColor = {};
        this.sashColor = {};
        this.layer = Layers.SashFrameInside;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            profiles: this.profiles,
            sash: this.sash,
        }, params);
    }
    setDrawData(data) {
        data.glazingBead.push({
            inner: new DrawData(this.poly),
            outer: new DrawData(this.parent.poly),
            sides: this.polygons.map(poly => new DrawData(poly, {}, true)),
            sashId: this.sash ? this.sash.id : null,
        });
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal
            .filter(o => o.sashes.some(e => e === this.positionId + this.sash.id))
            .map(dimension => {
            dimension.minor.push(...this.poly.map(o => o.x));
        });
        dimensions.vertical
            .filter(o => o.sashes.some(e => e === this.positionId + this.sash.id))
            .map(dimension => {
            dimension.minor.push(...this.poly.map(o => o.y));
        });
    }
    init() {
        this.svg.paths = [];
        /** math: obliczenie przesunięcia */
        const profile = this.profiles
            ? this.usedProfiles.find(o => o.id === this.profiles.profileId)
            : null;
        this.width = profile ? Number(profile.width) : 20;
        if (this.root.outerSide !== this.outerSash) {
            this.layer = Layers.SashFrameOutside;
        }
        /** math: obliczenie współrzędnych figury */
        this.poly = IccDrawMathService.getPolyShift(this.parent.poly, this.width);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        /** math: odfiltrowanie zbliżonych punktów */
        this.poly = this.poly.filter((p, i) => !i
            || Math.abs(p.x - this.poly[i - 1].x) > 3
            || Math.abs(p.y - this.poly[i - 1].y) > 3);
        /** math: przesunięcie figury względem rodzica */
        this.parentPoly = IccDrawMathService.getPolyShift(this.poly, -this.width);
        this.parentRect = IccDrawMathService.getRectFromPoly(this.parentPoly);
        const jointAngle = IccDrawMathService.getJointAngles(this.parentPoly, this.jointAngles, this.shape);
        /** math: przygotowanie zestawów profili */
        const { polygons, polygonLineMap } = IccDrawMathService.getPolygons(this.parentPoly, this.poly, jointAngle);
        this.polygons = polygons;
        this.profilesPolygonsMap = polygonLineMap;
        /** svg: rysowanie ścieżek */
        if (this.sash.filling.type === 'deco_panels') {
            if (this.root.outerSide) {
                if ([this.root.panelTypes.Double, this.root.panelTypes.Outer].indexOf(this.sash.filling.overlay_type) !== -1) {
                    return this;
                }
            }
            else {
                if ([this.root.panelTypes.Double, this.root.panelTypes.Inner].indexOf(this.sash.filling.overlay_type) !== -1) {
                    return this;
                }
            }
        }
        if (this.sash.filling.type === 'door_panels') {
            return this;
        }
        let i = 0;
        for (const polygon of this.polygons) {
            const color = typeof this.sash.parentId !== 'undefined' ? this.sashColor : this.frameColor;
            if (color && color.visualization && color.visualization.visualizationImage) {
                const frameColor = color && color.color ? color.color : 'fff';
                this.setColorVisualization(color.visualization, frameColor, this.root.outerSide, 'glazingbead' + i, polygon);
            }
            else {
                this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, this.root.side, {
                    stroke: IccColorContrastService.getInvertedColor(color === null || color === void 0 ? void 0 : color.color) || "#bbb",
                    fill: `url('${this.root.uri}#iccDraw-${typeof this.sash.parentId !== 'undefined' ? 'sash' : 'frame'}-${this.root.uuid}-${this.positionId}')`,
                }));
            }
            i++;
        }
    }
}

class MullionNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.mullion = {};
        this.mullions = [];
        this.sash = {};
        this.sashes = [];
        this.sashNodes = [];
        this.usedProfiles = [];
        this.frameColor = {};
        this.sashColor = {};
        this.layer = Layers.Mullion;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            mullion: this.mullion,
            sash: this.sash,
        }, params);
    }
    onMove(params = {}) {
        return Object.assign({
            min: this.options.minPosition || 0,
            max: this.options.maxPosition || null,
            positionMin: this.positionMin,
            positionMax: this.positionMax,
            prev: this.mullion.position - this.prev,
            next: this.next - this.mullion.position,
            direction: this.mullion.direction,
            position: this.mullion.position,
            mullion: this.mullion,
            rect: this.parent.parent.rect,
            sash: this.sash,
            shift: this.parent.parent.rect,
        }, params);
    }
    setDrawData(data) {
        data.mullion.push(new DrawData(this.poly, {
            direction: this.mullion ? this.mullion.direction : null,
            mullionId: this.mullion ? this.mullion.id : null,
            sashId: this.sash ? this.sash.id : null,
            minWidthPrev: this.positionMin,
            minWidthNext: this.positionMax
        }));
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal.map(dimension => {
            if (this.rect.y <= dimension.stop
                && this.rect.y + this.rect.height >= dimension.start) {
                dimension.minor.push(this.rect.x, this.rect.x + this.rect.width);
            }
        });
        dimensions.vertical.map(dimension => {
            if (this.rect.x <= dimension.stop && this.rect.x + this.rect.width >= dimension.start) {
                dimension.minor.push(this.rect.y, this.rect.y + this.rect.height);
            }
        });
    }
    init() {
        this.svg.paths = [];
        const mullionProfile = this.usedProfiles.find(o => o.id === this.mullion.profileId)
            || this.usedProfiles.find(o => o.type === 'divider')
            || {};
        if (this.root.outerSide !== this.outerSash) {
            this.width = Number(mullionProfile.widthOut || 90);
        }
        else {
            this.width = Number(mullionProfile.width || 45);
        }
        if ((!mullionProfile || !mullionProfile.id) && this.mullion.type !== 'no_mullion') {
            return this;
        }
        /** math: znalezienie sąsiadujących słupków */
        const shift = { top: 0, left: 0, right: 0, bottom: 0 };
        if (this.mullion.direction === 'vertical') {
            shift.top =
                this.mullions.filter(o => o.direction === 'horizontal'
                    && o.perpendicularMullions.bottom.filter(id => id === this.mullion.id)
                        .length > 0).length > 0
                    ? this.width / 2
                    : 0;
            shift.bottom =
                this.mullions.filter(o => o.direction === 'horizontal'
                    && o.perpendicularMullions.top.filter(id => id === this.mullion.id).length
                        > 0).length > 0
                    ? this.width / 2
                    : 0;
        }
        if (this.mullion.direction === 'horizontal') {
            shift.left =
                this.mullions.filter(o => o.direction === 'vertical'
                    && o.perpendicularMullions.right.filter(id => id === this.mullion.id)
                        .length > 0).length > 0
                    ? this.width / 2
                    : 0;
            shift.right =
                this.mullions.filter(o => o.direction === 'vertical'
                    && o.perpendicularMullions.left.filter(id => id === this.mullion.id).length
                        > 0).length > 0
                    ? this.width / 2
                    : 0;
        }
        /** math: obliczenie wymiarów słupka */
        this.rect.x =
            this.mullion.direction === 'vertical'
                ? this.mullion.position - this.width / 2
                : this.mullion.adjacentSashes.top.reduce((prev, sId) => {
                    const adjacentSash = this.sashes.filter(s => s.id === sId);
                    return adjacentSash.length > 0 && prev > adjacentSash[0].x
                        ? adjacentSash[0].x
                        : prev;
                }, Number.MAX_VALUE);
        this.rect.y =
            this.mullion.direction === 'horizontal'
                ? this.mullion.position - this.width / 2
                : this.mullion.adjacentSashes.left.reduce((prev, sId) => {
                    const adjacentSash = this.sashes.filter(s => s.id === sId);
                    return adjacentSash.length > 0 && prev > adjacentSash[0].y
                        ? adjacentSash[0].y
                        : prev;
                }, Number.MAX_VALUE);
        this.rect.x += this.parent.parent.rect.x;
        this.rect.y += this.parent.parent.rect.y;
        this.rect.width =
            this.mullion.direction === 'horizontal' ? this.mullion.length : this.width;
        this.rect.height = this.mullion.direction === 'vertical' ? this.mullion.length : this.width;
        /** math: obliczenie części wspólnej figur */
        this.rect = IccDrawMathService.getRectShift(this.rect, shift);
        this.poly = IccDrawMathService.intersectPolyWithRect(this.parent.poly, this.rect);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        const { positionMin, positionMax, prev, next } = this.getMullionPosition();
        this.positionMin = positionMin;
        this.positionMax = positionMax;
        this.prev = prev;
        this.next = next;
        /** svg: rysowanie ścieżek */
        const color = this.sash ? this.sashColor : this.frameColor;
        if (color && color.visualization && color.visualization.visualizationImage) {
            const frameColor = color && color.color ? color.color : 'fff';
            this.setColorVisualization(color.visualization, frameColor, this.root.outerSide, 'mullion' + this.mullion.id, this.poly, this.mullion.direction === 'vertical');
        }
        else {
            this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                stroke: IccColorContrastService.getInvertedColor(color === null || color === void 0 ? void 0 : color.color) || '#bbb',
                fill: `url('${this.root.uri}#iccDraw-${this.sash ? 'sash' : 'frame'}-${this.root.uuid}-${this.positionId}')`,
            }));
        }
    }
    getMullionPosition() {
        const sides = this.mullion.direction === 'vertical' ? ['left', 'right'] : ['top', 'bottom'];
        const field = this.mullion.direction === 'vertical' ? ['x', 'width'] : ['y', 'height'];
        const prev = Math.max(...this.sashes
            .filter(sash => this.mullion.adjacentSashes[sides[0]].includes(sash.id))
            .map(sash => {
            if (sash.intMullions
                && sash.intMullions.some(mullion => mullion.direction === this.mullion.direction)) {
                return (sash[field[0]]
                    + Math.max(...sash.intMullions
                        .filter(mullion => mullion.direction === this.mullion.direction)
                        .map(mullion => mullion.position)));
            }
            else if (sash.nearMullions && sash.nearMullions[sides[0]] !== -1) {
                return this.mullions.find(o => o.id === sash.nearMullions[sides[0]])
                    .position;
            }
            else {
                return sash[field[0]];
            }
        }));
        const positionMinNodes = this.sashes
            .filter(sash => this.mullion.adjacentSashes[sides[0]].includes(sash.id))
            .map(sash => this.sashNodes.find(s => s.sash.id === sash.id))
            .filter(node => node)
            .reduce((acu, node) => {
            acu.push(...this.getGlazingNodes(node));
            return acu;
        }, []);
        const positionMin = positionMinNodes.reduce((acu, node) => acu[1] < node.glazingBead.rect[field[0]]
            ? [
                node.glazingBead.rect[field[0]] - node.sash.rect[field[0]],
                node.glazingBead.rect[field[0]],
            ]
            : acu, [0, 0])[0]
            + positionMinNodes.reduce((acu, node) => acu[1] < node.glazingBead.rect[field[0]]
                ? [
                    node.sash.rect[field[0]]
                        + node.sash.rect[field[1]]
                        - node.glazingBead.rect[field[0]]
                        - node.glazingBead.rect[field[1]],
                    node.glazingBead.rect[field[0]],
                ]
                : acu, [0, 0])[0];
        const next = Math.min(...this.sashes
            .filter(sash => this.mullion.adjacentSashes[sides[1]].includes(sash.id))
            .map(sash => {
            if (sash.intMullions
                && sash.intMullions.some(mullion => mullion.direction === this.mullion.direction)) {
                return (sash[field[0]]
                    + Math.min(...sash.intMullions
                        .filter(mullion => mullion.direction === this.mullion.direction)
                        .map(mullion => mullion.position)));
            }
            else if (sash.nearMullions && sash.nearMullions[sides[1]] !== -1) {
                return this.mullions.find(o => o.id === sash.nearMullions[sides[1]])
                    .position;
            }
            else {
                return sash[field[0]] + sash[field[1]];
            }
        }));
        const positionMaxNodes = this.sashes
            .filter(sash => this.mullion.adjacentSashes[sides[1]].includes(sash.id))
            .map(sash => this.sashNodes.find(s => s.sash.id === sash.id))
            .filter(node => node)
            .reduce((acu, node) => {
            acu.push(...this.getGlazingNodes(node));
            return acu;
        }, []);
        const positionMax = positionMaxNodes.reduce((acu, node) => acu[1] > node.glazingBead.rect[field[0]]
            ? [
                node.glazingBead.rect[field[0]] - node.sash.rect[field[0]],
                node.glazingBead.rect[field[0]],
            ]
            : acu, [0, Number.MAX_SAFE_INTEGER])[0]
            + positionMaxNodes.reduce((acu, node) => acu[1] > node.glazingBead.rect[field[0]]
                ? [
                    node.sash.rect[field[0]]
                        + node.sash.rect[field[1]]
                        - node.glazingBead.rect[field[0]]
                        - node.glazingBead.rect[field[1]],
                    node.glazingBead.rect[field[0]],
                ]
                : acu, [0, Number.MAX_SAFE_INTEGER])[0];
        return { positionMin, positionMax, prev, next };
    }
    getGlazingNodes(node, data = [], sashNode = null) {
        if (node instanceof SashNode) {
            sashNode = node;
        }
        if (node instanceof GlazingBeadNode) {
            data.push({
                glazingBead: node,
                sash: sashNode,
            });
        }
        node.children.map(child => (data = this.getGlazingNodes(child, data, sashNode)));
        return data;
    }
}

class InterfaceButton {
    constructor(params) {
        Object.assign(this, params);
    }
}
class InterfaceGroup {
    constructor(params) {
        this.buttons = [];
        this.fields = [];
        Object.assign(this, params);
    }
}
class IccDrawInterfaceService {
    static getInterfaceGroups(groups, node) {
        if (node.options && node.options.buttons && node.options.buttons.length) {
            this.getInterfaceGroup(groups, node, node.options.buttons);
        }
        if (node.children && node.children.length) {
            node.children.map(child => this.getInterfaceGroups(groups, child));
        }
        if (groups.length) {
            groups.map(group => {
                group.buttons.map(button => {
                    if (button.uuid
                        && button.uuid !== 'move'
                        && !groups.some(e => e.uuid === button.uuid)) {
                        group.buttons.splice(group.buttons.indexOf(button), 1);
                    }
                });
            });
        }
    }
    static getInterfaceGroup(groups, node, buttons, rect, uuid) {
        const positions = {
            top: [],
            left: [],
            right: [],
            bottom: [],
            center: [],
            'center-profile': [],
            rect: [],
            start: [],
            end: [],
        };
        buttons.map(button => {
            const interfaceButton = new InterfaceButton({
                class: button.class,
                innerHtml: button.innerHtml,
                onClick: button.onClick,
                onMove: button.onMove,
                title: button.title,
                type: button.fields,
            });
            if (button.onMove) {
                interfaceButton.uuid = 'move';
            }
            if (button.buttons && button.buttons.length) {
                interfaceButton.uuid = node.getUUID();
                if (button.fields === 'extensions') {
                    this.getSideProfilesFields(node).map(field => {
                        this.getInterfaceGroup(groups, node, button.buttons, field, interfaceButton.uuid);
                    });
                }
                else if (button.fields === 'profiles') {
                    this.getFrameFields(node).map(field => {
                        this.getInterfaceGroup(groups, node, button.buttons, field, interfaceButton.uuid);
                    });
                }
                else {
                    this.getInterfaceGroup(groups, node, button.buttons, rect, interfaceButton.uuid);
                }
            }
            if (button.positions && button.positions.length) {
                for (const position of button.positions) {
                    if (!button.condition || button.condition(node.onClick({ index: position }))) {
                        positions[position].push(interfaceButton);
                    }
                }
            }
            else {
                if (!button.condition || button.condition(node.onClick({ index: 'center' }))) {
                    positions.center.push(interfaceButton);
                }
            }
        });
        Object.keys(positions).map(position => {
            if (positions[position] && positions[position].length) {
                positions[position].forEach(button => {
                    const buttonCopy = Object.assign({}, button);
                    if (button.type === 'profiles') {
                        node.polygons.forEach((p, pIndex) => {
                            if (p.every(i => !i.cr)) {
                                const fieldRect = IccDrawMathService.getRectFromPoly(p);
                                IccDrawInterfaceService.setInterfaceGroup(groups, position, fieldRect, buttonCopy, node, uuid, pIndex, button.type);
                            }
                        });
                    }
                    else {
                        const fieldRect = rect
                            ? rect
                            : node.poly
                                ? IccDrawMathService.getRectFromPoly(node.poly)
                                : null;
                        IccDrawInterfaceService.setInterfaceGroup(groups, position, fieldRect, buttonCopy, node, uuid, null, button.type);
                    }
                });
            }
        });
    }
    static setInterfaceGroup(groups, position, fieldRect, buttonCopy, node, uuid, index = null, type = null) {
        const interfaceGroup = groups.find(g => g.side === position
            && IccDrawInterfaceService.equalPosition(g.rect, fieldRect, position, node, g.node)
            && g.uuid === uuid
            && g.type == type);
        if (interfaceGroup) {
            interfaceGroup.buttons.push(buttonCopy);
        }
        else {
            const newInterfaceGroup = new InterfaceGroup({
                buttons: [buttonCopy],
                node: node,
                rect: fieldRect,
                side: position,
                uuid: uuid,
                index: index,
                type: buttonCopy.type,
            });
            groups.push(newInterfaceGroup);
        }
    }
    static equalPosition(rect1, rect2, side, node, node2) {
        const gravity1 = IccDrawInterfaceService.getGroupGravity(side, rect1);
        const gravity2 = IccDrawInterfaceService.getGroupGravity(side, rect2);
        const position1 = IccDrawInterfaceService.getGroupPosition(gravity1, node);
        const position2 = IccDrawInterfaceService.getGroupPosition(gravity2, node);
        return (Math.abs(position1.left - position2.left) < 5
            && Math.abs(position1.top - position2.top) < 5
            && node.positionId === node2.positionId);
    }
    static setInterfaceGroups(groups) {
        groups.map(group => {
            var _a, _b, _c, _d, _e, _f;
            if (group.rect) {
                group.style = {};
                switch (group.side) {
                    case 'top':
                        group.gravity = IccDrawInterfaceService.getGroupGravity(group.side, group.rect);
                        group.style.marginLeft = `${-25 * group.buttons.length}px`;
                        group.style.height = `50px`;
                        break;
                    case 'left':
                        group.gravity = IccDrawInterfaceService.getGroupGravity(group.side, group.rect);
                        group.style.marginTop = `${-25 * group.buttons.length}px`;
                        group.style.width = `50px`;
                        break;
                    case 'right':
                        group.gravity = IccDrawInterfaceService.getGroupGravity(group.side, group.rect);
                        group.style.marginTop = `${-25 * group.buttons.length}px`;
                        group.style.width = `50px`;
                        break;
                    case 'bottom':
                        group.gravity = IccDrawInterfaceService.getGroupGravity(group.side, group.rect);
                        group.style.marginLeft = `${-25 * group.buttons.length}px`;
                        group.style.height = `50px`;
                        break;
                    case 'center':
                        if ((group === null || group === void 0 ? void 0 : group.node) instanceof MullionNode && ((_b = (_a = group === null || group === void 0 ? void 0 : group.node) === null || _a === void 0 ? void 0 : _a.mullion) === null || _b === void 0 ? void 0 : _b.type) === 'no_mullion') {
                            const sashes = group.node.sashes.filter(i => group.node.mullion.adjacentSashes.left[0] === i.id || group.node.mullion.adjacentSashes.right[0] === i.id).sort((a, b) => (a === null || a === void 0 ? void 0 : a.x) - (b === null || b === void 0 ? void 0 : b.x));
                            group.rect = {
                                x: (_c = sashes[0]) === null || _c === void 0 ? void 0 : _c.x,
                                y: (_d = sashes[0]) === null || _d === void 0 ? void 0 : _d.y,
                                width: ((_e = sashes[0]) === null || _e === void 0 ? void 0 : _e.width) * 2,
                                height: (_f = sashes[1]) === null || _f === void 0 ? void 0 : _f.height,
                            };
                        }
                        group.gravity = IccDrawInterfaceService.getGroupGravity(group.side, group.rect);
                        group.style.marginLeft = `-50px`;
                        group.style.marginTop = `-50px`;
                        group.style.width = `100px`;
                        group.style.height = `100px`;
                        break;
                    case 'rect':
                        group.style = IccDrawMathService.getRelativePosition(group.node.root.rect, group.rect);
                        break;
                    case 'center-profile':
                        group.gravity = IccDrawInterfaceService.getGroupGravity(group.side, group.rect);
                        group.style.marginLeft = `-50px`;
                        group.style.marginTop = `-50px`;
                        group.style.width = `100px`;
                        group.style.height = `100px`;
                        break;
                    case 'start':
                        break;
                    case 'end':
                        break;
                }
                if (group.gravity) {
                    const { left, top } = IccDrawInterfaceService.getGroupPosition(group.gravity, group.node);
                    group.style.left = `${left}%`;
                    group.style.top = `${top}%`;
                }
            }
        });
    }
    static getMuntinsFields(node) {
        const fields = [];
        let poly, rect;
        // const nodeRect = node.rect;
        const nodeRect = IccDrawMathService.getRectFromPoly(node.poly);
        const muntinsH = node.parent.children.filter(node => node.muntin && node.rect.width && !node.rect.height);
        const muntinsV = node.parent.children.filter(node => node.muntin && !node.rect.width && node.rect.height);
        const breakpointsH = muntinsV
            .map(node => node.rect.x)
            .concat(nodeRect.x, nodeRect.x + nodeRect.width)
            .sort((a, b) => a - b);
        const breakpointsV = muntinsH
            .map(node => node.rect.y)
            .concat(nodeRect.y, nodeRect.y + nodeRect.height)
            .sort((a, b) => a - b);
        for (let indexV = 0; indexV < breakpointsV.length - 1; indexV++) {
            let lastBreakpointH = breakpointsH[0];
            for (let indexH = 0; indexH < breakpointsH.length - 1; indexH++) {
                if (muntinsV.some(node => node.rect.x === breakpointsH[indexH + 1]
                    && node.rect.y < breakpointsV[indexV + 1]
                    && node.rect.y + node.rect.height > breakpointsV[indexV])
                    || nodeRect.x + nodeRect.width === breakpointsH[indexH + 1]) {
                    rect = {
                        x: lastBreakpointH,
                        y: breakpointsV[indexV],
                        width: breakpointsH[indexH + 1] - lastBreakpointH,
                        height: breakpointsV[indexV + 1] - breakpointsV[indexV],
                    };
                    poly = IccDrawMathService.intersectPolyWithRect(node.poly, rect);
                    if (poly && poly.length) {
                        fields.push(IccDrawMathService.getRectFromPoly(poly));
                    }
                    lastBreakpointH = breakpointsH[indexH + 1];
                }
            }
        }
        return fields;
    }
    static getSideProfilesFields(node) {
        const fields = [];
        let poly, rect;
        // const nodeRect = node.rect;
        const nodeRect = IccDrawMathService.getRectFromPoly(node.poly);
        const muntinsH = node.parent.children.filter(node => node.muntin && node.rect.width && !node.rect.height);
        const muntinsV = node.parent.children.filter(node => node.muntin && !node.rect.width && node.rect.height);
        const breakpointsH = muntinsV
            .map(node => node.rect.x)
            .concat(nodeRect.x, nodeRect.x + nodeRect.width)
            .sort((a, b) => a - b);
        const breakpointsV = muntinsH
            .map(node => node.rect.y)
            .concat(nodeRect.y, nodeRect.y + nodeRect.height)
            .sort((a, b) => a - b);
        for (let indexV = 0; indexV < breakpointsV.length - 1; indexV++) {
            let lastBreakpointH = breakpointsH[0];
            for (let indexH = 0; indexH < breakpointsH.length - 1; indexH++) {
                if (muntinsV.some(node => node.rect.x === breakpointsH[indexH + 1]
                    && node.rect.y < breakpointsV[indexV + 1]
                    && node.rect.y + node.rect.height > breakpointsV[indexV])
                    || nodeRect.x + nodeRect.width === breakpointsH[indexH + 1]) {
                    rect = {
                        x: lastBreakpointH,
                        y: breakpointsV[indexV],
                        width: breakpointsH[indexH + 1] - lastBreakpointH,
                        height: breakpointsV[indexV + 1] - breakpointsV[indexV],
                    };
                    poly = IccDrawMathService.intersectPolyWithRect(node.poly, rect);
                    if (poly && poly.length) {
                        fields.push(IccDrawMathService.getRectFromPoly(poly));
                    }
                    lastBreakpointH = breakpointsH[indexH + 1];
                }
            }
        }
        return fields;
    }
    static getFrameFields(node) {
        const fields = [];
        for (const polygon of node.polygons) {
            fields.push(IccDrawMathService.getRectFromPoly(polygon));
        }
        return fields;
    }
    static getGroupGravity(side, rect) {
        switch (side) {
            case 'top':
                return { x: rect.x + rect.width / 2, y: rect.y };
            case 'left':
                return {
                    x: rect.x,
                    y: rect.y + rect.height / 2,
                };
            case 'right':
                return {
                    x: rect.x + rect.width,
                    y: rect.y + rect.height / 2,
                };
            case 'bottom':
                return {
                    x: rect.x + rect.width / 2,
                    y: rect.y + rect.height,
                };
            case 'center':
                return {
                    x: rect.x + rect.width / 2,
                    y: rect.y + rect.height / 2,
                };
            case 'rect':
                return {
                    x: rect.x + rect.width / 2,
                    y: rect.y + rect.height / 2,
                };
            case 'center-profile':
                return {
                    x: rect.x + rect.width / 2,
                    y: rect.y + rect.height / 2,
                };
        }
    }
    static getGroupPosition(gravity, node) {
        const left = ((gravity.x - node.root.rect.x) * 100) / node.root.rect.width;
        const top = ((gravity.y - node.root.rect.y) * 100) / node.root.rect.height;
        return { left, top };
    }
}

let IccDrawInterfaceComponent = class IccDrawInterfaceComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.clicked = new EventEmitter();
        // Sticky options
        this.stickyPositions = false;
        this.isPositionMinMaxValid = false;
        this.isPositionValid = false;
        this.stickyPreviewStyle = {};
        this.currentStickyBounds = null;
        this.groups = [];
        this.move = {
            actions: {
                onClick: () => { },
                onMove: () => { },
            },
            direction: null,
            inputs: {
                next: 0,
                prev: 0,
                ratio: 1,
            },
            listeners: {
                mousemove: () => { },
                mouseup: () => { },
            },
            min: 0,
            max: 0,
            node: null,
            position: {
                curr: 0,
                min: 0,
                minGlass: 0,
                max: 0,
                maxGlass: 0,
                next: 0,
                node: 0,
                old: 0,
                prev: 0,
                positionsMinMax: []
            },
            rect: {},
            shift: {
                next: 0,
                prev: 0,
            },
            style: {},
            update: () => {
                const response = this.move.node.onMove();
                const fields = response.direction === 'vertical' ? ['x', 'width'] : ['y', 'height'];
                this.move.direction = response.direction;
                this.move.min = response.min || 0;
                this.move.max = response.max || null;
                this.stickyPositions = response.stickyPositions;
                if (this.stickyPositions) {
                    this.move.position.positionsMinMax = response.positionsMinMax || [];
                }
                this.move.position.minGlass = response.positionMin;
                this.move.position.maxGlass = response.positionMax;
                this.move.position.min = response.position - response.prev;
                this.move.position.max = response.position + response.next;
                this.move.position.node = response.position;
                this.move.position.old = response.position;
                this.move.rect = response.rect;
                if (this.options.moveShift) {
                    this.move.shift.next =
                        response.rect[fields[0]]
                            + response.rect[fields[1]]
                            - response.shift[fields[0]]
                            - response.shift[fields[1]];
                    this.move.shift.prev = response.shift[fields[0]] - response.rect[fields[0]];
                }
                else {
                    this.move.shift.next = 0;
                    this.move.shift.prev = 0;
                }
                this.updatePosition(response.position);
            },
        };
    }
    click(event) {
        this.cancelMoving();
    }
    ngOnChanges() {
        this.groups = [];
        if (this.node) {
            IccDrawInterfaceService.getInterfaceGroups(this.groups, this.node);
            IccDrawInterfaceService.setInterfaceGroups(this.groups);
        }
    }
    cancelMoving() {
        if (this.uuid) {
            this.move.node = null;
            this.uuid = undefined;
            this.clicked.next(true);
            this.interfaceClickHandler && this.interfaceClickHandler();
            this.currentStickyBounds = null;
        }
    }
    onButtonClick(button, group) {
        this.uuid = button.uuid;
        this.clicked.next(true);
        if (button.onMove) {
            this.move.actions.onClick = button.onClick;
            this.move.actions.onMove = button.onMove;
            this.move.node = group.node;
            this.move.update();
        }
        else if (button.onClick) {
            button.onClick(group.node.onClick({
                index: group.side,
                rect: group.rect,
                profileIndex: group.index,
            }));
        }
        this.interfaceClickHandler && this.interfaceClickHandler();
    }
    onChangeNext() {
        this.move.inputs.next = parseFloat(this.move.inputs.next);
        this.move.position.next =
            this.move.inputs.next * (this.move.inputs.ratio || 1) + this.move.shift.next;
        this.updatePosition(this.move.position.max - this.move.position.next);
        this.submitPosition();
    }
    onChangePrev() {
        this.move.inputs.prev = parseFloat(this.move.inputs.prev);
        this.move.position.prev =
            this.move.inputs.prev * (this.move.inputs.ratio || 1) + this.move.shift.prev;
        this.updatePosition(this.move.position.min + this.move.position.prev);
        this.submitPosition();
    }
    onClickCancel() {
        if (this.move.position.curr !== this.move.position.old) {
            this.updatePosition(this.move.position.old);
            this.submitPosition();
        }
    }
    onClickSubmit() {
        this.move.actions.onClick(this.move.node.onClick({
            index: 'move',
        }));
        // this.uuid = undefined;
    }
    onStartMoving() {
        this.move.listeners.mousemove = this.renderer.listen('document', 'mousemove', this.onPointerMove.bind(this));
        this.move.listeners.touchmove = this.renderer.listen('document', 'touchmove', this.onPointerMove.bind(this));
        this.move.listeners.mouseup = this.renderer.listen('document', 'mouseup', this.onPointerUp.bind(this));
        this.move.listeners.touchend = this.renderer.listen('document', 'touchend', this.onPointerUp.bind(this));
    }
    submitPosition() {
        // Check if its in a valid position
        if (this.move.node && (!this.stickyPositions || this.isPositionValid)) {
            this.move.actions.onMove(this.move.node.onMove({
                difference: this.move.position.node - this.move.position.curr,
                position: this.move.position.curr,
            }));
            this.move.position.node = this.move.position.curr;
        }
        else if (this.currentStickyBounds) {
            // If position is not valid but it's in 'sticky' bounds
            const stickyBoundsMiddlePosition = this.currentStickyBounds.max
                - ((this.currentStickyBounds.max - this.currentStickyBounds.min) / 2);
            if (stickyBoundsMiddlePosition > this.move.position.minGlass
                && stickyBoundsMiddlePosition < this.move.position.maxGlass) {
                this.move.actions.onMove(this.move.node.onMove({
                    difference: this.move.position.node - stickyBoundsMiddlePosition,
                    position: stickyBoundsMiddlePosition,
                }));
                this.move.position.node = stickyBoundsMiddlePosition;
            }
            this.cancelMoving();
        }
        else {
            this.cancelMoving();
        }
    }
    updatePosition(curr) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        this.move.position.curr = Number(curr) || 0;
        if (((_a = this.move) === null || _a === void 0 ? void 0 : _a.node) instanceof MullionNode && ((_d = (_c = (_b = this.move) === null || _b === void 0 ? void 0 : _b.node) === null || _c === void 0 ? void 0 : _c.mullion) === null || _d === void 0 ? void 0 : _d.type) === 'no_mullion') {
            const sashes = (_e = this.move) === null || _e === void 0 ? void 0 : _e.node.sashes.filter(i => { var _a, _b; return ((_a = this.move) === null || _a === void 0 ? void 0 : _a.node.mullion.adjacentSashes.left[0]) === i.id || ((_b = this.move) === null || _b === void 0 ? void 0 : _b.node.mullion.adjacentSashes.right[0]) === i.id; }).sort((a, b) => (a === null || a === void 0 ? void 0 : a.x) - (b === null || b === void 0 ? void 0 : b.x));
            this.move.position.min = (_f = sashes[0]) === null || _f === void 0 ? void 0 : _f.x;
            this.move.position.max = ((_g = sashes[1]) === null || _g === void 0 ? void 0 : _g.x) + ((_h = sashes[1]) === null || _h === void 0 ? void 0 : _h.width);
            this.move.position.curr = curr || ((_j = sashes[0]) === null || _j === void 0 ? void 0 : _j.x) + ((_k = sashes[0]) === null || _k === void 0 ? void 0 : _k.width);
        }
        if (this.stickyPositions) {
            this.move.position.curr = Math.max(this.move.position.curr, this.move.position.min);
            this.move.position.curr = Math.min(this.move.position.curr, this.move.position.max);
        }
        else {
            this.move.position.curr = Math.max(this.move.position.curr, this.move.position.min
                + this.move.position.minGlass
                + this.move.shift.prev
                + this.move.min);
            this.move.position.curr = Math.min(this.move.position.curr, this.move.position.max
                - this.move.position.maxGlass
                - this.move.shift.next
                - this.move.min);
        }
        const rect = IccDrawMathService.getRectFromPoly(this.move.node.poly);
        if (this.stickyPositions) {
            this.isPositionMinMaxValid = (this.move.position.minGlass <= this.move.position.curr
                && this.move.position.maxGlass >= this.move.position.curr);
            this.isPositionValid = (this.isPositionMinMaxValid
                && (this.move.position.positionsMinMax.length === 0
                    || this.move.position.positionsMinMax.find(p => p.min <= this.move.position.curr - (rect.width / 2)
                        && p.max >= this.move.position.curr + (rect.width / 2)))) ? true : false;
            this.currentStickyBounds = this.move.position.positionsMinMax.find(p => (p.stickyMin && p.stickyMin <= this.move.position.curr)
                && (p.stickyMax && p.stickyMax >= this.move.position.curr));
            // Create style for a preview of available sticky position
            if (this.currentStickyBounds) {
                const stickyBoundsMid = this.move.rect.x
                    + this.currentStickyBounds.stickyMin
                    + ((this.currentStickyBounds.stickyMax - this.currentStickyBounds.stickyMin) / 2);
                this.stickyPreviewStyle = IccDrawMathService.getRelativePosition(this.move.node.root.rect, { x: stickyBoundsMid - (rect.width / 2), width: rect.width, height: rect.height, y: rect.y }, this.move.node.root.side);
                if (this.move.node.shape === 'circle') {
                    this.stickyPreviewStyle['border-radius'] = '100%';
                }
                else {
                    this.stickyPreviewStyle['border-radius'] = '0%';
                }
                this.stickyPreviewStyle['background-color'] = this.currentStickyBounds
                    && this.isPositionMinMaxValid ? 'rgb(0,255,0)' : 'rgb(255,0,0)';
                this.stickyPreviewStyle['border'] = '2px dashed ' + (this.currentStickyBounds
                    && this.isPositionMinMaxValid ? 'rgb(0, 150, 0)' : 'rgb(150, 0, 0)');
            }
        }
        if (this.move.max) {
            this.move.position.curr = Math.min(this.move.position.curr, this.move.max);
            this.move.position.curr = Math.max(this.move.position.curr, this.move.position.min + this.move.position.max - this.move.max);
        }
        if (((_l = this.move) === null || _l === void 0 ? void 0 : _l.node) instanceof MullionNode && ((_p = (_o = (_m = this.move) === null || _m === void 0 ? void 0 : _m.node) === null || _o === void 0 ? void 0 : _o.mullion) === null || _p === void 0 ? void 0 : _p.type) === 'no_mullion') {
            const sashes = (_q = this.move) === null || _q === void 0 ? void 0 : _q.node.sashes.filter(i => { var _a, _b; return ((_a = this.move) === null || _a === void 0 ? void 0 : _a.node.mullion.adjacentSashes.left[0]) === i.id || ((_b = this.move) === null || _b === void 0 ? void 0 : _b.node.mullion.adjacentSashes.right[0]) === i.id; }).sort((a, b) => (a === null || a === void 0 ? void 0 : a.x) - (b === null || b === void 0 ? void 0 : b.x));
            rect.y = (_r = sashes[0]) === null || _r === void 0 ? void 0 : _r.y;
            rect.height = (_s = sashes[0]) === null || _s === void 0 ? void 0 : _s.height;
        }
        this.move.position.next = this.move.position.max - this.move.position.curr;
        this.move.position.prev = this.move.position.curr - this.move.position.min;
        this.move.inputs.next = IccDrawMathService.round((this.move.position.next - this.move.shift.next) / (this.move.inputs.ratio || 1), 2);
        this.move.inputs.prev = IccDrawMathService.round((this.move.position.prev - this.move.shift.prev) / (this.move.inputs.ratio || 1), 2);
        if (this.move.direction === 'vertical') {
            rect.x = this.move.position.curr + this.move.rect.x;
            rect.width = 0;
        }
        else {
            rect.y = this.move.position.curr + this.move.rect.y;
            rect.height = 0;
        }
        this.move.style = IccDrawMathService.getRelativePosition(this.move.node.root.rect, rect, this.move.node.root.side);
    }
    onPointerMove(event) {
        event.preventDefault();
        if (this.move.node && this.svg) {
            let point = this.svg.createSVGPoint();
            point.x = event.clientX || event.changedTouches[0].clientX;
            point.y = event.clientY || event.changedTouches[0].clientY;
            point = point.matrixTransform(this.svg.getScreenCTM().inverse());
            let position = this.move.direction === 'vertical'
                ? point.x - this.move.rect.x
                : point.y - this.move.rect.y;
            if (event.altKey) {
                position = Math.round(position / 100) * 100;
            }
            else if (event.ctrlKey) {
                position = Math.round(position / 10) * 10;
            }
            else if (event.shiftKey) {
                position = Math.round(position * 10) / 10;
            }
            else {
                position = Math.round(position);
            }
            this.updatePosition(position);
        }
    }
    onPointerUp(event) {
        this.submitPosition();
        this.move.listeners.mousemove();
        this.move.listeners.touchmove();
        this.move.listeners.mouseup();
        this.move.listeners.touchend();
    }
};
IccDrawInterfaceComponent.ɵfac = function IccDrawInterfaceComponent_Factory(t) { return new (t || IccDrawInterfaceComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
IccDrawInterfaceComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IccDrawInterfaceComponent, selectors: [["icc-draw-interface"]], hostBindings: function IccDrawInterfaceComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function IccDrawInterfaceComponent_click_HostBindingHandler($event) { return ctx.click($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { node: "node", options: "options", svg: "svg", interfaceClickHandler: "interfaceClickHandler" }, outputs: { clicked: "clicked" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 6, consts: [[1, "icc-draw-interface", 3, "ngStyle"], ["class", "sticky-preview", 3, "ngStyle", 4, "ngIf"], [3, "ngClass", "ngStyle", "class", "click", 4, "ngFor", "ngForOf"], ["class", "icc-draw-move", 3, "ngClass", "ngStyle", "click", 4, "ngIf"], [1, "sticky-preview", 3, "ngStyle"], [3, "ngClass", "ngStyle", "click"], [3, "innerHTML", "ngClass", "ngStyle", "click", 4, "ngFor", "ngForOf"], [3, "innerHTML", "ngClass", "ngStyle", "click"], [1, "icc-draw-move", 3, "ngClass", "ngStyle", "click"], ["placeholder", "NaN", "type", "text", 1, "prev", 3, "ngModel", "ngModelChange", "change"], ["placeholder", "NaN", "type", "text", 1, "next", 3, "ngModel", "ngModelChange", "change"], ["class", "cancel ico-move-cancel", 3, "click", 4, "ngIf"], ["class", "submit ico-move-submit", 3, "click", 4, "ngIf"], [1, "move", 3, "ngClass", "mousedown", "touchstart"], [1, "cancel", "ico-move-cancel", 3, "click"], [1, "submit", "ico-move-submit", 3, "click"]], template: function IccDrawInterfaceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, IccDrawInterfaceComponent_span_1_Template, 1, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, IccDrawInterfaceComponent_div_2_Template, 2, 8, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, IccDrawInterfaceComponent_div_3_Template, 7, 13, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx.uuid ? "all" : "none"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentStickyBounds);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.groups);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.move.node && ctx.uuid === "move");
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], styles: ["[_nghost-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box;margin:0;outline:0;padding:0}.move--position-invalid[_ngcontent-%COMP%]{background-color:red!important}.text--position-invalid[_ngcontent-%COMP%]{color:red}.icc-draw-interface[_ngcontent-%COMP%]{bottom:0;left:0;position:absolute;right:0;top:0}.icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{opacity:0;position:absolute;pointer-events:none;transition:.1s ease-in-out}.icc-draw-interface[_ngcontent-%COMP%] > div.active[_ngcontent-%COMP%]{opacity:1}.icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.rect){align-content:center;align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:-25px 0 0 -25px;text-align:center}.icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:block}.icc-draw-interface[_ngcontent-%COMP%] > div.active[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{pointer-events:all}.icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:hover{cursor:pointer}.icc-draw-interface[_ngcontent-%COMP%] > div.rect[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{bottom:-10px;left:-10px;position:absolute;right:-10px;top:-10px;transition:.1s ease-in-out}.icc-draw-interface[_ngcontent-%COMP%] > div.rect[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:hover{background:rgba(255,0,0,.2)}.icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.rect) > span[_ngcontent-%COMP%]{background:center center no-repeat #fff;border:none;border-radius:20px;box-shadow:2px 2px 2px 0 rgba(0,0,0,.5);font:700 12px/40px Arial;height:40px;margin:5px;padding:0;text-align:center;transition:.1s ease-in-out;width:40px}.icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.rect) > span[_ngcontent-%COMP%]:active, .icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.rect) > span[_ngcontent-%COMP%]:focus, .icc-draw-interface[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.rect) > span[_ngcontent-%COMP%]:hover{box-shadow:3px 3px 3px 1px rgba(0,0,0,.5)}.sticky-preview[_ngcontent-%COMP%]{position:absolute}.icc-draw-move[_ngcontent-%COMP%]{border:1px dotted red;position:absolute}.icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{height:0;left:50%;position:relative;top:50%;width:0}.icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .move[_ngcontent-%COMP%]{left:-20px;top:-20px}.icc-draw-move.horizontal[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .cancel[_ngcontent-%COMP%], .icc-draw-move.vertical[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .prev[_ngcontent-%COMP%]{left:-70px;top:-20px}.icc-draw-move.horizontal[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .submit[_ngcontent-%COMP%], .icc-draw-move.vertical[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .next[_ngcontent-%COMP%]{left:30px;top:-20px}.icc-draw-move.horizontal[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .prev[_ngcontent-%COMP%], .icc-draw-move.vertical[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .cancel[_ngcontent-%COMP%]{left:-20px;top:-70px}.icc-draw-move.horizontal[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .next[_ngcontent-%COMP%], .icc-draw-move.vertical[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .submit[_ngcontent-%COMP%]{left:-20px;top:30px}.icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{background:center center no-repeat #fff;border:none;border-radius:20px;box-shadow:2px 2px 2px 0 rgba(0,0,0,.5);display:block;font:700 12px/40px Arial;height:40px;padding:0;position:absolute;text-align:center;transition:.1s ease-in-out;width:40px}.icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:active, .icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:focus, .icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:hover{box-shadow:3px 3px 3px 1px rgba(0,0,0,.5)}.icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .cancel[_ngcontent-%COMP%]:hover, .icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .submit[_ngcontent-%COMP%]:hover{cursor:pointer}.icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .move[_ngcontent-%COMP%]:hover{cursor:move}.icc-draw-move[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:hover{cursor:text}"] });
IccDrawInterfaceComponent.ctorParameters = () => [
    { type: Renderer2 }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawInterfaceComponent.prototype, "node", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawInterfaceComponent.prototype, "options", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawInterfaceComponent.prototype, "svg", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], IccDrawInterfaceComponent.prototype, "interfaceClickHandler", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], IccDrawInterfaceComponent.prototype, "clicked", void 0);
__decorate([
    HostListener('document:click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], IccDrawInterfaceComponent.prototype, "click", null);
IccDrawInterfaceComponent = __decorate([ __metadata("design:paramtypes", [Renderer2])
], IccDrawInterfaceComponent);

class IccDrawDetails {
    constructor(params = {}) {
        this.shape = {};
        this.usedProfiles = [];
        if (params.$version < 5) {
            params.mullions = params.dividers;
            for (const mullion of params.mullions || []) {
                mullion.perpendicularMullions = mullion.adjacentDividers;
            }
            for (const sash of params.sashes || []) {
                sash.intMullions = sash.intDividers;
                sash.nearMullions = sash.nearDividers;
                for (const mullion of sash.intMullions || []) {
                    mullion.perpendicularMullions = mullion.adjacentDividers;
                }
                for (const intSash of sash.intSashes || []) {
                    intSash.intMullions = intSash.intDividers;
                    intSash.nearMullions = intSash.nearDividers;
                    for (const mullion of intSash.intMullions || []) {
                        mullion.perpendicularMullions = mullion.adjacentDividers;
                    }
                }
            }
        }
        Object.assign(this, params);
    }
}
class IccDrawOptions {
    constructor(params = {}) {
        this.base = {
            kickerLowThreshold: false,
            side: 'inner',
            ventilator: true,
        };
        this.colors = {
            glassStartColor: '#cbdff4',
            glassStopColor: '#f0fbff',
            glassGradient: {},
        };
        this.dimensions = {
            multiplier: 1,
            ratio: 1,
            type: 'inner',
        };
        this.indexes = {
            multiplier: 1,
        };
        this.interface = {
            moveShift: true,
        };
        Object.assign(this, params);
    }
    onInterfaceClick() { }
    ;
}
class IccDrawService {
    static getViewBox(node, side, data = { x: 0, y: 0, width: 0, height: 0 }) {
        data = {
            x: Math.min(data.x, node.rect.x),
            y: Math.min(data.y, node.rect.y),
            width: data.x + data.width > node.rect.x + node.rect.width ? data.width : node.rect.x + node.rect.width - data.x,
            height: data.y + data.height > node.rect.y + node.rect.height ? data.height : node.rect.y + node.rect.height - data.y,
        };
        node.children.map(child => data = this.getViewBox(child, side, data));
        return data;
    }
}

class WicketDoorHandleNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.side = 'right';
        this.handleWidth = 120;
        this.handleHeight = 30;
        this.layer = GarageDoorLayers.WicketDoorHandle;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        this.svg.paths = [];
        this.handleWidth = this.parent.rect.width / 6;
        const escutcheonPlateWidth = this.frameWidth / 2;
        const escutcheonPlateHeight = this.handleHeight * 2;
        const handleFrameOffset = this.frameWidth / 8;
        let x = this.side === 'left'
            ? this.parent.rect.x + this.frameWidth - escutcheonPlateWidth - handleFrameOffset
            : this.parent.rect.x + this.parent.rect.width - this.frameWidth + handleFrameOffset;
        this.rect = {
            x,
            y: this.parent.rect.y + (this.parent.rect.height / 2) - (escutcheonPlateHeight / 2) || 0,
            height: escutcheonPlateHeight,
            width: escutcheonPlateWidth
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        const image = `/files/garagedoorcolor/${this.handleColorImg}`;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-wicketDoorHandle-${this.root.uuid}`,
            color: '#' + this.handleColor,
            image
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-wicketDoorHandle-${this.root.uuid}')`,
            stroke: '#000000',
            strokeWidth: 1
        }));
        x = this.side === 'left'
            ? this.parent.rect.x + (this.frameWidth / 2)
            : this.parent.rect.x + this.parent.rect.width - this.handleWidth - (this.frameWidth / 2);
        this.rect = {
            x,
            y: this.parent.rect.y + (this.parent.rect.height / 2) - (this.handleHeight / 2),
            height: this.handleHeight,
            width: this.handleWidth
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-wicketDoorHandle-${this.root.uuid}`,
            color: '#' + this.handleColor,
            image
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-wicketDoorHandle-${this.root.uuid}')`,
            stroke: '#000000',
            strokeWidth: 1
        }));
    }
}

class WicketDoorNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.layer = GarageDoorLayers.WicketDoor;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        this.svg.paths = [];
        this.rect = {
            x: this.parent.rect.x + Number(this.dimensions.x) || 0,
            y: this.parent.rect.y + Number(this.dimensions.y) || 0,
            height: Number(this.dimensions.height) || 0,
            width: Number(this.dimensions.width) || 0
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            stroke: '#000000',
            strokeWidth: 3
        }));
    }
}

class PanelInsertContainerNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.dimensions = {
            x: null,
            width: null,
            height: null,
            diameter: null
        };
        this.index = 0;
        this.layer = GarageDoorLayers.PanelInsertContainer;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        const wicketDoor = this.parent.parent.children.find(c => c instanceof WicketDoorNode);
        this.wicketDoorDimensions = wicketDoor && wicketDoor.dimensions;
        this.init();
    }
    onMove(params = {}) {
        const positionsMinMax = [];
        const panelInsertNodes = this.parent.children.filter(c => c instanceof PanelInsertContainerNode);
        const prevInsert = panelInsertNodes.length > 1 && panelInsertNodes.find(n => n.index === (this.index - 1));
        const positionMin = (prevInsert
            && prevInsert.dimensions
            && prevInsert.dimensions.x
                + this.getPanelInsertWidth(prevInsert.dimensions)
                + this.parent.insertsSpacing
                + (this.getPanelInsertWidth(this.dimensions) / 2))
            || this.parent.insertsOffset + (this.getPanelInsertWidth(this.dimensions) / 2);
        const nextInsert = panelInsertNodes.length > 1 && panelInsertNodes.find(n => n.index === (this.index + 1));
        const positionMax = (nextInsert
            && nextInsert.dimensions
            && nextInsert.dimensions.x - this.parent.insertsOffset - (this.getPanelInsertWidth(this.dimensions) / 2))
            || this.parent.rect.width - this.parent.insertsOffset - (this.getPanelInsertWidth(this.dimensions) / 2);
        // If insert is in panel with wicket door
        if (this.wicketDoorDimensions
            && this.parent.parent.rect.y + this.wicketDoorDimensions.y < this.parent.rect.y + this.parent.rect.height) {
            const wicketDoorMiddle = this.wicketDoorDimensions.x + (this.wicketDoorDimensions.width / 2);
            positionsMinMax.push({
                min: this.parent.insertsOffset,
                max: wicketDoorMiddle - 735
            });
            // If it's a 3rd panel or the type is 'ventilation_grate' make it possible to add insert at wicket door's middle position
            if (this.parent.index === 3 || this.type === 'ventilation_grate') {
                positionsMinMax.push({
                    stickyMin: this.wicketDoorDimensions.x,
                    stickyMax: this.wicketDoorDimensions.x + this.wicketDoorDimensions.width,
                    min: wicketDoorMiddle,
                    max: wicketDoorMiddle
                });
            }
            positionsMinMax.push({
                min: wicketDoorMiddle + 735,
                max: this.parent.rect.width - this.parent.insertsOffset
            });
        }
        return Object.assign({
            stickyPositions: true,
            positionMin,
            positionMax,
            min: 0,
            max: this.parent.rect.width,
            positionsMinMax,
            prev: this.prev,
            next: this.next,
            direction: 'vertical',
            position: this.position,
            panelPositionId: this.parent.index,
            positionId: this.index,
            rect: this.parent.parent.rect,
            shift: this.parent.parent.rect
        }, params);
    }
    onClick(params = {}) {
        return Object.assign({
            panelPositionId: this.parent.index,
            positionId: this.index
        }, params);
    }
    init() {
        this.svg.paths = [];
        const panelInsertWidth = this.getPanelInsertWidth(this.dimensions);
        const panelInsertHeight = this.getPanelInsertHeight(this.dimensions);
        this.prev = this.dimensions.x,
            this.position = this.dimensions.x + (panelInsertWidth / 2);
        this.next = (this.parent.rect.width - this.dimensions.x - panelInsertWidth);
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.rect.x + (this.dimensions.x || 0),
            y: this.parent.rect.y + (this.parent.rect.height / 2) - (panelInsertHeight / 2),
            height: panelInsertHeight || 0,
            width: panelInsertWidth || 0
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
    }
    getPanelInsertWidth(insert) {
        return (this.shape === 'circle' ? insert.diameter : insert.width);
    }
    getPanelInsertHeight(insert) {
        return this.type === 'glazing' ? this.parent.rect.height : (this.shape === 'circle' ? insert.diameter : insert.height);
    }
}

class PanelInsertImpostNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.color = {
            inner: null,
            outer: null
        };
        this.layer = GarageDoorLayers.PanelInsert;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        this.rect = {
            x: Number(this.parent.rect.x + this.x) || 0,
            y: Number(this.parent.rect.y + this.width) || 0,
            height: Number(this.parent.rect.height - (this.width * 2)) || 0,
            width: Number(this.width) || 0
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        const color = (this.root.side === 'inner'
            ? this.color.inner && this.color.inner.color
            : this.color.outer && this.color.outer.color) || 'ffffff';
        const image = '/files/garagedoorcolor/' + (this.root.side === 'inner'
            ? this.color.inner && this.color.inner.color_img
            : this.color.outer && this.color.outer.color_img);
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-panelInsertFrame-${this.root.uuid}-${this.parent.parent.index}-${this.parent.index}`,
            color: '#' + color,
            image,
            x: this.rect.x || 0,
            y: this.rect.y || 0,
            width: Number(this.rect.width) || 0,
            height: Number(this.rect.height) || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-panelInsertFrame-${this.root.uuid}-${this.parent.parent.index}-${this.parent.index}')`,
            stroke: '#000000',
            strokeWidth: 0.5
        }));
    }
}

class AlignmentNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.layer = Layers.Alignment;
        this.alignment = {};
        this.alignments = [];
        this.mullions = [];
        this.usedProfiles = [];
        this.frameColor = {};
        this.sashColor = {};
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        const alignmentProfile = this.usedProfiles.find(o => o.id === this.alignment.profileId) || {};
        if (this.root.side !== 'outer') {
            this.width = Number(alignmentProfile.width) || 45;
        }
        else {
            this.width = Number(alignmentProfile.widthOut) || 45;
        }
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.parent.rect.x + (this.alignment.direction === 'horizontal' ? this.alignment.shift : this.alignment.position),
            y: this.parent.parent.rect.y + (this.alignment.direction === 'vertical' ? this.alignment.shift : this.alignment.position),
            width: this.alignment.direction === 'horizontal' ? this.alignment.length : this.width,
            height: this.alignment.direction === 'vertical' ? this.alignment.length : this.width,
        };
        this.shiftFrame();
        this.poly = IccDrawMathService.intersectPolyWithRect(this.parent.poly, this.rect);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.shiftRect(this.alignment.id);
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        /** svg: rysowanie ścieżek */
        const color = this.sash ? this.sashColor : this.frameColor;
        if (color && color.visualization && color.visualization.visualizationImage) {
            const frameColor = color && color.color ? color.color : 'fff';
            this.setColorVisualization(color.visualization, frameColor, this.root.outerSide, 'alignment' + this.alignment.id, this.poly, this.alignment.direction === 'horizontal');
        }
        else {
            this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                stroke: '#bbb',
                // fill: '#f5f5f5',
                fill: `url('${this.root.uri}#iccDraw-${this.sash ? 'sash' : 'frame'}-${this.root.uuid}-${this.positionId}')`,
            }));
        }
    }
    onClick(params = {}) {
        return Object.assign({
            alignment: this.alignment,
            sash: this.sash,
        }, params);
    }
    setDrawData(data) {
        data.alignment.push(new DrawData(this.poly, {
            alignmentId: this.alignment ? this.alignment.id : null,
            direction: this.alignment ? this.alignment.direction : null,
            sashId: this.sash ? this.sash.id : null,
        }));
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal
            .filter(o => (o.start <= this.rect.y && this.rect.y < o.stop)
            || (o.start < this.rect.y + this.rect.height
                && this.rect.y + this.rect.height <= o.stop))
            .map(dimension => {
            dimension.minor.push(this.rect.x, this.rect.x + this.rect.width);
        });
        dimensions.vertical
            .filter(o => (o.start <= this.rect.x && this.rect.x < o.stop)
            || (o.start < this.rect.x + this.rect.width
                && this.rect.x + this.rect.width <= o.stop))
            .map(dimension => {
            dimension.minor.push(this.rect.y, this.rect.y + this.rect.height);
        });
    }
    shiftFrame() {
        if (this.alignment.side === 'left' && this.alignment.position === 0) {
            this.rect.x = this.parent.rect.x;
        }
        if (this.alignment.side === 'right' && this.alignment.position === this.parent.parent.rect.width) {
            this.rect.x = this.parent.rect.x + this.parent.rect.width;
        }
        if (this.alignment.side === 'top' && this.alignment.position === 0) {
            this.rect.y = this.parent.rect.y;
        }
        if (this.alignment.side === 'bottom' && this.alignment.position === this.parent.parent.rect.height) {
            this.rect.y = this.parent.rect.y + this.parent.rect.height;
        }
        if (this.alignment.side === 'right') {
            this.rect.x -= this.rect.width;
        }
        if (this.alignment.side === 'bottom') {
            this.rect.y -= this.rect.height;
        }
    }
    shiftRect(id, side) {
        const alignment = this.alignments.find(o => o.id === id) || {};
        const sides = this.alignment.direction === 'horizontal' ? ['left', 'right'] : ['top', 'bottom'];
        if (alignment && alignment.id) {
            if (this.alignment.id === alignment.id) {
                sides.map(side => {
                    alignment.perpendicularAlignments[side].map(id => this.shiftRect(id, side));
                    alignment.perpendicularMullions[side].map(id => this.shiftMullion(id, side));
                });
            }
            else {
                this.shiftAlignment(alignment.id, side);
            }
            alignment.parallelAlignments[side || this.alignment.side].map(id => this.shiftRect(id, side));
            alignment.parallelMullions[side || this.alignment.side].map(id => this.shiftMullion(id, side));
        }
    }
    shiftAlignment(id, side) {
        const alignment = this.alignments.find(o => o.id === id) || {};
        const alignmentProfile = this.usedProfiles.find(o => o.id === alignment.profileId) || {};
        if (this.root.side !== 'outer') {
            this.shiftSide(Number(alignmentProfile.width) || 45, side);
        }
        else {
            this.shiftSide(Number(alignmentProfile.widthOut) || 45, side);
        }
    }
    shiftMullion(id, side) {
        const mullion = this.mullions.find(o => o.id === id) || {};
        const mullionProfile = this.usedProfiles.find(o => o.id === mullion.profileId) || {};
        if (mullionProfile.id) {
            if (this.root.outerSide !== this.root.outerSash) {
                this.shiftSide((Number(mullionProfile.widthOut) || 90) / 2, side);
            }
            else {
                this.shiftSide((Number(mullionProfile.width) || 45) / 2, side);
            }
        }
    }
    shiftSide(width, side) {
        if (side) {
            switch (side) {
                case 'top':
                    this.rect.height -= width;
                    this.rect.y += width;
                    break;
                case 'left':
                    this.rect.width -= width;
                    this.rect.x += width;
                    break;
                case 'right':
                    this.rect.width -= width;
                    break;
                case 'bottom':
                    this.rect.height -= width;
                    break;
            }
        }
        else {
            switch (this.alignment.side) {
                case 'top':
                    this.rect.y += width;
                    break;
                case 'left':
                    this.rect.x += width;
                    break;
                case 'right':
                    this.rect.x -= width;
                    break;
                case 'bottom':
                    this.rect.y -= width;
                    break;
            }
        }
    }
}

class ColorsNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.layer = Layers.Colors;
        this.colors = {
            frame: {},
            sash: {},
        };
        this.muntins = {
            colorInner: {},
            colorOuter: {},
        };
        this.frame = {};
        this.sash = {};
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this.colors, params.colors);
        Object.assign(this.muntins, params.muntins);
        /** svg: gradient szyby */
        if (this.options.glassGradient) {
            this.svg.gradients.push(IccDrawSvgService.getGradient(Object.assign({ id: `iccDraw-glazing-${this.root.uuid}` }, this.options.glassGradient)));
        }
        else {
            this.svg.gradients.push(IccDrawSvgService.getGradient({
                id: `iccDraw-glazing-${this.root.uuid}`,
                steps: [
                    { color: this.options.glassStartColor || '#cbdff4', offset: '0%' },
                    { color: this.options.glassStopColor || '#f0fbff', offset: '100%' },
                ],
            }));
        }
        /** svg: tekstura szyby */
        /** svg: kolor ramy */
        let frame = this.root.side === 'outer' && this.colors.frame.alushell && this.colors.frame.alushell.id
            ? this.colors.frame.alushell
            : this.colors.frame[this.root.side] && this.colors.frame[this.root.side].id
                ? this.colors.frame[this.root.side]
                : this.colors.frame.core && this.colors.frame.core.id
                    ? this.colors.frame.core
                    : null;
        if (frame && params.colorsDict) {
            frame = params.colorsDict[frame.id + '+' + Number(frame.RAL)];
        }
        this.frame = frame;
        const frameColor = frame && frame.color ? frame.color : 'fff';
        const frameImage = frame && frame.color_img ? frame.color_img : null;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-frame-${this.root.uuid}-${this.positionId}`,
            color: frameColor ? `#${frameColor}` : null,
            image: frameImage ? `/files/color/${frameImage}` : null,
            height: this.root.rect.height,
            width: this.root.rect.width,
        }));
        /** svg: kolor skrzydła */
        let sash = this.root.side === 'outer' && this.colors.sash.alushell && this.colors.sash.alushell.id
            ? this.colors.sash.alushell
            : this.colors.sash[this.root.side] && this.colors.sash[this.root.side].id
                ? this.colors.sash[this.root.side]
                : this.colors.sash.core && this.colors.sash.core.id
                    ? this.colors.sash.core
                    : null;
        if (sash && params.colorsDict) {
            sash = params.colorsDict[sash.id + '+' + Number(sash.RAL)];
        }
        this.sash = sash;
        const sashColor = sash && sash.color ? sash.color : 'fff';
        const sashImage = sash && sash.color_img ? sash.color_img : null;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-sash-${this.root.uuid}-${this.positionId}`,
            color: sashColor ? `#${sashColor}` : null,
            image: sashImage ? `/files/color/${sashImage}` : null,
            height: this.root.rect.height,
            width: this.root.rect.width,
        }));
        /** svg: kolor listwy przyszybowej */
        /** svg: kolor szprosów */
        let muntins = this.root.side === 'inner' && this.muntins.colorInner && this.muntins.colorInner.id
            ? this.muntins.colorInner
            : this.root.side === 'outer'
                && this.muntins.colorOuter
                && this.muntins.colorOuter.id
                ? this.muntins.colorOuter
                : null;
        if (muntins && params.colorsDict) {
            muntins = params.colorsDict[muntins.id + '+' + Number(muntins.RAL)];
        }
        const muntinsColor = muntins ? muntins.color : 'fff';
        const muntinsImage = muntins ? muntins.color_img : null;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-muntins-${this.root.uuid}-${this.positionId}`,
            color: muntinsColor ? `#${muntinsColor}` : null,
            image: muntinsImage ? `/files/color/${muntinsImage}` : null,
            height: this.root.rect.height,
            width: this.root.rect.width,
        }));
        if (params.accessoryColorsDict) {
            Object.keys(params.accessoryColorsDict).forEach(colorId => {
                const color = params.accessoryColorsDict[colorId];
                const accessoryColor = color ? color.color : 'fff';
                const accessoryImage = color ? color.color_img : null;
                this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: `iccDraw-accessory-${colorId}-${this.root.uuid}-${this.positionId}`,
                    color: accessoryColor ? `#${accessoryColor}` : null,
                    image: accessoryImage ? `/files/windowhandlescolor/${accessoryImage}` : null,
                    height: this.root.rect.height,
                    width: this.root.rect.width,
                }));
            });
        }
        /** svg: wzór dla słupka ruchomego */
    }
}

class ExtensionsNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.sideProfiles = {};
        this.usedProfiles = [];
        this.frames = [];
        this.frameNodes = [];
        this.extensions = [];
        this.shift = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        };
        this.color = {};
        this.layer = Layers.Extensions;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            extensions: this.extensions,
        }, params);
    }
    setDrawData(data) {
        this.extensions.map(extension => {
            data.extension.push(new DrawData(extension.poly, {
                direction: ['top', 'bottom'].indexOf(extension.side) !== -1
                    ? 'horizontal'
                    : 'vertical',
                extensionId: extension.extension ? extension.extension.id : null,
                positionId: this.positionId,
            }));
        });
    }
    setDimensionsData(dimensions) {
        this.extensions.map(extension => {
            dimensions.horizontal.map(dimension => {
                dimension.minor.push(extension.rect.x, extension.rect.x + extension.rect.width);
            });
            dimensions.vertical.map(dimension => {
                dimension.minor.push(extension.rect.y, extension.rect.y + extension.rect.height);
            });
        });
    }
    init() {
        this.extensions = [];
        this.svg.paths = [];
        this.svg.patterns = [];
        this.shift = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        };
        this.rect = this.parent.rect;
        this.poly = this.parent.poly;
        const sides = this.getFrameSidesOnEdge();
        /** math: obliczenie współrzędnych figury */
        Object.keys(this.shift).map((side) => {
            if (this.sideProfiles && this.sideProfiles.length) {
                const extensions = this.profilesBySide(sides[side], this.sideProfiles);
                extensions.map(extension => {
                    const extensionProfile = this.usedProfiles.find(o => o.id === extension.profileId) || {};
                    let line;
                    let poly;
                    let rect;
                    poly = IccDrawMathService.getPolyFromRect(this.rect);
                    if (this.root.side !== 'outer') {
                        this.shift[side] -=
                            Number(extension.width) || Number(extensionProfile.width) || 45;
                    }
                    else {
                        this.shift[side] -=
                            Number(extension.widthOut) || Number(extensionProfile.widthOut) || 45;
                    }
                    this.poly = IccDrawMathService.getPolyShift(this.parent.poly, this.shift);
                    this.rect = IccDrawMathService.getRectFromPoly(this.poly);
                    switch (side) {
                        case 'left':
                            line = [poly[0], poly[1]];
                            break;
                        case 'right':
                            line = [poly[2], poly[3]];
                            break;
                        case 'top':
                            line = [poly[3], poly[0]];
                            break;
                        case 'bottom':
                            line = [poly[1], poly[2]];
                            break;
                    }
                    poly = IccDrawMathService.intersectPolyWithLine(this.poly, line, side);
                    rect = IccDrawMathService.getRectFromPoly(poly);
                    this.extensions.push({ extension, poly, rect, side });
                });
            }
        });
        /** svg: rysowanie ścieżek */
        this.extensions.map(extension => {
            const color = extension.extension.color;
            const sideColor = color && (color[this.root.side] && color[this.root.side].id ? color[this.root.side] : color.core);
            if (sideColor && sideColor.id) {
                if (sideColor
                    && sideColor.visualization
                    && sideColor.visualization.visualizationImage) {
                    const frameColor = sideColor && sideColor.color ? sideColor.color : 'fff';
                    this.setColorVisualization(sideColor.visualization, frameColor, this.root.outerSide, 'extension' + extension.extension.id, extension.poly, ['top', 'bottom'].indexOf(extension.side) === -1);
                }
                else {
                    this.svg.patterns.push(IccDrawSvgService.getPattern({
                        id: `iccDraw-extension-${extension.extension.id}-${this.uuid}`,
                        color: sideColor.color
                            ? `#${sideColor.color}`
                            : '#fff',
                        image: sideColor.color_img
                            ? `/files/color/${sideColor.color_img}`
                            : null,
                        height: extension.rect.height,
                        width: extension.rect.width,
                    }));
                    this.svg.paths.push(IccDrawSvgService.getPath(extension.poly, true, this.root.side, {
                        fill: `url('${this.root.uri}#iccDraw-extension-${extension.extension.id}-${this.uuid}')`,
                        stroke: '#bbb',
                    }));
                }
            }
            else {
                if (this.color
                    && this.color.visualization
                    && this.color.visualization.visualizationImage) {
                    const frameColor = this.color && this.color.color ? this.color.color : 'fff';
                    this.setColorVisualization(this.color.visualization, frameColor, this.root.outerSide, 'extension' + extension.extension.id, extension.poly, ['top', 'bottom'].indexOf(extension.side) === -1);
                }
                else {
                    this.svg.paths.push(IccDrawSvgService.getPath(extension.poly, true, this.root.side, {
                        fill: `url('${this.root.uri}#iccDraw-frame-${this.root.uuid}-${this.positionId}')`,
                        stroke: 'red',
                    }));
                }
            }
        });
    }
    getFrameSidesOnEdge() {
        const sides = {
            top: [],
            bottom: [],
            left: [],
            right: [],
        };
        const windowSides = [
            { side: 'bottom', sideSimple: 'bottom' },
            { side: 'right', sideSimple: 'side' },
            { side: 'top', sideSimple: 'top' },
            { side: 'left', sideSimple: 'side' },
        ];
        windowSides.forEach((side, sideIndex) => {
            if (this.frames && this.frames.length && this.frameNodes.length) {
                for (const frame of this.frames) {
                    const frameNode = this.frameNodes.find(f => f.frame.id === frame.id);
                    const parallelPoly = IccDrawMathService.getParallelPoly(frameNode.parent.poly, frameNode.parent.parent.poly);
                    if (parallelPoly.indexOf(sideIndex) > -1) {
                        sides[side.side].push({
                            frameId: frame.id,
                            frameEdgeIndex: parallelPoly.indexOf(sideIndex),
                        });
                    }
                    else {
                        sides[side.side].push({
                            frameId: frame.id,
                            frameEdgeIndex: parallelPoly.indexOf(sideIndex),
                        });
                    }
                }
            }
            else {
                sides[side.side].push({
                    frameId: 0,
                    frameEdgeIndex: sideIndex,
                });
            }
        });
        return sides;
    }
    profilesBySide(frameEdges, sideProfiles) {
        const profiles = [];
        const firstProfiles = sideProfiles.filter(s => s.framesId.some(f => frameEdges.some(fE => f.id === fE.frameId && f.edges.includes(fE.frameEdgeIndex))));
        profiles.push(...firstProfiles);
        profiles.push(...firstProfiles
            .map(s => s.adjacentOtherSideProfileId.length > 0
            ? this.getNextProfiles(s, sideProfiles)
            : null)
            .reduce((acc, val) => (val && acc.concat(val)) || acc, []));
        return profiles;
    }
    getNextProfiles(baseProfile, sideProfiles) {
        const allNextProfiles = [];
        const nextProfiles = sideProfiles.filter(s => baseProfile.adjacentOtherSideProfileId.includes(s.id));
        allNextProfiles.push(...nextProfiles);
        allNextProfiles.push(...nextProfiles
            .map(s => s.adjacentOtherSideProfileId.length > 0
            ? this.getNextProfiles(s, sideProfiles)
            : null)
            .reduce((acc, val) => (val && acc.concat(val)) || acc, []));
        return allNextProfiles;
    }
}

class CoupledExtensionNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.extension = {};
        this.extensions = [];
        this.windows = [];
        this.extensionPosition = 0;
        this.layer = Layers.Extensions;
        this.parallelFrameLine = null;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.width = Number(this.extension.width);
        /** math: znalezienie sąsiadujących słupków */
        const shift = { top: 0, left: 0, right: 0, bottom: 0 };
        const frameNodes = this.getFrameNodes(this.root);
        const coupledExtensionNodes = this.getCoupledExtensionNodes(this.root);
        const extensionNodes = this.getExtensionNodes(this.root);
        if (this.extension.framesId.length > 0) {
            const sId = this.extension.framesId[0];
            const frameNode = frameNodes.find(n => n.frame.id === sId.id && n.positionId === sId.positionId);
            this.parallelFrameLine = this.getParallelFrameLine(frameNode, sId.edges[0]);
            const extensionNode = extensionNodes.find(n => n.positionId === sId.positionId);
            if (extensionNode && extensionNode.extensions.length > 0) {
                const { angle, side } = IccDrawMathService.getLineInfo(this.parallelFrameLine);
                let line;
                switch (side) {
                    case 'bottom':
                        line = [extensionNode.poly[0], extensionNode.poly[1]];
                        break;
                    case 'top':
                        line = [extensionNode.poly[2], extensionNode.poly[3]];
                        break;
                    case 'left':
                        line = [extensionNode.poly[3], extensionNode.poly[3]];
                        break;
                    case 'right':
                        line = [extensionNode.poly[1], extensionNode.poly[2]];
                        break;
                }
                this.poly = this.getExtensionPoly(line);
            }
            else {
                this.poly = this.getExtensionPoly(this.parallelFrameLine);
            }
        }
        else if (this.extension.adjacentSideProfileId.length > 0) {
            const sId = this.extension.adjacentSideProfileId[0];
            const extensionNode = coupledExtensionNodes.find(n => n.extension.id === sId);
            this.parallelFrameLine = extensionNode.parallelFrameLine;
            const { angle } = IccDrawMathService.getLineInfo(extensionNode.parallelFrameLine);
            this.poly = this.getExtensionPoly(angle < 1
                ? [extensionNode.poly[0], extensionNode.poly[1]]
                : [extensionNode.poly[2], extensionNode.poly[3]]);
        }
        /** math: obliczenie części wspólnej figur */
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.setParentPoly();
        const color = this.extension.color;
        if (color && color[this.root.side]) {
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-extension-${this.extension.id}-${this.uuid}`,
                color: color[this.root.side].color ? `#${color[this.root.side].color}` : '#fff',
                image: color[this.root.side].color_img
                    ? `/files/color/${color[this.root.side].color_img}`
                    : null,
                height: this.rect.height,
                width: this.rect.width,
            }));
        }
        else {
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-extension-${this.extension.id}-${this.uuid}`,
                color: '#fff',
                image: null,
                height: this.rect.height,
                width: this.rect.width,
            }));
        }
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-extension-${this.extension.id}-${this.uuid}')`,
            stroke: '#bbb',
        }));
    }
    onClick(params = {}) {
        return Object.assign({
            extension: this.extension,
        }, params);
    }
    setDrawData(data) {
        data.extension.push(new DrawData(this.poly, {
            extensionId: this.extension ? this.extension.id : null,
        }, true));
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal.map(dimension => {
            if (this.rect.y <= dimension.stop
                && this.rect.y + this.rect.height >= dimension.start) {
                dimension.minor.push(this.rect.x, this.rect.x + this.rect.width);
            }
        });
        dimensions.vertical.map(dimension => {
            if (this.rect.x <= dimension.stop && this.rect.x + this.rect.width >= dimension.start) {
                dimension.minor.push(this.rect.y, this.rect.y + this.rect.height);
            }
        });
    }
    getFrameNodes(node, data = []) {
        if (node instanceof FrameNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getFrameNodes(child, data)));
        return data;
    }
    getCoupledExtensionNodes(node, data = []) {
        if (node instanceof CoupledExtensionNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getCoupledExtensionNodes(child, data)));
        return data;
    }
    getExtensionNodes(node, data = []) {
        if (node instanceof ExtensionsNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getExtensionNodes(child, data)));
        return data;
    }
    getParallelFrameLine(frameNode, edgeIndex) {
        return [
            frameNode.parent.poly[(edgeIndex + frameNode.parent.poly.length) % frameNode.parent.poly.length],
            frameNode.parent.poly[(edgeIndex + 1 + frameNode.parent.poly.length) % frameNode.parent.poly.length],
        ];
    }
    getExtensionPoly(parallelLine) {
        const line = IccDrawMathService.getLineShift(parallelLine, -this.extension.width);
        const { angle } = IccDrawMathService.getLineInfo(line);
        const line2 = angle < 1 ? [parallelLine[0], line[0]] : [line[1], parallelLine[1]];
        const line3 = IccDrawMathService.getLineShift(line2, this.extension.shift);
        const line4 = IccDrawMathService.getLineShift(line3, this.extension.length);
        return [line3[1], line4[1], line4[0], line3[0]];
    }
}

class CoupledCouplingNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.coupling = {};
        this.couplings = [];
        this.windows = [];
        this.couplingPosition = 0;
        this.layer = Layers.Frame;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.width = Number(this.coupling.width);
        const frameNodes = this.getFrameNodes(this.root);
        const coupledExtensionNodes = this.getCoupledExtensionNodes(this.root);
        const extensionNodes = this.getExtensionNodes(this.root);
        if (this.coupling.framesId.length > 0 || this.coupling.otherFramesId.length) {
            const sId = this.coupling.framesId[0] && this.coupling.framesId[0].edges.length > 0
                ? this.coupling.framesId[0]
                : this.coupling.otherFramesId[0];
            const frameNode = frameNodes.find(n => n.frame.id === sId.id && n.positionId === sId.positionId);
            const extensionNode = extensionNodes.find(n => n.positionId === sId.positionId);
            if (extensionNode && extensionNode.extensions.length > 0) {
                const { angle, side } = IccDrawMathService.getLineInfo(this.getParallelFrameLine(frameNode, sId.edges[0]));
                let line;
                let shift = 0;
                let framePoint = frameNode.parent.poly[(sId.edges[0] + frameNode.parent.poly.length) % frameNode.parent.poly.length];
                switch (side) {
                    case 'bottom':
                        line = [extensionNode.poly[0], extensionNode.poly[1]];
                        shift = framePoint.x - extensionNode.poly[0].x;
                        break;
                    case 'top':
                        framePoint = frameNode.parent.poly[(sId.edges[0] + frameNode.parent.poly.length + 1) % frameNode.parent.poly.length];
                        line = [extensionNode.poly[2], extensionNode.poly[3]];
                        shift = framePoint.x - extensionNode.poly[3].x;
                        break;
                    case 'left':
                        line = [extensionNode.poly[3], extensionNode.poly[0]];
                        shift = framePoint.y - extensionNode.poly[3].y;
                        break;
                    case 'right':
                        framePoint = frameNode.parent.poly[(sId.edges[0] + frameNode.parent.poly.length + 1) % frameNode.parent.poly.length];
                        line = [extensionNode.poly[1], extensionNode.poly[2]];
                        shift = framePoint.y - extensionNode.poly[2].y;
                        break;
                }
                this.poly = this.getCouplingPoly(line, shift);
            }
            else {
                this.poly = this.getCouplingPoly(this.getParallelFrameLine(frameNode, sId.edges[0]));
            }
        }
        else if (this.coupling.adjacentSideProfileId.length > 0) {
            const sId = this.coupling.adjacentSideProfileId[0];
            const extensionNode = coupledExtensionNodes.find(n => n.extension.id === sId);
            const { angle } = IccDrawMathService.getLineInfo(extensionNode.parallelFrameLine);
            this.poly = this.getCouplingPoly(angle < 1
                ? [extensionNode.poly[0], extensionNode.poly[1]]
                : [extensionNode.poly[2], extensionNode.poly[3]]);
        }
        else if (this.coupling.adjacentOtherSideProfileId.length > 0) {
            const sId = this.coupling.adjacentOtherSideProfileId[0];
            const extensionNode = coupledExtensionNodes.find(n => n.extension.id === sId);
            const { angle } = IccDrawMathService.getLineInfo(extensionNode.parallelFrameLine);
            this.poly = this.getCouplingPoly(angle < 1
                ? [extensionNode.poly[0], extensionNode.poly[1]]
                : [extensionNode.poly[2], extensionNode.poly[3]]);
        }
        /** math: obliczenie części wspólnej figur */
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.setParentPoly();
        const color = this.coupling.color;
        if (color && color[this.root.side]) {
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-extension-${this.coupling.id}-${this.uuid}`,
                color: color[this.root.side].color
                    ? `#${color[this.root.side].color}`
                    : '#fff',
                image: color[this.root.side].color_img
                    ? `/files/color/${color[this.root.side].color_img}`
                    : null,
                height: this.rect.height,
                width: this.rect.width,
            }));
        }
        else {
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-extension-${this.coupling.id}-${this.uuid}`,
                color: '#fff',
                image: null,
                height: this.rect.height,
                width: this.rect.width,
            }));
        }
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-extension-${this.coupling.id}-${this.uuid}')`,
            stroke: '#bbb',
        }));
    }
    onClick(params = {}) {
        return Object.assign({
            coupling: this.coupling,
        }, params);
    }
    setDrawData(data) {
        data.coupling.push(new DrawData(this.poly, {
            direction: this.coupling ? this.coupling.direction : null,
            couplingId: this.coupling ? this.coupling.id : null,
        }));
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal.map(dimension => {
            if (this.rect.y <= dimension.stop
                && this.rect.y + this.rect.height >= dimension.start) {
                dimension.minor.push(this.rect.x, this.rect.x + this.rect.width);
            }
        });
        dimensions.vertical.map(dimension => {
            if (this.rect.x <= dimension.stop && this.rect.x + this.rect.width >= dimension.start) {
                dimension.minor.push(this.rect.y, this.rect.y + this.rect.height);
            }
        });
    }
    getFrameNodes(node, data = []) {
        if (node instanceof FrameNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getFrameNodes(child, data)));
        return data;
    }
    getCoupledExtensionNodes(node, data = []) {
        if (node instanceof CoupledExtensionNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getCoupledExtensionNodes(child, data)));
        return data;
    }
    getExtensionNodes(node, data = []) {
        if (node instanceof ExtensionsNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getExtensionNodes(child, data)));
        return data;
    }
    getParallelFrameLine(frameNode, edgeIndex) {
        return [
            frameNode.parent.poly[(edgeIndex + frameNode.parent.poly.length) % frameNode.parent.poly.length],
            frameNode.parent.poly[(edgeIndex + 1 + frameNode.parent.poly.length) % frameNode.parent.poly.length],
        ];
    }
    getCouplingPoly(parallelLine, extensionShift = 0) {
        const line = IccDrawMathService.getLineShift(parallelLine, -this.coupling.width);
        const { side, angle, length: test } = IccDrawMathService.getLineInfo(line);
        const newLineSide = this.getPerpendicularSide(side);
        const line2 = angle < 1 ? [parallelLine[0], line[0]] : [line[1], parallelLine[1]];
        const { length } = IccDrawMathService.getLineInfo(line2);
        const line3 = IccDrawMathService.getLineShift(line2, this.coupling.shift + extensionShift, length > 0 ? null : newLineSide);
        const line4 = IccDrawMathService.getLineShift(line3, this.coupling.length, length > 0 ? null : newLineSide);
        return [line3[1], line4[1], line4[0], line3[0]];
    }
    getExtensionPoly(parallelLine) {
        const line = IccDrawMathService.getLineShift(parallelLine, -this.coupling.width);
        const { angle } = IccDrawMathService.getLineInfo(line);
        const line2 = angle < 1 ? [parallelLine[0], line[0]] : [line[1], parallelLine[1]];
        const line3 = IccDrawMathService.getLineShift(line2, this.coupling.shift);
        const line4 = IccDrawMathService.getLineShift(line3, this.coupling.length);
        return [line3[1], line4[1], line4[0], line3[0]];
    }
    getPerpendicularSide(side) {
        switch (side) {
            case 'top':
                return 'left';
            case 'bottom':
                return 'left';
            case 'left':
                return 'top';
            case 'right':
                return 'top';
        }
    }
}

class DimensionNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.layer = Layers.Dimension;
        this.ratio = 1;
        this.breakpoints = [];
        this.lines = [];
        this.texts = [];
        this.multiplier = 1;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        this.svg.paths = [];
        this.svg.texts = [];
        this.breakpoints = [];
        this.lines = [];
        this.texts = [];
        Object.keys(this.baseRect).map(key => (this.baseRect[key] = IccDrawMathService.round(this.baseRect[key])));
        this.multiplier = this.ratio * (this.options.multiplier || 1);
        /** math: obliczenie wymiarów */
        this.getPosition();
        this.getBreakpoints();
        this.getDimensions();
        /** svg: rysowanie ścieżek */
        for (const line of this.lines) {
            this.svg.paths.push(IccDrawSvgService.getPath(line, false, this.root.side, {
                stroke: '#000',
            }));
        }
        /** svg: rysowanie tekstów */
        for (const text of this.texts) {
            this.svg.texts.push(IccDrawSvgService.getText(text, {
                fill: '#000',
                fontSize: 12 * this.multiplier,
            }));
        }
    }
    getBreakpoints() {
        if (this.type === 'horizontal') {
            this.breakpoints.push(this.details.x || 0);
            this.breakpoints.push(this.details.width || 0);
            this.breakpoints.push(this.baseRect.x || 0);
            this.breakpoints.push(this.baseRect.x + this.baseRect.width || 0);
            if (this.shape && this.shape.shape && this.shape.shape.shape) {
                switch (this.shape.shape.shape) {
                    case 'circle':
                    case 'arc':
                        break;
                    default:
                        if (this.shape.poly && this.shape.poly.length) {
                            for (const point of this.shape.poly) {
                                this.breakpoints.push(point.x || 0);
                            }
                        }
                }
            }
            if ((this.details.rollerShutter
                && this.details.rollerShutter.shutters
                && this.details.rollerShutter.shutters.length
                && this.details.type === 'roller_shutter' || this.details.type === 'external_blind')
                || this.options.extendedRollerInWindow === 'full') {
                let x = 0;
                for (const shutter of this.details.rollerShutter.shutters) {
                    x += shutter.width;
                    this.breakpoints.push(x);
                }
            }
        }
        else {
            this.breakpoints.push(this.details.y || 0);
            this.breakpoints.push(this.details.height || 0);
            this.breakpoints.push(this.baseRect.y || 0);
            this.breakpoints.push(this.baseRect.y + this.baseRect.height || 0);
            if (this.shape && this.shape.shape && this.shape.shape.shape) {
                switch (this.shape.shape.shape) {
                    case 'circle':
                        break;
                    case 'arc':
                        this.breakpoints.push(this.shape.shape.h2 || 0);
                        break;
                    default:
                        if (this.shape.poly && this.shape.poly.length) {
                            for (const point of this.shape.poly) {
                                this.breakpoints.push(point.y || 0);
                            }
                        }
                }
            }
            if ((this.details.rollerShutter
                && this.details.rollerShutter.shutters
                && this.details.rollerShutter.shutters.length
                && this.details.type === 'roller_shutter' || this.details.type === 'external_blind')
                || this.options.extendedRollerInWindow === 'full') {
                for (const shutter of this.details.rollerShutter.shutters) {
                    this.breakpoints.push(shutter.height);
                }
            }
        }
        if (this.details.type !== 'coupled_window') {
            if (this.details.couplings && this.details.couplings.length) {
                for (const coupling of this.details.couplings.filter(c => c.direction !== this.type)) {
                    const frame = this.details.frames.find(f => coupling.framesId.find(fId => f.id === fId.id));
                    this.breakpoints.push((coupling.direction === 'vertical'
                        ? frame.x + frame.width
                        : frame.y + frame.height) + Math.ceil(coupling.width / 2));
                }
            }
            if (this.details.mullions && this.details.mullions.length) {
                for (const mullion of this.details.mullions.filter(o => o.direction !== this.type)) {
                    const frame = this.details.frames.find(f => f.id === mullion.frameId);
                    this.breakpoints.push((this.type === 'horizontal' ? frame.x : frame.y) + mullion.position || 0);
                }
            }
            if (this.details.sashes && this.details.sashes.length) {
                for (const sash of this.details.sashes) {
                    const frame = this.details.frames.find(f => f.id === sash.frameId);
                    if (sash.intMullions && sash.intMullions.length) {
                        for (const mullion of sash.intMullions.filter(o => o.direction !== this.type)) {
                            this.breakpoints.push((this.type === 'horizontal' ? frame.x + sash.x : frame.y + sash.y)
                                + mullion.position || 0);
                        }
                    }
                }
            }
        }
        else {
            if (this.details.windows && this.details.windows.length) {
                for (const window of this.details.windows) {
                    this.breakpoints.push(this.type === 'horizontal'
                        ? window.x
                        : window.y);
                    this.breakpoints.push(this.type === 'horizontal'
                        ? window.x + window.details.width
                        : window.y + window.details.height);
                }
            }
            const couplingNodes = this.getCouplingNodes(this.root);
            if (couplingNodes && couplingNodes.length) {
                for (const couplingNode of couplingNodes) {
                    this.breakpoints.push(Math.round(this.type === 'horizontal' ? couplingNode.rect.x : couplingNode.rect.y));
                    this.breakpoints.push(Math.round(this.type === 'horizontal'
                        ? couplingNode.rect.x + couplingNode.rect.width
                        : couplingNode.rect.y + couplingNode.rect.height));
                }
            }
            const extensionsNodes = this.getExtensionsNodes(this.root);
            if (extensionsNodes && extensionsNodes.length) {
                for (const extensionNode of extensionsNodes) {
                    this.breakpoints.push(Math.round(this.type === 'horizontal' ? extensionNode.rect.x : extensionNode.rect.y));
                    this.breakpoints.push(Math.round(this.type === 'horizontal'
                        ? extensionNode.rect.x + extensionNode.rect.width
                        : extensionNode.rect.y + extensionNode.rect.height));
                }
            }
        }
        this.breakpoints = this.breakpoints
            .map(IccDrawMathService.round)
            .filter((v, i, a) => a.indexOf(v) === i)
            .sort((a, b) => a - b);
    }
    getDimensions() {
        const width = this.details.type === 'roller_shutter' || this.details.type === 'external_blind' || this.options.extendedRollerInWindow === 'full'
            ? this.details.rollerShutter.shutters.map(o => o.width).reduce((a, b) => a + b, 0)
            : this.details.width;
        const height = this.details.type === 'roller_shutter' || this.details.type === 'external_blind' || this.options.extendedRollerInWindow === 'full'
            ? this.details.rollerShutter.shutters
                .map(o => o.height)
                .reduce((a, b) => (a > b ? a : b), 0)
            : this.details.height;
        if (this.type === 'horizontal') {
            this.lines.push([
                { x: this.baseRect.x, y: this.rect.y + this.rect.height / 2 },
                { x: this.baseRect.x + this.baseRect.width, y: this.rect.y + this.rect.height / 2 },
            ]);
        }
        else {
            this.lines.push([
                { x: this.rect.x + this.rect.width / 2, y: this.baseRect.y },
                { x: this.rect.x + this.rect.width / 2, y: this.baseRect.y + this.baseRect.height },
            ]);
        }
        for (let i = -1, j = 0; j < this.breakpoints.length; i++, j++) {
            if (this.type === 'horizontal') {
                this.lines.push([
                    { x: this.breakpoints[j], y: this.rect.y },
                    {
                        x: this.breakpoints[j],
                        y: this.rect.y
                            + (j && j < this.breakpoints.length - 1
                                ? this.rect.height / 2
                                : this.rect.height),
                    },
                ]);
                if (i !== -1 && (this.breakpoints[i] >= 0 || this.details.type === 'coupled_window') && this.breakpoints[j] <= width) {
                    let value = IccDrawMathService.round((this.breakpoints[j] - this.breakpoints[i]) / (this.options.ratio || 1), 2);
                    let x = (this.breakpoints[j] + this.breakpoints[i]) / 2;
                    x = this.root.side !== 'outer' ? x : -x;
                    let y = this.rect.y + this.rect.height / 4;
                    this.texts.push({ value, x, y });
                }
                else {
                    let value = `` + IccDrawMathService.round(width / (this.options.ratio || 1), 2);
                    let x = this.rect.x + this.rect.width / 2;
                    x = this.root.side !== 'outer' ? x : -x;
                    let y = this.rect.y + (this.rect.height * 3) / 4;
                    if (this.details.doorPortal && this.details.doorPortal.id) {
                        if (this.baseRect.x < 0 && this.details.type !== 'coupled_window') {
                            value = `${value} + ${-this.baseRect.x}`;
                        }
                        if (this.baseRect.x + this.baseRect.width > width && this.details.type !== 'coupled_window') {
                            value = `${this.baseRect.x + this.baseRect.width - width} + ${value}`;
                        }
                        if (this.details.type === 'coupled_window' && this.baseRect.x < 0) {
                            value = `` + IccDrawMathService.round((width - this.baseRect.x) / (this.options.ratio || 1), 2);
                        }
                    }
                    else {
                        if (this.baseRect.x < 0 && this.details.type !== 'coupled_window') {
                            value = `${-this.baseRect.x} + ${value}`;
                        }
                        if (this.baseRect.x + this.baseRect.width > width && this.details.type !== 'coupled_window') {
                            value = `${value} + ${this.baseRect.x + this.baseRect.width - width}`;
                        }
                        if (this.details.type === 'coupled_window' && this.baseRect.x < 0) {
                            value = `` + IccDrawMathService.round((width - this.baseRect.x) / (this.options.ratio || 1), 2);
                        }
                    }
                    this.texts.push({ value, x, y });
                }
            }
            else {
                this.lines.push([
                    { x: this.rect.x, y: this.breakpoints[j] },
                    {
                        x: this.rect.x
                            + (j && j < this.breakpoints.length - 1
                                ? this.rect.width / 2
                                : this.rect.width),
                        y: this.breakpoints[j],
                    },
                ]);
                if (i !== -1 && (this.breakpoints[i] >= 0 || this.details.type === 'coupled_window') && this.breakpoints[j] <= height) {
                    let value = IccDrawMathService.round((this.breakpoints[j] - this.breakpoints[i]) / (this.options.ratio || 1), 2);
                    let x = this.rect.x + this.rect.width / 4;
                    x = this.root.side !== 'outer' ? x : -x;
                    let y = (this.breakpoints[j] + this.breakpoints[i]) / 2;
                    this.texts.push({ transform: `rotate(270,${x},${y})`, value, x, y });
                }
                else {
                    let x = this.rect.x + (this.rect.width * 3) / 4;
                    x = this.root.side !== 'outer' ? x : -x;
                    let y = this.rect.y + this.rect.height / 2;
                    let value = 0;
                    if (this.options.sumHeight || this.details.type === 'coupled_window') {
                        value =
                            IccDrawMathService.round(height / (this.options.ratio || 1), 2);
                        if (this.baseRect.y < 0) {
                            value -= this.baseRect.y;
                        }
                        if (this.baseRect.y + this.baseRect.height > height) {
                            value += this.baseRect.y + this.baseRect.height - height;
                        }
                    }
                    else {
                        value =
                            `` + IccDrawMathService.round(height / (this.options.ratio || 1), 2);
                        if (this.baseRect.y < 0) {
                            value = `${value} + ${-this.baseRect.y}`;
                        }
                        if (this.baseRect.y + this.baseRect.height > height) {
                            value = `${this.baseRect.y + this.baseRect.height - height} + ${value}`;
                        }
                    }
                    this.texts.push({ transform: `rotate(270,${x},${y})`, value, x, y });
                }
            }
        }
    }
    getPosition() {
        const dimensionSize = Math.ceil(this.multiplier * 15);
        if (this.type === 'horizontal') {
            this.rect.x = this.baseRect.x;
            this.rect.y = this.parent.rect.y + this.parent.rect.height + dimensionSize;
            this.rect.width = this.baseRect.width;
            this.rect.height = dimensionSize * 2;
            this.parent.rect.height += dimensionSize * 3;
        }
        else {
            this.rect.x = this.parent.rect.x + this.parent.rect.width + dimensionSize;
            this.rect.y = this.baseRect.y;
            this.rect.width = dimensionSize * 2;
            this.rect.height = this.baseRect.height;
            this.parent.rect.width += dimensionSize * 3;
        }
    }
    getCouplingNodes(node, data = []) {
        if (node instanceof CoupledCouplingNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getCouplingNodes(child, data)));
        return data;
    }
    getExtensionsNodes(node, data = []) {
        if (node instanceof CoupledExtensionNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getExtensionsNodes(child, data)));
        return data;
    }
    getExtensionWidth(side, sideProfiles, frames, usedProfiles, node) {
        const frameNodes = this.getFrameNodes(node);
        const sides = this.getFrameSidesOnEdge(frames, frameNodes);
        let width = 0;
        if (sideProfiles && sideProfiles.length) {
            const extensions = this.profilesBySide(sides[side], sideProfiles);
            extensions.map(extension => {
                const extensionProfile = usedProfiles.find(o => o.id === extension.profileId) || {};
                if (this.root.side !== 'outer') {
                    width += Number(extension.width) || Number(extensionProfile.width) || 45;
                }
                else {
                    width += Number(extension.widthOut) || Number(extensionProfile.widthOut) || 45;
                }
            });
        }
        return width;
    }
    getFrameSidesOnEdge(frames, frameNodes) {
        const sides = {
            top: [],
            bottom: [],
            left: [],
            right: [],
        };
        const windowSides = [
            { side: 'bottom', sideSimple: 'bottom' },
            { side: 'right', sideSimple: 'side' },
            { side: 'top', sideSimple: 'top' },
            { side: 'left', sideSimple: 'side' },
        ];
        windowSides.forEach((side, sideIndex) => {
            if (frames && frames.length && frameNodes.length) {
                for (const frame of frames) {
                    const frameNode = frameNodes.find(f => f.frame.id === frame.id);
                    const parallelPoly = IccDrawMathService.getParallelPoly(frameNode.parent.poly, frameNode.parent.parent.poly);
                    if (parallelPoly.indexOf(sideIndex) > -1) {
                        sides[side.side].push({
                            frameId: frame.id,
                            frameEdgeIndex: parallelPoly.indexOf(sideIndex),
                        });
                    }
                    else {
                        sides[side.side].push({
                            frameId: frame.id,
                            frameEdgeIndex: parallelPoly.indexOf(sideIndex),
                        });
                    }
                }
            }
            else {
                sides[side.side].push({
                    frameId: 0,
                    frameEdgeIndex: sideIndex,
                });
            }
        });
        return sides;
    }
    profilesBySide(frameEdges, sideProfiles) {
        const profiles = [];
        const firstProfiles = sideProfiles.filter(s => s.framesId.some(f => frameEdges.some(fE => f.id === fE.frameId && f.edges.includes(fE.frameEdgeIndex))));
        profiles.push(...firstProfiles);
        profiles.push(...firstProfiles
            .map(s => s.adjacentOtherSideProfileId.length > 0
            ? this.getNextProfiles(s, sideProfiles)
            : null)
            .reduce((acc, val) => val && acc.concat(val) || acc, []));
        return profiles;
    }
    getNextProfiles(baseProfile, sideProfiles) {
        const allNextProfiles = [];
        const nextProfiles = sideProfiles.filter(s => baseProfile.adjacentOtherSideProfileId.includes(s.id));
        allNextProfiles.push(...nextProfiles);
        allNextProfiles.push(...nextProfiles
            .map(s => s.adjacentOtherSideProfileId.length > 0 ? this.getNextProfiles(s, sideProfiles) : null)
            .reduce((acc, val) => val && acc.concat(val) || acc, []));
        return allNextProfiles;
    }
    getFrameNodes(node, data = []) {
        if (node instanceof FrameNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getFrameNodes(child, data)));
        return data;
    }
}

class DowelHolesNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.accessories = {};
        this.dowelHoles = {};
        this.sashes = [];
        this.distanceFromEdge = 200;
        this.distanceBetween = 700;
        this.intersections = {};
        this.lines = [];
        this.width = 20;
        this.includeInExtendedDimensions = false;
        this.layer = Layers.DowelHoles;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        /** class: znalezienie pasujących akcesoriów */
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            dowelHoles: this.dowelHoles,
        }, params);
    }
    init() {
        this.svg.paths = [];
        this.lines = [];
        Object.keys(this.accessories).map(side => {
            this.dowelHoles[side] = this.accessories[side].find(o => o.type === 'dowel_hole');
            this.intersections[side] = [];
        });
        /** math: obliczenie pozycji na rysunku */
        this.sashes.map(sash => {
            Object.keys(sash.nearMullions || {}).map(side => {
                if (sash.nearMullions[side] === -1 && this.dowelHoles[side]) {
                    let position = (['top', 'bottom'].indexOf(side) !== -1 ? sash.x : sash.y) + this.distanceFromEdge;
                    let length = (['top', 'bottom'].indexOf(side) !== -1 ? sash.width : sash.height) - 2 * this.distanceFromEdge;
                    let count = length > 0 ? Math.ceil(length / this.distanceBetween) : 0;
                    let distance = count > 0 ? length / count : 0;
                    for (let i = 0; i <= count; i++) {
                        this.intersections[side].push(position);
                        position += distance;
                    }
                }
            });
        });
        /** math: przygotowanie linii na rysunku */
        this.parent.polygons.map(poly => {
            let line = IccDrawMathService.getLineInfo([poly[0], poly[1]], poly);
            if (this.intersections[line.side] && this.intersections[line.side].length) {
                this.intersections[line.side].map(position => {
                    let rect = {
                        x: ['top', 'bottom'].indexOf(line.side) !== -1 ? position - this.width / 2 : this.root.rect.x,
                        y: ['top', 'bottom'].indexOf(line.side) === -1 ? position - this.width / 2 : this.root.rect.y,
                        width: ['top', 'bottom'].indexOf(line.side) !== -1 ? this.width : this.root.rect.width,
                        height: ['top', 'bottom'].indexOf(line.side) === -1 ? this.width : this.root.rect.height,
                    };
                    this.lines.push(IccDrawMathService.intersectPolyWithRect(poly, rect));
                });
            }
        });
        /** svg: rysowanie ścieżek */
        // this.svg.patterns.push(IccDrawSvgService.getPattern({
        //     id: `iccDraw-dowelHoles-${this.uuid}`,
        //     color: '#bbb',
        // }));
        this.lines.map(line => {
            this.svg.paths.push(IccDrawSvgService.getPath(line, true, this.root.side, {
                // fill: `url(#iccDraw-dowelHoles-${this.uuid})`,
                fill: '#bbb',
            }));
        });
    }
}

class GlazingNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.glazing = {};
        this.innerPanel = null;
        this.panelGlazing = null;
        this.mullions = [];
        this.profiles = [];
        this.renson = null;
        this.sash = {};
        this.usedProfiles = [];
        this.filledDoor = false;
        this.colorsDict = {};
        this.insetPoly = [];
        this.parallelPoly = [];
        this.parallelProfiles = [];
        this.shift = [];
        this.shiftInset = [];
        this.layer = Layers.Glazing;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            glazing: this.glazing,
            sash: this.sash,
            positionId: this.positionId,
        }, params);
    }
    setDrawData(data) {
        data.filling.push(new DrawData(this.poly, {
            sashId: this.sash ? this.sash.id : null,
            insetData: new DrawData(this.insetPoly)
        }));
    }
    init() {
        this.svg.paths = [];
        this.svg.patterns = [];
        const parentSash = (this.parent && this.parent.parent && this.parent.parent.sash) || this.sash;
        const flipped = (this.root.outerSide === (parentSash.type.handlePosition !== 'R'));
        const isOverlayVisible = [
            this.root.panelTypes.Double,
            this.root.outerSide ? this.root.panelTypes.Outer : this.root.panelTypes.Inner,
        ].includes(this.glazing.overlay_type) || this.filledDoor;
        if (this.root.outerSide === this.outerSash
            && (this.glazing.type === 'deco_panels' || this.glazing.type === 'door_panels')) {
            this.layer = Layers.OverlayInside;
        }
        /** math: obliczenie odstępu na szklenie */
        this.parallelPoly = IccDrawMathService.getParallelPoly(this.parent.poly, this.parent.parent.poly);
        this.parallelPoly.reduce((prev, outer, inner) => {
            this.shift[inner] = 0;
            this.shiftInset[inner] = 0;
            if (Number.isInteger(outer)) {
                const profileId = (this.parent.parent.profiles[outer]
                    || this.parent.parent.profiles[0]
                    || {}).profileId;
                const profile = this.usedProfiles.find(o => o.id === profileId)
                    || this.usedProfiles.find(o => o.type === (this.parent.parent.sash ? 'sash' : 'frame'))
                    || {};
                this.parallelProfiles[inner] = profile.id;
                if (parentSash) {
                    // wewnątrz skrzydła
                    if (this.root.outerSide) {
                        const sashWidthOut = profile.type === 'virtual_door_sash'
                            ? 0
                            : Number(profile.widthOut) || 100;
                        this.shift[inner] -= sashWidthOut;
                        this.shiftInset[inner] -= sashWidthOut;
                        if (profile.type !== 'frame' && profile.type !== 'threshold') {
                            if (!(isOverlayVisible
                                && (this.glazing.type === 'deco_panels'
                                    || this.glazing.type === 'door_panels'))) {
                                this.shift[inner] += isFinite(profile.rebateWidthOut)
                                    ? Number(profile.rebateWidthOut)
                                    : 0;
                            }
                            this.shiftInset[inner] += isFinite(profile.rebateWidthOut)
                                ? Number(profile.rebateWidthOut)
                                : 0;
                        }
                    }
                    else {
                        const sashWidth = profile.type === 'virtual_door_sash' ? 0 : Number(profile.width) || 60;
                        this.shift[inner] -= sashWidth;
                        this.shiftInset[inner] -= sashWidth;
                        if (profile.type !== 'frame' && profile.type !== 'threshold') {
                            if (!(isOverlayVisible
                                && (this.glazing.type === 'deco_panels'
                                    || this.glazing.type === 'door_panels'))) {
                                this.shift[inner] += isFinite(profile.rebateWidth)
                                    ? Number(profile.rebateWidth)
                                    : 0;
                            }
                            this.shiftInset[inner] += isFinite(profile.rebateWidth)
                                ? Number(profile.rebateWidth)
                                : 0;
                        }
                    }
                }
                else {
                    // od strony ramy lub słupka
                    if (this.root.outerSide !== this.outerSash) {
                        this.shift[inner] -= Number(profile.widthOut) || 70;
                        this.shiftInset[inner] -= Number(profile.widthOut) || 70;
                    }
                    else {
                        this.shift[inner] -= Number(profile.width) || 45;
                        this.shiftInset[inner] -= Number(profile.width) || 45;
                    }
                }
                if (profile.type !== 'virtual_door_sash') {
                    if (!(isOverlayVisible
                        && (this.glazing.type === 'deco_panels'
                            || this.glazing.type === 'door_panels'))) {
                        this.shift[inner] += Number(profile.spaceGlass) || 45;
                    }
                    this.shiftInset[inner] += Number(profile.spaceGlass) || 45;
                }
            }
            else {
                const profileId = (this.mullions.find(o => o.id === this.sash.nearMullions[outer]) || {}).profileId;
                const profile = this.usedProfiles.find(o => o.id === profileId)
                    || this.usedProfiles.find(o => o.type === 'divider')
                    || {};
                this.parallelProfiles[inner] = profile.id;
                if (this.root.outerSide !== this.outerSash) {
                    this.shift[inner] -= Number(profile.widthOut || 90) / 2;
                    this.shiftInset[inner] -= Number(profile.widthOut || 90) / 2;
                }
                else {
                    this.shift[inner] -= Number(profile.width || 45) / 2;
                    this.shiftInset[inner] -= Number(profile.width || 45) / 2;
                }
                this.shift[inner] += Number(profile.spaceGlass) || 25;
                this.shiftInset[inner] += Number(profile.spaceGlass) || 25;
            }
        }, []);
        /** math: obliczenie współrzędnych figury */
        this.poly = IccDrawMathService.getPolyShift(this.parent.poly, this.shift);
        this.insetPoly = IccDrawMathService.getPolyShift(this.parent.poly, this.shiftInset);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        /** math: wysokość rensona */
        if (this.renson) {
            const rensonHeight = Number(this.renson.height) || 100;
            this.poly = IccDrawMathService.intersectPolyWithLine(this.poly, [
                { x: this.rect.x, y: this.rect.y + rensonHeight },
                { x: this.rect.x + this.rect.width, y: this.rect.y + rensonHeight },
            ], 'bottom');
            this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        }
        /** svg: rysowanie ścieżek */
        if (this.glazing.type !== 'glazing'
            && ((this.glazing.color && this.glazing.color[this.root.side])
                || (!this.root.outerSide
                    && this.innerPanel
                    && this.innerPanel.color
                    && this.innerPanel.color.inner))) {
            let color = this.glazing.color[this.root.side];
            if (!this.root.outerSide
                && this.innerPanel
                && this.innerPanel.color
                && this.innerPanel.color.inner) {
                color = this.innerPanel.color.inner;
            }
            if (this.colorsDict && this.colorsDict[Number(color.id) + '+' + Number(color.RAL)]) {
                color = this.colorsDict[Number(color.id) + '+' + Number(color.RAL)];
            }
            if (color && color.visualization && color.visualization.visualizationImage) {
                const sashColor = color && color.color ? color.color : 'fff';
                this.setColorVisualization(color.visualization, sashColor, this.root.outerSide, 'glazing' + this.uuid, this.poly, true);
            }
            else {
                this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: `iccDraw-glazing-${this.uuid}`,
                    color: color.color ? `#${color.color}` : '#fff',
                    image: color.color_img ? `/files/color/${color.color_img}` : null,
                    patternTransform: !flipped ? 'scale(-1, 1)' : null,
                    height: this.rect.height,
                    width: this.rect.width,
                    x: (flipped && this.root.outerSide) || (!flipped && !this.root.outerSide) ? -this.rect.x : this.rect.x,
                    y: this.rect.y,
                }));
                this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                    fill: `url('${this.root.uri}#iccDraw-glazing-${this.uuid}')`,
                    stroke: '#bbb',
                }));
            }
        }
        else if (this.glazing.type === 'pvc_panels') {
            if (this.glazing.texture) {
                this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: `iccDraw-glazing-texture-${this.uuid}`,
                    color: null,
                    image: `/files/filling/${!this.root.outerSide && this.glazing.inside_texture ? this.glazing.inside_texture : this.glazing.texture}`,
                    height: this.root.rect.height,
                    width: this.root.rect.width,
                }));
                this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                    fill: `url('${this.root.uri}#iccDraw-glazing-texture-${this.uuid}')`,
                    stroke: '#bbb',
                }));
            }
            this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                fill: `url('${this.root.uri}#iccDraw-${this.sash && !this.sash.intSashes ? 'sash' : 'frame'}-${this.root.uuid}-${this.positionId}')`,
                stroke: '#bbb',
            }));
        }
        else {
            if (this.glazing.texture) {
                this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: `iccDraw-glazing-texture-${this.uuid}`,
                    color: null,
                    image: `/files/filling/${!this.root.outerSide && this.glazing.inside_texture ? this.glazing.inside_texture : this.glazing.texture}`,
                    height: this.root.rect.height,
                    width: this.root.rect.width,
                }));
                this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                    fill: `url('${this.root.uri}#iccDraw-glazing-texture-${this.uuid}')`,
                    stroke: '#bbb',
                }));
            }
            else if (this.glazing.fillingColor) {
                this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                    fill: '#' + this.glazing.fillingColor,
                    stroke: IccColorContrastService.getInvertedColor(this.glazing.fillingColor) || "#bbb",
                }));
            }
            else {
                this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                    fill: `url('${this.root.uri}#iccDraw-glazing-${this.root.uuid}')`,
                    stroke: '#bbb',
                }));
            }
        }
        /** svg: dodatkowe grafiki dla paneli ozdobnych */
        if (this.glazing.visualization
            && this.glazing.visualization.overlay
            && (!this.filledDoor && (this.root.outerSide || !this.glazing.visualization.overlayInside)
                || (this.filledDoor && this.root.outerSide))) {
            this.setOverlayImage(this.glazing.visualization.overlay, this.glazing.overlayColor, flipped, this.root.outerSide, 'filling', this.panelGlazing);
        }
        /** svg: dodatkowe grafiki dla paneli ozdobnych */
        if (this.glazing.visualization
            && this.glazing.visualization.overlayInside
            && !this.filledDoor
            && (parentSash.panelType === 'Double' || parentSash.panelType === 'Inner')
            && !this.root.outerSide) {
            this.setOverlayImage(this.glazing.visualization.overlayInside, this.glazing.overlayColor, flipped, this.root.outerSide, 'innerFilling', this.panelGlazing);
        }
        if (this.innerPanel
            && this.innerPanel.visualization
            && (this.innerPanel.visualization.overlayInside
                || this.innerPanel.visualization.overlay)
            && this.filledDoor
            && !this.root.outerSide) {
            this.setOverlayImage(this.innerPanel.visualization.overlayInside
                || this.innerPanel.visualization.overlay, this.innerPanel.overlayColor, flipped, this.root.outerSide, 'innerPanel', this.panelGlazing);
        }
        /** svg: dodatkowe grafiki dla paneli ozdobnych */
        if (this.panelGlazing
            && this.panelGlazing.visualization
            && this.panelGlazing.visualization.overlay
            && (this.root.outerSide || !this.panelGlazing.visualization.overlayInside)) {
            this.setOverlayImage(this.panelGlazing.visualization.overlay, this.panelGlazing.overlayColor, flipped, this.root.outerSide, 'panelGlazing');
        }
        /** svg: dodatkowe grafiki dla paneli ozdobnych */
        if (this.panelGlazing
            && this.panelGlazing.visualization
            && this.panelGlazing.visualization.overlayInside
            && (parentSash.panelType === 'Double' || parentSash.panelType === 'Inner' || parentSash.panelType === 'Mixed')
            && !this.root.outerSide) {
            this.setOverlayImage(this.panelGlazing.visualization.overlayInside, this.panelGlazing.overlayColor, flipped, this.root.outerSide, 'innerPanelGlazing');
        }
    }
    setOverlayImage(overlay, overlayColor, flipped, outerSide, patternId, panelGlazing = null) {
        overlay = Object.assign({}, overlay);
        const decorPanelImageSize = {
            width: Number(overlay.overlayWidthMM),
            height: Number(overlay.overlayHeightMM),
            x: 0,
            y: 0,
            shift: {
                x: this.rect.x,
                y: this.rect.y,
            },
        };
        if (flipped) {
            decorPanelImageSize.shift.x =
                decorPanelImageSize.width - (this.rect.x + this.rect.width);
        }
        if (outerSide) {
            if (overlay.overlayPositionX === 'left') {
                overlay.overlayPositionX = 'right';
            }
            else if (overlay.overlayPositionX === 'right') {
                overlay.overlayPositionX = 'left';
            }
        }
        switch (overlay.overlayPositionX) {
            case 'center':
                decorPanelImageSize.shift.x -= (decorPanelImageSize.width - this.rect.width) / 2;
                break;
            case 'right':
                decorPanelImageSize.shift.x += this.rect.width - decorPanelImageSize.width;
                break;
        }
        if (outerSide) {
            decorPanelImageSize.shift.x = -decorPanelImageSize.shift.x;
        }
        switch (overlay.overlayPositionY) {
            case 'center':
                decorPanelImageSize.shift.y -= (decorPanelImageSize.height - this.rect.height) / 2;
                break;
            case 'bottom':
                decorPanelImageSize.shift.y -= decorPanelImageSize.height - this.rect.height;
                break;
        }
        const patternPaths = [];
        if (overlayColor && overlay.overlayPaths && overlayColor[this.root.side]) {
            let color = overlayColor[this.root.side];
            if (this.colorsDict && this.colorsDict[Number(color.id) + '+' + Number(color.RAL)]) {
                color = this.colorsDict[Number(color.id) + '+' + Number(color.RAL)];
            }
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-${patternId}-overlay-color-${this.uuid}`,
                color: color.color ? `#${color.color}` : null,
                image: color.color_img ? `/files/color/${color.color_img}` : null,
                height: decorPanelImageSize.height,
                width: decorPanelImageSize.width,
                x: 0,
                y: 0,
            }));
            const paths = overlay.overlayPaths || [];
            let pathsArray = [];
            if (Array.isArray(paths)) {
                pathsArray = paths;
            }
            if (paths && !Array.isArray(paths)) {
                pathsArray = JSON.parse(paths);
            }
            pathsArray.map(path => {
                if (path && !Array.isArray(path)) {
                    path = JSON.parse(path);
                }
                let poly = path.map(point => {
                    return {
                        x: Number(point[0]),
                        y: Number(point[1]),
                        cr: point[2],
                        cw: point[3],
                    };
                });
                let patternUrl = `url('${this.root.uri}#iccDraw-${patternId}-overlay-color-${this.uuid}')`;
                if (color && color.visualization && color.visualization.visualizationImage) {
                    const sashColor = color && color.color ? color.color : 'fff';
                    patternUrl = this.setPatternColorVisualization(color.visualization, sashColor, this.root.outerSide, 'overlay-color-' + patternId, poly);
                }
                patternPaths.push(IccDrawSvgService.getPath(poly, true, null, {
                    fill: patternUrl,
                }));
            });
        }
        if (panelGlazing && panelGlazing.texture && overlay.overlayGlazingPaths) {
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-${patternId}-overlay-glazing-${this.uuid}`,
                color: null,
                image: `/files/filling/${!this.root.outerSide && panelGlazing.inside_texture ? panelGlazing.inside_texture : panelGlazing.texture}`,
                height: decorPanelImageSize.height,
                width: decorPanelImageSize.width,
                x: 0,
                y: 0,
            }));
            const paths = overlay.overlayGlazingPaths || [];
            let pathsArray = [];
            if (Array.isArray(paths)) {
                pathsArray = paths;
            }
            if (paths && !Array.isArray(paths)) {
                pathsArray = JSON.parse(paths);
            }
            pathsArray.map(path => {
                if (path && !Array.isArray(path)) {
                    path = JSON.parse(path);
                }
                let poly = path.map(point => {
                    return {
                        x: Number(point[0]),
                        y: Number(point[1]),
                        cr: point[2],
                        cw: point[3],
                    };
                });
                patternPaths.push(IccDrawSvgService.getPath(poly, true, null, {
                    fill: `url('${this.root.uri}#iccDraw-${patternId}-overlay-glazing-${this.uuid}')`,
                }));
            });
        }
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-${patternId}-overlay-image-${this.uuid}`,
            image: overlay.overlayImage.includes('http')
                ? overlay.overlayImage
                : `/files/visualization/${overlay.overlayImage}`,
            height: decorPanelImageSize.height,
            width: decorPanelImageSize.width,
            patternTransform: flipped ? 'scale(-1, 1)' : null,
            x: decorPanelImageSize.shift.x,
            y: decorPanelImageSize.shift.y,
            paths: patternPaths,
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-${patternId}-overlay-image-${this.uuid}')`,
        }));
    }
    setPatternColorVisualization(visualization, color, outerSide, patternId, polygon, reverse = false) {
        visualization = Object.assign({}, visualization);
        const decorPanelImageSize = {
            width: Number(visualization.visualizationWidthMM),
            height: Number(visualization.visualizationHeightMM),
            x: 0,
            y: 0,
            shift: {
                x: polygon[0].x,
                y: polygon[0].y,
            },
        };
        if (outerSide) {
            if (visualization.visualizationPositionX === 'left') {
                visualization.visualizationPositionX = 'right';
            }
            else if (visualization.visualizationPositionX === 'right') {
                visualization.visualizationPositionX = 'left';
            }
        }
        const verticalLineInfo = IccDrawMathService.getLineInfo([polygon[0], polygon[1]], polygon);
        const horizontalLineInfo = IccDrawMathService.getLineInfo([polygon[1], polygon[2]], polygon);
        const angleDeg = ((reverse ? horizontalLineInfo : verticalLineInfo).angle * 180 - 90);
        switch (visualization.visualizationPositionX) {
            case 'center':
                decorPanelImageSize.shift.x -= (decorPanelImageSize.width - horizontalLineInfo.length) / 2;
                break;
            case 'right':
                decorPanelImageSize.shift.x += horizontalLineInfo.length - decorPanelImageSize.width;
                break;
        }
        if (outerSide) {
            decorPanelImageSize.shift.x = -decorPanelImageSize.shift.x;
        }
        switch (visualization.visualizationPositionY) {
            case 'center':
                decorPanelImageSize.shift.y -= (decorPanelImageSize.height - verticalLineInfo.length) / 2;
                break;
            case 'bottom':
                decorPanelImageSize.shift.y -= decorPanelImageSize.height - verticalLineInfo.length;
                break;
        }
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-color-${patternId}-${this.uuid}`,
            color: color ? `#${color}` : null,
            image: `/files/color/${visualization.visualizationImage}`,
            height: decorPanelImageSize.height,
            width: decorPanelImageSize.width,
            x: decorPanelImageSize.shift.x,
            y: decorPanelImageSize.shift.y,
            patternTransform: `rotate(${angleDeg + (visualization.visualizationOrientation === 'horizontal' ? 90 : 0)}, ${polygon[0].x}, ${polygon[0].y})`,
        }));
        return `url('${this.root.uri}#iccDraw-color-${patternId}-${this.uuid}')`;
    }
}

class HandleNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.sash = {};
        this.sashes = [];
        this.sashTypes = {};
        this.handlesDict = {};
        this.doorHardwareDict = {};
        this.doorHardware = {};
        this.hingesDict = {};
        this.hinge = {};
        this.decorativeHingeCovers = {};
        this.filledDoor = false;
        this.filling = {};
        this.isDoor = false;
        this.sashHardware = [];
        this.handle = {
            height: 30,
            width: 80,
        };
        this.layer = Layers.Handle;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        var _a, _b, _c;
        this.svg.paths = [];
        const position = {
            x: 0,
            y: 0,
        };
        let angle, index, firstLine, secondLine, edge;
        const root = this.parent.parent.parent.parent.parent.parent;
        const sashType = this.sash.type && this.sashTypes && this.sashTypes[this.sash.type.id]
            ? this.sashTypes[this.sash.type.id]
            : this.sash.type;
        const mainPlate = this.doorHardware
            && this.doorHardware.plates
            && this.doorHardware.plates.mainLock
            && this.doorHardwareDict[this.doorHardware.plates.mainLock];
        /** math: obliczenie pozycji klamki */
        if (!this.root.outerSide || (this.root.outerSide && this.isDoor)) {
            switch (this.sash.type.handlePosition) {
                case 'L':
                case 'R':
                    position.y = this.sash.handleHeight
                        ? this.parent.parent.rect.y + this.sash.height - this.sash.handleHeight
                        : (2 * this.parent.rect.y + this.parent.rect.height) / 2;
                    if (['DRA', 'DOA'].includes(sashType.type) && this.filledDoor && mainPlate) {
                        position.x = this.parent.grooveRect.x + mainPlate.backset;
                        if (this.sash.type.handlePosition === 'R') {
                            position.x =
                                this.parent.grooveRect.x + this.parent.grooveRect.width - mainPlate.backset;
                        }
                    }
                    else {
                        firstLine = IccDrawMathService.intersectLineWithPoly([
                            { x: root.rect.x, y: position.y },
                            { x: root.rect.x + root.rect.width, y: position.y },
                        ], this.parent.groovePoly);
                        secondLine = IccDrawMathService.intersectLineWithPoly([
                            { x: root.rect.x, y: position.y },
                            { x: root.rect.x + root.rect.width, y: position.y },
                        ], this.parent.poly);
                        index = this.sash.type.handlePosition === 'L' ? 0 : 1;
                        position.x = Math.ceil((firstLine[index].x + secondLine[index].x) / 2);
                        edge = firstLine[index].x;
                        const adjacentSash = this.sashes.find(el => {
                            return (el.y === this.sash.y
                                && el.height === this.sash.height
                                && (this.sash.type.handlePosition === 'L'
                                    ? el.x + el.width === this.sash.x
                                    : el.x === this.sash.x + this.sash.width));
                        });
                        if (adjacentSash && adjacentSash.type && adjacentSash.type.type === 'DSC') {
                            position.x =
                                this.sash.x
                                    + (this.sash.type.handlePosition === 'L' ? 0 : this.sash.width);
                            this.svg.paths.push(IccDrawSvgService.getPath([
                                {
                                    x: position.x - this.handle.height,
                                    y: this.parent.parentRect.y
                                        + this.parent.parentRect.height,
                                },
                                {
                                    x: position.x + this.handle.height,
                                    y: this.parent.parentRect.y
                                        + this.parent.parentRect.height,
                                },
                                {
                                    x: position.x + this.handle.height,
                                    y: this.parent.parentRect.y,
                                },
                                {
                                    x: position.x - this.handle.height,
                                    y: this.parent.parentRect.y,
                                },
                            ], true, root.side, {
                                stroke: '#bbb',
                                fill: `url('${root.uri}#iccDraw-sash-${root.uuid}-${this.positionId}')`,
                            }));
                        }
                    }
                    break;
                case 'T':
                case 'B':
                    position.x = this.parent.rect.x + this.parent.rect.width / 2 + 5;
                    firstLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x, y: root.rect.y },
                        { x: position.x, y: root.rect.y + root.rect.height },
                    ], this.parent.parentPoly);
                    secondLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x, y: root.rect.y },
                        { x: position.x, y: root.rect.y + root.rect.height },
                    ], this.parent.poly);
                    index = this.sash.type.handlePosition === 'T' ? 0 : 1;
                    const firstY = this.parent.parentPoly.length === 3
                        && this.parent.parentPoly[2].x === this.parent.sash.width / 2
                        ? this.parent.parentPoly[2].y
                        : firstLine[index].y
                            ? firstLine[index].y
                            : secondLine[index].y
                                ? secondLine[index].y
                                    - (this.parent.width.reduce((a, b) => a + b, 0)
                                        / this.parent.width.length || 60)
                                : this.parent.parentRect.y
                                    + (this.sash.type.handlePosition === 'T'
                                        ? 0
                                        : this.parent.parentRect.height);
                    const secondY = this.parent.poly.length === 3
                        && this.parent.poly[2].x === this.parent.sash.width / 2
                        ? this.parent.poly[2].y
                        : secondLine[index].y
                            ? secondLine[index].y
                            : firstLine[index].y
                                ? firstLine[index].y
                                    + (this.parent.width.reduce((a, b) => a + b, 0)
                                        / this.parent.width.length || 60)
                                : this.parent.rect.y
                                    + (this.sash.type.handlePosition === 'T'
                                        ? 0
                                        : this.parent.rect.height);
                    position.y = Math.ceil((firstY + secondY) / 2);
                    break;
            }
        }
        if (position.x && position.y) {
            /** math: obrócenie klamki wg profilu ramy skrzydła */
            switch (this.sash.type.handlePosition) {
                case 'L':
                case 'R':
                    firstLine = IccDrawMathService.intersectLineWithPoly([
                        { x: this.parent.rect.x, y: position.y - 20 },
                        { x: this.parent.rect.x + this.parent.rect.width, y: position.y - 20 },
                    ], this.parent.parentPoly);
                    secondLine = IccDrawMathService.intersectLineWithPoly([
                        { x: this.parent.rect.x, y: position.y + 20 },
                        { x: this.parent.rect.x + this.parent.rect.width, y: position.y + 20 },
                    ], this.parent.parentPoly);
                    index = this.sash.type.handlePosition === 'L' ? 0 : 1;
                    break;
                case 'T':
                case 'B':
                    firstLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x - 20, y: this.parent.rect.y },
                        { x: position.x - 20, y: this.parent.rect.y + this.parent.rect.height },
                    ], this.parent.parentPoly);
                    secondLine = IccDrawMathService.intersectLineWithPoly([
                        { x: position.x + 20, y: this.parent.rect.y },
                        { x: position.x + 20, y: this.parent.rect.y + this.parent.rect.height },
                    ], this.parent.parentPoly);
                    index = this.sash.type.handlePosition === 'T' ? 0 : 1;
                    break;
            }
            angle = IccDrawMathService.getLineInfo([firstLine[index], secondLine[index]]).angle;
        }
        if (position.x
            && position.y
            && !this.filledDoor
            && ['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(sashType.type) === -1) {
            const handle = this.root.outerSide && this.sash.handleOuter && this.sash.handleOuter.id
                ? this.sash.handleOuter
                : this.sash.handleInner;
            /** math: rysowanie klamki */
            if (handle && handle.visualization && handle.visualization.overlay) {
                let handlePosition = Object.assign({}, position);
                if (((_a = handle === null || handle === void 0 ? void 0 : handle.visualization) === null || _a === void 0 ? void 0 : _a.backset) > 0) {
                    handlePosition.x = index === 1 ? edge - ((_b = handle === null || handle === void 0 ? void 0 : handle.visualization) === null || _b === void 0 ? void 0 : _b.backset) : edge + ((_c = handle === null || handle === void 0 ? void 0 : handle.visualization) === null || _c === void 0 ? void 0 : _c.backset);
                }
                if (this.handlesDict && this.handlesDict[handle.id] && (this.handlesDict[handle.id].handleType === 'pull' || this.handlesDict[handle.id].handleType === 'leverPull')) {
                    handlePosition.x = this.parent.rect.x + handle.visualization.positionXMM;
                    handlePosition.y = this.parent.rect.y + this.parent.rect.height - handle.visualization.positionYMM;
                    if (this.sash.type.handlePosition === 'R') {
                        handlePosition.x = this.parent.rect.x + this.parent.rect.width - handle.visualization.positionXMM;
                    }
                }
                this.drawImageHandle('handle', handlePosition, angle, sashType, handle.visualization);
            }
            else {
                this.drawDefaultHandle(position, angle, sashType);
            }
        }
        const basePosition = Object.assign({}, position);
        const additionalPlate = this.doorHardware
            && this.doorHardware.plates
            && this.doorHardware.plates.additionalLock
            && this.doorHardware.visualizations.additionalLockPlate;
        const mainCylinder = this.doorHardware
            && this.doorHardware.cylinders
            && this.doorHardware.cylinders.mainLock
            && this.doorHardwareDict[this.doorHardware.cylinders.mainLock];
        const additionalCylinder = this.doorHardware
            && this.doorHardware.cylinders
            && this.doorHardware.cylinders.additionalLock
            && this.doorHardwareDict[this.doorHardware.cylinders.additionalLock];
        if (basePosition.x
            && basePosition.y
            && this.filledDoor
            && mainPlate
            && this.doorHardware.visualizations
            && this.doorHardware.visualizations.mainLockPlate
            && ['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(sashType.type) === -1) {
            this.drawImageHandle('mainPlate', basePosition, angle, sashType, this.doorHardware.visualizations.mainLockPlate);
        }
        if (basePosition.x
            && basePosition.y
            && this.filledDoor
            && additionalPlate
            && additionalCylinder
            && ['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(sashType.type) === -1) {
            this.drawImageHandle('additionalPlate', {
                x: basePosition.x,
                y: basePosition.y - additionalCylinder.distanceToAdditionalLock,
            }, angle, sashType, additionalPlate);
        }
        if (basePosition.x
            && basePosition.y
            && this.filledDoor
            && mainCylinder
            && this.doorHardware.visualizations
            && this.doorHardware.visualizations.mainLockCylinder
            && ['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(sashType.type) === -1) {
            this.drawImageHandle('mainCylinder', {
                x: basePosition.x,
                y: basePosition.y + mainCylinder.lockSpacing,
            }, angle, sashType, this.doorHardware.visualizations.mainLockCylinder);
        }
        if (basePosition.x
            && basePosition.y
            && this.filledDoor
            && additionalCylinder
            && this.doorHardware.visualizations
            && this.doorHardware.visualizations.additionalLockCylinder
            && ['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(sashType.type) === -1) {
            this.drawImageHandle('additionalCylinder', {
                x: basePosition.x,
                y: basePosition.y - additionalCylinder.distanceToAdditionalLock,
            }, angle, sashType, this.doorHardware.visualizations.additionalLockCylinder);
        }
        const doorViewer = this.doorHardware
            && this.doorHardware.doorViewer
            && this.doorHardware.visualizations.doorViewer
            && ['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(sashType.type) === -1;
        if (this.filling && doorViewer) {
            this.drawImageHandle('doorViewer', {
                x: this.filling.overlay_door_viewer_position_x_mm
                    ? this.parent.parentRect.x + this.filling.overlay_door_viewer_position_x_mm
                    : this.parent.parentRect.x + this.parent.parentRect.width / 2,
                y: this.filling.overlay_door_viewer_position_y_mm
                    ? this.parent.parentRect.y
                        + this.parent.parentRect.height
                        - this.filling.overlay_door_viewer_position_y_mm
                    : basePosition.y - (additionalCylinder ? additionalCylinder.distanceToAdditionalLock : 0),
            }, angle, sashType, this.doorHardware.visualizations.doorViewer);
        }
        const hinge = this.hinge;
        if (hinge
            && hinge.visualizations
            && hinge.visualizations.length > 0
            && ((['DOA', 'DOP'].includes(sashType.type) && this.root.outerSide) || ['DRA', 'DRP'].includes(sashType.type) && !this.root.outerSide)) {
            const hingePosition = {
                x: this.parent.parentRect.x,
                y: 0,
            };
            if (this.sash.type.handlePosition === 'L') {
                hingePosition.x = this.parent.parentRect.x + this.parent.parentRect.width;
            }
            for (let i = 0; i < hinge.visualizations.length; i++) {
                const element = hinge.visualizations[i];
                hingePosition.y =
                    this.parent.parentRect.y + this.parent.parentRect.height - element.positionYMM;
                this.drawImageHandle('hinge' + i, hingePosition, angle, sashType, element);
            }
        }
        const decorativeHingeCovers = this.doorHardware && this.doorHardware.visualizations && this.doorHardware.visualizations.decorativeHingeCovers;
        if (decorativeHingeCovers
            && ((['DOA', 'DOP'].includes(sashType.type) && this.root.outerSide) || ['DRA', 'DRP'].includes(sashType.type) && !this.root.outerSide)) {
            const decorativeHingeCoversPosition = {
                x: this.parent.parentRect.x,
                y: 0,
            };
            if (this.sash.type.handlePosition === 'L') {
                decorativeHingeCoversPosition.x = this.parent.parentRect.x + this.parent.parentRect.width;
            }
            for (let i = 0; i < decorativeHingeCovers.length; i++) {
                const element = decorativeHingeCovers[i];
                decorativeHingeCoversPosition.y =
                    this.parent.parentRect.y + this.parent.parentRect.height - element.positionYMM;
                this.drawImageHandle('decorativeHingeCovers' + i, decorativeHingeCoversPosition, angle, sashType, element);
            }
        }
        const pull = this.doorHardware && this.doorHardware.pull && this.doorHardware.visualizations.pull;
        if (pull && (['DRA', 'DOA'].includes(sashType.type) && this.root.outerSide)) {
            const pullPosition = {
                x: this.parent.parentRect.x + pull.positionXMM,
                y: this.parent.parentRect.y + this.parent.parentRect.height - pull.positionYMM,
            };
            if (this.sash.type.handlePosition === 'R') {
                pullPosition.x = this.parent.parentRect.x + this.parent.parentRect.width - pull.positionXMM;
            }
            this.drawImageHandle('pull', pullPosition, angle, sashType, pull);
        }
        if (this.sashHardware.length > 0
            && ((['DOA'].includes(sashType.type) && this.root.outerSide) || !this.root.outerSide)
            && this.filledDoor
            && ['DS', 'DSC', 'ODS', 'ODSC', 'DRP', 'DOP', 'FD', 'FDO'].indexOf(sashType.type) === -1) {
            for (const accessory of this.sashHardware) {
                if (accessory && accessory.visualization) {
                    const hardwarePosition = {
                        x: this.parent.parentRect.x
                            + accessory.visualization.positionXMM
                            + accessory.visualization.overlay.overlayWidthMM,
                        y: this.parent.parentRect.y + accessory.visualization.positionYMM,
                    };
                    if (this.sash.type.handlePosition === 'L') {
                        hardwarePosition.x =
                            this.parent.parentRect.x
                                + this.parent.parentRect.width
                                - accessory.visualization.positionXMM
                                - accessory.visualization.overlay.overlayWidthMM;
                    }
                    this.drawImageHandle('hardware', hardwarePosition, angle, sashType, accessory.visualization);
                }
            }
        }
    }
    drawDefaultHandle(position, angle, sashType) {
        var _a, _b;
        const polygons = [];
        polygons.push(IccDrawMathService.rotatePoly([
            {
                x: position.x - this.handle.width / 2,
                y: position.y + this.handle.height / 2,
            },
            {
                x: position.x + this.handle.width / 2,
                y: position.y + this.handle.height / 2,
            },
            {
                x: position.x + this.handle.width / 2,
                y: position.y - this.handle.height / 2,
            },
            {
                x: position.x - this.handle.width / 2,
                y: position.y - this.handle.height / 2,
            },
        ], position, angle));
        if (sashType.type === 'DRA' || sashType.type === 'DOA') {
            angle += this.sash.type.handlePosition === 'L' ? -0.5 : 0.5;
        }
        else if (sashType.type === 'HS') {
            angle += 1;
        }
        polygons.push(IccDrawMathService.rotatePoly([
            {
                x: position.x - this.handle.height / 3,
                y: position.y + (this.handle.height * 1) / 3,
            },
            {
                x: position.x + (this.handle.width * 5) / 3,
                y: position.y + (this.handle.height * 1) / 3,
            },
            {
                x: position.x + (this.handle.width * 5) / 3,
                y: position.y - this.handle.height / 3,
            },
            {
                x: position.x - this.handle.height / 3,
                y: position.y - this.handle.height / 3,
            },
        ], position, angle));
        /** svg: rysowanie ścieżek */
        for (const polygon of polygons) {
            const handleColor = this.root.side === 'outer'
                ? (_a = this.sash.handleOuter) === null || _a === void 0 ? void 0 : _a.color : (_b = this.sash.handleInner) === null || _b === void 0 ? void 0 : _b.color;
            const handleFillingColor = handleColor
                ? (this.sashTypes
                    && (handleColor
                        && `url('${this.root.uri}#iccDraw-accessory-${handleColor.id}-${this.root.uuid}-${this.positionId}')`))
                : "#fff";
            this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, this.root.side, {
                stroke: '#bbb',
                fill: handleFillingColor,
            }));
        }
    }
    drawImageHandle(overlayId, position, angle, sashType, visualization, model = 'visualization') {
        if (!visualization || !visualization.overlay) {
            return;
        }
        const overlay = !this.root.outerSide && visualization.overlayInside
            ? visualization.overlayInside
            : visualization.overlay;
        const flipped = (this.root.outerSide
            && (this.sash.type.handlePosition !== 'R'
                && this.sash.type.handlePosition !== 'T'))
            || (!this.root.outerSide
                && (this.sash.type.handlePosition === 'R'
                    || this.sash.type.handlePosition === 'T'));
        const polygons = [];
        const a = this.sash.type.handlePosition === 'L' || this.sash.type.handlePosition === 'B' ? -1 : 1;
        polygons.push(IccDrawMathService.rotatePoly([
            {
                x: position.x - overlay.overlayPositionYMM,
                y: position.y - a * overlay.overlayPositionXMM,
            },
            {
                x: position.x - (overlay.overlayPositionYMM - overlay.overlayHeightMM),
                y: position.y - a * overlay.overlayPositionXMM,
            },
            {
                x: position.x - (overlay.overlayPositionYMM - overlay.overlayHeightMM),
                y: position.y - a * (overlay.overlayPositionXMM - overlay.overlayWidthMM),
            },
            {
                x: position.x - overlay.overlayPositionYMM,
                y: position.y - a * (overlay.overlayPositionXMM - overlay.overlayWidthMM),
            },
        ], position, angle));
        /** svg: rysowanie ścieżek */
        let patternTransform = '';
        let patternX = position.x - overlay.overlayPositionXMM;
        if (angle === 0) {
            patternTransform = `rotate(-90, ${position.x}, ${position.y}) `;
        }
        if (flipped) {
            patternTransform += `scale(-1, 1) `;
        }
        if (this.sash.type.handlePosition === 'R' || this.sash.type.handlePosition === 'T') {
            patternX = overlay.overlayWidthMM - (overlay.overlayPositionXMM + position.x);
        }
        const ROUNDING_MARGIN = 1;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-${overlayId}-overlay-image-${this.uuid}`,
            image: overlay.overlayImage.includes('http')
                ? overlay.overlayImage
                : `/files/${model}/${overlay.overlayImage}`,
            height: overlay.overlayHeightMM + ROUNDING_MARGIN,
            width: overlay.overlayWidthMM + ROUNDING_MARGIN,
            patternTransform,
            x: patternX,
            y: position.y - overlay.overlayPositionYMM,
        }));
        for (const polygon of polygons) {
            this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, this.root.side, {
                stroke: null,
                fill: `url('${this.root.uri}#iccDraw-${overlayId}-overlay-image-${this.uuid}')`,
            }));
        }
    }
}

class ShutterNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.shutter = {};
        this.boxHeight = 0;
        this.index = 0;
        this.layer = Layers.Shutter;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            shutter: this.shutter,
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        const shutterNodes = this.parent.children.filter(c => c instanceof ShutterNode);
        const prevShutter = shutterNodes.length > 1 && shutterNodes[shutterNodes.length - 2];
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: prevShutter ? prevShutter.rect.x + prevShutter.rect.width : this.parent.rect.x || 0,
            y: this.positionId ? this.parent.rect.y : 0,
            width: Number(this.shutter.width) || 0,
            height: (this.positionId ? this.boxHeight : Number(this.shutter.height)) || 0,
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        /** svg: rysowanie ścieżek */
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-shutter-${this.root.uuid}')`,
            stroke: '#fff',
        }));
    }
}

class PanelNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.dimensions = {};
        this.colors = {};
        this.index = 0;
        this.layer = GarageDoorLayers.Panel;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.index,
        }, params);
    }
    init() {
        this.svg.paths = [];
        const panelNodes = this.parent.children.filter(c => c instanceof PanelNode);
        const prevPanel = panelNodes.length > 1 && panelNodes[panelNodes.length - 2];
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.rect.x,
            y: prevPanel ? prevPanel.rect.y + prevPanel.rect.height : this.parent.rect.y || 0,
            width: this.parent.rect.width || 0,
            height: Number(this.dimensions.height),
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        /** svg: rysowanie ścieżek */
        const color = this.root.side === 'inner' ? this.colors.inner : this.colors.outer;
        let image = this.root.side === 'inner' ? this.colors.innerImage : this.colors.outerImage;
        image = `/files/garagedoorcolor/${image}` || null;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-panel-${this.root.uuid}-${this.index}`,
            color: `#` + color,
            image,
            x: this.parent.rect.x || 0,
            y: prevPanel ? prevPanel.rect.y + prevPanel.rect.height : this.parent.rect.y || 0,
            height: Number(this.dimensions.height) || 0,
            width: Number(this.dimensions.width) || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-panel-${this.root.uuid}-${this.index}')`,
            stroke: '#000000',
            strokeWidth: 1
        }));
    }
}

class IndexesNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.indexes = [];
        this.frameIndexes = [];
        this.shutterIndexes = [];
        this.panelIndexes = [];
        this.nodes = [];
        this.frameNodes = [];
        this.shutterNodes = [];
        this.panelNodes = [];
        this.sashes = [];
        this.frames = [];
        this.ratio = 1;
        this.multiplier = 1;
        this.fitTo = 'width';
        this.layer = Layers.Indexes;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.multiplier = this.ratio * (this.options.multiplier || 1);
        /** node: znalezienie wszystkich pól */
        this.nodes = this.getNodes(this.root);
        this.frameNodes = this.getFrameNodes(this.root);
        this.shutterNodes = this.getShutterNodes(this.root);
        this.panelNodes = this.getPanelNodes(this.root);
        /** node: przygotowanie indeksów */
        this.nodes.map(node => {
            let sash = null;
            let value = node.sash.index;
            if (typeof node.sash.parentId !== 'undefined') {
                sash = this.sashes.find(e => e.id === node.sash.parentId);
                if (sash.intSashes
                    && sash.intSashes.length > 1
                    && sash.index != null
                    && node.sash.index != null) {
                    value = `${sash.index}.${node.sash.index}`;
                }
                else if (sash.index != null) {
                    value = sash.index;
                }
            }
            if (value != null) {
                let x = node.rect.x + node.rect.width - 50;
                if (this.root.side === 'outer') {
                    x = -node.rect.x - 50;
                }
                this.indexes.push({
                    x,
                    y: node.rect.y + node.rect.height - 50,
                    value,
                });
            }
        });
        const manyFramesinOneWindow = this.frameNodes.filter(node => node.positionId === this.positionId).length > 1;
        /** node: przygotowanie indeksów */
        this.frameNodes.map(node => {
            const value = (node.positionId ? String.fromCharCode(64 + node.windowIndex) : '')
                + (node.positionId && manyFramesinOneWindow ? '.' : '')
                + (manyFramesinOneWindow ? String.fromCharCode(64 + node.frame.index) : '');
            if (value != null) {
                let x = node.rect.x + 50;
                if (this.root.side === 'outer') {
                    x = -node.rect.x - node.rect.width + 50;
                }
                this.frameIndexes.push({
                    x,
                    y: node.rect.y + 50,
                    value,
                });
            }
        });
        /** node: przygotowanie indeksów */
        this.shutterNodes.map((node, index) => {
            const value = String.fromCharCode(65 + node.index) || String.fromCharCode(65 + index);
            if (value != null) {
                let x = node.rect.x + 75;
                if (this.root.side === 'outer') {
                    x = -node.rect.x - node.rect.width + 75;
                }
                this.shutterIndexes.push({
                    x,
                    y: node.rect.y + 50,
                    value,
                });
            }
        });
        /** node: przygotowanie indeksów */
        this.panelNodes.map((node, index) => {
            const value = String(node.index) || String(index);
            if (value != null) {
                let x = node.rect.x + 75;
                if (this.root.side === 'outer') {
                    x = -node.rect.x - node.rect.width + 75;
                }
                this.panelIndexes.push({
                    x,
                    y: node.rect.y + 50,
                    value,
                });
            }
        });
        /** svg: rysowanie indeksów */
        this.setTexts();
    }
    onRootChange() {
        super.onRootChange();
        this.updateRatio();
        this.multiplier = this.ratio * (this.options.multiplier || 1);
        this.setTexts();
    }
    updateRatio() {
        const viewBox = this.root.rect;
        let viewBoxWidth = viewBox.width;
        const viewBoxHeight = viewBox.height;
        if (this.root.side === 'outer') {
            viewBoxWidth = viewBox.width - viewBox.x;
        }
        const viewportWidth = this.boundingRect.width || viewBoxWidth / 5;
        const viewportHeight = this.boundingRect.height || viewBoxHeight / 5;
        this.ratio = this.fitTo === 'width' ? viewBoxWidth / viewportWidth : Math.max(viewBoxWidth / viewportWidth, viewBoxHeight / viewportHeight);
    }
    setTexts() {
        this.svg.texts = [];
        this.indexes.map(index => {
            this.svg.texts.push(IccDrawSvgService.getText(index, {
                fill: '#000',
                fontSize: Math.round(this.multiplier * 12),
                dominantBaseline: 'baseline',
                textAnchor: 'end'
            }));
        });
        if (this.frameIndexes.length > 1 || this.positionId) {
            this.frameIndexes.map(index => {
                this.svg.texts.push(IccDrawSvgService.getText(index, {
                    fill: '#000',
                    fontSize: Math.round(this.multiplier * 12),
                    dominantBaseline: 'hanging',
                    textAnchor: 'start'
                }));
            });
        }
        this.shutterIndexes.map(index => {
            this.svg.texts.push(IccDrawSvgService.getText(index, {
                fill: '#000',
                fontSize: Math.round(this.multiplier * 12),
                dominantBaseline: 'hanging',
                textAnchor: 'start'
            }));
        });
        this.panelIndexes.map(index => {
            this.svg.texts.push(IccDrawSvgService.getText(index, {
                fill: '#000',
                fontSize: Math.round(this.multiplier * 12),
                dominantBaseline: 'hanging',
                textAnchor: 'start'
            }));
        });
    }
    getNodes(node, data = []) {
        if (node instanceof GlazingNode && node.positionId === this.positionId) {
            data.push(node);
        }
        node.children.map(child => (data = this.getNodes(child, data)));
        return data;
    }
    getFrameNodes(node, data = []) {
        if (node instanceof FrameNode && node.positionId === this.positionId) {
            data.push(node);
        }
        node.children.map(child => (data = this.getFrameNodes(child, data)));
        return data;
    }
    getShutterNodes(node, data = []) {
        if (node instanceof ShutterNode && node.positionId === this.positionId) {
            data.push(node);
        }
        node.children.map(child => (data = this.getShutterNodes(child, data)));
        return data;
    }
    getPanelNodes(node, data = []) {
        if (node instanceof PanelNode && node.positionId === this.positionId) {
            data.push(node);
        }
        node.children.map(child => (data = this.getPanelNodes(child, data)));
        return data;
    }
}

class MuntinNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.muntins = {};
        this.muntin = {};
        this.sash = {};
        this.system = {};
        this.layer = Layers.Muntin;
        this.size = 10;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            muntin: this.muntin,
            sash: this.sash,
        }, params);
    }
    onMove(params = {}) {
        const glazingBeadNode = this.parent.children.find(o => o instanceof GlazingBeadNode);
        const direction = this.muntin.direction || (this.muntin.start && this.muntin.end ? (this.muntin.start.x === this.muntin.end.x ? 'vertical' :
            this.muntin.start.y === this.muntin.end.y ? 'horizontal' :
                null) : null);
        const position = this.muntin.positionInSash || (direction ? (direction === 'vertical' ? this.muntin.start.x :
            direction === 'horizontal' ? this.muntin.start.y :
                null) : null);
        return Object.assign({
            min: this.options.minPosition || 0,
            max: this.options.maxPosition || null,
            positionMin: 0,
            positionMax: 0,
            prev: position,
            next: this.sash[direction === 'vertical' ? 'width' : 'height'] - position,
            direction: direction,
            position: position,
            muntin: this.muntin,
            rect: this.parent.rect,
            sash: this.sash,
            shift: glazingBeadNode ? glazingBeadNode.rect : this.parent.rect,
        }, params);
    }
    setDrawData(data) {
        data.muntin.push(new DrawData(this.poly, {
            muntinId: this.muntin ? this.muntin.id : null,
            sashId: this.sash ? this.sash.id : null,
        }));
    }
    setDimensionsData(dimensions) {
        let direction, position;
        if (this.muntin.start && this.muntin.end && this.muntin.start.x === this.muntin.end.x) {
            direction = 'horizontal';
            position = this.poly[0].x;
        }
        if (this.muntin.start && this.muntin.end && this.muntin.start.y === this.muntin.end.y) {
            direction = 'vertical';
            position = this.poly[0].y;
        }
        if (direction && position) {
            dimensions[direction]
                .filter(o => o.sashes.some(e => e === this.positionId + this.sash.id))
                .map(dimension => {
                dimension.minor.push(Math.round(position - this.size / 2));
                dimension.minor.push(Math.round(position + this.size / 2));
            });
        }
    }
    init() {
        this.svg.paths = [];
        this.size = Number(this.muntins.size) || this.size;
        /** math: obliczenie współrzędnych figury */
        this.getMuntinPoly();
        this.poly.map(point => {
            point.x += this.parent.rect.x;
            point.y += this.parent.rect.y;
        });
        this.poly = IccDrawMathService.intersectLineWithPoly(this.poly, this.parent.poly);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        /** svg: rysowanie ścieżek */
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, false, this.root.side, {
            stroke: `url('${this.root.uri}#iccDraw-muntins-${this.root.uuid}-${this.positionId}')`,
            strokeWidth: Math.ceil(this.size / 2),
            vectorEffect: 'none',
        }));
    }
    getMuntinPoly() {
        if (this.muntin.direction) {
            this.poly = [
                {
                    x: this.muntin.direction === 'vertical' ? this.muntin.positionInSash : 0,
                    y: this.muntin.direction === 'horizontal' ? this.muntin.positionInSash : 0,
                },
                {
                    x: this.muntin.direction === 'vertical' ? this.muntin.positionInSash : this.parent.rect.width,
                    y: this.muntin.direction === 'horizontal' ? this.muntin.positionInSash : this.parent.rect.height,
                },
            ];
            if (Number.isInteger(this.muntin.startPinPoint)) {
                this.poly[0][this.muntin.direction === 'horizontal' ? 'x' : 'y'] =
                    this.sash.muntins[this.muntin.direction === 'horizontal' ? 'vertical' : 'horizontal']
                        .find(el => el.id === this.muntin.startPinPoint).positionInSash;
            }
            if (Number.isInteger(this.muntin.endPinPoint)) {
                this.poly[1][this.muntin.direction === 'horizontal' ? 'x' : 'y'] =
                    this.sash.muntins[this.muntin.direction === 'horizontal' ? 'vertical' : 'horizontal']
                        .find(el => el.id === this.muntin.endPinPoint).positionInSash;
            }
        }
        else {
            this.poly = [
                Object.assign({}, this.muntin.start),
                Object.assign({}, this.muntin.end),
            ];
        }
    }
}

class MuntinShadowNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}, drawShadows = false) {
        super(parentNode, childrenNodes, params, options);
        this.muntins = {};
        this.muntin = {};
        this.glazingColor = {};
        this.sash = {};
        this.system = {};
        this.shadowRect = {};
        this.layer = Layers.Muntin;
        this.size = 10;
        this.drawShadows = drawShadows;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        var _a, _b, _c, _d;
        this.svg.paths = [];
        this.size = Number(this.muntins.size) || this.size;
        this.strokeWidth = ((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.shadow) === null || _b === void 0 ? void 0 : _b.width) || 2,
            this.color = ((_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.shadow) === null || _d === void 0 ? void 0 : _d.color) || "#bbb",
            this.getMuntinPoly();
        this.direction = Math.abs(this.poly[0].x - this.poly[1].x) > Math.abs(this.poly[0].y - this.poly[1].y) ? "horizontal" : "vertical";
        this.poly.map(point => {
            point.x += this.parent.rect.x;
            point.y += this.parent.rect.y;
        });
        this.poly = IccDrawMathService.intersectLineWithPoly(this.poly, this.parent.poly);
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, false, this.root.side, {
            stroke: IccColorContrastService.getInvertedColor(IccColorContrastService.rgbToHex(this.glazingColor).substring(1)),
            strokeWidth: Math.ceil(this.size / 2) + this.strokeWidth * 2,
            vectorEffect: 'none',
        }));
    }
    getMuntinPoly() {
        if (this.muntin.direction) {
            this.poly = [
                {
                    x: this.muntin.direction === 'vertical' ? this.muntin.positionInSash : 0,
                    y: this.muntin.direction === 'horizontal' ? this.muntin.positionInSash : 0,
                },
                {
                    x: this.muntin.direction === 'vertical' ? this.muntin.positionInSash : this.parent.rect.width,
                    y: this.muntin.direction === 'horizontal' ? this.muntin.positionInSash : this.parent.rect.height,
                },
            ];
            if (Number.isInteger(this.muntin.startPinPoint)) {
                this.poly[0][this.muntin.direction === 'horizontal' ? 'x' : 'y'] =
                    this.sash.muntins[this.muntin.direction === 'horizontal' ? 'vertical' : 'horizontal']
                        .find(el => el.id === this.muntin.startPinPoint).positionInSash;
            }
            if (Number.isInteger(this.muntin.endPinPoint)) {
                this.poly[1][this.muntin.direction === 'horizontal' ? 'x' : 'y'] =
                    this.sash.muntins[this.muntin.direction === 'horizontal' ? 'vertical' : 'horizontal']
                        .find(el => el.id === this.muntin.endPinPoint).positionInSash;
            }
        }
        else {
            this.poly = [
                Object.assign({}, this.muntin.start),
                Object.assign({}, this.muntin.end),
            ];
        }
    }
}

class RenoNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.lowThreshold = false;
        this.frameNodes = [];
        this.frames = [];
        this.portal = {};
        this.profiles = [];
        this.usedProfiles = [];
        this.shift = [];
        this.layer = Layers.Reno;
        this.polygons = [];
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    setDrawData(data) {
        data.reno.push(new DrawData(this.poly));
    }
    init() {
        this.svg.paths = [];
        this.profiles = [];
        this.setProfiles();
        this.rect = this.parent.rect;
        this.poly = this.parent.poly;
        if (this.usedProfiles.some(el => el.options && el.options.indexOf('renovation_frame') !== -1)) {
            for (const frameNode of this.frameNodes) {
                const shift = [];
                /** math: przesunięcie względem bazowej figury */
                for (let i = 0; i < frameNode.parent.poly.length; i++) {
                    const frame = frameNode.frame.frame[i] || frameNode.frame.frame[0] || {};
                    shift[i] = -Number(frame.finWidth || 0);
                }
                /** math: obliczenie współrzędnych figury */
                this.polygons.push(IccDrawMathService.getPolyShift(frameNode.parent.poly, shift));
            }
            /** math: przesunięcie względem bazowej figury */
            for (let i = 0; i < this.parent.poly.length; i++) {
                const frame = this.profiles[i] || this.profiles[0] || {};
                this.shift[i] = -Number(frame.finWidth || 0);
            }
            /** math: obliczenie współrzędnych figury */
            // this.poly = IccDrawMathService.getPolyShift(this.parent.poly, this.shift);
            this.rect = IccDrawMathService.getRectFromPoly(IccDrawMathService.getPolyShift(this.parent.poly, this.shift));
            if (this.portal && Object.keys(this.portal).length && this.root.side === "inner") {
                /** svg: rysowanie ścieżek */
                for (const poly of this.polygons) {
                    this.svg.paths.push(IccDrawSvgService.getPath(poly, true, this.root.side, {
                        stroke: '#bbb',
                    }));
                }
            }
            else {
                for (const poly of this.polygons) {
                    this.svg.paths.push(IccDrawSvgService.getPath(poly, true, this.root.side, {
                        stroke: '#bbb',
                        strokeDasharray: '5,5',
                    }));
                }
            }
        }
    }
    setProfiles() {
        const sides = this.getFrameSidesOnEdge();
        if (!Array.isArray(sides) || !sides.length) {
            this.profiles = this.parent.poly.map(() => ({}));
        }
        if (sides.length && sides.length <= this.parent.poly.length) {
            const profiles = [];
            this.parent.poly.forEach((v, i) => profiles.push((sides[i] || sides[i - 1] || sides[0]).profile));
            this.profiles = profiles;
        }
    }
    getFrameSidesOnEdge() {
        const sides = [];
        if (this.frames && this.frames.length && this.frameNodes.length) {
            for (const frame of this.frames) {
                const frameNode = this.frameNodes.find(f => f.frame.id === frame.id);
                const parallelPoly = IccDrawMathService.getParallelPoly(frameNode.parent.poly, frameNode.parent.parent.poly);
                parallelPoly.forEach(sideIndex => {
                    if (typeof sideIndex === 'number' && sides.every(s => s.sideIndex !== sideIndex)) {
                        sides.push({
                            frameId: frame.id,
                            frameEdgeIndex: parallelPoly.indexOf(sideIndex),
                            profile: frame.frame[parallelPoly.indexOf(sideIndex)],
                            sideIndex
                        });
                    }
                });
            }
        }
        sides.sort((a, b) => a.sideIndex - b.sideIndex);
        return sides;
    }
}

class RensonNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.stripes = {
            polygons: [],
            poly: [],
            rect: {},
        };
        this.layer = Layers.Renson;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            sash: this.sash,
        }, params);
    }
    setDrawData(data) {
        data.renson.push(new DrawData(this.poly, {
            rensonId: this.renson ? this.renson.id : null,
            sashId: this.sash ? this.sash.id : null,
        }));
    }
    setDimensionsData(dimensions) {
        dimensions.vertical
            .filter(o => o.sashes.some(e => e === this.positionId + this.sash.id))
            .map(dimension => {
            dimension.minor.push(this.rect.y + this.rect.height);
        });
    }
    init() {
        this.svg.paths = [];
        this.rect = IccDrawMathService.getRectFromPoly(this.parent.poly);
        this.rect.height = Number(this.renson.height) || 100;
        this.poly = IccDrawMathService.intersectPolyWithRect(this.parent.poly, this.rect);
        /** math: poziome paski w rensonie */
        this.stripes.poly = IccDrawMathService.getPolyShift(this.poly, Math.round(this.rect.height / 5));
        this.stripes.rect = IccDrawMathService.getRectFromPoly(this.stripes.poly);
        this.stripes.polygons = [];
        [this.stripes.rect.height / 4, this.stripes.rect.height / 2, this.stripes.rect.height * 3 / 4].map(height => {
            this.stripes.polygons.push(IccDrawMathService.intersectPolyWithRect(this.stripes.poly, {
                x: this.stripes.rect.x,
                y: this.stripes.rect.y + height,
                width: this.stripes.rect.width,
                height: 0,
            }));
        });
        /** svg: rysowanie ścieżek */
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            stroke: '#bbb',
            fill: `#fff`,
        }));
        this.stripes.polygons.map(polygon => {
            this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                stroke: '#bbb',
                strokeDasharray: '5,5',
            }));
        });
    }
}

class RollerShutterNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.rollerShutter = {};
        this.stripes = {
            polygons: [],
            poly: [],
            rect: {},
        };
        this.layer = Layers.RollerShutter;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            rollerShutter: this.rollerShutter,
        }, params);
    }
    init() {
        this.svg.paths = [];
        this.rect = this.parent.rect;
        this.poly = this.parent.poly;
        if (this.rollerShutter) {
            /** math: obliczenie współrzędnych figury */
            this.rect = IccDrawMathService.getRectShift(this.parent.rect, { top: -this.rollerShutter.boxHeight });
            this.poly = IccDrawMathService.getPolyFromRect(this.rect);
            this.poly.push(this.poly.shift());
            /** math: poziome paski w rensonie */
            this.stripes.rect = Object.assign({}, this.rect);
            this.stripes.rect.height = this.rollerShutter.boxHeight;
            this.stripes.poly = IccDrawMathService.getPolyFromRect(this.stripes.rect);
            this.stripes.poly = IccDrawMathService.getPolyShift(this.stripes.poly, Math.round(this.stripes.rect.height / 4));
            this.stripes.rect = IccDrawMathService.getRectFromPoly(this.stripes.poly);
            this.stripes.polygons = [];
            [0, this.stripes.rect.height / 2, this.stripes.rect.height].map(height => {
                this.stripes.polygons.push(IccDrawMathService.intersectPolyWithRect(this.stripes.poly, {
                    x: this.stripes.rect.x,
                    y: this.stripes.rect.y + height,
                    width: this.stripes.rect.width,
                    height: 0,
                }));
            });
            /** svg: rysowanie ścieżek */
            this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                stroke: '#bbb',
                fill: `#fff`,
            }));
            this.stripes.polygons.map(polygon => {
                this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                    stroke: '#bbb',
                    strokeDasharray: '5,5',
                }));
            });
        }
    }
}

class SashFrameNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.frame = [];
        this.lowThreshold = false;
        this.mullions = [];
        this.profiles = [];
        this.sash = {};
        this.usedProfiles = [];
        this.profilesPolygonsMap = {};
        this.filledDoor = false;
        this.jointAngles = 'E_E_E_E';
        this.shape = 'rect';
        this.availableThresholdSashRebate = false;
        this.polygons = [];
        this.shift = [];
        this.grooveShift = [];
        this.width = [];
        this.profileJointAngles = [];
        this.parallelPoly = [];
        this.parallelProfiles = [];
        this.parentPoly = [];
        this.parentRect = {};
        this.groovePoly = [];
        this.grooveRect = [];
        this.sides = {
            'L': 'left',
            'R': 'right',
        };
        this.color = {};
        this.layer = Layers.SashFrameInside;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            profiles: this.profiles,
            sash: this.sash,
        }, params);
    }
    setDrawData(data) {
        data.sashFrame.push({
            inner: new DrawData(this.poly),
            outer: new DrawData(this.parentPoly),
            sides: this.polygons.map(poly => new DrawData(poly, {}, true)),
            sashId: this.sash ? this.sash.id : null,
        });
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal
            .filter(o => o.sashes.some(e => e === this.positionId + this.sash.id))
            .map(dimension => {
            dimension.minor.push(...this.poly.map(o => o.x));
        });
        dimensions.vertical
            .filter(o => o.sashes.some(e => e === this.positionId + this.sash.id))
            .map(dimension => {
            dimension.minor.push(...this.poly.map(o => o.y));
        });
    }
    init() {
        var _a;
        this.svg.paths = [];
        /** class: przygotowanie zestawu profili  */
        this.setProfiles();
        /** math: obliczenie odstępu na skrzydło */
        this.parallelPoly = IccDrawMathService.getParallelPoly(this.parent.poly, this.parent.parent.poly);
        if (this.root.outerSide !== this.outerSash) {
            this.layer = Layers.SashFrameOutside;
        }
        this.parallelPoly.reduce((prev, outer, inner) => {
            const sashFrame = this.profiles[inner] || this.profiles[0] || {};
            const sashFrameProfile = this.usedProfiles.find(o => o.id === sashFrame.profileId) || this.usedProfiles.find(o => o.type === 'sash') || {};
            let thresholdSide = false;
            let falseMullionSashSide = false;
            if (Number.isInteger(outer)) {
                // Od strony ramy
                const frame = this.frame[outer] || this.frame[this.frame.length - 1] || this.frame[0] || this.frame || {};
                const frameProfile = this.usedProfiles.find(o => o.id === frame.profileId) || this.usedProfiles.find(o => o.type === 'frame') || {};
                thresholdSide = frameProfile && frameProfile.type === 'threshold';
                this.parallelProfiles[inner] = frame.profileId;
                if (this.root.outerSide !== this.outerSash
                    || (this.lowThreshold && !this.root.options.kickerLowThreshold && Number(inner) === 0)) {
                    this.shift[inner] = Number(frameProfile.spaceSash || 60) - Number(frameProfile.widthOut || 70);
                }
                else {
                    this.shift[inner] = Number(frameProfile.spaceSash || 60) - Number(frameProfile.width || 45);
                }
            }
            else {
                // Od strony słupka
                const mullion = this.mullions.find(o => o.id === this.sash.nearMullions[outer]) || {};
                const mullionProfile = this.usedProfiles.find(o => o.id === mullion.profileId) || this.usedProfiles.find(o => o.type === 'divider') || {};
                if (sashFrameProfile.type === 'false_mullion_sash') {
                    falseMullionSashSide = true;
                }
                this.parallelProfiles[inner] = mullion.profileId;
                if (mullionProfile && mullionProfile.id) {
                    if (this.root.outerSide !== this.outerSash) {
                        this.shift[inner] = Number(mullionProfile.spaceSash || 30) - Number(mullionProfile.widthOut || 90) / 2;
                    }
                    else {
                        this.shift[inner] = Number(mullionProfile.spaceSash || 30) - Number(mullionProfile.width || 45) / 2;
                    }
                }
                else {
                    this.shift[inner] = 0;
                }
            }
            this.grooveShift[inner] = this.shift[inner];
            if (this.root.outerSide) {
                const sashWidthOut = sashFrameProfile.type === 'virtual_door_sash' ? 0 : (Number(sashFrameProfile.widthOut) || 100);
                const rebateWidth = (thresholdSide && this.availableThresholdSashRebate || falseMullionSashSide) ? 0 : (isFinite(sashFrameProfile.rebateWidthOut) ? Number(sashFrameProfile.rebateWidthOut) : 0);
                this.shift[inner] -= rebateWidth;
                this.width[inner] = sashWidthOut;
            }
            else {
                const sashWidth = sashFrameProfile.type === 'virtual_door_sash' ? 0 : (Number(sashFrameProfile.width) || 60);
                const rebateWidth = (thresholdSide && this.availableThresholdSashRebate || falseMullionSashSide) ? 0 : (isFinite(sashFrameProfile.rebateWidth) ? Number(sashFrameProfile.rebateWidth) : 20);
                this.shift[inner] -= rebateWidth;
                this.width[inner] = sashWidth;
            }
            this.shift[inner] += this.width[inner];
            this.profileJointAngles[inner] = (sashFrameProfile && sashFrameProfile.jointAngles) || null;
        }, []);
        /** math: obliczenie współrzędnych figury */
        this.poly = IccDrawMathService.getPolyShift(this.parent.poly, this.shift);
        /**
         * W przypadku drzwi, w których szerokość profilu wynosi 0 i mamy przymyk, obszar, w którym nakłada się wypełnienie
         * przekracza wymiary kontenera, co powoduje błędy przy wyznaczaniu sąsiadujących profili i w rysowaniu wypełnienia.
         * Aby do tego nie dopuścić rzutujemy wymiary przekraczające rozmiar kontenera na rozmiar kontenera.
         */
        this.poly = this.poly.map(p => {
            if (p.x < 0) {
                p.x = 0;
            }
            if (p.y < 0) {
                p.y = 0;
            }
            if (p.x > this.parent.rect.x + this.parent.rect.width) {
                p.x = this.parent.rect.x + this.parent.rect.width;
            }
            if (p.y > this.parent.rect.y + this.parent.rect.height) {
                p.y = this.parent.rect.y + this.parent.rect.height;
            }
            return p;
        });
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.groovePoly = IccDrawMathService.getPolyShift(this.parent.poly, this.grooveShift);
        this.grooveRect = IccDrawMathService.getRectFromPoly(this.groovePoly);
        /** math: odfiltrowanie zbliżonych punktów */
        this.poly = this.poly.filter((p, i) => !i || Math.abs(p.x - this.poly[i - 1].x) > 3 || Math.abs(p.y - this.poly[i - 1].y) > 3);
        /** math: przesunięcie figury względem rodzica */
        this.parentPoly = IccDrawMathService.getPolyShift(this.poly, this.width.map(e => -e));
        this.parentRect = IccDrawMathService.getRectFromPoly(this.parentPoly);
        /** math: przygotowanie zestawów profili */
        const jointAngle = IccDrawMathService.getJointAngles(this.parentPoly, this.jointAngles, this.shape, this.profileJointAngles);
        const { polygons, polygonLineMap } = IccDrawMathService.getPolygons(this.parentPoly, this.poly, jointAngle);
        this.polygons = polygons;
        this.profilesPolygonsMap = polygonLineMap;
        /** svg: rysowanie ścieżek */
        if (this.sash.filling.type === 'deco_panels') {
            if (this.root.outerSide) {
                if ([this.root.panelTypes.Double, this.root.panelTypes.Outer].indexOf(this.sash.filling.overlay_type) !== -1) {
                    return this;
                }
            }
            else {
                if ([this.root.panelTypes.Double, this.root.panelTypes.Inner].indexOf(this.sash.filling.overlay_type) !== -1) {
                    return this;
                }
            }
        }
        if (this.filledDoor) {
            return;
        }
        let i = 0;
        for (const polygon of this.polygons) {
            if (this.color && this.color.visualization && this.color.visualization.visualizationImage) {
                const sashColor = this.color && this.color.color ? this.color.color : '#fff';
                this.setColorVisualization(this.color.visualization, sashColor, this.root.outerSide, 'sash' + i, polygon);
            }
            else {
                this.svg.paths.push(IccDrawSvgService.getPath(polygon, true, this.root.side, {
                    stroke: IccColorContrastService.getInvertedColor((_a = this === null || this === void 0 ? void 0 : this.color) === null || _a === void 0 ? void 0 : _a.color) || "#bbb",
                    fill: `url('${this.root.uri}#iccDraw-sash-${this.root.uuid}-${this.positionId}')`,
                }));
            }
            i++;
        }
    }
    setProfiles() {
        if (this.profiles && this.profiles['bottom']) {
            const profiles = [];
            for (let curr = 0, next = 1; curr < this.parent.poly.length; ++curr, ++next, next %= this.parent.poly.length) {
                const { side } = IccDrawMathService.getLineInfo([this.parent.poly[curr], this.parent.poly[next]], this.parent.poly);
                profiles[curr] = this.profiles[side];
            }
            this.profiles = profiles;
        }
        if (!Array.isArray(this.profiles) || !this.profiles.length) {
            this.profiles = this.parent.poly.map(() => ({}));
        }
        if (this.profiles.length && this.profiles.length < this.parent.poly.length) {
            const profiles = [];
            this.parent.poly.forEach((v, i) => profiles.push(this.profiles[i] || this.profiles[i - 1] || this.profiles[0]));
            this.profiles = profiles;
        }
    }
}

class FrameShapeNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.frame = {};
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            frame: this.frame,
        }, params);
    }
    init() {
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.rect.x + this.frame.x,
            y: this.parent.rect.y + this.frame.y,
            width: this.frame.width,
            height: this.frame.height,
        };
        const rectPoly = IccDrawMathService.rotateRect(this.rect, this.rotation);
        this.poly = IccDrawMathService.intersectPolyWithRectPoly(this.parent.poly, rectPoly);
        // this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, { fill: '#' + ((1<<24)*Math.random()|0).toString(16) }));
    }
}

class ShapeNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.shape = {
            d: 0,
            h1: 1500,
            h2: 0,
            h3: 1500,
            s1: 1500,
            s2: 0,
            s3: 0,
            shape: 'rect',
            type: null,
        };
        this.layer = Layers.Shape;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        /** math: obliczenie współrzędnych figury */
        this.poly = IccDrawMathService.getPolyFromShape(this.shape, this.parent.rect);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.poly = IccDrawMathService.rotatePoly(this.poly, this.poly[this.poly.length - 1], this.rotation);
        this.setParentPoly();
        // this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, { fill: '#' + ((1<<24)*Math.random()|0).toString(16) }));
    }
    onClick(params = {}) {
        return Object.assign({
            shape: this.shape,
        }, params);
    }
    setDrawData(data) {
        const frameShapeNodes = this.children.filter(n => n instanceof FrameShapeNode);
        const parallelPolygons = frameShapeNodes.map(n => IccDrawMathService.getParallelPoly(n.poly, this.poly));
        const angles = this.poly.reduce((prev, point, index) => {
            let oneSideProfile;
            let otherSideProfile;
            frameShapeNodes.forEach((n, fsIndex) => {
                for (let currInner = 0, nextInner = 1; currInner < n.poly.length; ++currInner, ++nextInner, nextInner %= n.poly.length) {
                    const line1 = [n.poly[currInner], n.poly[nextInner]];
                    const parallelEdge = parallelPolygons[fsIndex][currInner];
                    if (line1[1].x === point.x
                        && line1[1].y === point.y
                        && typeof parallelEdge === 'number'
                        && Number.isInteger(parallelEdge)) {
                        oneSideProfile = {
                            frameId: n.frame ? n.frame.id : 0,
                            frameEdgeIndex: currInner,
                        };
                    }
                    if (line1[0].x === point.x
                        && line1[0].y === point.y
                        && typeof parallelEdge === 'number'
                        && Number.isInteger(parallelEdge)) {
                        otherSideProfile = {
                            frameId: n.frame ? n.frame.id : 0,
                            frameEdgeIndex: currInner,
                        };
                    }
                }
            });
            prev[index] = [oneSideProfile, otherSideProfile];
            return prev;
        }, {});
        data.shape.push(Object.assign(new DrawData(this.poly), {
            angles,
            positionId: this.positionId,
        }));
    }
}

class ShutterBoxNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.height = 0;
        this.stripes = {
            polygons: [],
            poly: [],
            rect: {},
        };
        this.layer = Layers.ShutterBox;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.rect.x,
            y: this.parent.rect.y + (this.positionId ? 0 : -this.height),
            width: this.parent.rect.width,
            height: this.height,
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        this.setParentPoly();
        /** math: poziome paski w rensonie */
        this.stripes.rect = Object.assign({}, this.rect);
        this.stripes.rect.height = this.height;
        this.stripes.poly = IccDrawMathService.getPolyFromRect(this.stripes.rect);
        this.stripes.poly = IccDrawMathService.getPolyShift(this.stripes.poly, Math.round(this.stripes.rect.height / 4));
        this.stripes.rect = IccDrawMathService.getRectFromPoly(this.stripes.poly);
        this.stripes.polygons = [];
        [0, this.stripes.rect.height / 2, this.stripes.rect.height].map(height => {
            this.stripes.polygons.push(IccDrawMathService.intersectPolyWithRect(this.stripes.poly, {
                x: this.stripes.rect.x,
                y: this.stripes.rect.y + height,
                width: this.stripes.rect.width,
                height: 0,
            }));
        });
        /** svg: rysowanie ścieżek */
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `#fff`,
            stroke: '#bbb',
        }));
        this.stripes.polygons.map(polygon => {
            this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                stroke: '#bbb',
                strokeDasharray: '5,5',
            }));
        });
    }
}

class ShutterColorsNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.colors = {};
        this.layer = Layers.Colors;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this.colors, params.colors);
        /** svg: gradient szyby */
        this.svg.gradients.push(IccDrawSvgService.getGradient({
            id: `iccDraw-shutter-${this.root.uuid}`,
            steps: [
                { color: '#ddd', offset: '0%' },
                { color: '#fff', offset: '100%' },
            ],
        }));
    }
}

class ShutterDriveNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.nextShutter = {};
        this.prevShutter = {};
        this.shutter = {};
        this.shift = 50;
        this.side = null;
        this.layer = Layers.ShutterDrive;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
        // shutter: this.shutter,
        }, params);
    }
    init() {
        this.svg.paths = [];
        /** class: sprawdzenie warunków */
        if (!this.shutter.commonRail && (this.shutter.controlSide === 'L' || !this.nextShutter || !this.nextShutter.commonRail)) {
            this.side = this.shutter.controlSide;
        }
        if (this.shutter.commonRail && this.prevShutter.controlSide === 'R' && (!this.nextShutter || !this.nextShutter.commonRail)) {
            this.side = this.prevShutter.controlSide;
        }
        if (this.side) {
            /** math: obliczenie współrzędnych figury */
            this.rect = {
                x: this.side === 'L' ? this.parent.rect.x + this.shift : this.parent.rect.x + this.parent.rect.width - this.shift,
                y: this.parent.rect.y + this.shift,
                width: 0,
                height: this.parent.rect.height - this.shift * 2,
            };
            this.poly = IccDrawMathService.getPolyFromRect(this.rect);
            /** svg: rysowanie ścieżek */
            this.svg.paths.push(IccDrawSvgService.getPath(this.poly, false, this.root.side, {
                stroke: '#aaa',
                strokeDasharray: '5,10',
                strokeWidth: '5',
            }));
        }
    }
}

class SideAccessoriesNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.accessories = {};
        this.shift = {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        };
        this.color = {};
        this.layer = Layers.Extensions;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        this.svg.paths = [];
        this.rect = this.parent.rect;
        this.poly = this.parent.poly;
        if (this.accessories && this.accessories.bottom && this.accessories.bottom.some(e => e.type === 'windowsill')) {
            this.accessories.bottom.filter(e => e.type === 'windowsill').map((accessory, index) => {
                this.shift.bottom = -Number(accessory.height) || -30;
                /** math: obliczenie współrzędnych figury */
                this.poly = IccDrawMathService.getPolyShift(this.poly, this.shift);
                this.rect = IccDrawMathService.getRectFromPoly(this.poly);
                /** svg: rysowanie ścieżek */
                if (this.color && this.color.visualization && this.color.visualization.visualizationImage) {
                    const frameColor = this.color && this.color.color ? this.color.color : 'fff';
                    this.setColorVisualization(this.color.visualization, frameColor, this.root.outerSide, 'sideaccessory' + index, this.poly);
                }
                else {
                    this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                        fill: `url('${this.root.uri}#iccDraw-frame-${this.root.uuid}-${this.positionId}')`,
                        stroke: '#bbb',
                    }));
                }
            });
        }
    }
}

class SymbolNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.shift = 0;
        this.type = {};
        this.layer = Layers.Symbol;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        var _a, _b;
        this.svg.paths = [];
        const polygons = [];
        /** math: obliczenie współrzędnych figury */
        if (this.shift > 0) {
            const shift = {
                top: this.shift,
                left: this.shift,
                right: this.shift,
                bottom: this.shift,
            };
            this.poly = IccDrawMathService.getPolyShift(this.parent.poly, shift);
        }
        else {
            this.poly = this.parent.poly;
        }
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        /** środek ciężkości figury */
        // const gravity = IccDrawMathService.getGravityFromRect(this.rect);
        const gravity = IccDrawMathService.getGravityFromPoly(this.poly);
        /** stałe szklenie */
        if (this.type.type === 'F') {
            const length = Math.ceil(Math.min(this.rect.width, this.rect.height) / 8);
            polygons.push([
                { x: gravity.x - length, y: gravity.y },
                { x: gravity.x + length, y: gravity.y },
            ]);
            polygons.push([
                { x: gravity.x, y: gravity.y - length },
                { x: gravity.x, y: gravity.y + length },
            ]);
        }
        /** stałe szklenie w ramie */
        if (this.type.type === 'FF' || this.type.type === 'OFF') {
            const length = Math.ceil(Math.min(this.rect.width, this.rect.height) / 8);
            const gravity1 = { x: gravity.x, y: Math.ceil(gravity.y - 2 * length) };
            const gravity2 = { x: gravity.x, y: Math.ceil(gravity.y + 2 * length) };
            polygons.push([
                { x: gravity1.x - length, y: gravity1.y },
                { x: gravity1.x + length, y: gravity1.y },
            ]);
            polygons.push([
                { x: gravity1.x, y: gravity1.y - length },
                { x: gravity1.x, y: gravity1.y + length },
            ]);
            polygons.push([
                { x: gravity2.x - length, y: gravity2.y },
                { x: gravity2.x + length, y: gravity2.y },
            ]);
            polygons.push([
                { x: gravity2.x, y: gravity2.y - length },
                { x: gravity2.x, y: gravity2.y + length },
            ]);
        }
        /** skrzydło z ruchomym słupkiem */
        if (['DS', 'ODS', 'DSH', 'ODSH', 'DSC', 'DRP', 'DOP'].some(e => e === this.type.type) || (this.type.type === 'PSK' && this.type.passive)) {
            let poly;
            if (this.type.handlePosition === 'R') {
                poly = [
                    { x: this.rect.x + this.rect.width + 50, y: gravity.y - gravity.height },
                    { x: this.rect.x + this.rect.width + 50, y: gravity.y + gravity.height },
                ];
            }
            else {
                poly = [
                    { x: this.rect.x - 50, y: gravity.y - gravity.height },
                    { x: this.rect.x - 50, y: gravity.y + gravity.height },
                ];
            }
            this.svg.paths.push(IccDrawSvgService.getPath(poly, false, this.root.side, {
                stroke: IccColorContrastService.getInvertedColor((_a = this === null || this === void 0 ? void 0 : this.filling) === null || _a === void 0 ? void 0 : _a.fillingColor) || '#bbb',
                strokeWidth: '4px',
            }));
            this.svg.paths.push(IccDrawSvgService.getPath(poly, false, this.root.side, {
                stroke: '#fff',
                strokeWidth: '4px',
                strokeDasharray: '5,5',
            }));
        }
        /** skrzydło rozwierne */
        if (['D', 'DK', 'DRA', 'DRP', 'DOA', 'DOP', 'DS', 'DSH', 'ODSH', 'DSC', 'OD', 'ODS', 'SWH'].some(e => e === this.type.type)) {
            if (this.type.handlePosition === 'R') {
                polygons.push([
                    { x: this.rect.x, y: gravity.y - gravity.height },
                    gravity.horizontal[1],
                    { x: this.rect.x, y: gravity.y + gravity.height },
                ]);
            }
            else {
                polygons.push([
                    { x: this.rect.x + this.rect.width, y: gravity.y - gravity.height },
                    gravity.horizontal[0],
                    { x: this.rect.x + this.rect.width, y: gravity.y + gravity.height },
                ]);
            }
        }
        /** skrzydło uchylne */
        if (['DK', 'K', 'PSK'].some(e => e === this.type.type)) {
            polygons.push([
                { x: gravity.x - gravity.width / (this.poly.length > 3 ? 1 : 2) + 5, y: this.rect.y + this.rect.height - 5 },
                { x: gravity.x, y: gravity.vertical[0].y && gravity.vertical[0].y < this.rect.y + this.rect.height / 2 ? gravity.vertical[0].y + 5 : this.rect.y + 5 },
                { x: gravity.x + gravity.width / (this.poly.length > 3 ? 1 : 2) - 5, y: this.rect.y + this.rect.height - 5 },
            ]);
        }
        /** skrzydło odchylne */
        if (['OKL'].some(e => e === this.type.type)) {
            polygons.push([
                { x: gravity.x - gravity.width, y: this.rect.y },
                gravity.vertical[1],
                { x: gravity.x + gravity.width, y: this.rect.y },
            ]);
        }
        /** skrzydło przesuwne */
        if (['PSK', 'S'].some(e => e === this.type.type)) {
            const posX = gravity.x;
            const posY = this.rect.y + Math.ceil(this.rect.height * 5 / 6);
            const length = Math.ceil(this.rect.width / 6);
            polygons.push([
                { x: posX - length, y: posY },
                { x: posX + length, y: posY },
            ]);
            if (this.type.handlePosition === 'R') {
                polygons.push([
                    { x: posX - length / 3, y: posY - length / 3 },
                    { x: posX - length, y: posY },
                    { x: posX - length / 3, y: posY + length / 3 },
                ]);
            }
            else {
                polygons.push([
                    { x: posX + length / 3, y: posY - length / 3 },
                    { x: posX + length, y: posY },
                    { x: posX + length / 3, y: posY + length / 3 },
                ]);
            }
        }
        /** skrzydło przesuwne w górę */
        if (this.type.type === 'SU') {
            const posX = gravity.x;
            const posY = gravity.y;
            const length = Math.ceil(this.rect.height / 6);
            polygons.push([
                { x: posX, y: posY - length },
                { x: posX, y: posY + length },
            ]);
            polygons.push([
                { x: posX - length / 3, y: posY - length / 3 },
                { x: posX, y: posY - length },
                { x: posX + length / 3, y: posY - length / 3 },
            ]);
        }
        /** skrzydło przesuwne w dół */
        if (this.type.type === 'SD') {
            const posX = gravity.x;
            const posY = gravity.y;
            const length = Math.ceil(this.rect.height / 6);
            polygons.push([
                { x: posX, y: posY - length },
                { x: posX, y: posY + length },
            ]);
            polygons.push([
                { x: posX + length / 3, y: posY + length / 3 },
                { x: posX, y: posY + length },
                { x: posX - length / 3, y: posY + length / 3 },
            ]);
        }
        /** skrzydło przechylne */
        if (this.type.type === 'SWF') {
            polygons.push([
                { x: this.rect.x, y: this.rect.y + this.rect.height / 2 },
                { x: this.rect.x + this.rect.width / 2, y: this.rect.y },
                { x: this.rect.x + this.rect.width, y: this.rect.y + this.rect.height / 2 },
            ]);
            polygons.push([
                { x: this.rect.x + this.rect.width, y: this.rect.y + this.rect.height / 2 },
                { x: this.rect.x + this.rect.width / 2, y: this.rect.y + this.rect.height },
                { x: this.rect.x, y: this.rect.y + this.rect.height / 2 },
            ]);
        }
        /** drzwi przesuwne */
        if (['HS'].some(e => e === this.type.type)) {
            const posX = this.rect.x + this.rect.width / 2;
            const posY = this.rect.y + this.rect.height / 2;
            const length = Math.ceil(this.rect.width / 6);
            polygons.push([
                { x: posX - length, y: posY },
                { x: posX + length, y: posY },
            ]);
            if (this.type.handlePosition === 'R') {
                polygons.push([
                    { x: posX - length / 3, y: posY - length / 3 },
                    { x: posX - length, y: posY },
                    { x: posX - length / 3, y: posY + length / 3 },
                ]);
            }
            else {
                polygons.push([
                    { x: posX + length / 3, y: posY - length / 3 },
                    { x: posX + length, y: posY },
                    { x: posX + length / 3, y: posY + length / 3 },
                ]);
            }
        }
        /** skrzydło obrotowe */
        if (['SWH'].some(e => e === this.type.type)) {
            const posX = this.rect.x;
            const posY = this.rect.y + this.rect.height / 2;
            const length = Math.ceil(this.rect.width);
            polygons.push([
                { x: posX - length, y: posY },
                { x: posX + length, y: posY },
            ]);
            polygons.push([
                { x: posX + length / 12, y: posY - length / 72 },
                { x: posX, y: posY },
                { x: posX + length / 12, y: posY + length / 72 },
                { x: posX, y: posY },
                { x: posX + length, y: posY },
                { x: posX + length * 11 / 12, y: posY - length / 72 },
                { x: posX + length, y: posY },
                { x: posX + length * 11 / 12, y: posY + length / 72 },
            ]);
        }
        /** drzwi harmonijkowe */
        if (['FD', 'FDO'].some(e => e === this.type.type)) {
            const posX = this.rect.x + this.rect.width / 2;
            const posY = this.rect.y + this.rect.height / 2;
            const length = Math.ceil(this.rect.width / 6);
            polygons.push([
                { x: posX - length * 2, y: posY },
                { x: posX + length * 2, y: posY },
            ]);
            if (this.type.handlePosition === 'L') {
                polygons.push([
                    { x: posX - length / 3, y: posY - length },
                    { x: posX - length * 2, y: posY },
                    { x: posX - length / 3, y: posY + length },
                ]);
            }
            else {
                polygons.push([
                    { x: posX + length / 3, y: posY - length },
                    { x: posX + length * 2, y: posY },
                    { x: posX + length / 3, y: posY + length },
                ]);
            }
        }
        /** math: przycinanie linii do krawędzi figury */
        for (const polygon of polygons) {
            for (let curr = 0, next = 1; next < polygon.length; curr++, next++) {
                const line = IccDrawMathService.intersectLineWithPoly([polygon[curr], polygon[next]], this.poly);
                polygon[curr] = line[0];
                polygon[next] = line[1];
            }
        }
        /** svg: rysowanie ścieżek */
        for (const polygon of polygons) {
            this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                stroke: IccColorContrastService.getInvertedColor((_b = this === null || this === void 0 ? void 0 : this.filling) === null || _b === void 0 ? void 0 : _b.fillingColor) || '#bbb',
                strokeWidth: '4px',
            }));
            this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                stroke: '#fff',
                strokeWidth: '2px',
                strokeDasharray: (this.root.side === 'outer') !== (['OKL', 'OD', 'ODS', 'ODSH', 'FDO', 'DOA', 'DOP'].some(e => e === this.type.type)
                    || (this.type.type === 'SWF' && polygon === polygons[1])) ? '5,5' : null,
            }));
        }
    }
}

class VentilatorNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.layer = Layers.Ventilator;
        this.includeInExtendedDimensions = false;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            sash: this.sash,
        }, params);
    }
    init() {
        this.svg.paths = [];
        /** math: znalezienie górnego profilu */
        this.poly = this.parent.polygons.find(poly => IccDrawMathService.getLineInfo([poly[0], poly[1]], poly).side === 'top');
        if (this.poly) {
            this.rect = IccDrawMathService.getRectFromPoly(this.poly);
            this.position = this.ventilator.position || this.sash.width / 2;
            this.width = this.ventilator.width || this.rect.width / 2;
            this.height = this.ventilator.height || this.rect.height / 2;
            this.rect = {
                x: this.parent.parent.rect.x + this.position - this.width / 2,
                y: this.rect.y + this.rect.height / 2 - this.height / 2,
                width: this.width,
                height: this.height,
            };
            this.poly = IccDrawMathService.getPolyFromRect(this.rect);
            /** math: dodatkowy pasek w środku */
            const stripe = IccDrawMathService.getPolyFromRect({
                x: this.rect.x + 10,
                y: this.rect.y + (this.rect.height / 2),
                width: this.rect.width - 20,
                height: 0,
            });
            /** svg: rysowanie ścieżek */
            this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                stroke: '#bbb',
                fill: '#fff',
            }));
            this.svg.paths.push(IccDrawSvgService.getPath(stripe, false, this.root.side, {
                stroke: '#bbb',
                strokeDasharray: '5,5',
            }));
        }
    }
}

class CouplingNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.coupling = {};
        this.couplings = [];
        this.usedProfiles = [];
        this.frames = [];
        this.mullions = [];
        this.sashes = [];
        this.sashNodes = [];
        this.couplingPosition = 0;
        this.color = {};
        this.layer = Layers.Frame;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        const couplingProfile = this.usedProfiles.find(o => o.id === this.coupling.profileId)
            || this.usedProfiles.find(o => o.type === 'coupling')
            || {};
        if (this.root.outerSide !== this.root.outerSash) {
            this.width =
                typeof this.coupling.widthOut !== undefined
                    ? Number(this.coupling.widthOut)
                    : Number(couplingProfile.widthOut);
        }
        else {
            this.width =
                typeof this.coupling.width !== undefined
                    ? Number(this.coupling.width)
                    : Number(couplingProfile.width);
        }
        /** math: znalezienie sąsiadujących słupków */
        const shift = { top: 0, left: 0, right: 0, bottom: 0 };
        this.coupling.framesId.reduce((prev, sId) => {
            const adjacentFrame = this.frames.find(s => s.id === sId.id);
            return adjacentFrame && prev < adjacentFrame.x + adjacentFrame.width
                ? adjacentFrame.x + adjacentFrame.width
                : prev;
        }, 0);
        this.couplingPosition =
            this.coupling.direction === 'vertical'
                ? this.coupling.framesId.reduce((prev, sId) => {
                    const adjacentFrame = this.frames.find(s => s.id === sId.id);
                    return adjacentFrame && prev < adjacentFrame.x + adjacentFrame.width
                        ? adjacentFrame.x + adjacentFrame.width
                        : prev;
                }, 0)
                : this.coupling.framesId.reduce((prev, sId) => {
                    const adjacentFrame = this.frames.find(s => s.id === sId.id);
                    return adjacentFrame && prev < adjacentFrame.y + adjacentFrame.height
                        ? adjacentFrame.y + adjacentFrame.height
                        : prev;
                }, 0);
        /** math: obliczenie wymiarów słupka */
        this.rect.x =
            this.coupling.direction === 'vertical'
                ? this.couplingPosition
                : this.coupling.framesId.reduce((prev, sId) => {
                    const adjacentFrame = this.frames.filter(s => s.id === sId.id);
                    return adjacentFrame.length > 0 && prev > adjacentFrame[0].x
                        ? adjacentFrame[0].x
                        : prev;
                }, Number.MAX_VALUE);
        this.rect.y =
            this.coupling.direction === 'horizontal'
                ? this.couplingPosition
                : this.coupling.framesId.reduce((prev, sId) => {
                    const adjacentFrame = this.frames.filter(s => s.id === sId.id);
                    return adjacentFrame.length > 0 && prev > adjacentFrame[0].y
                        ? adjacentFrame[0].y
                        : prev;
                }, Number.MAX_VALUE);
        this.rect.x += this.parent.parent.rect.x;
        this.rect.y += this.parent.parent.rect.y;
        this.rect.width =
            this.coupling.direction === 'horizontal' ? this.coupling.length : this.width;
        this.rect.height =
            this.coupling.direction === 'vertical' ? this.coupling.length : this.width;
        /** math: obliczenie części wspólnej figur */
        this.rect = IccDrawMathService.getRectShift(this.rect, shift);
        this.poly = IccDrawMathService.intersectPolyWithRect(this.parent.poly, this.rect);
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        const { positionMin, positionMax, prev, next } = this.getCouplingPosition();
        this.positionMin = positionMin;
        this.positionMax = positionMax;
        this.prev = prev;
        this.next = next;
        const color = this.coupling.color;
        if (color && color.frame && color.frame[this.root.side]) {
            if (color.frame[this.root.side] && color.frame[this.root.side].visualization && color.frame[this.root.side].visualization.visualizationImage) {
                const frameColor = color.frame[this.root.side] && color.frame[this.root.side].color ? color.frame[this.root.side].color : 'fff';
                this.setColorVisualization(color.frame[this.root.side].visualization, frameColor, this.root.outerSide, 'coupling' + this.coupling.id, this.poly, this.coupling.direction === 'vertical');
            }
            else {
                this.svg.patterns.push(IccDrawSvgService.getPattern({
                    id: `iccDraw-extension-${this.coupling.id}-${this.uuid}`,
                    color: color.frame[this.root.side].color
                        ? `#${color.frame[this.root.side].color}`
                        : '#fff',
                    image: color.frame[this.root.side].color_img
                        ? `/files/color/${color.frame[this.root.side].color_img}`
                        : null,
                    height: this.rect.height,
                    width: this.rect.width,
                }));
                this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                    fill: `url('${this.root.uri}#iccDraw-extension-${this.coupling.id}-${this.uuid}')`,
                    stroke: '#bbb',
                }));
            }
        }
        else {
            if (this.color && this.color.visualization && this.color.visualization.visualizationImage) {
                const frameColor = this.color && this.color.color ? this.color.color : 'fff';
                this.setColorVisualization(this.color.visualization, frameColor, this.root.outerSide, 'coupling' + this.coupling.id, this.poly, true);
            }
            else {
                this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
                    fill: `url('${this.root.uri}#iccDraw-frame-${this.root.uuid}-${this.positionId}')`,
                    stroke: '#bbb',
                }));
            }
        }
    }
    onClick(params = {}) {
        return Object.assign({
            coupling: this.coupling,
        }, params);
    }
    onMove(params = {}) {
        return Object.assign({
            min: this.options.minPosition || 0,
            max: this.options.maxPosition || null,
            positionMin: this.positionMin,
            positionMax: this.positionMax,
            prev: this.couplingPosition + Math.ceil(this.width / 2) - this.prev,
            next: this.next - (this.couplingPosition + Math.ceil(this.width / 2)),
            direction: this.coupling.direction,
            position: this.couplingPosition + Math.ceil(this.width / 2),
            coupling: this.coupling,
            rect: this.parent.parent.rect,
            shift: this.parent.parent.rect,
        }, params);
    }
    setDrawData(data) {
        data.coupling.push(new DrawData(this.poly, {
            direction: this.coupling ? this.coupling.direction : null,
            couplingId: this.coupling ? this.coupling.id : null,
            positionId: this.positionId,
        }));
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal.map(dimension => {
            if (this.rect.y <= dimension.stop
                && this.rect.y + this.rect.height >= dimension.start) {
                dimension.minor.push(this.rect.x, this.rect.x + this.rect.width);
            }
        });
        dimensions.vertical.map(dimension => {
            if (this.rect.x <= dimension.stop && this.rect.x + this.rect.width >= dimension.start) {
                dimension.minor.push(this.rect.y, this.rect.y + this.rect.height);
            }
        });
    }
    getCouplingPosition() {
        const sides = this.coupling.direction === 'vertical' ? ['left', 'right'] : ['top', 'bottom'];
        const field = this.coupling.direction === 'vertical' ? ['x', 'width'] : ['y', 'height'];
        const prev = Math.max(...this.frames
            .filter(frame => this.coupling.framesId.find(f => f.id === frame.id))
            .map(frame => {
            const mullions = this.mullions.filter(mullion => mullion.frameId === frame.id);
            const sashes = this.sashes.filter(sash => sash.frameId === frame.id
                && sash[field[1]] + sash[field[0]] === frame.width);
            if (sashes.some(sash => sash.intMullions
                && sash.intMullions.some(mullion => mullion.direction === this.coupling.direction))) {
                return (frame[field[0]]
                    + Math.max(...sashes.map(sash => sash[field[0]]
                        + Math.max(...sash.intMullions
                            .filter(mullion => mullion.direction
                            === this.coupling.direction)
                            .map(mullion => mullion.position)))));
            }
            else if (mullions.some(mullion => mullion.direction === this.coupling.direction)) {
                return (frame[field[0]]
                    + Math.max(...mullions
                        .filter(mullion => mullion.direction === this.coupling.direction)
                        .map(mullion => mullion.position)));
            }
            else {
                return frame[field[0]];
            }
        }));
        const positionMinNodes = this.frames
            .filter(frame => this.coupling.framesId.find(f => f.id === frame.id))
            .reduce((acu, frame) => acu.concat(this.sashes.filter(sash => sash.frameId === frame.id
            && sash[field[1]] + sash[field[0]] === frame.width)), [])
            .map(sash => this.sashNodes.find(s => s.sash.id === sash.id))
            .filter(node => node)
            .reduce((acu, node) => {
            acu.push(...this.getGlazingNodes(node));
            return acu;
        }, []);
        const positionMin = positionMinNodes.reduce((acu, node) => acu[1] < node.glazingBead.rect[field[0]]
            ? [
                node.glazingBead.rect[field[0]] - node.sash.rect[field[0]],
                node.glazingBead.rect[field[0]],
            ]
            : acu, [0, 0])[0]
            + positionMinNodes.reduce((acu, node) => acu[1] < node.glazingBead.rect[field[0]]
                ? [
                    node.sash.rect[field[0]]
                        + node.sash.rect[field[1]]
                        - node.glazingBead.rect[field[0]]
                        - node.glazingBead.rect[field[1]],
                    node.glazingBead.rect[field[0]],
                ]
                : acu, [0, 0])[0];
        const next = Math.max(...this.frames
            .filter(frame => this.coupling.otherFramesId.find(f => f.id === frame.id))
            .map(frame => {
            const mullions = this.mullions.filter(mullion => mullion.frameId === frame.id);
            const sashes = this.sashes.filter(sash => sash.frameId === frame.id
                && sash[field[1]] + sash[field[0]] === frame.width);
            if (sashes.some(sash => sash.intMullions
                && sash.intMullions.some(mullion => mullion.direction === this.coupling.direction))) {
                return (frame[field[0]]
                    + Math.max(...sashes.map(sash => sash[field[0]]
                        + Math.max(...sash.intMullions
                            .filter(mullion => mullion.direction
                            === this.coupling.direction)
                            .map(mullion => mullion.position)))));
            }
            else if (mullions.some(mullion => mullion.direction === this.coupling.direction)) {
                return (frame[field[0]]
                    + Math.max(...mullions
                        .filter(mullion => mullion.direction === this.coupling.direction)
                        .map(mullion => mullion.position)));
            }
            else {
                return frame[field[0]] + frame[field[1]];
            }
        }));
        const positionMaxNodes = this.frames
            .filter(frame => this.coupling.otherFramesId.find(f => f.id === frame.id))
            .reduce((acu, frame) => acu.concat(this.sashes.filter(sash => sash.frameId === frame.id
            && sash[field[0]] === 0)), [])
            .map(sash => this.sashNodes.find(s => s.sash.id === sash.id))
            .filter(node => node)
            .reduce((acu, node) => {
            acu.push(...this.getGlazingNodes(node));
            return acu;
        }, []);
        const positionMax = positionMaxNodes.reduce((acu, node) => acu[1] > node.glazingBead.rect[field[0]]
            ? [
                node.glazingBead.rect[field[0]] - node.sash.rect[field[0]],
                node.glazingBead.rect[field[0]],
            ]
            : acu, [0, Number.MAX_SAFE_INTEGER])[0]
            + positionMaxNodes.reduce((acu, node) => acu[1] > node.glazingBead.rect[field[0]]
                ? [
                    node.sash.rect[field[0]]
                        + node.sash.rect[field[1]]
                        - node.glazingBead.rect[field[0]]
                        - node.glazingBead.rect[field[1]],
                    node.glazingBead.rect[field[0]],
                ]
                : acu, [0, Number.MAX_SAFE_INTEGER])[0];
        return { positionMin, positionMax, prev, next };
    }
    getGlazingNodes(node, data = [], sashNode = null) {
        if (node instanceof SashNode) {
            sashNode = node;
        }
        if (node instanceof GlazingBeadNode) {
            data.push({
                glazingBead: node,
                sash: sashNode,
            });
        }
        node.children.map(child => (data = this.getGlazingNodes(child, data, sashNode)));
        return data;
    }
}

class SillNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.sill = {};
        this.windows = [];
        this.extensionPosition = 0;
        this.layer = Layers.Extensions;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            extension: this.sill,
        }, params);
    }
    setDimensionsData(dimensions) {
        dimensions.horizontal.map(dimension => {
            if (this.rect.y <= dimension.stop
                && this.rect.y + this.rect.height >= dimension.start) {
                dimension.minor.push(this.rect.x, this.rect.x + this.rect.width);
            }
        });
        dimensions.vertical.map(dimension => {
            if (this.rect.x <= dimension.stop && this.rect.x + this.rect.width >= dimension.start) {
                dimension.minor.push(this.rect.y, this.rect.y + this.rect.height);
            }
        });
    }
    init() {
        this.svg.patterns = [];
        this.svg.paths = [];
        this.width = Number(this.sill.width);
        const frameNodes = this.getFrameNodes(this.root);
        if (this.sill.framesId.length > 0) {
            const sId = this.sill.framesId[0];
            const frameNode = frameNodes.find(n => n.frame.id === sId.id && n.positionId === sId.positionId);
            this.poly = this.getExtensionPoly(this.getParallelFrameLine(frameNode, sId.edges[0]));
        }
        /** math: obliczenie części wspólnej figur */
        this.rect = IccDrawMathService.getRectFromPoly(this.poly);
        this.setParentPoly();
        const color = this.sill.color;
        if (color && color[this.root.side]) {
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-extension-${this.sill.id}-${this.uuid}`,
                color: color[this.root.side].color
                    ? `#${color[this.root.side].color}`
                    : '#fff',
                image: color[this.root.side].color_img
                    ? `/files/color/${color[this.root.side].color_img}`
                    : null,
                height: this.rect.height,
                width: this.rect.width,
            }));
        }
        else {
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-extension-${this.sill.id}-${this.uuid}`,
                color: '#fff',
                image: null,
                height: this.rect.height,
                width: this.rect.width,
            }));
        }
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-extension-${this.sill.id}-${this.uuid}')`,
            stroke: '#bbb',
        }));
    }
    getFrameNodes(node, data = []) {
        if (node instanceof FrameNode) {
            data.push(node);
        }
        node.children.map(child => (data = this.getFrameNodes(child, data)));
        return data;
    }
    getParallelFrameLine(frameNode, edgeIndex) {
        return [
            frameNode.parent.poly[(edgeIndex + frameNode.parent.poly.length) % frameNode.parent.poly.length],
            frameNode.parent.poly[(edgeIndex + 1 + frameNode.parent.poly.length) % frameNode.parent.poly.length],
        ];
    }
    getExtensionPoly(parallelLine) {
        const line = IccDrawMathService.getLineShift(parallelLine, -20);
        const { angle } = IccDrawMathService.getLineInfo(line);
        const line2 = angle < 1 ? [parallelLine[0], line[0]] : [line[1], parallelLine[1]];
        const line4 = IccDrawMathService.getLineShift(line2, this.sill.length);
        return [line2[1], line4[1], line4[0], line2[0]];
    }
}

class WallNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.dimensions = {};
        this.index = 0;
        this.layer = GarageDoorLayers.Wall;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: 0,
            y: this.positionId ? this.parent.rect.y : 0,
            width: Number(this.dimensions.width) + 300 || 0,
            height: Number(this.dimensions.height) + Number(this.dimensions.lintelHeight) || 0,
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        /** svg: rysowanie ścieżek */
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: '#febd9e',
            stroke: '#febd9e',
        }));
    }
}

class PanelsNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.dimensions = {};
        this.index = 0;
        this.layer = GarageDoorLayers.Panels;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.rect.x + 150,
            y: this.parent.rect.y + this.dimensions.lintelHeight,
            width: Number(this.dimensions.width) || 0,
            height: Number(this.dimensions.height) || 0,
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        /** svg: rysowanie ścieżek */
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `#fff`,
            stroke: '#fff',
        }));
    }
}

class EmbossingNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.layer = GarageDoorLayers.Embossing;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        const embossingNodes = this.parent.children.filter(c => c instanceof EmbossingNode);
        const prevEmbossing = embossingNodes.length > 1 && embossingNodes[embossingNodes.length - 2];
        /** math: obliczenie współrzędnych figury */
        // Pattern Up
        this.rect = {
            x: this.parent.rect.x,
            y: this.embossingSpacing + (prevEmbossing ? prevEmbossing.rect.y : this.parent.rect.y) || 0,
            width: this.parent.rect.width || 0,
            height: 0.01,
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        const color1 = '999999';
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-embossingUp-${this.root.uuid}-${this.index}`,
            color: '#' + color1,
            x: this.parent.rect.x || 0,
            y: this.embossingSpacing + (prevEmbossing ? prevEmbossing.rect.y : this.parent.rect.y) || 0,
            height: 0.01,
            width: this.parent.rect.width || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-embossingUp-${this.root.uuid}-${this.index}')`,
            stroke: '#' + color1,
            strokeWidth: 0.2
        }));
        // Pattern Down
        this.rect.y += this.embossingHeight;
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        const color2 = 'ffffff';
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-embossingDown-${this.root.uuid}-${this.index}`,
            color: '#' + color2,
            x: this.parent.rect.x || 0,
            y: this.embossingHeight + this.embossingSpacing + (prevEmbossing ? prevEmbossing.rect.y : this.parent.rect.y || 0),
            height: 0.01,
            width: this.parent.rect.width || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-embossingDown-${this.root.uuid}-${this.index}')`,
            stroke: '#' + color2,
            strokeWidth: 0.2
        }));
    }
}

class PanelPatternNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.panelStructures = {};
        this.index = 0;
        this.layer = GarageDoorLayers.PanelPattern;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        const panelPatternNodes = this.parent.children.filter(c => c instanceof PanelPatternNode);
        const prevPanelPattern = panelPatternNodes.length > 1 && panelPatternNodes[panelPatternNodes.length - 2];
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.rect.x,
            y: 5 + (prevPanelPattern ? prevPanelPattern.rect.y + prevPanelPattern.rect.height : this.parent.rect.y || 0),
            width: Number(this.parent.rect.width) || 0,
            height: Number(this.parent.rect.height) || 0,
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        /** svg: rysowanie ścieżek */
        let image = this.root.side === 'inner' ? this.panelStructures.innerImage : this.panelStructures.outerImage;
        image = `/files/garagedoorpanelstructure/${image}` || null;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-panelPattern-${this.root.uuid}-${this.index}`,
            image,
            x: this.parent.rect.x || 0,
            y: 5 + (prevPanelPattern ? prevPanelPattern.rect.y + prevPanelPattern.rect.height : this.parent.rect.y || 0),
            width: Number(this.parent.rect.width) || 0,
            height: Number(this.parent.rect.height) || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-panelPattern-${this.root.uuid}-${this.index}')`,
            stroke: '#ffffff',
            strokeWidth: 1
        }));
    }
}

class PanelInsertNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.stripes = {
            polygons: [],
            poly: [],
            rect: {},
        };
        this.colors = {
            inner: null,
            outer: null
        };
        this.images = {
            inner: null,
            outer: null
        };
        this.layer = GarageDoorLayers.PanelInsert;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        const panelInsertNodes = this.parent.children.filter(c => c instanceof PanelInsertNode);
        const prevPanelInsert = panelInsertNodes.length > 1 && panelInsertNodes[panelInsertNodes.length - 2];
        /** math: obliczenie współrzędnych figury */
        const rect = this.parent.parent.rect;
        rect.x += this.parent.frameWidth;
        rect.y += this.parent.frameWidth;
        rect.width -= 2 * this.parent.frameWidth;
        rect.height -= 2 * this.parent.frameWidth;
        if (this.parent.parent.shape === 'circle') {
            const shape = { d: this.parent.parent.dimensions.diameter - (2 * this.parent.frameWidth), shape: this.parent.parent.shape };
            this.poly = IccDrawMathService.getPolyFromShape(shape, rect);
            this.rect = IccDrawMathService.getRectFromPoly(this.poly);
            this.poly = IccDrawMathService.rotatePoly(this.poly, this.poly[this.poly.length - 1], this.rotation);
            this.setParentPoly();
        }
        else {
            this.rect = rect;
            this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        }
        let color = 'a8ccd7';
        let colorImg = null;
        let image = null;
        if (this.insertType === 'ventilation_grate') {
            color = (this.root.side === 'inner'
                ? this.colors.inner && this.colors.inner.color
                : this.colors.outer && this.colors.outer.color) || 'ffffff';
            colorImg = (this.root.side === 'inner'
                ? this.colors.inner && this.colors.inner.color_img
                : this.colors.outer && this.colors.outer.color_img);
            image = `/files/garagedoorcolor/${colorImg}`;
        }
        else {
            image = `/files/garagedoorinsertglazing/` + (this.root.side === 'inner' ? this.images.inner : this.images.outer);
        }
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-panelInsert-${this.root.uuid}-${this.parent.parent.parent.index}-${this.parent.parent.index}`,
            color: '#' + color,
            image,
            x: this.rect.x || 0,
            y: this.rect.y || 0,
            width: Number(this.rect.width) || 0,
            height: Number(this.rect.height) || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-panelInsert-${this.root.uuid}-${this.parent.parent.parent.index}-${this.parent.parent.index}')`,
            stroke: this.insertType === 'glazing' ? '#000000' : null,
            strokeWidth: 0.5
        }));
        if (this.insertType === 'ventilation_grate') {
            /** math: poziome paski w kratce */
            this.stripes.rect = Object.assign({}, this.parent.rect);
            this.stripes.poly = IccDrawMathService.getPolyFromRect(this.stripes.rect);
            this.stripes.poly = IccDrawMathService.getPolyShift(this.stripes.poly, Math.round(this.parent.rect.height / 4));
            this.stripes.rect = IccDrawMathService.getRectFromPoly(this.stripes.poly);
            const stripesYPositions = [0, this.stripes.rect.height / 2, this.stripes.rect.height];
            // Linie białe - górne
            const polygonsWhite = [];
            stripesYPositions.map(height => {
                polygonsWhite.push(IccDrawMathService.intersectPolyWithRect(this.stripes.poly, {
                    x: this.stripes.rect.x,
                    y: this.stripes.rect.y + height - 10,
                    width: this.stripes.rect.width,
                    height: 0,
                }));
            });
            polygonsWhite.map(polygon => {
                this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                    stroke: '#cccccc',
                }));
            });
            // Linie czarne - dolne
            const polygonsBlack = [];
            stripesYPositions.map(height => {
                polygonsBlack.push(IccDrawMathService.intersectPolyWithRect(this.stripes.poly, {
                    x: this.stripes.rect.x,
                    y: this.stripes.rect.y + height,
                    width: this.stripes.rect.width,
                    height: 0,
                }));
            });
            polygonsBlack.map(polygon => {
                this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                    stroke: '#888888',
                }));
            });
            /** math: pionowe paski w kratce - dzieli kratkę na 3 sekcje */
            this.stripes.rect = Object.assign({}, this.rect);
            this.stripes.poly = IccDrawMathService.getPolyFromRect(this.stripes.rect);
            const stripesXPositions = [this.stripes.rect.width * 0.33, this.stripes.rect.width * 0.66];
            const verticalPolygons = [];
            stripesXPositions.map(width => {
                verticalPolygons.push(IccDrawMathService.intersectPolyWithRect(this.stripes.poly, {
                    x: this.stripes.rect.x + width,
                    y: rect.y,
                    width: 0,
                    height: this.parent.rect.height,
                }));
            });
            verticalPolygons.map(polygon => {
                this.svg.paths.push(IccDrawSvgService.getPath(polygon, false, this.root.side, {
                    stroke: '#' + color,
                    strokeWidth: 3
                }));
            });
        }
    }
}

class PanelInsertFrameNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.frameColor = {
            inner: null,
            outer: null
        };
        this.layer = GarageDoorLayers.PanelInsertFrame;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            positionId: this.positionId
        }, params);
    }
    init() {
        this.svg.paths = [];
        if (this.parent.shape === 'circle') {
            const shape = { d: this.parent.dimensions.diameter, shape: this.parent.shape };
            this.poly = IccDrawMathService.getPolyFromShape(shape, this.parent.rect);
            this.rect = IccDrawMathService.getRectFromPoly(this.poly);
            this.poly = IccDrawMathService.rotatePoly(this.poly, this.poly[this.poly.length - 1], this.rotation);
            this.setParentPoly();
        }
        else {
            this.rect = {
                x: Number(this.parent.rect.x) || 0,
                y: Number(this.parent.rect.y) || 0,
                height: Number(this.parent.rect.height) || 0,
                width: Number(this.parent.rect.width) || 0
            };
            this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        }
        const color = (this.root.side === 'inner'
            ? this.frameColor.inner && this.frameColor.inner.color
            : this.frameColor.outer && this.frameColor.outer.color) || 'ffffff';
        const image = '/files/garagedoorcolor/' + (this.root.side === 'inner'
            ? this.frameColor.inner && this.frameColor.inner.color_img
            : this.frameColor.outer && this.frameColor.outer.color_img);
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-panelInsertFrame-${this.root.uuid}-${this.parent.parent.index}-${this.parent.index}`,
            color: '#' + color,
            image,
            x: this.parent.rect.x || 0,
            y: this.parent.rect.y || 0,
            width: Number(this.parent.rect.width) || 0,
            height: Number(this.parent.rect.height) || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-panelInsertFrame-${this.root.uuid}-${this.parent.parent.index}-${this.parent.index}')`,
            stroke: '#000000',
            strokeWidth: 0.5
        }));
    }
}

class PanelInsertFramePatternNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.framePattern = {};
        this.index = 0;
        this.layer = GarageDoorLayers.PanelInsertFramePattern;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        this.svg.paths = [];
        /** math: obliczenie współrzędnych figury */
        this.rect = {
            x: this.parent.rect.x,
            y: this.parent.rect.y,
            width: Number(this.parent.rect.width) || 0,
            height: Number(this.parent.rect.height) || 0,
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        /** svg: rysowanie ścieżek */
        let image = this.root.side === 'inner' ? this.framePattern.innerImage : this.framePattern.outerImage;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-panelFramePattern-${this.root.uuid}-${this.index}`,
            image: image ? `/files/garagedoorpanelstructure/${image}` : null,
            x: this.parent.rect.x || 0,
            y: this.parent.rect.y || 0,
            width: Number(this.parent.rect.width) || 0,
            height: Number(this.parent.rect.height) || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-panelFramePattern-${this.root.uuid}-${this.index}')`,
            stroke: '#ffffff',
            strokeWidth: 1
        }));
    }
}

class WicketDoorFrameNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.index = 1;
        this.layer = GarageDoorLayers.WicketDoorFrame;
        /** class: nadpisanie domyślnych parametrów */
        Object.assign(this, params);
        this.init();
    }
    init() {
        this.svg.paths = [];
        this.rect = {
            x: this.parent.parent.rect.x + Number(this.frame.x) || 0,
            y: this.parent.parent.rect.y + Number(this.frame.y) || 0,
            height: Number(this.frame.height) || 0,
            width: Number(this.frame.width) || 0
        };
        this.poly = IccDrawMathService.getPolyFromRect(this.rect);
        const image = `/files/garagedoorcolor/${this.frameColorImg}`;
        this.svg.patterns.push(IccDrawSvgService.getPattern({
            id: `iccDraw-wicketDoorFrame-${this.root.uuid}-${this.index}`,
            color: '#' + this.frameColor,
            image,
            x: this.parent.rect.x || 0,
            y: this.parent.rect.y || 0,
            width: Number(this.parent.rect.width) || 0,
            height: Number(this.parent.rect.height) || 0
        }));
        this.svg.paths.push(IccDrawSvgService.getPath(this.poly, true, this.root.side, {
            fill: `url('${this.root.uri}#iccDraw-wicketDoorFrame-${this.root.uuid}-${this.index}')`,
        }));
    }
}

class PortalNode extends BaseNode {
    constructor(parentNode = null, childrenNodes = null, params = {}, options = {}) {
        super(parentNode, childrenNodes, params, options);
        this.doorPortal = {};
        this.polygons = [];
        this.frameNodes = [];
        this.portalDimensions = [];
        this.shiftPortal = {};
        this.shiftFrame = [];
        this.shiftRenoFrame = [];
        this.color = {};
        this.profiles = [];
        Object.assign(this, params);
        this.init();
    }
    onClick(params = {}) {
        return Object.assign({
            doorPortal: this.doorPortal,
        }, params);
    }
    init() {
        this.svg.paths = [];
        this.svg.patterns = [];
        this.rect = this.parent.rect;
        this.poly = this.parent.poly;
        this.portalDimensions = [];
        this.shiftPortal = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        };
        if (this.usedProfiles.some(el => el.options && el.options.indexOf('renovation_frame') !== -1)) {
            for (const frameNode of this.frameNodes) {
                const shift = [];
                /** math: przesunięcie względem bazowej figury */
                for (let i = 0; i < frameNode.parent.poly.length; i++) {
                    const frame = frameNode.frame.frame[i] || frameNode.frame.frame[0] || {};
                    shift[i] = -Number(frame.finWidth || 0);
                }
                /** math: obliczenie współrzędnych figury */
                this.polygons.push(IccDrawMathService.getPolyShift(frameNode.parent.poly, shift));
            }
            /** math: przesunięcie względem bazowej figury */
            for (let i = 0; i < this.parent.poly.length; i++) {
                const frame = this.profiles[i] || this.profiles[0] || {};
                this.shiftRenoFrame[i] = -Number(frame.finWidth || 0);
            }
            /** math: obliczenie współrzędnych figury */
            this.rect = IccDrawMathService.getRectFromPoly(IccDrawMathService.getPolyShift(this.parent.poly, this.shiftRenoFrame));
        }
        /** math: obliczenie współrzędnych figury */
        Object.keys(this.shiftPortal).map((side) => {
            if (this.doorPortal) {
                let poly = IccDrawMathService.getPolyFromRect(this.rect);
                let line;
                if (this.root.side === 'inner') {
                    if (side === 'left') {
                        this.shiftPortal['left'] -= this.doorPortal.rightWidth || 0;
                    }
                    else if (side === 'right') {
                        this.shiftPortal['right'] -= this.doorPortal.leftWidth || 0;
                    }
                    else if (side === 'top') {
                        this.shiftPortal['top'] -= this.doorPortal.upperHeight || 0;
                    }
                }
                else {
                    if (side === 'left') {
                        this.shiftPortal['left'] -= this.doorPortal.rightWidth || 0;
                    }
                    else if (side === 'right') {
                        this.shiftPortal['right'] -= this.doorPortal.leftWidth || 0;
                    }
                    else if (side === 'top') {
                        this.shiftPortal['top'] -= this.doorPortal.upperHeight || 0;
                    }
                }
                this.poly = IccDrawMathService.getPolyShift(this.parent.poly, this.shiftPortal);
                this.rect = IccDrawMathService.getRectFromPoly(this.poly);
                switch (side) {
                    case 'left':
                        line = [poly[0], poly[1]];
                        break;
                    case 'right':
                        line = [poly[2], poly[3]];
                        break;
                    case 'top':
                        line = [poly[3], poly[0]];
                        break;
                    case 'bottom':
                        line = [poly[1], poly[2]];
                        break;
                }
                if (this.root.side === 'outer') {
                    poly = IccDrawMathService.intersectPolyWithLine(this.poly, line, side);
                }
                let rect = IccDrawMathService.getRectFromPoly(poly);
                const portal = this.doorPortal;
                this.portalDimensions.push({ portal, poly, rect, side });
            }
        });
        /** svg: rysowanie ścieżek */
        this.portalDimensions.map(dimension => {
            var _a, _b;
            const color = dimension.portal.selectedColor;
            this.svg.patterns.push(IccDrawSvgService.getPattern({
                id: `iccDraw-portal-${dimension.portal.id}-${this.uuid}`,
                color: color && color.color ? `#${color.color}` : '#bbb',
                image: color && color.color_img ? `/files/color/${color.color_img}` : null,
                height: this.rect.height,
                width: this.rect.width,
            }));
            if (this.root.side === 'outer') {
                this.svg.paths.push(IccDrawSvgService.getPath(dimension.poly, true, this.root.side, {
                    stroke: IccColorContrastService.getInvertedColor((_a = this === null || this === void 0 ? void 0 : this.color) === null || _a === void 0 ? void 0 : _a.color) || '#bbb',
                    fill: `url('${this.root.uri}#iccDraw-portal-${dimension.portal.id}-${this.uuid}')`,
                }));
            }
            else {
                this.svg.paths.push(IccDrawSvgService.getPath(dimension.poly, true, this.root.side, {
                    stroke: IccColorContrastService.getInvertedColor((_b = this === null || this === void 0 ? void 0 : this.color) === null || _b === void 0 ? void 0 : _b.color) || '#bbb',
                    strokeDasharray: '5,5',
                }));
            }
        });
    }
}

class IccDrawSyncService {
    static mapMuntins(sash) {
        if (sash.muntins && (sash.muntins.horizontal || sash.muntins.vertical)) {
            Object.keys(sash.muntins).map(direction => sash.muntins[direction].map(muntin => (muntin.direction = direction)));
            return [].concat(...sash.muntins.horizontal, ...sash.muntins.vertical);
        }
        else {
            return sash.muntins || [];
        }
    }
    static syncDetails(details, options, boundingRect, fitTo = 'width') {
        let baseNode;
        if (details.type === 'coupled_window') {
            baseNode = this.syncDetailsCoupledWindow(details, options, boundingRect, fitTo);
        }
        else {
            if (details.type === 'roller_shutter'
                || details.type === 'external_blind'
                || options.extendedRollerInWindow === 'full') {
                baseNode = this.syncDetailsShutter(details, options, boundingRect, fitTo);
            }
            else if (details.type === 'garage_door') {
                baseNode = this.syncDetailsGarageDoor(details, options, boundingRect, fitTo);
            }
            else {
                baseNode = this.syncDetailsWindow(details, options, boundingRect, fitTo);
            }
        }
        if (baseNode
            && baseNode.children
            && options.dimensions
            && options.dimensions.type !== 'extended') {
            const shapeNode = baseNode.children.find(o => o instanceof ShapeNode);
            const baseRect = Object.assign({}, options.dimensions.type === 'outer' || !shapeNode ? baseNode.rect : shapeNode.rect);
            const ratio = IccDrawSyncService.getRatio(baseNode, boundingRect, fitTo, options);
            /** wymiary poziome */
            const horizontalDimensionNode = new DimensionNode(baseNode, null, {
                details: details,
                baseRect: baseRect,
                shape: shapeNode,
                type: 'horizontal',
                ratio,
            }, Object.assign({}, options.dimensions, {
                extendedRollerInWindow: options.extendedRollerInWindow,
            }));
            /** wymiary pionowe */
            const verticalDimensionNode = new DimensionNode(baseNode, null, {
                details: details,
                baseRect: baseRect,
                shape: shapeNode,
                type: 'vertical',
                ratio,
            }, Object.assign({}, options.dimensions, {
                extendedRollerInWindow: options.extendedRollerInWindow,
            }));
        }
        return baseNode;
    }
    static getRatio(baseNode, boundingRect, fitTo, options) {
        const viewBox = baseNode.rect;
        let viewBoxWidth = viewBox.width;
        const viewBoxHeight = viewBox.height;
        if (baseNode.side === 'outer') {
            viewBoxWidth = viewBox.width - viewBox.x;
        }
        const viewportWidth = boundingRect.width || options.width || viewBoxWidth / 5;
        const viewportHeight = boundingRect.height || options.height || viewBoxHeight / 5;
        return fitTo === 'width'
            ? viewBoxWidth / viewportWidth
            : Math.max(viewBoxWidth / viewportWidth, viewBoxHeight / viewportHeight);
    }
    static syncDetailsShutter(details, options, boundingRect, fitTo = 'width', base = null, position = null) {
        if (!details
            || !details.rollerShutter
            || !details.rollerShutter.shutters
            || !details.rollerShutter.shutters.length) {
            return {};
        }
        /** konstrukcja */
        const baseNode = new BaseNode(base, null, {
            side: options.base.side,
            positionId: position && position.positionId,
            zIndex: position && position.zIndex,
            rotation: (position && position.rotation) || 0,
        }, options.base);
        baseNode.rect = {
            x: (position && Number(position.x)) || 0,
            y: (position ? Number(position.y) : -Number(details.rollerShutter.boxHeight)) || 0,
            width: Number(details.rollerShutter.boxWidth) || 0,
            height: Number(details.rollerShutter.boxHeight + details.rollerShutter.rollerHeight) || 0,
        };
        /** kolory rolety */
        const shutterColorsNode = new ShutterColorsNode(baseNode, null, {
            colors: details.rollerShutter.colors,
        }, options.shutterColors);
        let i = 0;
        for (const shutter of details.rollerShutter.shutters) {
            /** roleta */
            const shutterNode = new ShutterNode(baseNode, null, {
                index: i,
                shutter: shutter,
                boxHeight: details.rollerShutter.boxHeight,
            }, options.shutter);
            /** skrzynka rolety */
            const shutterBoxNode = new ShutterBoxNode(shutterNode, null, {
                height: details.rollerShutter.boxHeight,
            }, options.shutterBox);
            /** napęd rolety */
            const shutterDriveNode = new ShutterDriveNode(shutterNode, null, {
                nextShutter: details.rollerShutter.shutters.find(o => o.id > shutter.id),
                prevShutter: details.rollerShutter.shutters
                    .filter(o => o.id < shutter.id && !o.commonRail)
                    .pop(),
                shutter: shutter,
            }, options.shutterDrive);
            i++;
        }
        if (options.indexes) {
            const ratio = IccDrawSyncService.getRatio(baseNode, boundingRect, fitTo, options);
            const indexesNode = new IndexesNode(baseNode, null, {
                frames: details.frames,
                sashes: details.sashes,
                ratio,
                fitTo,
                boundingRect,
            }, options.indexes);
        }
        return baseNode;
    }
    static syncDetailsWindow(details, options, boundingRect, fitTo = 'width', base = null, position = null) {
        var _a, _b, _c, _d, _e;
        if (!details || !details.shape || !details.frames || !details.frames.length) {
            return null;
        }
        const OUTWARD_OPENING = ['OKL', 'OD', 'SWF', 'ODS', 'ODSH', 'DOA', 'DOP'];
        const usedProfiles = (details.dictionary && Object.values(details.dictionary.profiles))
            || details.usedProfiles
            || [];
        const outerSash = usedProfiles.some(el => el.type === 'sash' && el.options && el.options.includes('outward_opening'))
            || (details.sashes
                && details.sashes.some(sash => {
                    const sashType = details.dictionary
                        ? Object.assign({}, details.dictionary.sashTypes[sash.type.id], sash.type)
                        : sash.type;
                    return sashType && OUTWARD_OPENING.includes(sashType.type);
                }));
        if (!options.base.side && outerSash) {
            options.base.side = 'outer';
        }
        /** konstrukcja */
        const baseNode = new BaseNode(base, null, {
            side: options.base.side,
            showSymbolsForFullDoors: options.base.showSymbolsForFullDoors,
            showSymbolsForProfileDoors: options.base.showSymbolsForProfileDoors,
            showSymbolsForWindow: options.base.showSymbolsForWindow,
            strokeContrastRatio: options.base.strokeContrastRatio,
            positionId: position && position.positionId,
            zIndex: position && position.zIndex,
            rotation: (position && position.rotation) || 0,
            outerSash,
        }, options.base);
        baseNode.rect = {
            x: (position && Number(position.x)) || Number(details.x) || 0,
            y: (position && Number(position.y)) || Number(details.y) || 0,
            width: Number(details.width) || 0,
            height: Number(details.height) || 0,
        };
        /** kolory */
        const colorsNode = new ColorsNode(baseNode, null, {
            colors: details.colors,
            muntins: details.muntins,
            colorsDict: details.dictionary && details.dictionary.colors,
            accessoryColorsDict: details.dictionary && details.dictionary.accessoryColors,
        }, options.colors);
        /** kształt */
        const shapeNode = new ShapeNode(baseNode, null, {
            shape: details.shape,
        }, options.shape);
        const frameNodes = [];
        const sashNodes = [];
        const filledDoor = details.type === 'door'
            && details.dictionary
            && details.dictionary.systems
            && Boolean(details.dictionary.systems[details.system].doorType);
        const seperateFrameAndSashShortening = details.type === 'door'
            && details.dictionary
            && details.dictionary.systems
            && Boolean(details.dictionary.systems[details.system].seperateFrameAndSashShortening);
        const frameExtensionHeight = seperateFrameAndSashShortening
            ? ((details.doorSizes.shortening || 0) - (details.doorSizes.frameShortening || 0))
            : 0;
        for (const frame of details.frames) {
            const outerSashFrame = (details.sashes
                && details.sashes.filter(el => el.frameId === frame.id).some(sash => {
                    const sashType = details.dictionary
                        ? Object.assign({}, details.dictionary.sashTypes[sash.type.id], sash.type)
                        : sash.type;
                    return sashType && OUTWARD_OPENING.includes(sashType.type);
                }));
            /** kształt ramy */
            const frameShapeNode = new FrameShapeNode(shapeNode, null, {
                frame: frame,
            }, options.frameShape);
            /** rama */
            const frameNode = new FrameNode(frameShapeNode, null, {
                frame,
                sashes: details.sashes,
                lowThreshold: !!details.lowThreshold,
                profiles: frame.frame,
                usedProfiles,
                windowIndex: position && position.index,
                filledDoor,
                thresholdColor: details.thresholdColor
                    && details.dictionary
                    && details.dictionary.colors[details.thresholdColor.id + '+' + Number(details.thresholdColor.RAL)],
                shape: details.shape.shape,
                jointAngles: (details.dictionary
                    && details.dictionary.systems
                    && details.dictionary.systems[details.system].frameJointAngles)
                    || 'E_E_E_E',
                thresholdJointAngles: (details.dictionary
                    && details.dictionary.systems
                    && details.dictionary.systems[details.system].thresholdJointAngles)
                    || 'L_R',
                color: colorsNode.frame,
                outerSash: outerSashFrame,
                frameExtensionHeight
            }, options.frame);
            frameNodes.push(frameNode);
            /** otwory pod dyble */
            const dowelHolesNode = new DowelHolesNode(frameNode, null, {
                frame,
                accessories: details.sideAccessories,
                sashes: details.sashes,
            }, options.dowelHoles);
            if (details.sashes && details.sashes.length) {
                const sashesCopy = details.sashes.concat();
                if (details.alignments && details.alignments.length) {
                    for (const alignment of details.alignments.filter(el => el.frameId === frame.id)) {
                        /** wyrównanie w ramie */
                        const alignmentNode = new AlignmentNode(frameNode, null, {
                            alignment: alignment,
                            alignments: details.alignments,
                            mullions: details.mullions,
                            usedProfiles,
                            frameColor: colorsNode.frame,
                            sashColor: colorsNode.sash
                        }, options.alignments);
                    }
                }
                /** kolejność rysowania kwater */
                if (details.layout && details.layout.sashes && details.layout.sashes.length) {
                    details.layout.sashes.map(sash => {
                        if (sashesCopy.find(o => o.id === sash.id)) {
                            sashesCopy.find(o => o.id === sash.id).level = sash.level;
                        }
                    });
                    const passiveOrder = ['D', 'DK', 'DRA', 'DS', 'DSH', 'DRP', 'ODS', 'ODSH', 'DOP', 'DOA', 'OD', 'OKL'];
                    if (sashesCopy.every((sash, i, arr) => sash.level === arr[0].level)) {
                        sashesCopy.forEach(sash => {
                            const sashType = details.dictionary
                                ? Object.assign({}, details.dictionary.sashTypes[sash.type.id], sash.type)
                                : sash.type;
                            if (sashType && passiveOrder.includes(sashType.type)) {
                                sash.level = passiveOrder.indexOf(sashType.type) + 1;
                            }
                        });
                    }
                    sashesCopy.sort((a, b) => (a.level > b.level ? 1 : -1));
                }
                for (const sash of sashesCopy.filter(el => el.frameId === frame.id)) {
                    /** kwatera w ramie */
                    const sashNode = new SashNode(frameNode, null, {
                        alignments: details.alignments,
                        mullions: details.mullions,
                        sash: sash,
                        usedProfiles,
                    }, options.sash);
                    if (sash.intSashes && sash.intSashes.length) {
                        /** skrzydło */
                        const sashFrameNode = new SashFrameNode(sashNode, null, {
                            frame: frame.frame,
                            level: sash.level,
                            lowThreshold: !!details.lowThreshold,
                            mullions: details.mullions,
                            profiles: sash.frame,
                            sash: sash,
                            usedProfiles,
                            filledDoor,
                            shape: details.shape.shape,
                            jointAngles: (details.dictionary
                                && details.dictionary.systems
                                && details.dictionary.systems[details.system]
                                    .sashJointAngles)
                                || 'E_E_E_E',
                            availableThresholdSashRebate: (details.dictionary
                                && details.dictionary.systems
                                && details.dictionary.systems[details.system]
                                    .availableThresholdSashRebate)
                                || false,
                            color: colorsNode.frame,
                        }, options.sashFrame);
                        if (sash.hardware && sash.hardware.length && options.base.ventilator) {
                            sash.hardware
                                .filter(o => o.type === 'ventilator' || o.type === 'ventilator_hole')
                                .map(ventilator => {
                                /** nawiewnik w skrzydle */
                                const ventilatorNode = new VentilatorNode(sashFrameNode, null, {
                                    sash: sash,
                                    ventilator: ventilator,
                                });
                            });
                        }
                        if (sash.intAlignments && sash.intAlignments.length) {
                            for (const alignment of sash.intAlignments) {
                                /** wyrównanie w skrzydle */
                                const intAlignmentNode = new AlignmentNode(sashFrameNode, null, {
                                    alignment: alignment,
                                    alignments: sash.intAlignments,
                                    mullions: sash.intMullions,
                                    sash: sash,
                                    usedProfiles,
                                    frameColor: colorsNode.frame,
                                    sashColor: colorsNode.sash
                                }, options.alignments);
                            }
                        }
                        const intSashNodes = [];
                        for (const intSash of sash.intSashes) {
                            /** kwatera w skrzydle */
                            const intSashNode = new SashNode(sashFrameNode, null, {
                                alignments: sash.intAlignments,
                                mullions: sash.intMullions,
                                sash: intSash,
                                usedProfiles,
                            }, options.sash);
                            /** pakiet szybowy */
                            const glazingNode = new GlazingNode(intSashNode, null, {
                                glazing: Object.assign({}, details.dictionary
                                    && details.dictionary.fillings[intSash.filling.id], intSash.filling),
                                innerPanel: sash.panelInner
                                    && Object.assign({}, details.dictionary
                                        && details.dictionary.fillings[sash.panelInner.id], sash.panelInner),
                                panelGlazing: sash.panelGlazing
                                    && Object.assign({}, details.dictionary
                                        && details.dictionary.fillings[sash.panelGlazing.id], sash.panelGlazing),
                                mullions: sash.intMullions,
                                renson: sash.hardware && intSash.y === 0
                                    ? sash.hardware.find(o => o.type === 'renson')
                                    : null,
                                sash: intSash,
                                usedProfiles,
                                filledDoor,
                                colorsDict: details.dictionary && details.dictionary.colors,
                            }, options.glazing);
                            this.mapMuntins(intSash).map(muntin => {
                                const muntinNode = new MuntinNode(intSashNode, null, {
                                    muntins: details.muntins,
                                    muntin: muntin,
                                    sash: intSash,
                                    system: details.system,
                                }, options.muntins);
                            });
                            /** szprosy */
                            if ((_a = options === null || options === void 0 ? void 0 : options.muntinShadow) === null || _a === void 0 ? void 0 : _a.drawShadow) {
                                this.mapMuntins(intSash).map(muntin => {
                                    var _a, _b, _c, _d, _e, _f;
                                    const muntinNodeShadow = new MuntinShadowNode(intSashNode, null, {
                                        muntins: details.muntins,
                                        muntin: muntin,
                                        sash: intSash,
                                        system: details.system,
                                        glazingColor: details.dictionary.fillings[(_a = sash === null || sash === void 0 ? void 0 : sash.filling) === null || _a === void 0 ? void 0 : _a.id].color || IccColorContrastService.getAvgColor(((_b = options === null || options === void 0 ? void 0 : options.colors) === null || _b === void 0 ? void 0 : _b.glassGradient) ? (_d = (_c = options === null || options === void 0 ? void 0 : options.colors) === null || _c === void 0 ? void 0 : _c.glassGradient) === null || _d === void 0 ? void 0 : _d.steps.map(i => i.color) : [(_e = options === null || options === void 0 ? void 0 : options.colors) === null || _e === void 0 ? void 0 : _e.glassStartColor, (_f = options === null || options === void 0 ? void 0 : options.colors) === null || _f === void 0 ? void 0 : _f.glassStopColor])
                                    }, options.muntinShadow);
                                });
                            }
                            /** listwa przyszybowa */
                            const glazingBeadNode = new GlazingBeadNode(intSashNode, null, {
                                level: sash.level,
                                profiles: intSash.glazingBead,
                                sash: intSash,
                                usedProfiles,
                                filledDoor,
                                shape: details.shape.shape,
                                jointAngles: (details.dictionary
                                    && details.dictionary
                                        .systems
                                    && details.dictionary
                                        .systems[details.system]
                                        .glazingBeadJointAngles)
                                    || 'E_E_E_E',
                                frameColor: colorsNode.frame,
                                sashColor: colorsNode.sash,
                            }, options.glazingBead);
                            if (sash.hardware && sash.hardware.length && intSash.y === 0) {
                                sash.hardware
                                    .filter(o => o.type === 'renson')
                                    .map(renson => {
                                    /** nawiewnik w szybie */
                                    const rensonNode = new RensonNode(glazingBeadNode || glazingNode, null, {
                                        renson: renson,
                                        sash: intSash,
                                    }, options.renson);
                                });
                            }
                            intSashNodes.push(intSashNode);
                        }
                        if (sash.intMullions && sash.intMullions.length) {
                            for (const intMullion of sash.intMullions) {
                                /** słupek w skrzydle */
                                const intMullionNode = new MullionNode(sashFrameNode, null, {
                                    mullion: intMullion,
                                    mullions: sash.intMullions,
                                    sash: sash,
                                    sashes: sash.intSashes,
                                    sashNodes: intSashNodes,
                                    usedProfiles,
                                    frameColor: colorsNode.frame,
                                    sashColor: colorsNode.sash
                                }, options.mullion);
                            }
                        }
                        if ((filledDoor && options.base.showSymbolsForFullDoors) || (!filledDoor && options.base.showSymbolsForProfileDoors && details.type !== 'window') || (options.base.showSymbolsForWindow && details.type === 'window')) {
                            /** symbol otwierania */
                            const symbolNode = new SymbolNode(sashFrameNode, null, {
                                shift: 20,
                                type: details.dictionary
                                    ? Object.assign({}, details.dictionary.sashTypes[sash.type.id], sash.type)
                                    : sash.type,
                                filling: details.dictionary
                                    ? details.dictionary.fillings[(_b = sash === null || sash === void 0 ? void 0 : sash.filling) === null || _b === void 0 ? void 0 : _b.id]
                                    : null
                            }, options.symbol);
                        }
                        /** klamka w skrzydle */
                        const handleNode = new HandleNode(sashFrameNode, null, {
                            sash: sash,
                            sashes: sashesCopy,
                            sashTypes: details.dictionary && details.dictionary.sashTypes,
                            handlesDict: details.dictionary && details.dictionary.handles,
                            doorHardwareDict: details.dictionary && details.dictionary.doorHardware,
                            doorHardware: details.doorHardware,
                            hingesDict: details.dictionary && details.dictionary.hinges,
                            hinge: details.hinge,
                            decorativeHingeCoversDict: details.dictionary && details.dictionary.decorativeHingeCovers,
                            decorativeHingeCover: details.decorativeHingeCover,
                            isDoor: details.type === 'door',
                            filledDoor,
                            filling: Object.assign({}, details.dictionary
                                && details.dictionary.fillings[sash.filling.id], sash.filling),
                            sashHardware: sash.hardware,
                        }, options.handle);
                    }
                    else {
                        /** pakiet szybowy */
                        const glazingNode = new GlazingNode(sashNode, null, {
                            glazing: Object.assign({}, details.dictionary
                                && details.dictionary.fillings[sash.filling.id], sash.filling),
                            innerPanel: sash.panelInner
                                && Object.assign({}, details.dictionary
                                    && details.dictionary.fillings[sash.panelInner.id], sash.panelInner),
                            mullions: details.mullions,
                            renson: sash.hardware
                                ? sash.hardware.find(o => o.type === 'renson')
                                : null,
                            sash: sash,
                            usedProfiles,
                            filledDoor,
                            colorsDict: details.dictionary && details.dictionary.colors,
                        }, options.glazing);
                        /** listwa przyszybowa */
                        const glazingBeadNode = new GlazingBeadNode(sashNode, null, {
                            profiles: sash.glazingBead,
                            sash: sash,
                            usedProfiles,
                            filledDoor,
                            shape: details.shape.shape,
                            jointAngles: (details.dictionary
                                && details.dictionary.systems
                                && details.dictionary.systems[details.system].glazingBeadJointAngles)
                                || 'E_E_E_E',
                            frameColor: colorsNode.frame,
                            sashColor: colorsNode.sash,
                        }, options.glazingBead);
                        this.mapMuntins(sash).map(muntin => {
                            const muntinNode = new MuntinNode(sashNode, null, {
                                muntins: details.muntins,
                                muntin: muntin,
                                sash: sash,
                                system: details.system,
                            }, options.muntins);
                        });
                        /** szprosy */
                        if ((_c = options === null || options === void 0 ? void 0 : options.muntinShadow) === null || _c === void 0 ? void 0 : _c.drawShadow) {
                            this.mapMuntins(sash).map(muntin => {
                                var _a, _b, _c, _d, _e, _f;
                                const muntinNodeShadow = new MuntinShadowNode(sashNode, null, {
                                    muntins: details.muntins,
                                    muntin: muntin,
                                    sash: sash,
                                    system: details.system,
                                    glazingColor: details.dictionary.fillings[(_a = sash === null || sash === void 0 ? void 0 : sash.filling) === null || _a === void 0 ? void 0 : _a.id].color || IccColorContrastService.getAvgColor(((_b = options === null || options === void 0 ? void 0 : options.colors) === null || _b === void 0 ? void 0 : _b.glassGradient) ? (_d = (_c = options === null || options === void 0 ? void 0 : options.colors) === null || _c === void 0 ? void 0 : _c.glassGradient) === null || _d === void 0 ? void 0 : _d.steps.map(i => i.color) : [(_e = options === null || options === void 0 ? void 0 : options.colors) === null || _e === void 0 ? void 0 : _e.glassStartColor, (_f = options === null || options === void 0 ? void 0 : options.colors) === null || _f === void 0 ? void 0 : _f.glassStopColor])
                                }, options.muntinShadow);
                            });
                        }
                        if (sash.hardware && sash.hardware.length) {
                            sash.hardware
                                .filter(o => o.type === 'renson')
                                .map(renson => {
                                /** nawiewnik w szybie */
                                const rensonNode = new RensonNode(glazingBeadNode || glazingNode, null, {
                                    renson: renson,
                                    sash: sash,
                                }, options.renson);
                            });
                        }
                        if (options.base.showSymbolsForWindow) {
                            /** symbol otwierania */
                            const symbolNode = new SymbolNode(glazingNode, null, {
                                type: details.dictionary
                                    ? Object.assign({}, details.dictionary.sashTypes[sash.type.id], sash.type)
                                    : sash.type,
                                filling: details.dictionary.fillings[(_d = sash === null || sash === void 0 ? void 0 : sash.filling) === null || _d === void 0 ? void 0 : _d.id]
                            }, options.symbol);
                        }
                    }
                    sashNodes.push(sashNode);
                }
                if (details.mullions && details.mullions.length) {
                    for (const mullion of details.mullions.filter(el => el.frameId === frame.id)) {
                        /** słupek w ramie */
                        const mullionNode = new MullionNode(frameNode, null, {
                            mullion: mullion,
                            mullions: details.mullions,
                            sash: null,
                            sashes: sashesCopy,
                            sashNodes,
                            usedProfiles,
                            frameColor: colorsNode.frame,
                            sashColor: colorsNode.sash
                        }, options.mullion);
                    }
                }
            }
        }
        if (details.couplings && details.couplings.length) {
            for (const coupling of details.couplings) {
                /** słupek w ramie */
                const couplingNode = new CouplingNode(shapeNode, null, {
                    coupling: coupling,
                    couplings: details.couplings,
                    frames: details.frames,
                    mullions: details.mullions,
                    sashes: details.sashes,
                    sashNodes,
                    usedProfiles,
                    color: colorsNode.frame,
                }, options.coupling);
            }
        }
        if (details.rollerShutter
            || details.sideProfiles
            || details.sideAccessories
            || details.couplings
            || details.lowThreshold) {
            /** roleta */
            const rollerShutterNode = new RollerShutterNode(shapeNode, null, {
                rollerShutter: details.rollerShutter,
            }, options.rollerShutter);
            Object.assign(baseNode.rect, rollerShutterNode.rect);
            baseNode.poly = rollerShutterNode.poly;
            /** poszerzenia */
            const extensionsNode = new ExtensionsNode(rollerShutterNode, null, {
                sideProfiles: details.sideProfiles,
                usedProfiles,
                frames: details.frames,
                frameNodes,
                color: colorsNode.frame,
            }, options.extensions);
            const oldRect = Object.assign({}, baseNode.rect);
            Object.assign(baseNode.rect, extensionsNode.rect);
            baseNode.poly = extensionsNode.poly;
            /** parapety */
            const sillsNode = new SideAccessoriesNode(extensionsNode, null, {
                accessories: details.sideAccessories,
                color: colorsNode.frame,
            }, options.sills);
            Object.assign(baseNode.rect, sillsNode.rect);
            baseNode.poly = sillsNode.poly;
            /** rama renowacyjna */
            const renoNode = new RenoNode(sillsNode, null, {
                lowThreshold: !!details.lowThreshold,
                frames: details.frames,
                usedProfiles,
                frameNodes,
                portal: details.doorPortal
            }, options.reno);
            Object.assign(baseNode.rect, renoNode.rect);
            baseNode.poly = renoNode.poly;
        }
        if (details.doorPortal && ((_e = details.doorPortal) === null || _e === void 0 ? void 0 : _e.id)) {
            const portalNode = new PortalNode(baseNode, null, {
                frame: details.frames,
                usedProfiles,
                doorPortal: details.doorPortal,
                frameNodes,
            }, options.doorPortal);
            Object.assign(baseNode.rect, portalNode.rect);
            baseNode.poly = portalNode.poly;
        }
        if (options.indexes) {
            const ratio = IccDrawSyncService.getRatio(baseNode, boundingRect, fitTo, options);
            const indexesNode = new IndexesNode(baseNode, null, {
                frames: details.frames,
                sashes: details.sashes,
                ratio,
                fitTo,
                boundingRect,
            }, options.indexes);
        }
        baseNode.setParentPoly();
        return baseNode;
    }
    static syncDetailsCoupledWindow(details, options, boundingRect, fitTo = 'width') {
        if (!details.windows || details.windows.length === 0) {
            return null;
        }
        /** konstrukcja */
        const windowBaseNode = new BaseNode(null, null, {
            side: options.base.side,
        }, options.base);
        windowBaseNode.rect = {
            x: Number(details.x) || 0,
            y: Number(details.y) || 0,
            width: Number(details.width) || 0,
            height: Number(details.height) || 0,
        };
        for (const window of details.windows) {
            this.syncDetailsWindow(window.details, options, boundingRect, fitTo, windowBaseNode, {
                x: window.x,
                y: window.y,
                positionId: window.positionId,
                zIndex: window.zIndex,
                rotation: window.rotation,
                index: window.index,
            });
        }
        for (const rollerShutter of details.rollerShutters) {
            this.syncDetailsShutter(rollerShutter.details, options, boundingRect, fitTo, windowBaseNode, {
                x: rollerShutter.x,
                y: rollerShutter.y,
                positionId: rollerShutter.positionId,
                zIndex: rollerShutter.zIndex,
                rotation: rollerShutter.rotation,
            });
        }
        if (details.sideProfiles && details.sideProfiles.length) {
            for (const sideProfile of details.sideProfiles) {
                /** słupek w ramie */
                const couplingNode = new CoupledExtensionNode(windowBaseNode, null, {
                    extension: sideProfile,
                    extensions: details.sideProfiles,
                    windows: details.windows,
                }, options.extension);
            }
        }
        if (details.couplings && details.couplings.length) {
            for (const coupling of details.couplings) {
                /** słupek w ramie */
                const couplingNode = new CoupledCouplingNode(windowBaseNode, null, {
                    coupling: coupling,
                    couplings: details.couplings,
                    windows: details.windows,
                }, options.coupling);
            }
        }
        if (details.windowSills && details.windowSills.length) {
            for (const sill of details.windowSills) {
                if (sill.framesId.some(f => f.side === options.base.side)) {
                    /** słupek w ramie */
                    const sillNode = new SillNode(windowBaseNode, null, {
                        sill: sill,
                        windows: details.windows,
                    }, options.sill);
                }
            }
        }
        return windowBaseNode;
    }
    static syncDetailsGarageDoor(details, options, boundingRect, fitTo = 'width', base = null, position = null) {
        if (!details
            || !details.dimensions
            || !details.dimensions.width
            || !details.dimensions.height) {
            return {};
        }
        details.width = details.dimensions.width + 300;
        details.height = details.dimensions.height + details.dimensions.lintelHeight;
        /** konstrukcja */
        const baseNode = new BaseNode(base, null, {
            side: options.base.side,
            positionId: position && position.positionId,
            zIndex: position && position.zIndex,
            rotation: (position && position.rotation) || 0,
        }, options.base);
        baseNode.rect = {
            x: (position && Number(position.x)) || 0,
            y: (position && Number(position.y)) || 0,
            width: Number(details.dimensions.width) + 300 || 0,
            height: Number(details.dimensions.height) + details.dimensions.lintelHeight || 0,
        };
        const shape = {
            shape: 'rect',
            width: details.dimensions.width,
            height: details.dimensions.height,
            s1: 150,
            s2: details.dimensions.width,
            s3: 150,
            h1: details.dimensions.height + details.dimensions.lintelHeight,
            h2: details.dimensions.height,
            h3: 0,
        };
        /** kształt */
        const shapeNode = new ShapeNode(baseNode, null, {
            shape
        }, options.shape);
        const wallNode = new WallNode(baseNode, null, {
            dimensions: details.dimensions,
        }, options.wall);
        /** panele */
        const panelsNode = new PanelsNode(wallNode, null, {
            dimensions: details.dimensions,
        }, options.panels);
        if (details.panelsData && details.panelsData.panels) {
            for (const panel of details.panelsData.panels) {
                /** panel */
                const panelNode = new PanelNode(panelsNode, null, {
                    index: panel.index,
                    dimensions: { width: details.dimensions.width, height: panel.panelHeight.height },
                    colors: {
                        inner: details.panelInternalColor.color,
                        outer: details.panelColor.color,
                        innerImage: details.panelInternalColor.color_img,
                        outerImage: details.panelColor.color_img
                    },
                    insertsSpacing: panel.insertsSpacing || 250,
                    insertsOffset: panel.insertsOffset || 250
                }, options.panel);
                /** struktura powierzchni */
                const panelPatternNode = new PanelPatternNode(panelNode, null, {
                    index: panel.index,
                    panelStructures: {
                        outerImage: panel.index === 1 && details.plinthPanelStructure
                            ? details.plinthPanelStructure.img
                            : details.panelStructure && details.panelStructure.img,
                        innerImage: panel.index === 1 && details.plinthPanelStructure
                            ? details.plinthPanelStructure.img
                            : details.panelStructure && details.panelStructure.img,
                    }
                });
                /** przetłoczenia */
                if (details.panel) {
                    const embossingSpacing = (baseNode.side === 'outer'
                        ? (panel.index === 1 && details.plinthPanel
                            ? details.plinthPanel.embossing_spacing
                            : details.panel.embossing_spacing)
                        : details.panelInternal.embossing_spacing) || 0;
                    const embossingHeight = (panel.index === 1 && details.plinthPanel
                        ? details.plinthPanel.embossing_height
                        : details.panel.embossing_height) || 5;
                    if (embossingSpacing > 0) {
                        const embossingsAmount = Math.floor(panel.panelHeight.height / embossingSpacing);
                        const embossingRealSpacing = panel.panelHeight.height / embossingsAmount - embossingHeight;
                        for (let j = 0; j < (embossingsAmount - 1); j++) {
                            const embossingNode = new EmbossingNode(panelNode, null, {
                                index: j,
                                embossingSpacing: embossingRealSpacing,
                                embossingHeight
                            });
                        }
                    }
                }
                if (details.wicketDoor) {
                    const wicketDoorFrameWidth = details.wicketDoor.frame_profiles_width || 75;
                    const wicketDoorThresholdHeight = details.wicketDoor.threshold_height || 0;
                    const wicketDoorHandleSide = details.wicketDoorDirection || 'right';
                    const wicketDoorDimensions = {
                        x: details.wicketDoor.x,
                        y: details.dimensions.height - details.wicketDoor.height - wicketDoorThresholdHeight,
                        width: details.wicketDoor.width,
                        height: details.wicketDoor.height
                    };
                    const wicketDoorNode = new WicketDoorNode(panelsNode, null, {
                        dimensions: wicketDoorDimensions
                    });
                    let wicketDoorFrames = [];
                    wicketDoorFrames.push({
                        x: wicketDoorDimensions.x,
                        y: wicketDoorDimensions.y,
                        width: wicketDoorFrameWidth,
                        height: wicketDoorDimensions.height,
                        side: 'left'
                    });
                    wicketDoorFrames.push({
                        x: wicketDoorDimensions.x,
                        y: wicketDoorDimensions.y,
                        width: wicketDoorDimensions.width,
                        height: wicketDoorFrameWidth,
                        side: 'top'
                    });
                    wicketDoorFrames.push({
                        x: wicketDoorDimensions.x + wicketDoorDimensions.width - wicketDoorFrameWidth,
                        y: wicketDoorDimensions.y,
                        width: wicketDoorFrameWidth,
                        height: wicketDoorDimensions.height,
                        side: 'right'
                    });
                    wicketDoorFrames.push({
                        x: wicketDoorDimensions.x,
                        y: wicketDoorDimensions.y + wicketDoorDimensions.height - wicketDoorFrameWidth,
                        width: wicketDoorDimensions.width,
                        height: wicketDoorFrameWidth,
                        side: 'bottom'
                    });
                    let i = 1;
                    for (const frame of wicketDoorFrames) {
                        /** rama */
                        const wicketDoorFrameNode = new WicketDoorFrameNode(wicketDoorNode, null, {
                            index: i,
                            frame,
                            frameColor: details.wicketDoorFrameProfilesColor && details.wicketDoorFrameProfilesColor.color,
                            frameColorImg: details.wicketDoorFrameProfilesColor && details.wicketDoorFrameProfilesColor.color_img
                        });
                        i++;
                    }
                    const wicketDoorHandleNode = new WicketDoorHandleNode(wicketDoorNode, null, {
                        frameWidth: wicketDoorFrameWidth,
                        side: wicketDoorHandleSide,
                        handleColor: details.wicketDoorHandleColor && details.wicketDoorHandleColor.color,
                        handleColorImg: details.wicketDoorHandleColor && details.wicketDoorHandleColor.color_img
                    });
                }
                /** Wypełnienia do paneli (okna, kratki wentylacyjne, szklenia) */
                if (panel.panelInserts && panel.panelInsertsType && panel.panelInserts.length > 0) {
                    if (panel.panelInsertsType === 'glazing') {
                        const GLAZING_FRAME_WIDTH = 35;
                        for (let i = 0; i < panel.panelInserts.length; i++) {
                            const insert = panel.panelInserts[i];
                            const panelInsertContainerNode = new PanelInsertContainerNode(panelNode, null, {
                                index: insert.index,
                                dimensions: {
                                    width: Number(insert.width),
                                    height: Number(insert.height),
                                    x: insert.x,
                                    diameter: Number(insert.diameter)
                                },
                                shape: insert.shape,
                                type: panel.panelInsertsType
                            });
                            // imposts
                            for (let k = 0; k < insert.imposts.length; k++) {
                                const panelInsertImpostNode = new PanelInsertImpostNode(panelInsertContainerNode, null, {
                                    width: insert.imposts.width,
                                    color: {
                                        inner: insert.innerColor,
                                        outer: insert.outerColor
                                    },
                                    x: insert.imposts[k].x
                                });
                            }
                            // glazing
                            const panelInsertFrameNode = new PanelInsertFrameNode(panelInsertContainerNode, null, {
                                frameWidth: GLAZING_FRAME_WIDTH,
                                frameColor: {
                                    inner: insert.innerColor,
                                    outer: insert.outerColor
                                }
                            });
                            const panelInsertFramePatternNode = new PanelInsertFramePatternNode(panelInsertFrameNode, null, {
                                framePattern: {
                                    outerImage: panel.index === 1 && details.plinthPanelStructure
                                        ? details.plinthPanelStructure.img
                                        : details.panelStructure && details.panelStructure.img,
                                    innerImage: panel.index === 1 && details.plinthPanelStructure
                                        ? details.plinthPanelStructure.img
                                        : details.panelStructure && details.panelStructure.img,
                                }
                            });
                            const panelInsertNode = new PanelInsertNode(panelInsertFrameNode, null, {
                                insertType: panel.panelInsertsType,
                                images: {
                                    inner: insert.glazing && insert.glazing.img,
                                    outer: insert.glazing && insert.glazing.img
                                }
                            });
                        }
                    }
                    else {
                        for (const insert of panel.panelInserts) {
                            const panelInsertContainerNode = new PanelInsertContainerNode(panelNode, null, {
                                index: insert.index,
                                dimensions: {
                                    width: Number(insert.width),
                                    height: Number(insert.height),
                                    x: Number(insert.x),
                                    diameter: Number(insert.diameter)
                                },
                                shape: insert.shape,
                                type: panel.panelInsertsType
                            }, options.insert);
                            const panelInsertFrameNode = new PanelInsertFrameNode(panelInsertContainerNode, null, {
                                frameWidth: insert.frameWidth || 0,
                                frameColor: {
                                    inner: insert.innerColor,
                                    outer: insert.outerColor
                                }
                            });
                            const panelInsertNode = new PanelInsertNode(panelInsertFrameNode, null, {
                                insertType: panel.panelInsertsType,
                                colors: {
                                    inner: insert.innerColor,
                                    outer: insert.outerColor
                                },
                                images: {
                                    inner: insert.glazing && insert.glazing.img,
                                    outer: insert.glazing && insert.glazing.img
                                }
                            });
                        }
                    }
                }
            }
            if (options.indexes) {
                const ratio = IccDrawSyncService.getRatio(baseNode, boundingRect, fitTo, options);
                const indexesNode = new IndexesNode(baseNode, null, {
                    panels: details.panelsData.panels,
                    ratio,
                    fitTo,
                    boundingRect,
                }, options.indexes);
            }
        }
        return baseNode;
    }
}

let IccDrawComponent = class IccDrawComponent {
    constructor() {
        this.details = {};
        this.options = {};
        this.fitTo = 'width';
        this.interfaceClicked = new EventEmitter();
        this.redrawn = new EventEmitter();
        this.drawDetails = {};
        this.drawOptions = {};
        this.node = {};
        this.timestamp = 0;
        this.viewBox = '0 0 0 0';
        this.show = false;
    }
    style() { }
    ngAfterViewInit() {
        setTimeout(() => {
            this.style = () => this.dimensionsComponent.margins;
            this.redrawn.emit();
        }, 0);
    }
    ngDoCheck() {
        if (this.details && this.details.timestamp !== this.timestamp) {
            this.timestamp = this.details.timestamp;
            this.drawDetails = new IccDrawDetails(this.details);
            this.drawOptions = new IccDrawOptions(this.options);
            IccColorContrastService.contrastRatio = this.drawOptions.colors.strokeContrastRatio > 0 ? this.drawOptions.colors.strokeContrastRatio : 30;
            if (this.interfaceComponent) {
                this.interfaceComponent.move.inputs.ratio = this.drawOptions.dimensions.ratio || 1;
            }
            let boundingRect = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            if (this.svgElement && this.svgElement.nativeElement && this.svgElement.nativeElement.getBoundingClientRect) {
                boundingRect = this.svgElement.nativeElement.getBoundingClientRect();
            }
            this.node = IccDrawSyncService.syncDetails(this.drawDetails, this.drawOptions, boundingRect, this.fitTo);
            if (this.node && this.node.children) {
                // const viewBox = IccDrawService.getViewBox(this.node, this.drawOptions.side);
                const viewBox = this.node.rect;
                if (this.node.side !== 'outer') {
                    this.viewBox = `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`;
                }
                else {
                    this.viewBox = `${-viewBox.width - viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`;
                }
            }
            this.redrawn.emit();
        }
    }
};
IccDrawComponent.ɵfac = function IccDrawComponent_Factory(t) { return new (t || IccDrawComponent)(); };
IccDrawComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IccDrawComponent, selectors: [["icc-draw"]], viewQuery: function IccDrawComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(IccDrawDimensionsComponent, true);
        ɵngcc0.ɵɵstaticViewQuery(IccDrawInterfaceComponent, true);
        ɵngcc0.ɵɵstaticViewQuery(_c2, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dimensionsComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.interfaceComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.svgElement = _t.first);
    } }, inputs: { details: "details", options: "options", fitTo: "fitTo" }, outputs: { interfaceClicked: "interfaceClicked", redrawn: "redrawn" }, decls: 6, vars: 10, consts: [[1, "icc-draw", 3, "ngStyle"], ["preserveAspectRatio", "xMidYMid meet", "width", "100%", "height", "100%", 1, "icc-draw-svg"], ["svg", ""], ["icc-draw-svg", "", 3, "node"], [3, "details", "node", "options"], [3, "node", "options", "interfaceClickHandler", "svg"]], template: function IccDrawComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1, 2);
        ɵngcc0.ɵɵelement(3, "svg", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelement(4, "icc-draw-dimensions", 4);
        ɵngcc0.ɵɵelement(5, "icc-draw-interface", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.style());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("viewBox", ctx.viewBox);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("node", ctx.node);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("details", ctx.drawDetails)("node", ctx.node)("options", ctx.drawOptions.dimensions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("node", ctx.node)("options", ctx.drawOptions.interface)("interfaceClickHandler", ctx.drawOptions.onInterfaceClick)("svg", _r0);
    } }, directives: function () { return [ɵngcc1.NgStyle, IccDrawSvgComponent, IccDrawDimensionsComponent, IccDrawInterfaceComponent]; }, styles: ["[_nghost-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box;margin:0;padding:0}.icc-draw[_ngcontent-%COMP%]{clear:both;position:relative;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.icc-draw-svg[_ngcontent-%COMP%]{display:block}.icc-draw-indexes[_ngcontent-%COMP%]{position:absolute}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawComponent.prototype, "details", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawComponent.prototype, "options", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], IccDrawComponent.prototype, "fitTo", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], IccDrawComponent.prototype, "interfaceClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], IccDrawComponent.prototype, "redrawn", void 0);
__decorate([
    ViewChild(IccDrawDimensionsComponent, { static: true }),
    __metadata("design:type", IccDrawDimensionsComponent)
], IccDrawComponent.prototype, "dimensionsComponent", void 0);
__decorate([
    ViewChild(IccDrawInterfaceComponent, { static: true }),
    __metadata("design:type", IccDrawInterfaceComponent)
], IccDrawComponent.prototype, "interfaceComponent", void 0);
__decorate([
    ViewChild('svg', { static: true }),
    __metadata("design:type", ElementRef)
], IccDrawComponent.prototype, "svgElement", void 0);
IccDrawComponent = __decorate([ __metadata("design:paramtypes", [])
], IccDrawComponent);

let IccDrawSvgComponent = class IccDrawSvgComponent {
    constructor() {
        this.node = {};
    }
    ngDoCheck() {
        this.nodes = [];
        this.getNodes();
        this.sortNodes();
    }
    getNodes(node = this.node) {
        if (node && node.svg) {
            this.nodes.push(node);
        }
        if (node && node.children && node.children.length) {
            node.children.map(child => this.getNodes(child));
        }
    }
    sortNodes() {
        this.nodes.sort((a, b) => a.zIndex - b.zIndex
            || this.sortByPositionId(a, b)
            || a.layer - b.layer
            || a.level - b.level
            || -1);
    }
    sortByPositionId(a, b) {
        if (a.positionId === b.positionId) {
            return 0;
        }
        else if (a.positionId > b.positionId) {
            return 1;
        }
        else {
            return -1;
        }
    }
};
IccDrawSvgComponent.ɵfac = function IccDrawSvgComponent_Factory(t) { return new (t || IccDrawSvgComponent)(); };
IccDrawSvgComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IccDrawSvgComponent, selectors: [["svg", "icc-draw-svg", ""]], inputs: { node: "node" }, attrs: _c3, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngClass", "click", 4, "ngIf"], ["preserveAspectRatio", "none", 4, "ngIf"], ["attr.pointer-events", "none", 4, "ngFor", "ngForOf"], ["preserveAspectRatio", "none"], ["attr.pointer-events", "none"], [3, "ngClass", "click"], [3, "click", 4, "ngFor", "ngForOf"], ["font-family", "sans-serif", 4, "ngFor", "ngForOf"], [3, "click"], ["font-family", "sans-serif"]], template: function IccDrawSvgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, IccDrawSvgComponent__svg_g_0_Template, 3, 3, "g", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.nodes);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{overflow:visible}g.group-hover[_ngcontent-%COMP%]:hover > path[_ngcontent-%COMP%], g.single-hover[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]:hover{cursor:pointer;fill:#eee}"], changeDetection: 0 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], IccDrawSvgComponent.prototype, "node", void 0);
IccDrawSvgComponent = __decorate([ __metadata("design:paramtypes", [])
], IccDrawSvgComponent);

let IccDrawModule = class IccDrawModule {
};
IccDrawModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: IccDrawModule });
IccDrawModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function IccDrawModule_Factory(t) { return new (t || IccDrawModule)(); }, imports: [[
            CommonModule,
            FormsModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IccDrawDimensionsComponent, [{
        type: Component,
        args: [{
                selector: 'icc-draw-dimensions',
                template: "<div class=\"icc-draw-dimensions\">\r\n    <div *ngFor=\"let element of elements\"\r\n        [ngClass]=\"element.class\"\r\n        [ngStyle]=\"element.style\"\r\n        [innerHTML]=\"element.innerHtml ? element.innerHtml : ''\"\r\n    ></div>\r\n</div>\r\n",
                styles: [":host *{box-sizing:border-box;margin:0;padding:0}.icc-draw-dimensions{color:#000;font:400 14px/1em Arial}.icc-draw-dimensions .center{display:flex;-webkit-box-orient:vertical;-webkit-box-pack:center;align-items:center;justify-content:center}.icc-draw-dimensions .horizontal,.icc-draw-dimensions .vertical{position:absolute}.icc-draw-dimensions .letter{font-weight:700}.icc-draw-dimensions .major.line.horizontal{border-left:1px solid #000}.icc-draw-dimensions .minor.line.horizontal{border-left:1px solid #000;border-bottom:1px solid #000}.icc-draw-dimensions .major.line.vertical{border-top:1px solid #000}.icc-draw-dimensions .minor.line.vertical{border-top:1px solid #000;border-right:1px solid #000}.icc-draw-dimensions .major.center{font-size:.8em;font-weight:700}.icc-draw-dimensions .minor.center{font-size:.6em}.icc-draw-dimensions .major.center.horizontal{align-items:flex-end}.icc-draw-dimensions .minor.center.horizontal{align-items:flex-start}"]
            }]
    }], function () { return []; }, { details: [{
            type: Input
        }], node: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IccDrawInterfaceComponent, [{
        type: Component,
        args: [{
                selector: 'icc-draw-interface',
                template: "<div\r\n    class=\"icc-draw-interface\"\r\n    [ngStyle]=\"{'pointer-events': uuid ? 'all' : 'none'}\"\r\n>\r\n    <span *ngIf=\"currentStickyBounds\" class=\"sticky-preview\" [ngStyle]=\"stickyPreviewStyle\"></span>\r\n\r\n\r\n    <div *ngFor=\"let group of groups\"\r\n        (click)=\"$event.stopPropagation()\"\r\n        [ngClass]=\"{'active': group.uuid === uuid}\"\r\n        [ngStyle]=\"group.style\"\r\n        class=\"{{group.side}}\"\r\n    >\r\n        <span *ngFor=\"let button of group.buttons\"\r\n            (click)=\"onButtonClick(button, group)\"\r\n            [innerHTML]=\"button.innerHtml ? button.innerHtml : ''\"\r\n            [ngClass]=\"button.class\"\r\n            [ngStyle]=\"button.style\"\r\n            [attr.title]=\"button.title\"\r\n        >\r\n        </span>\r\n    </div>\r\n</div>\r\n<div *ngIf=\"move.node && uuid === 'move'\"\r\n    class=\"icc-draw-move\"\r\n    (click)=\"$event.stopPropagation()\"\r\n    [ngClass]=\"move.direction\"\r\n    [ngStyle]=\"move.style\"\r\n>\r\n    <div>\r\n        <input [class.text--position-invalid]=\"stickyPositions && (!isPositionValid && (!currentStickyBounds || !isPositionMinMaxValid))\" class=\"prev\" [(ngModel)]=\"move.inputs.prev\" (change)=\"onChangePrev()\" placeholder=\"NaN\" type=\"text\">\r\n        <input [class.text--position-invalid]=\"stickyPositions && (!isPositionValid && (!currentStickyBounds || !isPositionMinMaxValid))\" class=\"next\" [(ngModel)]=\"move.inputs.next\" (change)=\"onChangeNext()\" placeholder=\"NaN\" type=\"text\">\r\n\r\n        <span class=\"cancel ico-move-cancel\" *ngIf=\"move.actions.onClick\" (click)=\"onClickCancel()\"></span>\r\n        <span class=\"submit ico-move-submit\" *ngIf=\"move.actions.onClick\" (click)=\"onClickSubmit()\"></span>\r\n\r\n        <span [class.move--position-invalid]=\"stickyPositions && (!isPositionValid && (!currentStickyBounds || !isPositionMinMaxValid))\" class=\"move\" [ngClass]=\"move.direction === 'horizontal' ? 'ico-move-horizontal' : 'ico-move-vertical'\" (mousedown)=\"onStartMoving()\" (touchstart)=\"onStartMoving()\"></span>\r\n    </div>\r\n</div>\r\n",
                styles: [":host *{box-sizing:border-box;margin:0;outline:0;padding:0}.move--position-invalid{background-color:red!important}.text--position-invalid{color:red}.icc-draw-interface{bottom:0;left:0;position:absolute;right:0;top:0}.icc-draw-interface>div{opacity:0;position:absolute;pointer-events:none;transition:.1s ease-in-out}.icc-draw-interface>div.active{opacity:1}.icc-draw-interface>div:not(.rect){align-content:center;align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:-25px 0 0 -25px;text-align:center}.icc-draw-interface>div>span{display:block}.icc-draw-interface>div.active>span{pointer-events:all}.icc-draw-interface>div>span:hover{cursor:pointer}.icc-draw-interface>div.rect>span{bottom:-10px;left:-10px;position:absolute;right:-10px;top:-10px;transition:.1s ease-in-out}.icc-draw-interface>div.rect>span:hover{background:rgba(255,0,0,.2)}.icc-draw-interface>div:not(.rect)>span{background:center center no-repeat #fff;border:none;border-radius:20px;box-shadow:2px 2px 2px 0 rgba(0,0,0,.5);font:700 12px/40px Arial;height:40px;margin:5px;padding:0;text-align:center;transition:.1s ease-in-out;width:40px}.icc-draw-interface>div:not(.rect)>span:active,.icc-draw-interface>div:not(.rect)>span:focus,.icc-draw-interface>div:not(.rect)>span:hover{box-shadow:3px 3px 3px 1px rgba(0,0,0,.5)}.sticky-preview{position:absolute}.icc-draw-move{border:1px dotted red;position:absolute}.icc-draw-move>div{height:0;left:50%;position:relative;top:50%;width:0}.icc-draw-move>div>.move{left:-20px;top:-20px}.icc-draw-move.horizontal>div>.cancel,.icc-draw-move.vertical>div>.prev{left:-70px;top:-20px}.icc-draw-move.horizontal>div>.submit,.icc-draw-move.vertical>div>.next{left:30px;top:-20px}.icc-draw-move.horizontal>div>.prev,.icc-draw-move.vertical>div>.cancel{left:-20px;top:-70px}.icc-draw-move.horizontal>div>.next,.icc-draw-move.vertical>div>.submit{left:-20px;top:30px}.icc-draw-move>div>*{background:center center no-repeat #fff;border:none;border-radius:20px;box-shadow:2px 2px 2px 0 rgba(0,0,0,.5);display:block;font:700 12px/40px Arial;height:40px;padding:0;position:absolute;text-align:center;transition:.1s ease-in-out;width:40px}.icc-draw-move>div>:active,.icc-draw-move>div>:focus,.icc-draw-move>div>:hover{box-shadow:3px 3px 3px 1px rgba(0,0,0,.5)}.icc-draw-move>div>.cancel:hover,.icc-draw-move>div>.submit:hover{cursor:pointer}.icc-draw-move>div>.move:hover{cursor:move}.icc-draw-move>div>input:hover{cursor:text}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { clicked: [{
            type: Output
        }], click: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], node: [{
            type: Input
        }], options: [{
            type: Input
        }], svg: [{
            type: Input
        }], interfaceClickHandler: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IccDrawComponent, [{
        type: Component,
        args: [{
                selector: 'icc-draw',
                template: "<div class=\"icc-draw\" [ngStyle]=\"style()\">\r\n    <svg #svg\r\n        [attr.viewBox]=\"viewBox\"\r\n        class=\"icc-draw-svg\"\r\n        preserveAspectRatio=\"xMidYMid meet\"\r\n        width=\"100%\"\r\n        height=\"100%\"\r\n    >\r\n        <svg icc-draw-svg [node]=\"node\"></svg>\r\n    </svg>\r\n\r\n    <icc-draw-dimensions [details]=\"drawDetails\" [node]=\"node\" [options]=\"drawOptions.dimensions\"></icc-draw-dimensions>\r\n\r\n    <icc-draw-interface [node]=\"node\" [options]=\"drawOptions.interface\" [interfaceClickHandler]=\"drawOptions.onInterfaceClick\" [svg]=\"svg\"></icc-draw-interface>\r\n</div>\r\n",
                styles: [":host *{box-sizing:border-box;margin:0;padding:0}.icc-draw{clear:both;position:relative;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.icc-draw-svg{display:block}.icc-draw-indexes{position:absolute}"]
            }]
    }], function () { return []; }, { details: [{
            type: Input
        }], options: [{
            type: Input
        }], fitTo: [{
            type: Input
        }], interfaceClicked: [{
            type: Output
        }], redrawn: [{
            type: Output
        }], dimensionsComponent: [{
            type: ViewChild,
            args: [IccDrawDimensionsComponent, { static: true }]
        }], interfaceComponent: [{
            type: ViewChild,
            args: [IccDrawInterfaceComponent, { static: true }]
        }], svgElement: [{
            type: ViewChild,
            args: ['svg', { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IccDrawSvgComponent, [{
        type: Component,
        args: [{
                selector: 'svg [icc-draw-svg]',
                template: "<svg:g *ngFor=\"let node of nodes\"\r\n    [attr.class]=\"node.constructor.name\"\r\n>\r\n    <svg:defs *ngIf=\"node.svg.gradients.length || node.svg.patterns.length\">\r\n        <svg:linearGradient *ngFor=\"let svgGradient of node.svg.gradients\"\r\n            [attr.id]=\"svgGradient.id\"\r\n            [attr.gradientTransform]=\"svgGradient.gradientTransform\"\r\n            [attr.x1]=\"svgGradient.x1\"\r\n            [attr.x2]=\"svgGradient.x2\"\r\n            [attr.y1]=\"svgGradient.y1\"\r\n            [attr.y2]=\"svgGradient.y2\"\r\n        >\r\n            <svg:stop *ngFor=\"let svgGradientStep of svgGradient.steps\"\r\n                [attr.offset]=\"svgGradientStep.offset\"\r\n                [attr.stop-color]=\"svgGradientStep.color\"\r\n            ></svg:stop>\r\n        </svg:linearGradient>\r\n\r\n        <!--patternUnits=\"objectBoundingBox\"-->\r\n        <svg:pattern *ngFor=\"let svgPattern of node.svg.patterns\"\r\n            [attr.id]=\"svgPattern.id\"\r\n            [attr.patternTransform]=\"svgPattern.patternTransform\"\r\n            [attr.patternUnits]=\"svgPattern.patternUnits\"\r\n            [attr.width]=\"svgPattern.width\"\r\n            [attr.height]=\"svgPattern.height\"\r\n            [attr.x]=\"svgPattern.x\"\r\n            [attr.y]=\"svgPattern.y\"\r\n        >\r\n            <svg:rect *ngIf=\"svgPattern.color\"\r\n                [attr.fill]=\"svgPattern.color\"\r\n                [attr.width]=\"svgPattern.width\"\r\n                [attr.height]=\"svgPattern.height\"\r\n                [attr.x]=\"0\"\r\n                [attr.y]=\"0\"\r\n            />\r\n            <svg:image *ngIf=\"svgPattern.image\"\r\n                [attr.xlink:href]=\"svgPattern.image\"\r\n                [attr.width]=\"svgPattern.width\"\r\n                [attr.height]=\"svgPattern.height\"\r\n                [attr.x]=\"0\"\r\n                [attr.y]=\"0\"\r\n                preserveAspectRatio=\"none\"\r\n            />\r\n\r\n            <svg:path *ngFor=\"let svgPath of svgPattern.paths; let i = index\"\r\n                [attr.d]=\"svgPath.d\"\r\n                [attr.fill]=\"svgPath.fill\"\r\n                [attr.stroke]=\"svgPath.stroke\"\r\n                [attr.stroke-dasharray]=\"svgPath.strokeDasharray\"\r\n                [attr.stroke-width]=\"svgPath.strokeWidth\"\r\n                [attr.vector-effect]=\"svgPath.vectorEffect\"\r\n                attr.pointer-events=\"none\"\r\n            />\r\n        </svg:pattern>\r\n    </svg:defs>\r\n\r\n    <svg:g *ngIf=\"node.svg.paths.length || node.svg.texts.length\"\r\n        (click)=\"node.options.actions && node.options.actions.onHover === 'group-hover' ? node.options.actions.onClick(node.onClick({index: 'all'})) : null\"\r\n        [ngClass]=\"node.options.actions ? node.options.actions.onHover : null\"\r\n        attr.pointer-events=\"{{node.options.actions && node.options.actions.onHover ? 'all' : 'none'}}\"\r\n    >\r\n        <svg:path *ngFor=\"let svgPath of node.svg.paths; let i = index\"\r\n            (click)=\"node.options.actions && node.options.actions.onHover === 'single-hover' ? node.options.actions.onClick(node.onClick({index: i})) : null\"\r\n            [attr.d]=\"svgPath.d\"\r\n            [attr.fill]=\"svgPath.fill\"\r\n            [attr.stroke]=\"svgPath.stroke\"\r\n            [attr.stroke-dasharray]=\"svgPath.strokeDasharray\"\r\n            [attr.stroke-width]=\"svgPath.strokeWidth\"\r\n            [attr.vector-effect]=\"svgPath.vectorEffect\"\r\n            attr.pointer-events=\"{{node.options.actions && node.options.actions.onHover ? 'all' : 'none'}}\"\r\n        />\r\n\r\n        <svg:text *ngFor=\"let svgText of node.svg.texts\"\r\n            [attr.dominant-baseline]=\"svgText.dominantBaseline\"\r\n            [attr.fill]=\"svgText.fill\"\r\n            [attr.font-size]=\"svgText.fontSize\"\r\n            [attr.stroke]=\"svgText.stroke\"\r\n            [attr.stroke-width]=\"svgText.strokeWidth\"\r\n            [attr.text-anchor]=\"svgText.textAnchor\"\r\n            [attr.transform]=\"svgText.transform\"\r\n            [attr.x]=\"svgText.x\"\r\n            [attr.y]=\"svgText.y\"\r\n            font-family=\"sans-serif\"\r\n        >{{svgText.value}}</svg:text>\r\n    </svg:g>\r\n</svg:g>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{overflow:visible}g.group-hover:hover>path,g.single-hover>path:hover{cursor:pointer;fill:#eee}"]
            }]
    }], function () { return []; }, { node: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IccDrawModule, { declarations: function () { return [IccDrawComponent, IccDrawDimensionsComponent, IccDrawInterfaceComponent, IccDrawSvgComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [IccDrawComponent, IccDrawDimensionsComponent, IccDrawInterfaceComponent, IccDrawSvgComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IccDrawModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                ],
                declarations: [
                    IccDrawComponent,
                    IccDrawDimensionsComponent,
                    IccDrawInterfaceComponent,
                    IccDrawSvgComponent,
                ],
                entryComponents: [
                    IccDrawComponent,
                    IccDrawDimensionsComponent,
                    IccDrawInterfaceComponent,
                    IccDrawSvgComponent,
                ],
                exports: [
                    IccDrawComponent,
                    IccDrawDimensionsComponent,
                    IccDrawInterfaceComponent,
                    IccDrawSvgComponent,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of icc-draw-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DrawData, IccDrawComponent, IccDrawDetails, IccDrawDimensionsComponent, IccDrawInterfaceComponent, IccDrawMathService, IccDrawModule, IccDrawSvgComponent, IccDrawSyncService };

//# sourceMappingURL=icc-draw.js.map